import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, QueryFunctionContext } from 'react-query';
import { fetcher } from '../src/commons/fetcher';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Void: any;
};

export enum AdvertCollectionPositioning {
  Random = 'random',
  /**  Custom Order  */
  Setorder = 'setorder'
}

export enum AdvertCollectionRepetitions {
  Norepeat = 'norepeat',
  Repeat = 'repeat'
}

export type AllContent = ContentBaby | ContentDisease | ContentDocumentationPage | ContentEvent | ContentKitchenSink | ContentLandingPage | ContentLocation | ContentLocationContact | ContentNews | ContentPage | ContentPatientInformation | ContentSpecialist | ContentTeam | GroupDocumentation;

export type AllParagraphs = ParagraphAccordion | ParagraphAccordionElement | ParagraphAnchor | ParagraphAnimatedNumberElement | ParagraphAnimatedNumbers | ParagraphBabiesSearch | ParagraphCallToAction | ParagraphContextualEvent | ParagraphContextualText | ParagraphDocuments | ParagraphEmpty | ParagraphEventForm | ParagraphEventsSearch | ParagraphFileList | ParagraphForm | ParagraphFormattedTextWithTitle | ParagraphImageCarousel | ParagraphImageWithCaption | ParagraphLabCardListing | ParagraphLinkList | ParagraphLinkListLink | ParagraphListingAllocation | ParagraphListingClinicsByArea | ParagraphListingDiseaseFromLocation | ParagraphListingDiseaseSearchSource | ParagraphListingEventsEmbed | ParagraphListingEventsEmbedByDepartment | ParagraphListingEventsEmbedByTypeAndDepartment | ParagraphListingJobList | ParagraphListingJobToolSearch | ParagraphListingLocationByTreatmentOffer | ParagraphListingMedicineNews | ParagraphListingNewsroomFiltered | ParagraphListingNewsroomFrontpage | ParagraphListingNewsroomPersonnelBlock | ParagraphListingNewsroomResearch | ParagraphListingNewsroomTreatment | ParagraphListingSpecialists | ParagraphLiteratureLinks | ParagraphLiteraturePdfs | ParagraphLiteratureText | ParagraphLogoCloud | ParagraphLogoCloudImage | ParagraphMegaTeasers | ParagraphNewsTeaser | ParagraphPreAnalyticData | ParagraphQuote | ParagraphSiteSearch | ParagraphSpacer | ParagraphSpecialistsSlider | ParagraphStaticCampaignMonitorSubscribeForm | ParagraphStaticWallsBlock | ParagraphTeaser | ParagraphTeasers | ParagraphTestimonialSlider | ParagraphTile | ParagraphTiles | ParagraphTimeline | ParagraphTimelineElement | ParagraphTimelineGroup | ParagraphVideo | ParagraphWysiwygContent | ParagraphYoutubeEmbed;

export type BreadcrumbItem = {
  _original_typename: Scalars['String'];
  text: Scalars['String'];
  url: Scalars['String'];
};

export type ContentAdvert = {
  _original_typename: Scalars['String'];
  buttonPlacement: LeftOrRight;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  image: Maybe<MediaImage>;
  link: LinkWithText;
  text: Maybe<Scalars['String']>;
  textAlignment: LeftOrRight;
  title: Scalars['String'];
};

export type ContentAdvertCollection = {
  _original_typename: Scalars['String'];
  collection: Array<Maybe<ContentAdvert>>;
  drupalId: Scalars['String'];
  frequency: Scalars['Int'];
  id: Scalars['String'];
  positioning: AdvertCollectionPositioning;
  repetitions: AdvertCollectionRepetitions;
  title: Scalars['String'];
};

export type ContentAnalysis = {
  _original_typename: Scalars['String'];
  analysisExternal: Maybe<Scalars['String']>;
  analysisFrequency: Maybe<Scalars['String']>;
  analysisName: Scalars['String'];
  breadcrumbs: Array<BreadcrumbItem>;
  clinicIndicationHtml: Maybe<Scalars['String']>;
  conversionFactorHtml: Maybe<Scalars['String']>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  interferenceFactorsHtml: Maybe<Scalars['String']>;
  interpretationHtml: Maybe<Scalars['String']>;
  laboratoryContact: Maybe<Array<Maybe<TermLabContact>>>;
  links: Maybe<Array<Maybe<LinkWithText>>>;
  literatureReference: Maybe<Array<Maybe<ParagraphLiterature>>>;
  metaTags: Maybe<Array<Maybe<MetaTag>>>;
  methodHtml: Maybe<Scalars['String']>;
  notesInternalHtml: Maybe<Scalars['String']>;
  path: Scalars['String'];
  preAnalyticData: Maybe<Array<Maybe<ParagraphPreAnalyticData>>>;
  referenceRangesHtml: Maybe<Scalars['String']>;
  sampleStabilityStorageHtml: Maybe<Scalars['String']>;
  specialityArea: Maybe<Array<Maybe<TermSpecialityArea>>>;
  subsequentRegulationHtml: Maybe<Scalars['String']>;
  synonymsKeyWords: Maybe<Scalars['String']>;
  taxposition: Maybe<Array<Maybe<TermTaxposition>>>;
  unit: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type ContentBaby = {
  _original_typename: Scalars['String'];
  /**
   * This field is not resolved within Drupal, but in the Gatsby GraphQL layer.
   * See gatsby-node.ts
   */
  birthdayFact: Maybe<ContentBirthdayFact>;
  breadcrumbs: Array<BreadcrumbItem>;
  createdTimestamp: Scalars['Int'];
  dateOfBirth: Scalars['String'];
  drupalId: Scalars['String'];
  gender: Scalars['String'];
  gtmData: Maybe<Scalars['String']>;
  height: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image: Maybe<MediaImage>;
  location: Maybe<ContentLocation>;
  metaTags: Maybe<Array<Maybe<MetaTag>>>;
  path: Scalars['String'];
  title: Scalars['String'];
  updatedTimestamp: Scalars['Int'];
  uuid: Scalars['String'];
  weight: Maybe<Scalars['String']>;
};

export type ContentBirthdayFact = {
  _original_typename: Scalars['String'];
  birthday: Maybe<Scalars['String']>;
  day: Scalars['Int'];
  drupalId: Scalars['String'];
  event: Maybe<Scalars['String']>;
  id: Scalars['String'];
  month: Scalars['Int'];
};

export type ContentDisease = {
  _original_typename: Scalars['String'];
  breadcrumbs: Array<BreadcrumbItem>;
  causesHtml: Maybe<Scalars['String']>;
  courseHtml: Maybe<Scalars['String']>;
  diagnosisHtml: Maybe<Scalars['String']>;
  drupalId: Scalars['String'];
  faqs: Maybe<ParagraphAccordion>;
  gtmData: Maybe<Scalars['String']>;
  id: Scalars['String'];
  metaTags: Maybe<Array<Maybe<MetaTag>>>;
  overviewHtml: Maybe<Scalars['String']>;
  paragraphBottom: Array<AllParagraphs>;
  path: Scalars['String'];
  preventionHtml: Maybe<Scalars['String']>;
  shortDescriptionHtml: Maybe<Scalars['String']>;
  specialists: Array<Maybe<ContentSpecialist>>;
  specialistsTitle: Maybe<Scalars['String']>;
  symptomsHtml: Maybe<Scalars['String']>;
  title: Scalars['String'];
  treatmentArea: Array<Maybe<TermTreatmentArea>>;
  treatmentHtml: Maybe<Scalars['String']>;
  updatedTimestamp: Scalars['Int'];
};

export type ContentDocumentationPage = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  group: Maybe<GroupDocumentation>;
  id: Scalars['String'];
  metaTags: Maybe<Array<Maybe<MetaTag>>>;
  paragraphs: Array<Maybe<AllParagraphs>>;
  path: Scalars['String'];
  title: Scalars['String'];
};

export type ContentEvent = {
  _original_typename: Scalars['String'];
  breadcrumbs: Array<BreadcrumbItem>;
  content: Array<Maybe<AllParagraphs>>;
  createdTimestamp: Scalars['Int'];
  drupalId: Scalars['String'];
  endDate: Scalars['String'];
  endTime: Maybe<Scalars['String']>;
  eventStatus: Maybe<Scalars['String']>;
  form: Maybe<ParagraphEventForm>;
  gtmData: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image: Maybe<MediaImage>;
  lead: Maybe<Scalars['String']>;
  location: Maybe<Scalars['String']>;
  metaTags: Maybe<Array<Maybe<MetaTag>>>;
  organizer: Array<Maybe<ContentLocation>>;
  path: Scalars['String'];
  sidebar: Array<Maybe<AllParagraphs>>;
  startDate: Scalars['String'];
  startTime: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedTimestamp: Scalars['Int'];
  uuid: Scalars['String'];
};

export type ContentJob = {
  _original_typename: Scalars['String'];
  area: Maybe<TermJobArea>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  link: Maybe<Link>;
  location: Maybe<TermAdministrativeArea>;
  title: Scalars['String'];
  workload: Scalars['String'];
};

export type ContentKitchenSink = {
  _original_typename: Scalars['String'];
  breadcrumbs: Array<BreadcrumbItem>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  paragraphs: Array<Maybe<AllParagraphs>>;
  path: Scalars['String'];
  title: Scalars['String'];
};

export type ContentLandingPage = {
  _original_typename: Scalars['String'];
  advertCollection: Maybe<ContentAdvertCollection>;
  body: Array<Maybe<AllParagraphs>>;
  breadcrumbs: Array<BreadcrumbItem>;
  description: Maybe<Scalars['String']>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  image: Maybe<MediaImage>;
  increaseHeroHeight: Maybe<Scalars['Boolean']>;
  metaTags: Maybe<Array<Maybe<MetaTag>>>;
  path: Scalars['String'];
  title: Scalars['String'];
  updatedTimestamp: Scalars['Int'];
  video: Maybe<MediaVideo>;
};

export type ContentLocation = {
  _original_typename: Scalars['String'];
  area: Maybe<TermAdministrativeArea>;
  breadcrumbs: Array<BreadcrumbItem>;
  contact: Maybe<ContentLocationContact>;
  contactParentLocationAreaTitle: Maybe<Scalars['String']>;
  content: Array<Maybe<AllParagraphs>>;
  contentBottom: Array<Maybe<AllParagraphs>>;
  contentSidebar: Array<Maybe<AllParagraphs>>;
  /** Whether to display listingNewsroomLocation results. */
  displayRelatedNews: Scalars['Boolean'];
  domains: Array<Scalars['String']>;
  drupalId: Scalars['String'];
  hideParentLocationTitleFromContactInformation: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  metaTags: Maybe<Array<Maybe<MetaTag>>>;
  navigation: Array<NavigationItem>;
  path: Scalars['String'];
  specialists: Array<Maybe<ContentSpecialist>>;
  specialistsTitle: Maybe<Scalars['String']>;
  subtitle: Maybe<Scalars['String']>;
  teamPageTitle: Maybe<Scalars['String']>;
  title: Scalars['String'];
  treatmentOffer: Array<Maybe<ContentDisease>>;
  updatedTimestamp: Scalars['Int'];
  uuid: Scalars['String'];
  welcomeTitle: Maybe<Scalars['String']>;
};

export type ContentLocationContact = {
  _original_typename: Scalars['String'];
  addressFirstLine: Scalars['String'];
  addressSecondLine: Maybe<Scalars['String']>;
  breadcrumbs: Array<BreadcrumbItem>;
  city: Scalars['String'];
  companyName: Maybe<Scalars['String']>;
  drupalId: Scalars['String'];
  email: Maybe<Scalars['String']>;
  id: Scalars['String'];
  infoAddress: Array<Maybe<AllParagraphs>>;
  infoBooking: Array<Maybe<AllParagraphs>>;
  infoEmergency: Array<Maybe<AllParagraphs>>;
  latitude: Scalars['String'];
  locationHeader: LocationHeader;
  longitude: Scalars['String'];
  mapOverlayHtml: Maybe<Scalars['String']>;
  metaTags: Maybe<Array<Maybe<MetaTag>>>;
  parentLocation: Maybe<ContentLocation>;
  path: Scalars['String'];
  phone: Maybe<Scalars['String']>;
  postCode: Scalars['String'];
  title: Scalars['String'];
  updatedTimestamp: Scalars['Int'];
};

export type ContentMedicineNews = {
  _original_typename: Scalars['String'];
  commentHtml: Maybe<Scalars['String']>;
  date: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  newArticleNumber: Maybe<Scalars['Float']>;
  newChange: Maybe<Scalars['String']>;
  newComment: Maybe<Scalars['String']>;
  newComposition: Maybe<Scalars['String']>;
  newName: Maybe<Scalars['String']>;
  oldArticleNumber: Maybe<Scalars['Float']>;
  oldChange: Maybe<Scalars['String']>;
  oldComment: Maybe<Scalars['String']>;
  oldComposition: Maybe<Scalars['String']>;
  oldName: Scalars['String'];
};

export type ContentNews = {
  _original_typename: Scalars['String'];
  body: Array<Maybe<AllParagraphs>>;
  breadcrumbs: Array<BreadcrumbItem>;
  caption: Maybe<Scalars['String']>;
  constructionTerms: Array<Maybe<TermConstruction>>;
  date: Scalars['String'];
  dateChanged: Scalars['String'];
  diseases: Array<Maybe<ContentDisease>>;
  drupalId: Scalars['String'];
  gtmData: Maybe<Scalars['String']>;
  id: Scalars['String'];
  knowledgeTerms: Array<Maybe<TermKnowledge>>;
  lead: Maybe<Scalars['String']>;
  locations: Array<Maybe<ContentLocation>>;
  metaTags: Maybe<Array<Maybe<MetaTag>>>;
  path: Scalars['String'];
  readTime: Maybe<Scalars['String']>;
  sidebar: Array<Maybe<AllParagraphs>>;
  specialists: Array<Maybe<ContentSpecialist>>;
  strategyTerms: Array<Maybe<TermStrategy>>;
  teaserImage: Maybe<MediaImage>;
  teaserText: Maybe<Scalars['String']>;
  title: Scalars['String'];
  treatmentAreas: Array<Maybe<TermTreatmentArea>>;
  types: Array<Scalars['String']>;
  updatedTimestamp: Scalars['Int'];
};

export type ContentPage = {
  _original_typename: Scalars['String'];
  body: Array<Maybe<AllParagraphs>>;
  bottom: Array<Maybe<AllParagraphs>>;
  breadcrumbs: Array<BreadcrumbItem>;
  description: Maybe<Scalars['String']>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  locationHeader: LocationHeader;
  metaTags: Maybe<Array<Maybe<MetaTag>>>;
  path: Scalars['String'];
  sidebar: Array<Maybe<AllParagraphs>>;
  title: Scalars['String'];
  translations: Maybe<Array<Maybe<ContentPage>>>;
  translationsLanguageTitle: Maybe<Scalars['String']>;
  updatedTimestamp: Scalars['Int'];
  uuid: Scalars['String'];
};

export type ContentPatientInformation = {
  _original_typename: Scalars['String'];
  body: Array<Maybe<AllParagraphs>>;
  breadcrumbs: Array<BreadcrumbItem>;
  documentationGroup: Maybe<GroupDocumentation>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  metaTags: Maybe<Array<Maybe<MetaTag>>>;
  path: Scalars['String'];
  title: Scalars['String'];
  updatedTimestamp: Scalars['Int'];
};

export type ContentScreen = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  fallbackImageDoubleScreen: Maybe<MediaImage>;
  fallbackImageSingleScreen: Maybe<MediaImage>;
  forceDualScreens: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  path: Scalars['String'];
  screenInfo: Array<ScreenInfo>;
  standardImage: Maybe<MediaImage>;
  textLeft: Array<Scalars['String']>;
  textRight: Array<Scalars['String']>;
  uuid: Scalars['String'];
};

export type ContentSpecialist = {
  _original_typename: Scalars['String'];
  areas: Array<Maybe<TermAdministrativeArea>>;
  awards: Array<Scalars['String']>;
  breadcrumbs: Array<BreadcrumbItem>;
  career: Array<Scalars['String']>;
  contactInfo: Array<SpecialistContactInfo>;
  degree: Maybe<Scalars['String']>;
  department: Maybe<Scalars['String']>;
  drupalId: Scalars['String'];
  email: Maybe<Scalars['String']>;
  expertise: Maybe<Array<Maybe<TermExpertise>>>;
  firstName: Scalars['String'];
  forceChildrenHospitalTheme: Scalars['Boolean'];
  gender: Scalars['String'];
  gtmData: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageFallbackGender: Maybe<Scalars['String']>;
  imageLandscape: Maybe<MediaImage>;
  imagePortrait: Maybe<MediaImage>;
  job: Maybe<Scalars['String']>;
  jobFunction: Array<Maybe<TermJobFunction>>;
  languages: Array<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  locations: Array<Maybe<ContentLocation>>;
  mandates: Array<Scalars['String']>;
  memberships: Array<Scalars['String']>;
  metaTags: Maybe<Array<Maybe<MetaTag>>>;
  offices: Maybe<Array<Maybe<ContentLocationContact>>>;
  path: Scalars['String'];
  personalSecretaries: Array<Secretary>;
  phone: Maybe<Scalars['String']>;
  publications: Maybe<LinkWithText>;
  spokenLanguage: Array<Maybe<TermSpokenLanguage>>;
  studies: Array<Scalars['String']>;
  title: Scalars['String'];
  treatments: Maybe<Scalars['String']>;
  updatedTimestamp: Scalars['Int'];
  uuid: Scalars['String'];
};

export type ContentTeam = {
  _original_typename: Scalars['String'];
  breadcrumbs: Array<BreadcrumbItem>;
  contentBottom: Array<Maybe<AllParagraphs>>;
  contentSidebar: Array<Maybe<AllParagraphs>>;
  description: Array<Maybe<AllParagraphs>>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  lead: Maybe<Scalars['String']>;
  locationHeader: LocationHeader;
  metaTags: Maybe<Array<Maybe<MetaTag>>>;
  path: Scalars['String'];
  specialists: Array<Maybe<ContentSpecialist>>;
  specialistsTitle: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedTimestamp: Scalars['Int'];
};

export type ContentTestimonial = {
  _original_typename: Scalars['String'];
  author: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  image: Maybe<MediaImage>;
  link: Maybe<LinkWithOptionalText>;
  textFullHtml: Scalars['String'];
  textSummaryHtml: Scalars['String'];
  title: Scalars['String'];
};

export type DrupalSettings = {
  _original_typename: Scalars['String'];
  emergencyMessage: Maybe<EmergencyMessage>;
  errorPageContentId: Scalars['String'];
  frontPageContentId: Scalars['String'];
  siteName: Scalars['String'];
  siteSlogan: Scalars['String'];
};

/**
 * A simple fullscreen image or video.
 *
 * If all three fields are NULL - skip the slide.
 *
 * The reason why we have three GraphQL fields here while there is a single Drupal
 * field: Gatsby has issues tracking entity relations if a union is used 🤷 This
 * leads to fatal build errors like "Cannot return null for non nullable field
 * _original_typename".
 */
export type DsFullScreenSlide = {
  _original_typename: Scalars['String'];
  /** The duration this slide should be shown. Only for video slides. */
  durationSeconds: Maybe<Scalars['Int']>;
  mediaImage: Maybe<MediaImage>;
  mediaVideoLocal: Maybe<MediaVideoLocal>;
  /** Note: It supports only Vimeo URLs. */
  mediaVideoRemote: Maybe<MediaVideoRemote>;
};

/**
 * Show a health tip by and expert. Displays the rich text content
 * alongside the experts name and portrait.
 */
export type DsHealthTipSlide = {
  _original_typename: Scalars['String'];
  contentHtml: Scalars['String'];
  /** If NULL - skip the slide. */
  expert: Maybe<ContentSpecialist>;
  label: Scalars['String'];
  title: Scalars['String'];
};

/**
 * Display a "then" and "now" comparison.
 *
 * This slide should be displayed as two slides.
 * First slide:
 * - left: "then" image, "then" caption
 * - right: "now" image, "now" caption
 * Second slide:
 * - left: "now" image
 * - right: "now" description
 *
 * Both slides should be displayed for the same duration.
 */
export type DsHistorySlide = {
  _original_typename: Scalars['String'];
  nowCaption: Scalars['String'];
  nowDescriptionHtml: Scalars['String'];
  /** If NULL - skip the slide. */
  nowImage: Maybe<MediaImage>;
  thenCaption: Scalars['String'];
  /** If NULL - skip the slide. */
  thenImage: Maybe<MediaImage>;
};

/**
 * Displays collage of media items alongside with a short rich text
 * section and call to action to follow a fixed instagram account.
 */
export type DsInstagramSlide = {
  _original_typename: Scalars['String'];
  contentHtml: Scalars['String'];
  /** Text to be displayed above "[instagram icon] luzernerkantonsspital". */
  cta: Scalars['String'];
  /** If NULL - skip the slide. */
  expert: Maybe<ContentSpecialist>;
  /**
   * One or two images.
   *
   * If empty - skip the slide.
   */
  images: Array<Maybe<MediaImage>>;
  title: Scalars['String'];
};

/**
 * The DsLoop is the main entry point. Each Loop is rendered
 * onto a single HTML page, loads all possible slides and displays
 * them in an automatic slideshow based on the configured segments.
 */
export type DsLoop = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  dsSettings: SettingsDigitalSignage;
  id: Scalars['String'];
  path: Scalars['String'];
  /**
   * A list of segments that make up the rules for this loop.
   * Each segment defines a playlist and the amount of slides to
   * randomly pick from it. After each segment has been executed,
   * the loop starts over at the first segment.
   */
  segments: Array<DsLoopSegment>;
  uuid: Scalars['String'];
};

/**
 * A segment defines a playlist and the amount of slides to randomly
 * pick from it.
 */
export type DsLoopSegment = {
  _original_typename: Scalars['String'];
  amountOfSlidesToPick: Scalars['Int'];
  filters: DsSegmentFilters;
  filtersExclude: DsSegmentFilters;
  /** If NULL - skip the segment. */
  playlist: Maybe<DsPlaylist>;
};

/** If all slide* fields are empty - skip the parent segment. */
export type DsPlaylist = {
  _original_typename: Scalars['String'];
  content: PlaylistContent;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  uuid: Scalars['String'];
};

/**
 * Shows a question and multiple answer options alongside a media item.
 * After a given amount of time, the correct answer is highlighted.
 */
export type DsQuizSlide = {
  _original_typename: Scalars['String'];
  /** From 2 to 5 items. */
  answers: Array<Scalars['String']>;
  correctAnswer: Scalars['String'];
  /** If NULL - skip the slide. */
  image: Maybe<MediaImage>;
  question: Scalars['String'];
};

export type DsSegmentFilters = {
  _original_typename: Scalars['String'];
  departmentIds: Array<Scalars['String']>;
  projectIds: Array<Scalars['String']>;
  treatmentAreaIds: Array<Scalars['String']>;
};

/**
 * A manually edited slide, displaying media and rich text content
 * side by side.
 */
export type DsSimpleSlide = {
  _original_typename: Scalars['String'];
  contentHtml: Scalars['String'];
  /** If NULL - skip the slide. */
  image: Maybe<MediaImage>;
  title: Scalars['String'];
};

/** A single slide, displayed in the loop. */
export type DsSlide = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  dsSettings: SettingsDigitalSignage;
  id: Scalars['String'];
  /** The layout of this slide, carrying the actual content. */
  layout: DsSlideLayout;
  metadata: DsSlideMetadata;
  path: Scalars['String'];
  uuid: Scalars['String'];
};

export type DsSlideLayout = DsFullScreenSlide | DsHealthTipSlide | DsHistorySlide | DsInstagramSlide | DsQuizSlide | DsSimpleSlide;

export type DsSlideMetadata = {
  _original_typename: Scalars['String'];
  departmentIds: Array<Scalars['String']>;
  projectIds: Array<Scalars['String']>;
  treatmentAreaIds: Array<Scalars['String']>;
};

export type DynamicExposedFiltersInput = {
  filter: Scalars['String'];
  value: Scalars['String'];
};

export type EmergencyMessage = {
  _original_typename: Scalars['String'];
  textHtml: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type Feed = {
  _original_typename: Scalars['String'];
  changes: Array<Scalars['String']>;
  listFieldName: Scalars['String'];
  pathFieldName: Maybe<Scalars['String']>;
  singleFieldName: Scalars['String'];
  templateFieldName: Maybe<Scalars['String']>;
  translatable: Scalars['Boolean'];
  typeName: Scalars['String'];
};


export type FeedChangesArgs = {
  currentBuild: InputMaybe<Scalars['Int']>;
  lastBuild: InputMaybe<Scalars['Int']>;
};

export type FocalPoint = {
  _original_typename: Scalars['String'];
  x: Scalars['Int'];
  y: Scalars['Int'];
};

export type GroupDocumentation = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  mainContent: Maybe<GroupDocumentationMainContent>;
  menuMain: Maybe<Array<MenuItem>>;
  path: Scalars['String'];
  title: Scalars['String'];
};

export type GroupDocumentationMainContent = ContentDocumentationPage | ContentPatientInformation;

export type ImageSource = {
  _original_typename: Scalars['String'];
  height: Scalars['Int'];
  url: Scalars['String'];
  width: Scalars['Int'];
};

export type ImageStyle = {
  _original_typename: Scalars['String'];
  id: Scalars['String'];
  sources: Array<ImageSource>;
};

export type ImageStyleOther = {
  _original_typename: Scalars['String'];
  id: Scalars['String'];
  url: Scalars['String'];
};

export type Item = {
  _original_typename: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type ItemWithParent = {
  _original_typename: Scalars['String'];
  id: Scalars['String'];
  parentId: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type JobFunctionFacet = {
  _original_typename: Scalars['String'];
  count: Maybe<Scalars['Int']>;
  delta: Scalars['Int'];
  label: Maybe<Scalars['String']>;
};

export type JobSearchSubscribeInput = {
  area: InputMaybe<Array<Scalars['String']>>;
  email: Scalars['String'];
  location: InputMaybe<Array<Scalars['String']>>;
  subject: Scalars['String'];
  text: InputMaybe<Scalars['String']>;
  workload: InputMaybe<Array<Scalars['String']>>;
};

export type JobSearchSubscribeResult = JobSearchSubscribeSubmissionError | JobSearchSubscribeSuccess | JobSearchSubscribeValidationErrors;

export type JobSearchSubscribeSubmissionError = {
  _original_typename: Scalars['String'];
  void: Maybe<Scalars['Void']>;
};

export type JobSearchSubscribeSuccess = {
  _original_typename: Scalars['String'];
  void: Maybe<Scalars['Void']>;
};

export enum JobSearchSubscribeValidationError {
  InvalidEmail = 'InvalidEmail',
  MissingSubject = 'MissingSubject'
}

export type JobSearchSubscribeValidationErrors = {
  _original_typename: Scalars['String'];
  errors: Array<JobSearchSubscribeValidationError>;
};

export enum LeftOrRight {
  Left = 'left',
  Right = 'right'
}

export type Link = {
  _original_typename: Scalars['String'];
  url: Scalars['String'];
};

export type LinkWithOptionalText = {
  _original_typename: Scalars['String'];
  text: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type LinkWithText = {
  _original_typename: Scalars['String'];
  text: Scalars['String'];
  url: Scalars['String'];
};

export type ListingJobToolSearchFilters = {
  _original_typename: Scalars['String'];
  area: Array<Item>;
  /**  If null, the filter should not appear on the frontend  */
  location: Maybe<Array<Maybe<Item>>>;
  workload: Array<Item>;
};

export type ListingJobToolSearchFiltersInput = {
  area: InputMaybe<Array<Scalars['String']>>;
  location: InputMaybe<Array<Scalars['String']>>;
  text: InputMaybe<Scalars['String']>;
  workload: InputMaybe<Array<Scalars['String']>>;
};

export type ListingMedicineNewsFilters = {
  _original_typename: Scalars['String'];
  change: Array<Item>;
};

export type ListingMedicineNewsFiltersInput = {
  change: InputMaybe<Scalars['String']>;
  text: InputMaybe<Scalars['String']>;
};

export type ListingResultContentDisease = {
  _original_typename: Scalars['String'];
  items: Array<Maybe<ContentDisease>>;
  total: Scalars['Int'];
};

export type ListingResultContentEvent = {
  _original_typename: Scalars['String'];
  items: Array<Maybe<ContentEvent>>;
  total: Scalars['Int'];
};

export type ListingResultContentJob = {
  _original_typename: Scalars['String'];
  items: Array<Maybe<ContentJob>>;
  total: Scalars['Int'];
};

export type ListingResultContentLocation = {
  _original_typename: Scalars['String'];
  items: Array<Maybe<ContentLocation>>;
  total: Scalars['Int'];
};

export type ListingResultContentMedicineNews = {
  _original_typename: Scalars['String'];
  items: Array<Maybe<ContentMedicineNews>>;
  total: Scalars['Int'];
};

export type ListingResultContentNews = {
  _original_typename: Scalars['String'];
  items: Array<Maybe<ContentNews>>;
  total: Scalars['Int'];
};

export type ListingResultContentPage = {
  _original_typename: Scalars['String'];
  items: Array<Maybe<ContentPage>>;
  total: Scalars['Int'];
};

export type ListingSpecialistsFacets = {
  _original_typename: Scalars['String'];
  department: Array<Scalars['String']>;
  /**  Includes only letters which should be clickable  */
  glossary: Array<Scalars['String']>;
  jobFunction: Array<JobFunctionFacet>;
  location: Array<Scalars['String']>;
  spokenLanguage: Array<Scalars['String']>;
};

export type ListingSpecialistsFiltersInput = {
  department: InputMaybe<Scalars['String']>;
  glossary: InputMaybe<Scalars['String']>;
  jobFunction: InputMaybe<Scalars['String']>;
  location: InputMaybe<Scalars['String']>;
  spokenLanguage: InputMaybe<Scalars['String']>;
  text: InputMaybe<Scalars['String']>;
};

export type ListingSpecialistsResult = {
  _original_typename: Scalars['String'];
  facets: ListingSpecialistsFacets;
  items: Array<Maybe<ContentSpecialist>>;
  total: Scalars['Int'];
};

export type LiteratureLinks = {
  _original_typename: Scalars['String'];
  description: Maybe<Scalars['String']>;
  link: Maybe<LinkWithOptionalText>;
};

export type LocationHeader = {
  _original_typename: Scalars['String'];
  location: Maybe<ContentLocation>;
  navigation: Array<NavigationItem>;
};

export type MediaFile = {
  _original_typename: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type MediaImage = {
  _original_typename: Scalars['String'];
  alt: Maybe<Scalars['String']>;
  drupalId: Scalars['String'];
  focalPoint: FocalPoint;
  id: Scalars['String'];
  original: Maybe<Scalars['String']>;
  styles: Array<ImageStyle>;
  stylesOther: Array<ImageStyleOther>;
  title: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type MediaLabCardContainer = {
  _original_typename: Scalars['String'];
  alt: Maybe<Scalars['String']>;
  containerName: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  imageCaption: Maybe<Scalars['String']>;
  original: Maybe<Scalars['String']>;
  styles: Array<ImageStyle>;
  stylesOther: Array<ImageStyleOther>;
  uuid: Scalars['String'];
};

export type MediaLabCardPdf = {
  _original_typename: Scalars['String'];
  description: Maybe<Scalars['String']>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
  uuid: Scalars['String'];
};

export type MediaVideo = MediaVideoLocal | MediaVideoRemote;

export type MediaVideoLocal = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  url: Scalars['String'];
  uuid: Scalars['String'];
};

export type MediaVideoRemote = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  url: Scalars['String'];
  uuid: Scalars['String'];
};

export type MenuFooter = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  items: Array<MenuItem>;
};

export type MenuItem = {
  _original_typename: Scalars['String'];
  id: Scalars['String'];
  label: Scalars['String'];
  parent: Scalars['String'];
  url: Scalars['String'];
};

export type MenuLegal = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  items: Array<MenuItem>;
};

export type MenuMain = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  items: Array<MenuItem>;
};

export type MenuMeta = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  items: Array<MenuItem>;
};

export type MenuNewsroom = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  items: Array<MenuItem>;
};

export type MetaTag = {
  _original_typename: Scalars['String'];
  attributes: MetaTagAttributes;
  tag: Scalars['String'];
};

export type MetaTagAttributes = {
  _original_typename: Scalars['String'];
  content: Maybe<Scalars['String']>;
  href: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  property: Maybe<Scalars['String']>;
  rel: Maybe<Scalars['String']>;
};

export type Mutation = {
  _original_typename: Scalars['String'];
  addCommentToPageFeedback: PageFeedbackCommentResult;
  addPageFeedback: PageFeedbackResult;
  jobSearchSubscribe: JobSearchSubscribeResult;
};


export type MutationAddCommentToPageFeedbackArgs = {
  input: InputMaybe<PageFeedbackCommentInput>;
};


export type MutationAddPageFeedbackArgs = {
  input: InputMaybe<PageFeedbackInput>;
};


export type MutationJobSearchSubscribeArgs = {
  input: InputMaybe<JobSearchSubscribeInput>;
};

export type NavigationItem = {
  _original_typename: Scalars['String'];
  isActive: Scalars['Boolean'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type PageFeedbackCommentInput = {
  comment: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  /** The ID returned in PageFeedbackResult. */
  submissionId: Scalars['String'];
};

export enum PageFeedbackCommentResult {
  EmailValidationError = 'EmailValidationError',
  Success = 'Success'
}

export type PageFeedbackInput = {
  /** Absolute URL of a page. */
  pageUrl: Scalars['String'];
  pageWasHelpful: Scalars['Boolean'];
};

export type PageFeedbackResult = {
  _original_typename: Scalars['String'];
  /** The ID is only returned if PageFeedbackInput.pageWasHelpful was false. */
  submissionId: Maybe<Scalars['String']>;
};

export type PaginationInput = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type ParagraphAccordion = {
  _original_typename: Scalars['String'];
  accordionElements: Array<ParagraphAccordionElement>;
};

export type ParagraphAccordionElement = {
  _original_typename: Scalars['String'];
  textHtml: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphAnchor = {
  _original_typename: Scalars['String'];
  anchorLink: Maybe<Scalars['String']>;
};

export type ParagraphAnimatedNumberElement = {
  Image: Maybe<MediaImage>;
  _original_typename: Scalars['String'];
  itemDisableSeparator: Scalars['Boolean'];
  itemNumber: Maybe<Scalars['String']>;
  itemTitle: Maybe<Scalars['String']>;
  itemUnit: Maybe<Scalars['String']>;
};

export type ParagraphAnimatedNumberRange = {
  Image: Maybe<MediaImage>;
  _original_typename: Scalars['String'];
  itemConnectingWord: Maybe<Scalars['String']>;
  itemDisableSeparator: Scalars['Boolean'];
  itemFirstNumber: Maybe<Scalars['String']>;
  itemSecondNumber: Maybe<Scalars['String']>;
  itemTitle: Maybe<Scalars['String']>;
  itemUnit: Maybe<Scalars['String']>;
};

export type ParagraphAnimatedNumbers = {
  _original_typename: Scalars['String'];
  animLink: Maybe<LinkWithOptionalText>;
  items: Array<Maybe<ParagraphAnimatedOptions>>;
  linkType: Scalars['Boolean'];
  title: Maybe<Scalars['String']>;
};

export type ParagraphAnimatedOptions = ParagraphAnimatedNumberElement | ParagraphAnimatedNumberRange;

export type ParagraphBabiesSearch = {
  _original_typename: Scalars['String'];
  filters: SearchBabiesFilters;
  searchBabiesResult: SearchBabiesResult;
};


export type ParagraphBabiesSearchSearchBabiesResultArgs = {
  pagination: PaginationInput;
};

export type ParagraphCallToAction = {
  _original_typename: Scalars['String'];
  ctaDescription: Maybe<Scalars['String']>;
  ctaImage: Maybe<MediaImage>;
  ctaLink: Maybe<LinkWithOptionalText>;
  ctaTitle: Maybe<Scalars['String']>;
  imgAlignment: Maybe<Scalars['String']>;
};

export type ParagraphContextualEvent = {
  _original_typename: Scalars['String'];
  event: Maybe<ContentEvent>;
};

export type ParagraphContextualText = {
  _original_typename: Scalars['String'];
  link: Maybe<LinkWithText>;
  textHtml: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphDocuments = {
  _original_typename: Scalars['String'];
  documents: Array<Maybe<MediaFile>>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphEmpty = {
  _original_typename: Scalars['String'];
  void: Maybe<Scalars['Void']>;
};

export type ParagraphEventForm = {
  _original_typename: Scalars['String'];
  formUrl: Scalars['String'];
};

export type ParagraphEventsSearch = {
  _original_typename: Scalars['String'];
  filters: SearchEventsFilters;
  searchEventsResult: SearchEventsResult;
};


export type ParagraphEventsSearchSearchEventsResultArgs = {
  pagination: PaginationInput;
};

export type ParagraphFileList = {
  _original_typename: Scalars['String'];
  files: Maybe<Array<Maybe<MediaFile>>>;
};

export type ParagraphForm = {
  _original_typename: Scalars['String'];
  formUrl: Scalars['String'];
};

export type ParagraphFormattedTextWithTitle = {
  _original_typename: Scalars['String'];
  textHtml: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphImageCarousel = {
  _original_typename: Scalars['String'];
  display: Maybe<ParagraphTeasersDisplay>;
  items: Array<Maybe<ParagraphImageCarouselItem>>;
  lightboxItems: Array<Maybe<ParagraphImageCarouselItem>>;
};

export type ParagraphImageCarouselItem = ParagraphEmpty | ParagraphImageWithCaption | ParagraphVideo;

export type ParagraphImageWithCaption = {
  _original_typename: Scalars['String'];
  caption: Maybe<Scalars['String']>;
  image: Maybe<MediaImage>;
};

export type ParagraphLabCardListing = {
  _original_typename: Scalars['String'];
  title: Maybe<Scalars['String']>;
};

export type ParagraphLinkList = {
  _original_typename: Scalars['String'];
  links: Array<Maybe<ParagraphLinkListLinkNullable>>;
};

export type ParagraphLinkListLink = {
  _original_typename: Scalars['String'];
  listLink: LinkWithText;
  title: Maybe<Scalars['String']>;
};

export type ParagraphLinkListLinkNullable = ParagraphEmpty | ParagraphLinkListLink;

export type ParagraphListingAllocation = {
  _original_typename: Scalars['String'];
  argument: Maybe<Scalars['String']>;
  /**  Indicates which root field to use to get the list  */
  rootListField: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphListingClinicsByArea = {
  _original_typename: Scalars['String'];
  argument: Maybe<Scalars['String']>;
  /**  Indicates which root field to use to get the list  */
  rootListField: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphListingDiseaseFromLocation = {
  _original_typename: Scalars['String'];
  diseaseList: Maybe<Array<Maybe<ContentDisease>>>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphListingDiseaseSearchSource = {
  _original_typename: Scalars['String'];
  /**  Indicates which root field to use to get the list  */
  rootListField: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphListingEventsEmbed = {
  _original_typename: Scalars['String'];
  argument: Maybe<Scalars['String']>;
  cta: Link;
  /**  Indicates which root field to use to get the list  */
  rootListField: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphListingEventsEmbedByDepartment = {
  _original_typename: Scalars['String'];
  argument: Maybe<Scalars['String']>;
  cta: Link;
  /**  Indicates which root field to use to get the list  */
  rootListField: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphListingEventsEmbedByTypeAndDepartment = {
  _original_typename: Scalars['String'];
  argument: Maybe<Scalars['String']>;
  cta: Link;
  /**  Indicates which root field to use to get the list  */
  rootListField: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphListingJobList = {
  _original_typename: Scalars['String'];
  keyword: Maybe<Scalars['String']>;
  location: Maybe<Array<Scalars['String']>>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphListingJobToolSearch = {
  _original_typename: Scalars['String'];
  argument: Maybe<Scalars['String']>;
  jobFilters: ListingJobToolSearchFilters;
  /**  Indicates which root field to use to get the list  */
  rootListField: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphListingLocationByTreatmentOffer = {
  _original_typename: Scalars['String'];
  argument: Maybe<Scalars['String']>;
  /**  Indicates which root field to use to get the list  */
  rootListField: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphListingMedicineNews = {
  _original_typename: Scalars['String'];
  argument: Maybe<Scalars['String']>;
  medicineFilters: Maybe<ListingMedicineNewsFilters>;
  /**  Indicates which root field to use to get the list  */
  rootListField: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphListingNewsroomFiltered = {
  _original_typename: Scalars['String'];
  argument: Maybe<Scalars['String']>;
  exposedFilters: Array<Maybe<ViewExposedFilters>>;
  /**  Indicates which root field to use to get the list  */
  rootListField: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphListingNewsroomFrontpage = {
  _original_typename: Scalars['String'];
  argument: Maybe<Scalars['String']>;
  /**  Indicates which root field to use to get the list  */
  rootListField: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphListingNewsroomPersonnelBlock = {
  _original_typename: Scalars['String'];
  argument: Maybe<Scalars['String']>;
  /**  Indicates which root field to use to get the list  */
  rootListField: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphListingNewsroomResearch = {
  _original_typename: Scalars['String'];
  argument: Maybe<Scalars['String']>;
  /**  Indicates which root field to use to get the list  */
  rootListField: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphListingNewsroomTreatment = {
  _original_typename: Scalars['String'];
  argument: Maybe<Scalars['String']>;
  /**  Indicates which root field to use to get the list  */
  rootListField: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphListingSpecialists = {
  _original_typename: Scalars['String'];
  argument: Maybe<Scalars['String']>;
  /**  Indicates which root field to use to get the list  */
  rootListField: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphLiterature = ParagraphLiteratureLinks | ParagraphLiteraturePdfs | ParagraphLiteratureText;

export type ParagraphLiteratureLinks = {
  _original_typename: Scalars['String'];
  refLinks: Maybe<Array<Maybe<LiteratureLinks>>>;
  uuid: Scalars['String'];
};

export type ParagraphLiteraturePdfs = {
  _original_typename: Scalars['String'];
  pdfs: Maybe<Array<Maybe<MediaLabCardPdf>>>;
  uuid: Scalars['String'];
};

export type ParagraphLiteratureText = {
  _original_typename: Scalars['String'];
  textHtml: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type ParagraphLogoCloud = {
  _original_typename: Scalars['String'];
  logoImages: Maybe<Array<Maybe<ParagraphLogoCloudImage>>>;
};

export type ParagraphLogoCloudImage = {
  _original_typename: Scalars['String'];
  image: Maybe<MediaImage>;
  link: Maybe<Link>;
};

export type ParagraphMegaTeasers = {
  _original_typename: Scalars['String'];
  teasers: Array<Maybe<ParagraphTeaserNullable>>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphNewsTeaser = {
  _original_typename: Scalars['String'];
  newsContent: Maybe<ContentNews>;
};

export type ParagraphPreAnalyticData = {
  _original_typename: Scalars['String'];
  containerImage: Maybe<MediaLabCardContainer>;
  furtherRemarksHtml: Maybe<Scalars['String']>;
  materialAmountHtml: Maybe<Scalars['String']>;
  minimumVolumeHtml: Maybe<Scalars['String']>;
  patientType: Scalars['String'];
  sampleMaterial: Maybe<Array<Maybe<TermSampleMaterial>>>;
  uuid: Scalars['String'];
};

export type ParagraphQuote = {
  _original_typename: Scalars['String'];
  author: Maybe<Scalars['String']>;
  quote: Scalars['String'];
};

export type ParagraphSiteSearch = {
  _original_typename: Scalars['String'];
  placeholderText: Maybe<Scalars['String']>;
};

export type ParagraphSpacer = {
  _original_typename: Scalars['String'];
  desktopOnly: Scalars['Boolean'];
  withoutBorder: Scalars['Boolean'];
};

export type ParagraphSpecialistsSlider = {
  _original_typename: Scalars['String'];
  specialists: Array<Maybe<ContentSpecialist>>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphStaticCampaignMonitorSubscribeForm = {
  _original_typename: Scalars['String'];
  title: Maybe<Scalars['String']>;
};

export type ParagraphStaticWallsBlock = {
  _original_typename: Scalars['String'];
  title: Maybe<Scalars['String']>;
};

export type ParagraphTeaser = {
  _original_typename: Scalars['String'];
  image: Maybe<MediaImage>;
  lead: Maybe<Scalars['String']>;
  link: Maybe<Link>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphTeaserNullable = ParagraphEmpty | ParagraphTeaser;

export type ParagraphTeasers = {
  _original_typename: Scalars['String'];
  display: Maybe<ParagraphTeasersDisplay>;
  teasers: Array<Maybe<ParagraphTeaserNullable>>;
  title: Maybe<Scalars['String']>;
};

export enum ParagraphTeasersDisplay {
  Carousel = 'carousel',
  Grid = 'grid'
}

export type ParagraphTestimonialSlider = {
  _original_typename: Scalars['String'];
  testimonial: Array<Maybe<ContentTestimonial>>;
  title: Maybe<Scalars['String']>;
};

export type ParagraphTile = {
  _original_typename: Scalars['String'];
  text: Scalars['String'];
  url: Scalars['String'];
};

export type ParagraphTileNullable = ParagraphEmpty | ParagraphTile;

export type ParagraphTiles = {
  _original_typename: Scalars['String'];
  tiles: Array<Maybe<ParagraphTileNullable>>;
};

export type ParagraphTimeline = {
  _original_typename: Scalars['String'];
  groups: Array<Maybe<ParagraphTimelineGroupNullable>>;
};

export type ParagraphTimelineElement = {
  _original_typename: Scalars['String'];
  anchorLabel: Scalars['String'];
  body: Array<Maybe<ParagraphTimelineElementItems>>;
  elementTitle: Scalars['String'];
};

export type ParagraphTimelineElementItems = ParagraphEmpty | ParagraphImageCarousel | ParagraphImageWithCaption | ParagraphQuote | ParagraphVideo | ParagraphWysiwygContent | ParagraphYoutubeEmbed;

export type ParagraphTimelineElementNullable = ParagraphEmpty | ParagraphTimelineElement;

export type ParagraphTimelineGroup = {
  _original_typename: Scalars['String'];
  elements: Array<Maybe<ParagraphTimelineElementNullable>>;
  groupTitle: Maybe<Scalars['String']>;
};

export type ParagraphTimelineGroupNullable = ParagraphEmpty | ParagraphTimelineGroup;

export type ParagraphVideo = {
  _original_typename: Scalars['String'];
  image: Maybe<MediaImage>;
  video: Maybe<MediaVideo>;
};

export type ParagraphWysiwygContent = {
  _original_typename: Scalars['String'];
  textHtml: Maybe<Scalars['String']>;
};

export type ParagraphYoutubeEmbed = {
  _original_typename: Scalars['String'];
  embed: Link;
};

export type PlaylistBabies = {
  _original_typename: Scalars['String'];
  babies: Maybe<Array<Maybe<ContentBaby>>>;
};

export type PlaylistContent = PlaylistBabies | PlaylistEvents | PlaylistSlides;

export type PlaylistEvents = {
  _original_typename: Scalars['String'];
  events: Maybe<Array<Maybe<ContentEvent>>>;
};

export type PlaylistSlides = {
  _original_typename: Scalars['String'];
  slides: Maybe<Array<Maybe<DsSlide>>>;
};

export type Query = {
  _original_typename: Scalars['String'];
  currentUser: User;
  drupalBuildId: Scalars['Int'];
  drupalFeedInfo: Array<Feed>;
  drupalSettings: DrupalSettings;
  listingAllocation: ListingResultContentPage;
  listingClinicsByArea: ListingResultContentLocation;
  listingDiseaseSearchSource: ListingResultContentDisease;
  listingEventsEmbed: ListingResultContentEvent;
  listingEventsEmbedByDepartment: ListingResultContentEvent;
  listingEventsEmbedByTypeAndDepartment: ListingResultContentEvent;
  listingJobToolSearch: ListingResultContentJob;
  listingLocationByTreatmentOffer: ListingResultContentLocation;
  listingLocationNews: ListingResultContentNews;
  listingMedicineNews: ListingResultContentMedicineNews;
  listingNewsroomDisease: ListingResultContentNews;
  listingNewsroomFiltered: ListingResultContentNews;
  listingNewsroomFrontpage: ListingResultContentNews;
  listingNewsroomLocation: ListingResultContentNews;
  listingNewsroomMediaReleases: ListingResultContentNews;
  listingNewsroomMediaReviews: ListingResultContentNews;
  listingNewsroomOverview: ListingResultContentNews;
  listingNewsroomPersonnel: ListingResultContentNews;
  listingNewsroomPersonnelBlock: ListingResultContentNews;
  listingNewsroomResearch: ListingResultContentNews;
  listingNewsroomSpecialist: ListingResultContentNews;
  listingNewsroomTreatment: ListingResultContentNews;
  listingPressRelease: ListingResultContentNews;
  listingRelatedNews: ListingResultContentNews;
  listingSpecialists: ListingSpecialistsResult;
  loadContentAdvert: Maybe<ContentAdvert>;
  loadContentAdvertCollection: Maybe<ContentAdvertCollection>;
  loadContentAdvertCollectionRevision: Maybe<ContentAdvertCollection>;
  loadContentAdvertRevision: Maybe<ContentAdvert>;
  loadContentAnalysis: Maybe<ContentAnalysis>;
  loadContentAnalysisRevision: Maybe<ContentAnalysis>;
  loadContentBaby: Maybe<ContentBaby>;
  loadContentBabyRevision: Maybe<ContentBaby>;
  loadContentBirthdayFact: Maybe<ContentBirthdayFact>;
  loadContentBirthdayFactRevision: Maybe<ContentBirthdayFact>;
  loadContentDisease: Maybe<ContentDisease>;
  loadContentDiseaseRevision: Maybe<ContentDisease>;
  loadContentDocumentationPage: Maybe<ContentDocumentationPage>;
  loadContentDocumentationPageRevision: Maybe<ContentDocumentationPage>;
  loadContentEvent: Maybe<ContentEvent>;
  loadContentEventRevision: Maybe<ContentEvent>;
  loadContentJob: Maybe<ContentJob>;
  loadContentJobRevision: Maybe<ContentJob>;
  loadContentKitchenSink: Maybe<ContentKitchenSink>;
  loadContentKitchenSinkRevision: Maybe<ContentKitchenSink>;
  loadContentLandingPage: Maybe<ContentLandingPage>;
  loadContentLandingPageRevision: Maybe<ContentLandingPage>;
  loadContentLocation: Maybe<ContentLocation>;
  loadContentLocationContact: Maybe<ContentLocationContact>;
  loadContentLocationContactRevision: Maybe<ContentLocationContact>;
  loadContentLocationRevision: Maybe<ContentLocation>;
  loadContentMedicineNews: Maybe<ContentMedicineNews>;
  loadContentMedicineNewsRevision: Maybe<ContentMedicineNews>;
  loadContentNews: Maybe<ContentNews>;
  loadContentNewsRevision: Maybe<ContentNews>;
  loadContentPage: Maybe<ContentPage>;
  loadContentPageRevision: Maybe<ContentPage>;
  loadContentPatientInformation: Maybe<ContentPatientInformation>;
  loadContentPatientInformationRevision: Maybe<ContentPatientInformation>;
  loadContentScreen: Maybe<ContentScreen>;
  loadContentScreenRevision: Maybe<ContentScreen>;
  loadContentSpecialist: Maybe<ContentSpecialist>;
  loadContentSpecialistRevision: Maybe<ContentSpecialist>;
  loadContentTeam: Maybe<ContentTeam>;
  loadContentTeamRevision: Maybe<ContentTeam>;
  loadContentTestimonial: Maybe<ContentTestimonial>;
  loadContentTestimonialRevision: Maybe<ContentTestimonial>;
  loadDsLoop: Maybe<DsLoop>;
  loadDsLoopNoAccessCheck: Maybe<DsLoop>;
  loadDsLoopRevision: Maybe<DsLoop>;
  loadDsPlaylist: Maybe<DsPlaylist>;
  loadDsPlaylistRevision: Maybe<DsPlaylist>;
  loadDsSlide: Maybe<DsSlide>;
  loadDsSlideRevision: Maybe<DsSlide>;
  loadGroupDocumentation: Maybe<GroupDocumentation>;
  loadGroupDocumentationRevision: Maybe<GroupDocumentation>;
  loadMediaImage: Maybe<MediaImage>;
  loadMediaImageRevision: Maybe<MediaImage>;
  loadMediaLabCardContainer: Maybe<MediaLabCardContainer>;
  loadMediaLabCardContainerRevision: Maybe<MediaLabCardContainer>;
  loadMediaLabCardPdf: Maybe<MediaLabCardPdf>;
  loadMediaLabCardPdfRevision: Maybe<MediaLabCardPdf>;
  loadMediaVideoLocal: Maybe<MediaVideoLocal>;
  loadMediaVideoLocalRevision: Maybe<MediaVideoLocal>;
  loadMediaVideoRemote: Maybe<MediaVideoRemote>;
  loadMediaVideoRemoteRevision: Maybe<MediaVideoRemote>;
  loadMenuFooter: Maybe<MenuFooter>;
  loadMenuLegal: Maybe<MenuLegal>;
  loadMenuMain: Maybe<MenuMain>;
  loadMenuMeta: Maybe<MenuMeta>;
  loadMenuNewsroom: Maybe<MenuNewsroom>;
  loadSettingsChildrenHospitalTheme: Maybe<SettingsChildrenHospitalTheme>;
  loadSettingsChildrenHospitalThemeRevision: Maybe<SettingsChildrenHospitalTheme>;
  loadSettingsDigitalSignage: Maybe<SettingsDigitalSignage>;
  loadSettingsDigitalSignageRevision: Maybe<SettingsDigitalSignage>;
  loadSettingsNewsletterForm: Maybe<SettingsNewsletterForm>;
  loadSettingsNewsletterFormRevision: Maybe<SettingsNewsletterForm>;
  loadTermAdministrativeArea: Maybe<TermAdministrativeArea>;
  loadTermAdministrativeAreaRevision: Maybe<TermAdministrativeArea>;
  loadTermConstruction: Maybe<TermConstruction>;
  loadTermConstructionRevision: Maybe<TermConstruction>;
  loadTermExpertise: Maybe<TermExpertise>;
  loadTermExpertiseRevision: Maybe<TermExpertise>;
  loadTermJobArea: Maybe<TermJobArea>;
  loadTermJobAreaRevision: Maybe<TermJobArea>;
  loadTermJobFunction: Maybe<TermJobFunction>;
  loadTermJobFunctionRevision: Maybe<TermJobFunction>;
  loadTermKnowledge: Maybe<TermKnowledge>;
  loadTermKnowledgeRevision: Maybe<TermKnowledge>;
  loadTermLabContact: Maybe<TermLabContact>;
  loadTermLabContactRevision: Maybe<TermLabContact>;
  loadTermLocationType: Maybe<TermLocationType>;
  loadTermLocationTypeRevision: Maybe<TermLocationType>;
  loadTermSampleMaterial: Maybe<TermSampleMaterial>;
  loadTermSampleMaterialRevision: Maybe<TermSampleMaterial>;
  loadTermSpecialityArea: Maybe<TermSpecialityArea>;
  loadTermSpecialityAreaRevision: Maybe<TermSpecialityArea>;
  loadTermSpokenLanguage: Maybe<TermSpokenLanguage>;
  loadTermSpokenLanguageRevision: Maybe<TermSpokenLanguage>;
  loadTermStrategy: Maybe<TermStrategy>;
  loadTermStrategyRevision: Maybe<TermStrategy>;
  loadTermTaxposition: Maybe<TermTaxposition>;
  loadTermTaxpositionRevision: Maybe<TermTaxposition>;
  loadTermTreatmentArea: Maybe<TermTreatmentArea>;
  loadTermTreatmentAreaRevision: Maybe<TermTreatmentArea>;
  queryContentAdvertCollections: Array<Maybe<ContentAdvertCollection>>;
  queryContentAdverts: Array<Maybe<ContentAdvert>>;
  queryContentAnalysiss: Array<Maybe<ContentAnalysis>>;
  queryContentBabys: Array<Maybe<ContentBaby>>;
  queryContentBirthdayFacts: Array<Maybe<ContentBirthdayFact>>;
  queryContentDiseases: Array<Maybe<ContentDisease>>;
  queryContentDocumentationPages: Array<Maybe<ContentDocumentationPage>>;
  queryContentEvents: Array<Maybe<ContentEvent>>;
  queryContentJobs: Array<Maybe<ContentJob>>;
  queryContentKitchenSinks: Array<Maybe<ContentKitchenSink>>;
  queryContentLandingPages: Array<Maybe<ContentLandingPage>>;
  queryContentLocationContacts: Array<Maybe<ContentLocationContact>>;
  queryContentLocations: Array<Maybe<ContentLocation>>;
  queryContentMedicineNewss: Array<Maybe<ContentMedicineNews>>;
  queryContentNewss: Array<Maybe<ContentNews>>;
  queryContentPages: Array<Maybe<ContentPage>>;
  queryContentPatientInformations: Array<Maybe<ContentPatientInformation>>;
  queryContentScreens: Array<Maybe<ContentScreen>>;
  queryContentSpecialists: Array<Maybe<ContentSpecialist>>;
  queryContentTeams: Array<Maybe<ContentTeam>>;
  queryContentTestimonials: Array<Maybe<ContentTestimonial>>;
  queryDsLoopNoAccessCheck: Array<Maybe<DsLoop>>;
  queryDsLoops: Array<Maybe<DsLoop>>;
  queryDsPlaylists: Array<Maybe<DsPlaylist>>;
  queryDsSlides: Array<Maybe<DsSlide>>;
  queryGroupDocumentations: Array<Maybe<GroupDocumentation>>;
  queryMediaImages: Array<Maybe<MediaImage>>;
  queryMediaLabCardContainers: Array<Maybe<MediaLabCardContainer>>;
  queryMediaLabCardPdfs: Array<Maybe<MediaLabCardPdf>>;
  queryMediaVideoLocals: Array<Maybe<MediaVideoLocal>>;
  queryMediaVideoRemotes: Array<Maybe<MediaVideoRemote>>;
  queryMenuFooters: Array<Maybe<MenuFooter>>;
  queryMenuLegals: Array<Maybe<MenuLegal>>;
  queryMenuMains: Array<Maybe<MenuMain>>;
  queryMenuMetas: Array<Maybe<MenuMeta>>;
  queryMenuNewsrooms: Array<Maybe<MenuNewsroom>>;
  querySettingsChildrenHospitalThemes: Array<Maybe<SettingsChildrenHospitalTheme>>;
  querySettingsDigitalSignages: Array<Maybe<SettingsDigitalSignage>>;
  querySettingsNewsletterForms: Array<Maybe<SettingsNewsletterForm>>;
  queryTermAdministrativeAreas: Array<Maybe<TermAdministrativeArea>>;
  queryTermConstructions: Array<Maybe<TermConstruction>>;
  queryTermExpertises: Array<Maybe<TermExpertise>>;
  queryTermJobAreas: Array<Maybe<TermJobArea>>;
  queryTermJobFunctions: Array<Maybe<TermJobFunction>>;
  queryTermKnowledges: Array<Maybe<TermKnowledge>>;
  queryTermLabContacts: Array<Maybe<TermLabContact>>;
  queryTermLocationTypes: Array<Maybe<TermLocationType>>;
  queryTermSampleMaterials: Array<Maybe<TermSampleMaterial>>;
  queryTermSpecialityAreas: Array<Maybe<TermSpecialityArea>>;
  queryTermSpokenLanguages: Array<Maybe<TermSpokenLanguage>>;
  queryTermStrategys: Array<Maybe<TermStrategy>>;
  queryTermTaxpositions: Array<Maybe<TermTaxposition>>;
  queryTermTreatmentAreas: Array<Maybe<TermTreatmentArea>>;
  searchBabies: SearchBabiesResult;
  searchDocumentationPages: SearchDocumentationPagesResult;
  searchEvents: SearchEventsResult;
};


export type QueryListingAllocationArgs = {
  argument: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingClinicsByAreaArgs = {
  argument: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingDiseaseSearchSourceArgs = {
  argument: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingEventsEmbedArgs = {
  argument: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingEventsEmbedByDepartmentArgs = {
  argument: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingEventsEmbedByTypeAndDepartmentArgs = {
  argument: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingJobToolSearchArgs = {
  argument: InputMaybe<Scalars['String']>;
  filters: InputMaybe<ListingJobToolSearchFiltersInput>;
  pagination: PaginationInput;
};


export type QueryListingLocationByTreatmentOfferArgs = {
  argument: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingLocationNewsArgs = {
  argument: Scalars['String'];
  pagination: PaginationInput;
};


export type QueryListingMedicineNewsArgs = {
  argument: InputMaybe<Scalars['String']>;
  filters: InputMaybe<ListingMedicineNewsFiltersInput>;
  pagination: PaginationInput;
};


export type QueryListingNewsroomDiseaseArgs = {
  argument: Scalars['String'];
  pagination: PaginationInput;
};


export type QueryListingNewsroomFilteredArgs = {
  argument: InputMaybe<Scalars['String']>;
  filters: InputMaybe<Array<InputMaybe<DynamicExposedFiltersInput>>>;
  pagination: PaginationInput;
};


export type QueryListingNewsroomFrontpageArgs = {
  argument: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingNewsroomLocationArgs = {
  argument: Scalars['String'];
  pagination: PaginationInput;
};


export type QueryListingNewsroomMediaReleasesArgs = {
  argument: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingNewsroomMediaReviewsArgs = {
  argument: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingNewsroomOverviewArgs = {
  argument: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingNewsroomPersonnelArgs = {
  argument: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingNewsroomPersonnelBlockArgs = {
  argument: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingNewsroomResearchArgs = {
  argument: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingNewsroomSpecialistArgs = {
  argument: Scalars['String'];
  pagination: PaginationInput;
};


export type QueryListingNewsroomTreatmentArgs = {
  argument: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingPressReleaseArgs = {
  argument: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingRelatedNewsArgs = {
  argument: Scalars['String'];
  pagination: PaginationInput;
};


export type QueryListingSpecialistsArgs = {
  argument: InputMaybe<Scalars['String']>;
  filters: InputMaybe<ListingSpecialistsFiltersInput>;
  pagination: PaginationInput;
};


export type QueryLoadContentAdvertArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentAdvertCollectionArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentAdvertCollectionRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentAdvertRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentAnalysisArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentAnalysisRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentBabyArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentBabyRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentBirthdayFactArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentBirthdayFactRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentDiseaseArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentDiseaseRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentDocumentationPageArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentDocumentationPageRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentEventArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentEventRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentJobArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentJobRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentKitchenSinkArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentKitchenSinkRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentLandingPageArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentLandingPageRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentLocationArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentLocationContactArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentLocationContactRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentLocationRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentMedicineNewsArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentMedicineNewsRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentNewsArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentNewsRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentPageArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentPageRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentPatientInformationArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentPatientInformationRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentScreenArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentScreenRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentSpecialistArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentSpecialistRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentTeamArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentTeamRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentTestimonialArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentTestimonialRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadDsLoopArgs = {
  id: Scalars['String'];
};


export type QueryLoadDsLoopNoAccessCheckArgs = {
  uuid: Scalars['String'];
};


export type QueryLoadDsLoopRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadDsPlaylistArgs = {
  id: Scalars['String'];
};


export type QueryLoadDsPlaylistRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadDsSlideArgs = {
  id: Scalars['String'];
};


export type QueryLoadDsSlideRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadGroupDocumentationArgs = {
  id: Scalars['String'];
};


export type QueryLoadGroupDocumentationRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadMediaImageArgs = {
  id: Scalars['String'];
};


export type QueryLoadMediaImageRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadMediaLabCardContainerArgs = {
  id: Scalars['String'];
};


export type QueryLoadMediaLabCardContainerRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadMediaLabCardPdfArgs = {
  id: Scalars['String'];
};


export type QueryLoadMediaLabCardPdfRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadMediaVideoLocalArgs = {
  id: Scalars['String'];
};


export type QueryLoadMediaVideoLocalRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadMediaVideoRemoteArgs = {
  id: Scalars['String'];
};


export type QueryLoadMediaVideoRemoteRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadMenuFooterArgs = {
  id: Scalars['String'];
};


export type QueryLoadMenuLegalArgs = {
  id: Scalars['String'];
};


export type QueryLoadMenuMainArgs = {
  id: Scalars['String'];
};


export type QueryLoadMenuMetaArgs = {
  id: Scalars['String'];
};


export type QueryLoadMenuNewsroomArgs = {
  id: Scalars['String'];
};


export type QueryLoadSettingsChildrenHospitalThemeArgs = {
  id: Scalars['String'];
};


export type QueryLoadSettingsChildrenHospitalThemeRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadSettingsDigitalSignageArgs = {
  id: Scalars['String'];
};


export type QueryLoadSettingsDigitalSignageRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadSettingsNewsletterFormArgs = {
  id: Scalars['String'];
};


export type QueryLoadSettingsNewsletterFormRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermAdministrativeAreaArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermAdministrativeAreaRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermConstructionArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermConstructionRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermExpertiseArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermExpertiseRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermJobAreaArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermJobAreaRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermJobFunctionArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermJobFunctionRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermKnowledgeArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermKnowledgeRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermLabContactArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermLabContactRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermLocationTypeArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermLocationTypeRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermSampleMaterialArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermSampleMaterialRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermSpecialityAreaArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermSpecialityAreaRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermSpokenLanguageArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermSpokenLanguageRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermStrategyArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermStrategyRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermTaxpositionArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermTaxpositionRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermTreatmentAreaArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermTreatmentAreaRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryQueryContentAdvertCollectionsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentAdvertsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentAnalysissArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentBabysArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentBirthdayFactsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentDiseasesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentDocumentationPagesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentEventsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentJobsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentKitchenSinksArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentLandingPagesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentLocationContactsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentLocationsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentMedicineNewssArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentNewssArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentPagesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentPatientInformationsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentScreensArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentSpecialistsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentTeamsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentTestimonialsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryDsLoopsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryDsPlaylistsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryDsSlidesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryGroupDocumentationsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryMediaImagesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryMediaLabCardContainersArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryMediaLabCardPdfsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryMediaVideoLocalsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryMediaVideoRemotesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryMenuFootersArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryMenuLegalsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryMenuMainsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryMenuMetasArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryMenuNewsroomsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQuerySettingsChildrenHospitalThemesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQuerySettingsDigitalSignagesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQuerySettingsNewsletterFormsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermAdministrativeAreasArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermConstructionsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermExpertisesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermJobAreasArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermJobFunctionsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermKnowledgesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermLabContactsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermLocationTypesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermSampleMaterialsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermSpecialityAreasArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermSpokenLanguagesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermStrategysArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermTaxpositionsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermTreatmentAreasArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QuerySearchBabiesArgs = {
  filters: InputMaybe<SearchBabiesFiltersInput>;
  pagination: PaginationInput;
};


export type QuerySearchDocumentationPagesArgs = {
  groupId: Scalars['String'];
  pagination: PaginationInput;
  query: InputMaybe<Scalars['String']>;
};


export type QuerySearchEventsArgs = {
  filters: InputMaybe<SearchEventsFiltersInput>;
  pagination: PaginationInput;
};

export type ScreenInfo = {
  _original_typename: Scalars['String'];
  datetimeFrom: Maybe<Scalars['String']>;
  datetimeTo: Maybe<Scalars['String']>;
  image: Maybe<MediaImage>;
  room: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type SearchBabiesFilters = {
  _original_typename: Scalars['String'];
  gender: Array<Item>;
  location: Array<Item>;
};

export type SearchBabiesFiltersInput = {
  date: InputMaybe<Scalars['String']>;
  gender: InputMaybe<Scalars['String']>;
  location: InputMaybe<Scalars['String']>;
  title: InputMaybe<Scalars['String']>;
};

export type SearchBabiesResult = {
  _original_typename: Scalars['String'];
  items: Array<ContentBaby>;
  total: Scalars['Int'];
};

export type SearchDocumentationPagesResult = {
  _original_typename: Scalars['String'];
  items: Array<SearchDocumentationPagesResultItem>;
  total: Scalars['Int'];
};

export type SearchDocumentationPagesResultItem = {
  _original_typename: Scalars['String'];
  excerptHtml: Scalars['String'];
  path: Scalars['String'];
  title: Scalars['String'];
};

export type SearchEventsFilters = {
  _original_typename: Scalars['String'];
  location: Array<Item>;
  type: Array<ItemWithParent>;
};

export type SearchEventsFiltersInput = {
  date: InputMaybe<Scalars['String']>;
  location: InputMaybe<Scalars['String']>;
  title: InputMaybe<Scalars['String']>;
  type: InputMaybe<Scalars['String']>;
};

export type SearchEventsResult = {
  _original_typename: Scalars['String'];
  items: Array<ContentEvent>;
  total: Scalars['Int'];
};

export type Secretary = {
  _original_typename: Scalars['String'];
  email: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type SettingsChildrenHospitalTheme = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  paths: Maybe<Scalars['String']>;
};

export type SettingsDigitalSignage = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  durationBabies: Scalars['Int'];
  durationEvents: Scalars['Int'];
  durationFullScreen: Scalars['Int'];
  durationHealthTip: Scalars['Int'];
  durationHistory: Scalars['Int'];
  durationInstagram: Scalars['Int'];
  durationQuiz: Scalars['Int'];
  durationQuizAnswerReveal: Scalars['Int'];
  durationSimple: Scalars['Int'];
  id: Scalars['String'];
  uuid: Scalars['String'];
};

export type SettingsNewsletterForm = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  imageForm: Maybe<MediaImage>;
  imageThankYouPage: Maybe<MediaImage>;
};

export type SpecialistContactInfo = {
  _original_typename: Scalars['String'];
  label: Scalars['String'];
  value: Scalars['String'];
};

export type TermAdministrativeArea = {
  _original_typename: Scalars['String'];
  areaIdentifier: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type TermConstruction = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  referenceNode: Maybe<AllContent>;
  title: Scalars['String'];
};

export type TermExpertise = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type TermJobArea = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type TermJobFunction = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type TermKnowledge = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  referenceNode: Maybe<AllContent>;
  title: Scalars['String'];
};

export type TermLabContact = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  internalLab: Maybe<Scalars['Boolean']>;
  labContact: Scalars['String'];
  telephoneNumber: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type TermLocationType = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type TermSampleMaterial = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
  uuid: Scalars['String'];
};

export type TermSpecialityArea = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
  uuid: Scalars['String'];
};

export type TermSpokenLanguage = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type TermStrategy = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  referenceNode: Maybe<AllContent>;
  title: Scalars['String'];
};

export type TermTaxposition = {
  _original_typename: Scalars['String'];
  description: Maybe<Scalars['String']>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  taxpoints: Maybe<Scalars['String']>;
  taxposition: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type TermTreatmentArea = {
  _original_typename: Scalars['String'];
  descriptionHtml: Maybe<Scalars['String']>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  showParagraphs: Maybe<Scalars['Boolean']>;
  termParagraph: Array<AllParagraphs>;
  title: Scalars['String'];
};

export type User = {
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export type ViewExposedFilters = {
  _original_typename: Scalars['String'];
  filter: Scalars['String'];
  value: Scalars['String'];
};

export type AdvertFragment = (
  Pick<ContentAdvert, 'id' | 'title' | 'text' | 'textAlignment' | 'buttonPlacement'>
  & { image: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )>, link: Pick<LinkWithText, 'url' | 'text'> }
);

export type AdvertCollectionFragment = (
  Pick<ContentAdvertCollection, 'frequency' | 'positioning' | 'repetitions'>
  & { collection: Array<Maybe<(
    Pick<ContentAdvert, 'id' | 'title' | 'text' | 'textAlignment' | 'buttonPlacement'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, link: Pick<LinkWithText, 'url' | 'text'> }
  )>> }
);

type AllContent_ContentBaby_Fragment = Pick<ContentBaby, 'title' | 'path'>;

type AllContent_ContentDisease_Fragment = Pick<ContentDisease, 'title' | 'path'>;

type AllContent_ContentDocumentationPage_Fragment = Pick<ContentDocumentationPage, 'title' | 'path'>;

type AllContent_ContentEvent_Fragment = Pick<ContentEvent, 'title' | 'path'>;

type AllContent_ContentKitchenSink_Fragment = Pick<ContentKitchenSink, 'title' | 'path'>;

type AllContent_ContentLandingPage_Fragment = Pick<ContentLandingPage, 'title' | 'path'>;

type AllContent_ContentLocation_Fragment = Pick<ContentLocation, 'title' | 'path'>;

type AllContent_ContentLocationContact_Fragment = Pick<ContentLocationContact, 'title' | 'path'>;

type AllContent_ContentNews_Fragment = Pick<ContentNews, 'title' | 'path'>;

type AllContent_ContentPage_Fragment = Pick<ContentPage, 'title' | 'path'>;

type AllContent_ContentPatientInformation_Fragment = Pick<ContentPatientInformation, 'title' | 'path'>;

type AllContent_ContentSpecialist_Fragment = Pick<ContentSpecialist, 'title' | 'path'>;

type AllContent_ContentTeam_Fragment = Pick<ContentTeam, 'title' | 'path'>;

type AllContent_GroupDocumentation_Fragment = Pick<GroupDocumentation, 'title' | 'path'>;

export type AllContentFragment = AllContent_ContentBaby_Fragment | AllContent_ContentDisease_Fragment | AllContent_ContentDocumentationPage_Fragment | AllContent_ContentEvent_Fragment | AllContent_ContentKitchenSink_Fragment | AllContent_ContentLandingPage_Fragment | AllContent_ContentLocation_Fragment | AllContent_ContentLocationContact_Fragment | AllContent_ContentNews_Fragment | AllContent_ContentPage_Fragment | AllContent_ContentPatientInformation_Fragment | AllContent_ContentSpecialist_Fragment | AllContent_ContentTeam_Fragment | AllContent_GroupDocumentation_Fragment;

export type BreadcrumbItemFragment = Pick<BreadcrumbItem, 'url' | 'text'>;

export type ImageSourceFragment = Pick<ImageSource, 'url' | 'width' | 'height'>;

export type ImageStyleOtherFragment = Pick<ImageStyleOther, 'id' | 'url'>;

export type ImageFragment = (
  { __typename: 'MediaImage' }
  & Pick<MediaImage, 'id' | 'alt'>
  & { styles: Array<(
    Pick<ImageStyle, 'id'>
    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
);

export type LocationHeaderFragment = { location: Maybe<(
    Pick<ContentLocation, 'path' | 'title' | 'subtitle'>
    & { contact: Maybe<Pick<ContentLocationContact, 'path'>> }
  )>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>> };

export type LabCardContainerFragment = (
  Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
  & { styles: Array<(
    Pick<ImageStyle, 'id'>
    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
  )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
);

export type LabCardPdfFragment = Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>;

export type MetatagsFragment = (
  Pick<MetaTag, 'tag'>
  & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
);

export type AnalysisPageFragment = (
  Pick<ContentAnalysis, 'drupalId' | 'analysisName' | 'analysisExternal' | 'synonymsKeyWords' | 'clinicIndicationHtml' | 'sampleStabilityStorageHtml' | 'subsequentRegulationHtml' | 'interferenceFactorsHtml' | 'methodHtml' | 'unit' | 'conversionFactorHtml' | 'referenceRangesHtml' | 'analysisFrequency' | 'interpretationHtml' | 'notesInternalHtml'>
  & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, metaTags: Maybe<Array<Maybe<(
    Pick<MetaTag, 'tag'>
    & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
  )>>>, preAnalyticData: Maybe<Array<Maybe<(
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  )>>>, laboratoryContact: Maybe<Array<Maybe<Pick<TermLabContact, 'uuid' | 'labContact' | 'telephoneNumber' | 'internalLab'>>>>, literatureReference: Maybe<Array<Maybe<(
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  )>>>, specialityArea: Maybe<Array<Maybe<Pick<TermSpecialityArea, 'uuid' | 'title'>>>>, links: Maybe<Array<Maybe<Pick<LinkWithText, 'text' | 'url'>>>>, taxposition: Maybe<Array<Maybe<Pick<TermTaxposition, 'taxposition' | 'taxpoints' | 'description'>>>> }
);

export type BabyPageFragment = (
  Pick<ContentBaby, 'title' | 'dateOfBirth' | 'gender' | 'weight' | 'height' | 'createdTimestamp' | 'gtmData'>
  & { location: Maybe<(
    Pick<ContentLocation, 'title' | 'path'>
    & { area: Maybe<Pick<TermAdministrativeArea, 'title'>> }
  )>, image: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )>, metaTags: Maybe<Array<Maybe<(
    Pick<MetaTag, 'tag'>
    & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
  )>>> }
);

export type BasicPageFragment = (
  Pick<ContentPage, 'title' | 'description'>
  & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, locationHeader: { location: Maybe<(
      Pick<ContentLocation, 'path' | 'title' | 'subtitle'>
      & { contact: Maybe<Pick<ContentLocationContact, 'path'>> }
    )>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>> }, body: Array<Maybe<(
    { __typename: 'ParagraphAccordion' }
    & { accordionElements: Array<(
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    )> }
  ) | (
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphAnchor' }
    & Pick<ParagraphAnchor, 'anchorLink'>
  ) | (
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumbers' }
    & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
    & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumberRange' }
      & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphBabiesSearch' }
    & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphCallToAction' }
    & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
    & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualEvent' }
    & { event: Maybe<(
      Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualText' }
    & Pick<ParagraphContextualText, 'title' | 'textHtml'>
    & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
  ) | (
    { __typename: 'ParagraphDocuments' }
    & Pick<ParagraphDocuments, 'title'>
    & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
  ) | { __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphEventForm' }
    & Pick<ParagraphEventForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphEventsSearch' }
    & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphFileList' }
    & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphForm' }
    & Pick<ParagraphForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphFormattedTextWithTitle' }
    & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphLabCardListing' }
    & Pick<ParagraphLabCardListing, 'title'>
  ) | (
    { __typename: 'ParagraphLinkList' }
    & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  ) | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  ) | (
    { __typename: 'ParagraphListingAllocation' }
    & Pick<ParagraphListingAllocation, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingClinicsByArea' }
    & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingDiseaseFromLocation' }
    & Pick<ParagraphListingDiseaseFromLocation, 'title'>
    & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
  ) | (
    { __typename: 'ParagraphListingDiseaseSearchSource' }
    & Pick<ParagraphListingDiseaseSearchSource, 'title'>
  ) | (
    { __typename: 'ParagraphListingEventsEmbed' }
    & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByDepartment' }
    & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
    & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingJobList' }
    & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
  ) | (
    { __typename: 'ParagraphListingJobToolSearch' }
    & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
    & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
  ) | (
    { __typename: 'ParagraphListingLocationByTreatmentOffer' }
    & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingMedicineNews' }
    & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
    & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFiltered' }
    & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
    & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFrontpage' }
    & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
    & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomResearch' }
    & Pick<ParagraphListingNewsroomResearch, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomTreatment' }
    & Pick<ParagraphListingNewsroomTreatment, 'argument'>
  ) | (
    { __typename: 'ParagraphListingSpecialists' }
    & Pick<ParagraphListingSpecialists, 'title'>
  ) | (
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  ) | (
    { __typename: 'ParagraphLogoCloud' }
    & { logoImages: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphMegaTeasers' }
    & Pick<ParagraphMegaTeasers, 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphNewsTeaser' }
    & { newsContent: Maybe<(
      Pick<ContentNews, 'path' | 'title' | 'date'>
      & { teaserImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphSiteSearch' }
    & Pick<ParagraphSiteSearch, 'placeholderText'>
  ) | (
    { __typename: 'ParagraphSpacer' }
    & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
  ) | (
    { __typename: 'ParagraphSpecialistsSlider' }
    & Pick<ParagraphSpecialistsSlider, 'title'>
    & { specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
    & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
  ) | (
    { __typename: 'ParagraphStaticWallsBlock' }
    & Pick<ParagraphStaticWallsBlock, 'title'>
  ) | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphTeasers' }
    & Pick<ParagraphTeasers, 'display' | 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTestimonialSlider' }
    & Pick<ParagraphTestimonialSlider, 'title'>
    & { testimonial: Array<Maybe<(
      Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  ) | (
    { __typename: 'ParagraphTiles' }
    & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    )>> }
  ) | (
    { __typename: 'ParagraphTimeline' }
    & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>>, sidebar: Array<Maybe<(
    { __typename: 'ParagraphAccordion' }
    & { accordionElements: Array<(
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    )> }
  ) | (
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphAnchor' }
    & Pick<ParagraphAnchor, 'anchorLink'>
  ) | (
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumbers' }
    & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
    & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumberRange' }
      & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphBabiesSearch' }
    & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphCallToAction' }
    & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
    & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualEvent' }
    & { event: Maybe<(
      Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualText' }
    & Pick<ParagraphContextualText, 'title' | 'textHtml'>
    & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
  ) | (
    { __typename: 'ParagraphDocuments' }
    & Pick<ParagraphDocuments, 'title'>
    & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
  ) | { __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphEventForm' }
    & Pick<ParagraphEventForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphEventsSearch' }
    & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphFileList' }
    & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphForm' }
    & Pick<ParagraphForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphFormattedTextWithTitle' }
    & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphLabCardListing' }
    & Pick<ParagraphLabCardListing, 'title'>
  ) | (
    { __typename: 'ParagraphLinkList' }
    & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  ) | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  ) | (
    { __typename: 'ParagraphListingAllocation' }
    & Pick<ParagraphListingAllocation, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingClinicsByArea' }
    & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingDiseaseFromLocation' }
    & Pick<ParagraphListingDiseaseFromLocation, 'title'>
    & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
  ) | (
    { __typename: 'ParagraphListingDiseaseSearchSource' }
    & Pick<ParagraphListingDiseaseSearchSource, 'title'>
  ) | (
    { __typename: 'ParagraphListingEventsEmbed' }
    & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByDepartment' }
    & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
    & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingJobList' }
    & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
  ) | (
    { __typename: 'ParagraphListingJobToolSearch' }
    & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
    & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
  ) | (
    { __typename: 'ParagraphListingLocationByTreatmentOffer' }
    & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingMedicineNews' }
    & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
    & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFiltered' }
    & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
    & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFrontpage' }
    & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
    & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomResearch' }
    & Pick<ParagraphListingNewsroomResearch, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomTreatment' }
    & Pick<ParagraphListingNewsroomTreatment, 'argument'>
  ) | (
    { __typename: 'ParagraphListingSpecialists' }
    & Pick<ParagraphListingSpecialists, 'title'>
  ) | (
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  ) | (
    { __typename: 'ParagraphLogoCloud' }
    & { logoImages: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphMegaTeasers' }
    & Pick<ParagraphMegaTeasers, 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphNewsTeaser' }
    & { newsContent: Maybe<(
      Pick<ContentNews, 'path' | 'title' | 'date'>
      & { teaserImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphSiteSearch' }
    & Pick<ParagraphSiteSearch, 'placeholderText'>
  ) | (
    { __typename: 'ParagraphSpacer' }
    & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
  ) | (
    { __typename: 'ParagraphSpecialistsSlider' }
    & Pick<ParagraphSpecialistsSlider, 'title'>
    & { specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
    & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
  ) | (
    { __typename: 'ParagraphStaticWallsBlock' }
    & Pick<ParagraphStaticWallsBlock, 'title'>
  ) | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphTeasers' }
    & Pick<ParagraphTeasers, 'display' | 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTestimonialSlider' }
    & Pick<ParagraphTestimonialSlider, 'title'>
    & { testimonial: Array<Maybe<(
      Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  ) | (
    { __typename: 'ParagraphTiles' }
    & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    )>> }
  ) | (
    { __typename: 'ParagraphTimeline' }
    & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>>, bottom: Array<Maybe<(
    { __typename: 'ParagraphAccordion' }
    & { accordionElements: Array<(
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    )> }
  ) | (
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphAnchor' }
    & Pick<ParagraphAnchor, 'anchorLink'>
  ) | (
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumbers' }
    & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
    & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumberRange' }
      & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphBabiesSearch' }
    & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphCallToAction' }
    & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
    & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualEvent' }
    & { event: Maybe<(
      Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualText' }
    & Pick<ParagraphContextualText, 'title' | 'textHtml'>
    & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
  ) | (
    { __typename: 'ParagraphDocuments' }
    & Pick<ParagraphDocuments, 'title'>
    & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
  ) | { __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphEventForm' }
    & Pick<ParagraphEventForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphEventsSearch' }
    & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphFileList' }
    & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphForm' }
    & Pick<ParagraphForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphFormattedTextWithTitle' }
    & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphLabCardListing' }
    & Pick<ParagraphLabCardListing, 'title'>
  ) | (
    { __typename: 'ParagraphLinkList' }
    & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  ) | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  ) | (
    { __typename: 'ParagraphListingAllocation' }
    & Pick<ParagraphListingAllocation, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingClinicsByArea' }
    & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingDiseaseFromLocation' }
    & Pick<ParagraphListingDiseaseFromLocation, 'title'>
    & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
  ) | (
    { __typename: 'ParagraphListingDiseaseSearchSource' }
    & Pick<ParagraphListingDiseaseSearchSource, 'title'>
  ) | (
    { __typename: 'ParagraphListingEventsEmbed' }
    & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByDepartment' }
    & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
    & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingJobList' }
    & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
  ) | (
    { __typename: 'ParagraphListingJobToolSearch' }
    & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
    & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
  ) | (
    { __typename: 'ParagraphListingLocationByTreatmentOffer' }
    & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingMedicineNews' }
    & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
    & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFiltered' }
    & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
    & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFrontpage' }
    & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
    & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomResearch' }
    & Pick<ParagraphListingNewsroomResearch, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomTreatment' }
    & Pick<ParagraphListingNewsroomTreatment, 'argument'>
  ) | (
    { __typename: 'ParagraphListingSpecialists' }
    & Pick<ParagraphListingSpecialists, 'title'>
  ) | (
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  ) | (
    { __typename: 'ParagraphLogoCloud' }
    & { logoImages: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphMegaTeasers' }
    & Pick<ParagraphMegaTeasers, 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphNewsTeaser' }
    & { newsContent: Maybe<(
      Pick<ContentNews, 'path' | 'title' | 'date'>
      & { teaserImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphSiteSearch' }
    & Pick<ParagraphSiteSearch, 'placeholderText'>
  ) | (
    { __typename: 'ParagraphSpacer' }
    & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
  ) | (
    { __typename: 'ParagraphSpecialistsSlider' }
    & Pick<ParagraphSpecialistsSlider, 'title'>
    & { specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
    & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
  ) | (
    { __typename: 'ParagraphStaticWallsBlock' }
    & Pick<ParagraphStaticWallsBlock, 'title'>
  ) | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphTeasers' }
    & Pick<ParagraphTeasers, 'display' | 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTestimonialSlider' }
    & Pick<ParagraphTestimonialSlider, 'title'>
    & { testimonial: Array<Maybe<(
      Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  ) | (
    { __typename: 'ParagraphTiles' }
    & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    )>> }
  ) | (
    { __typename: 'ParagraphTimeline' }
    & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>>, metaTags: Maybe<Array<Maybe<(
    Pick<MetaTag, 'tag'>
    & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
  )>>>, translations: Maybe<Array<Maybe<Pick<ContentPage, 'path' | 'translationsLanguageTitle'>>>> }
);

export type DiseasePageFragment = (
  Pick<ContentDisease, 'drupalId' | 'title' | 'shortDescriptionHtml' | 'overviewHtml' | 'causesHtml' | 'symptomsHtml' | 'diagnosisHtml' | 'courseHtml' | 'treatmentHtml' | 'preventionHtml' | 'specialistsTitle' | 'gtmData'>
  & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, faqs: Maybe<{ accordionElements: Array<Pick<ParagraphAccordionElement, 'title' | 'textHtml'>> }>, specialists: Array<Maybe<(
    { __typename: 'ContentSpecialist' }
    & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
    & { imagePortrait: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  )>>, paragraphBottom: Array<(
    { __typename: 'ParagraphAccordion' }
    & { accordionElements: Array<(
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    )> }
  ) | (
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphAnchor' }
    & Pick<ParagraphAnchor, 'anchorLink'>
  ) | (
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumbers' }
    & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
    & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumberRange' }
      & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphBabiesSearch' }
    & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphCallToAction' }
    & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
    & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualEvent' }
    & { event: Maybe<(
      Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualText' }
    & Pick<ParagraphContextualText, 'title' | 'textHtml'>
    & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
  ) | (
    { __typename: 'ParagraphDocuments' }
    & Pick<ParagraphDocuments, 'title'>
    & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
  ) | { __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphEventForm' }
    & Pick<ParagraphEventForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphEventsSearch' }
    & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphFileList' }
    & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphForm' }
    & Pick<ParagraphForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphFormattedTextWithTitle' }
    & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphLabCardListing' }
    & Pick<ParagraphLabCardListing, 'title'>
  ) | (
    { __typename: 'ParagraphLinkList' }
    & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  ) | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  ) | (
    { __typename: 'ParagraphListingAllocation' }
    & Pick<ParagraphListingAllocation, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingClinicsByArea' }
    & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingDiseaseFromLocation' }
    & Pick<ParagraphListingDiseaseFromLocation, 'title'>
    & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
  ) | (
    { __typename: 'ParagraphListingDiseaseSearchSource' }
    & Pick<ParagraphListingDiseaseSearchSource, 'title'>
  ) | (
    { __typename: 'ParagraphListingEventsEmbed' }
    & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByDepartment' }
    & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
    & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingJobList' }
    & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
  ) | (
    { __typename: 'ParagraphListingJobToolSearch' }
    & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
    & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
  ) | (
    { __typename: 'ParagraphListingLocationByTreatmentOffer' }
    & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingMedicineNews' }
    & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
    & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFiltered' }
    & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
    & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFrontpage' }
    & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
    & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomResearch' }
    & Pick<ParagraphListingNewsroomResearch, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomTreatment' }
    & Pick<ParagraphListingNewsroomTreatment, 'argument'>
  ) | (
    { __typename: 'ParagraphListingSpecialists' }
    & Pick<ParagraphListingSpecialists, 'title'>
  ) | (
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  ) | (
    { __typename: 'ParagraphLogoCloud' }
    & { logoImages: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphMegaTeasers' }
    & Pick<ParagraphMegaTeasers, 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphNewsTeaser' }
    & { newsContent: Maybe<(
      Pick<ContentNews, 'path' | 'title' | 'date'>
      & { teaserImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphSiteSearch' }
    & Pick<ParagraphSiteSearch, 'placeholderText'>
  ) | (
    { __typename: 'ParagraphSpacer' }
    & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
  ) | (
    { __typename: 'ParagraphSpecialistsSlider' }
    & Pick<ParagraphSpecialistsSlider, 'title'>
    & { specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
    & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
  ) | (
    { __typename: 'ParagraphStaticWallsBlock' }
    & Pick<ParagraphStaticWallsBlock, 'title'>
  ) | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphTeasers' }
    & Pick<ParagraphTeasers, 'display' | 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTestimonialSlider' }
    & Pick<ParagraphTestimonialSlider, 'title'>
    & { testimonial: Array<Maybe<(
      Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  ) | (
    { __typename: 'ParagraphTiles' }
    & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    )>> }
  ) | (
    { __typename: 'ParagraphTimeline' }
    & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>, metaTags: Maybe<Array<Maybe<(
    Pick<MetaTag, 'tag'>
    & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
  )>>> }
);

export type DocumentationPageFragment = (
  Pick<ContentDocumentationPage, 'title' | 'path'>
  & { group: Maybe<(
    Pick<GroupDocumentation, 'title' | 'path'>
    & { mainContent: Maybe<Pick<ContentDocumentationPage, 'path'> | Pick<ContentPatientInformation, 'path'>>, menuMain: Maybe<Array<Pick<MenuItem, 'id' | 'parent' | 'url' | 'label'>>> }
  )>, metaTags: Maybe<Array<Maybe<(
    Pick<MetaTag, 'tag'>
    & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
  )>>>, paragraphs: Array<Maybe<(
    { __typename: 'ParagraphAccordion' }
    & { accordionElements: Array<(
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    )> }
  ) | (
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphAnchor' }
    & Pick<ParagraphAnchor, 'anchorLink'>
  ) | (
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumbers' }
    & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
    & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumberRange' }
      & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphBabiesSearch' }
    & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphCallToAction' }
    & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
    & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualEvent' }
    & { event: Maybe<(
      Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualText' }
    & Pick<ParagraphContextualText, 'title' | 'textHtml'>
    & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
  ) | (
    { __typename: 'ParagraphDocuments' }
    & Pick<ParagraphDocuments, 'title'>
    & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
  ) | { __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphEventForm' }
    & Pick<ParagraphEventForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphEventsSearch' }
    & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphFileList' }
    & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphForm' }
    & Pick<ParagraphForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphFormattedTextWithTitle' }
    & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphLabCardListing' }
    & Pick<ParagraphLabCardListing, 'title'>
  ) | (
    { __typename: 'ParagraphLinkList' }
    & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  ) | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  ) | (
    { __typename: 'ParagraphListingAllocation' }
    & Pick<ParagraphListingAllocation, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingClinicsByArea' }
    & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingDiseaseFromLocation' }
    & Pick<ParagraphListingDiseaseFromLocation, 'title'>
    & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
  ) | (
    { __typename: 'ParagraphListingDiseaseSearchSource' }
    & Pick<ParagraphListingDiseaseSearchSource, 'title'>
  ) | (
    { __typename: 'ParagraphListingEventsEmbed' }
    & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByDepartment' }
    & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
    & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingJobList' }
    & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
  ) | (
    { __typename: 'ParagraphListingJobToolSearch' }
    & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
    & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
  ) | (
    { __typename: 'ParagraphListingLocationByTreatmentOffer' }
    & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingMedicineNews' }
    & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
    & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFiltered' }
    & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
    & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFrontpage' }
    & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
    & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomResearch' }
    & Pick<ParagraphListingNewsroomResearch, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomTreatment' }
    & Pick<ParagraphListingNewsroomTreatment, 'argument'>
  ) | (
    { __typename: 'ParagraphListingSpecialists' }
    & Pick<ParagraphListingSpecialists, 'title'>
  ) | (
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  ) | (
    { __typename: 'ParagraphLogoCloud' }
    & { logoImages: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphMegaTeasers' }
    & Pick<ParagraphMegaTeasers, 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphNewsTeaser' }
    & { newsContent: Maybe<(
      Pick<ContentNews, 'path' | 'title' | 'date'>
      & { teaserImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphSiteSearch' }
    & Pick<ParagraphSiteSearch, 'placeholderText'>
  ) | (
    { __typename: 'ParagraphSpacer' }
    & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
  ) | (
    { __typename: 'ParagraphSpecialistsSlider' }
    & Pick<ParagraphSpecialistsSlider, 'title'>
    & { specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
    & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
  ) | (
    { __typename: 'ParagraphStaticWallsBlock' }
    & Pick<ParagraphStaticWallsBlock, 'title'>
  ) | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphTeasers' }
    & Pick<ParagraphTeasers, 'display' | 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTestimonialSlider' }
    & Pick<ParagraphTestimonialSlider, 'title'>
    & { testimonial: Array<Maybe<(
      Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  ) | (
    { __typename: 'ParagraphTiles' }
    & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    )>> }
  ) | (
    { __typename: 'ParagraphTimeline' }
    & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>> }
);

export type DsLoopFragment = { segments: Array<(
    Pick<DsLoopSegment, 'amountOfSlidesToPick'>
    & { filters: Pick<DsSegmentFilters, 'departmentIds' | 'treatmentAreaIds' | 'projectIds'>, filtersExclude: Pick<DsSegmentFilters, 'departmentIds' | 'treatmentAreaIds' | 'projectIds'>, playlist: Maybe<{ content: { babies: Maybe<Array<Maybe<(
          Pick<ContentBaby, 'id' | 'title'>
          & { image: Maybe<{ src: MediaImage['original'] }>, department: Maybe<{ id: ContentLocation['drupalId'] }> }
        )>>> } | { events: Maybe<Array<Maybe<(
          Pick<ContentEvent, 'title' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
          & { department: Array<Maybe<{ id: ContentLocation['drupalId'] }>> }
        )>>> } | { slides: Maybe<Array<Maybe<(
          Pick<DsSlide, 'id'>
          & { dsSettings: Pick<SettingsDigitalSignage, 'durationBabies' | 'durationEvents' | 'durationFullScreen' | 'durationHealthTip' | 'durationHistory' | 'durationInstagram' | 'durationQuiz' | 'durationQuizAnswerReveal' | 'durationSimple'>, metadata: Pick<DsSlideMetadata, 'departmentIds' | 'treatmentAreaIds' | 'projectIds'>, layout: (
            { __typename: 'DsFullScreenSlide' }
            & Pick<DsFullScreenSlide, 'durationSeconds'>
            & { mediaImage: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, mediaVideoRemote: Maybe<Pick<MediaVideoRemote, 'url'>>, mediaVideoLocal: Maybe<Pick<MediaVideoLocal, 'url'>> }
          ) | (
            { __typename: 'DsHealthTipSlide' }
            & Pick<DsHealthTipSlide, 'title' | 'contentHtml' | 'label'>
            & { expert: Maybe<(
              Pick<ContentSpecialist, 'title' | 'job'>
              & { areas: Array<Maybe<Pick<TermAdministrativeArea, 'title'>>>, imageLandscape: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            )> }
          ) | (
            { __typename: 'DsHistorySlide' }
            & Pick<DsHistorySlide, 'thenCaption' | 'nowCaption' | 'nowDescriptionHtml'>
            & { thenImage: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, nowImage: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'DsInstagramSlide' }
            & Pick<DsInstagramSlide, 'title' | 'contentHtml' | 'cta'>
            & { images: Array<Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>>, expert: Maybe<Pick<ContentSpecialist, 'id'>> }
          ) | (
            { __typename: 'DsQuizSlide' }
            & Pick<DsQuizSlide, 'question' | 'answers' | 'correctAnswer'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'DsSimpleSlide' }
            & Pick<DsSimpleSlide, 'title' | 'contentHtml'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) }
        )>>> } }> }
  )>, dsSettings: Pick<SettingsDigitalSignage, 'durationBabies' | 'durationEvents' | 'durationFullScreen' | 'durationHealthTip' | 'durationHistory' | 'durationInstagram' | 'durationQuiz' | 'durationQuizAnswerReveal' | 'durationSimple'> };

export type DsSettingsFragment = Pick<SettingsDigitalSignage, 'durationBabies' | 'durationEvents' | 'durationFullScreen' | 'durationHealthTip' | 'durationHistory' | 'durationInstagram' | 'durationQuiz' | 'durationQuizAnswerReveal' | 'durationSimple'>;

export type DsSlideFragment = (
  Pick<DsSlide, 'id'>
  & { dsSettings: Pick<SettingsDigitalSignage, 'durationBabies' | 'durationEvents' | 'durationFullScreen' | 'durationHealthTip' | 'durationHistory' | 'durationInstagram' | 'durationQuiz' | 'durationQuizAnswerReveal' | 'durationSimple'>, metadata: Pick<DsSlideMetadata, 'departmentIds' | 'treatmentAreaIds' | 'projectIds'>, layout: (
    { __typename: 'DsFullScreenSlide' }
    & Pick<DsFullScreenSlide, 'durationSeconds'>
    & { mediaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, mediaVideoRemote: Maybe<Pick<MediaVideoRemote, 'url'>>, mediaVideoLocal: Maybe<Pick<MediaVideoLocal, 'url'>> }
  ) | (
    { __typename: 'DsHealthTipSlide' }
    & Pick<DsHealthTipSlide, 'title' | 'contentHtml' | 'label'>
    & { expert: Maybe<(
      Pick<ContentSpecialist, 'title' | 'job'>
      & { areas: Array<Maybe<Pick<TermAdministrativeArea, 'title'>>>, imageLandscape: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'DsHistorySlide' }
    & Pick<DsHistorySlide, 'thenCaption' | 'nowCaption' | 'nowDescriptionHtml'>
    & { thenImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, nowImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'DsInstagramSlide' }
    & Pick<DsInstagramSlide, 'title' | 'contentHtml' | 'cta'>
    & { images: Array<Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>>, expert: Maybe<Pick<ContentSpecialist, 'id'>> }
  ) | (
    { __typename: 'DsQuizSlide' }
    & Pick<DsQuizSlide, 'question' | 'answers' | 'correctAnswer'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'DsSimpleSlide' }
    & Pick<DsSimpleSlide, 'title' | 'contentHtml'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) }
);

export type EventPageFragment = (
  Pick<ContentEvent, 'drupalId' | 'createdTimestamp' | 'title' | 'location' | 'startDate' | 'startTime' | 'endDate' | 'endTime' | 'lead' | 'eventStatus' | 'gtmData'>
  & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, image: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )>, organizer: Array<Maybe<Pick<ContentLocation, 'title' | 'subtitle' | 'path'>>>, content: Array<Maybe<(
    { __typename: 'ParagraphAccordion' }
    & { accordionElements: Array<(
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    )> }
  ) | (
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphAnchor' }
    & Pick<ParagraphAnchor, 'anchorLink'>
  ) | (
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumbers' }
    & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
    & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumberRange' }
      & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphBabiesSearch' }
    & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphCallToAction' }
    & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
    & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualEvent' }
    & { event: Maybe<(
      Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualText' }
    & Pick<ParagraphContextualText, 'title' | 'textHtml'>
    & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
  ) | (
    { __typename: 'ParagraphDocuments' }
    & Pick<ParagraphDocuments, 'title'>
    & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
  ) | { __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphEventForm' }
    & Pick<ParagraphEventForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphEventsSearch' }
    & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphFileList' }
    & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphForm' }
    & Pick<ParagraphForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphFormattedTextWithTitle' }
    & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphLabCardListing' }
    & Pick<ParagraphLabCardListing, 'title'>
  ) | (
    { __typename: 'ParagraphLinkList' }
    & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  ) | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  ) | (
    { __typename: 'ParagraphListingAllocation' }
    & Pick<ParagraphListingAllocation, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingClinicsByArea' }
    & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingDiseaseFromLocation' }
    & Pick<ParagraphListingDiseaseFromLocation, 'title'>
    & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
  ) | (
    { __typename: 'ParagraphListingDiseaseSearchSource' }
    & Pick<ParagraphListingDiseaseSearchSource, 'title'>
  ) | (
    { __typename: 'ParagraphListingEventsEmbed' }
    & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByDepartment' }
    & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
    & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingJobList' }
    & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
  ) | (
    { __typename: 'ParagraphListingJobToolSearch' }
    & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
    & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
  ) | (
    { __typename: 'ParagraphListingLocationByTreatmentOffer' }
    & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingMedicineNews' }
    & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
    & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFiltered' }
    & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
    & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFrontpage' }
    & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
    & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomResearch' }
    & Pick<ParagraphListingNewsroomResearch, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomTreatment' }
    & Pick<ParagraphListingNewsroomTreatment, 'argument'>
  ) | (
    { __typename: 'ParagraphListingSpecialists' }
    & Pick<ParagraphListingSpecialists, 'title'>
  ) | (
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  ) | (
    { __typename: 'ParagraphLogoCloud' }
    & { logoImages: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphMegaTeasers' }
    & Pick<ParagraphMegaTeasers, 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphNewsTeaser' }
    & { newsContent: Maybe<(
      Pick<ContentNews, 'path' | 'title' | 'date'>
      & { teaserImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphSiteSearch' }
    & Pick<ParagraphSiteSearch, 'placeholderText'>
  ) | (
    { __typename: 'ParagraphSpacer' }
    & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
  ) | (
    { __typename: 'ParagraphSpecialistsSlider' }
    & Pick<ParagraphSpecialistsSlider, 'title'>
    & { specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
    & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
  ) | (
    { __typename: 'ParagraphStaticWallsBlock' }
    & Pick<ParagraphStaticWallsBlock, 'title'>
  ) | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphTeasers' }
    & Pick<ParagraphTeasers, 'display' | 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTestimonialSlider' }
    & Pick<ParagraphTestimonialSlider, 'title'>
    & { testimonial: Array<Maybe<(
      Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  ) | (
    { __typename: 'ParagraphTiles' }
    & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    )>> }
  ) | (
    { __typename: 'ParagraphTimeline' }
    & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>>, form: Maybe<Pick<ParagraphEventForm, 'formUrl'>>, sidebar: Array<Maybe<(
    { __typename: 'ParagraphAccordion' }
    & { accordionElements: Array<(
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    )> }
  ) | (
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphAnchor' }
    & Pick<ParagraphAnchor, 'anchorLink'>
  ) | (
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumbers' }
    & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
    & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumberRange' }
      & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphBabiesSearch' }
    & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphCallToAction' }
    & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
    & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualEvent' }
    & { event: Maybe<(
      Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualText' }
    & Pick<ParagraphContextualText, 'title' | 'textHtml'>
    & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
  ) | (
    { __typename: 'ParagraphDocuments' }
    & Pick<ParagraphDocuments, 'title'>
    & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
  ) | { __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphEventForm' }
    & Pick<ParagraphEventForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphEventsSearch' }
    & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphFileList' }
    & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphForm' }
    & Pick<ParagraphForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphFormattedTextWithTitle' }
    & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphLabCardListing' }
    & Pick<ParagraphLabCardListing, 'title'>
  ) | (
    { __typename: 'ParagraphLinkList' }
    & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  ) | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  ) | (
    { __typename: 'ParagraphListingAllocation' }
    & Pick<ParagraphListingAllocation, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingClinicsByArea' }
    & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingDiseaseFromLocation' }
    & Pick<ParagraphListingDiseaseFromLocation, 'title'>
    & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
  ) | (
    { __typename: 'ParagraphListingDiseaseSearchSource' }
    & Pick<ParagraphListingDiseaseSearchSource, 'title'>
  ) | (
    { __typename: 'ParagraphListingEventsEmbed' }
    & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByDepartment' }
    & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
    & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingJobList' }
    & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
  ) | (
    { __typename: 'ParagraphListingJobToolSearch' }
    & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
    & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
  ) | (
    { __typename: 'ParagraphListingLocationByTreatmentOffer' }
    & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingMedicineNews' }
    & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
    & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFiltered' }
    & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
    & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFrontpage' }
    & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
    & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomResearch' }
    & Pick<ParagraphListingNewsroomResearch, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomTreatment' }
    & Pick<ParagraphListingNewsroomTreatment, 'argument'>
  ) | (
    { __typename: 'ParagraphListingSpecialists' }
    & Pick<ParagraphListingSpecialists, 'title'>
  ) | (
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  ) | (
    { __typename: 'ParagraphLogoCloud' }
    & { logoImages: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphMegaTeasers' }
    & Pick<ParagraphMegaTeasers, 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphNewsTeaser' }
    & { newsContent: Maybe<(
      Pick<ContentNews, 'path' | 'title' | 'date'>
      & { teaserImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphSiteSearch' }
    & Pick<ParagraphSiteSearch, 'placeholderText'>
  ) | (
    { __typename: 'ParagraphSpacer' }
    & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
  ) | (
    { __typename: 'ParagraphSpecialistsSlider' }
    & Pick<ParagraphSpecialistsSlider, 'title'>
    & { specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
    & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
  ) | (
    { __typename: 'ParagraphStaticWallsBlock' }
    & Pick<ParagraphStaticWallsBlock, 'title'>
  ) | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphTeasers' }
    & Pick<ParagraphTeasers, 'display' | 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTestimonialSlider' }
    & Pick<ParagraphTestimonialSlider, 'title'>
    & { testimonial: Array<Maybe<(
      Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  ) | (
    { __typename: 'ParagraphTiles' }
    & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    )>> }
  ) | (
    { __typename: 'ParagraphTimeline' }
    & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>>, metaTags: Maybe<Array<Maybe<(
    Pick<MetaTag, 'tag'>
    & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
  )>>> }
);

export type GroupDocumentationFragment = (
  Pick<GroupDocumentation, 'path'>
  & { mainContent: Maybe<Pick<ContentDocumentationPage, 'path'> | Pick<ContentPatientInformation, 'path'>>, menuMain: Maybe<Array<Pick<MenuItem, 'id' | 'parent' | 'url' | 'label'>>> }
);

export type KitchenSinkFragment = (
  Pick<ContentKitchenSink, 'title'>
  & { paragraphs: Array<Maybe<(
    { __typename: 'ParagraphAccordion' }
    & { accordionElements: Array<(
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    )> }
  ) | (
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphAnchor' }
    & Pick<ParagraphAnchor, 'anchorLink'>
  ) | (
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumbers' }
    & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
    & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumberRange' }
      & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphBabiesSearch' }
    & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphCallToAction' }
    & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
    & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualEvent' }
    & { event: Maybe<(
      Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualText' }
    & Pick<ParagraphContextualText, 'title' | 'textHtml'>
    & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
  ) | (
    { __typename: 'ParagraphDocuments' }
    & Pick<ParagraphDocuments, 'title'>
    & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
  ) | { __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphEventForm' }
    & Pick<ParagraphEventForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphEventsSearch' }
    & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphFileList' }
    & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphForm' }
    & Pick<ParagraphForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphFormattedTextWithTitle' }
    & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphLabCardListing' }
    & Pick<ParagraphLabCardListing, 'title'>
  ) | (
    { __typename: 'ParagraphLinkList' }
    & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  ) | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  ) | (
    { __typename: 'ParagraphListingAllocation' }
    & Pick<ParagraphListingAllocation, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingClinicsByArea' }
    & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingDiseaseFromLocation' }
    & Pick<ParagraphListingDiseaseFromLocation, 'title'>
    & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
  ) | (
    { __typename: 'ParagraphListingDiseaseSearchSource' }
    & Pick<ParagraphListingDiseaseSearchSource, 'title'>
  ) | (
    { __typename: 'ParagraphListingEventsEmbed' }
    & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByDepartment' }
    & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
    & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingJobList' }
    & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
  ) | (
    { __typename: 'ParagraphListingJobToolSearch' }
    & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
    & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
  ) | (
    { __typename: 'ParagraphListingLocationByTreatmentOffer' }
    & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingMedicineNews' }
    & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
    & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFiltered' }
    & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
    & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFrontpage' }
    & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
    & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomResearch' }
    & Pick<ParagraphListingNewsroomResearch, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomTreatment' }
    & Pick<ParagraphListingNewsroomTreatment, 'argument'>
  ) | (
    { __typename: 'ParagraphListingSpecialists' }
    & Pick<ParagraphListingSpecialists, 'title'>
  ) | (
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  ) | (
    { __typename: 'ParagraphLogoCloud' }
    & { logoImages: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphMegaTeasers' }
    & Pick<ParagraphMegaTeasers, 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphNewsTeaser' }
    & { newsContent: Maybe<(
      Pick<ContentNews, 'path' | 'title' | 'date'>
      & { teaserImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphSiteSearch' }
    & Pick<ParagraphSiteSearch, 'placeholderText'>
  ) | (
    { __typename: 'ParagraphSpacer' }
    & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
  ) | (
    { __typename: 'ParagraphSpecialistsSlider' }
    & Pick<ParagraphSpecialistsSlider, 'title'>
    & { specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
    & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
  ) | (
    { __typename: 'ParagraphStaticWallsBlock' }
    & Pick<ParagraphStaticWallsBlock, 'title'>
  ) | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphTeasers' }
    & Pick<ParagraphTeasers, 'display' | 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTestimonialSlider' }
    & Pick<ParagraphTestimonialSlider, 'title'>
    & { testimonial: Array<Maybe<(
      Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  ) | (
    { __typename: 'ParagraphTiles' }
    & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    )>> }
  ) | (
    { __typename: 'ParagraphTimeline' }
    & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>> }
);

export type LandingPageFragment = (
  Pick<ContentLandingPage, 'title' | 'description' | 'increaseHeroHeight'>
  & { image: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )>, video: Maybe<(
    { __typename: 'MediaVideoLocal' }
    & Pick<MediaVideoLocal, 'url'>
  ) | (
    { __typename: 'MediaVideoRemote' }
    & Pick<MediaVideoRemote, 'url'>
  )>, body: Array<Maybe<(
    { __typename: 'ParagraphAccordion' }
    & { accordionElements: Array<(
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    )> }
  ) | (
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphAnchor' }
    & Pick<ParagraphAnchor, 'anchorLink'>
  ) | (
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumbers' }
    & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
    & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumberRange' }
      & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphBabiesSearch' }
    & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphCallToAction' }
    & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
    & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualEvent' }
    & { event: Maybe<(
      Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualText' }
    & Pick<ParagraphContextualText, 'title' | 'textHtml'>
    & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
  ) | (
    { __typename: 'ParagraphDocuments' }
    & Pick<ParagraphDocuments, 'title'>
    & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
  ) | { __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphEventForm' }
    & Pick<ParagraphEventForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphEventsSearch' }
    & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphFileList' }
    & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphForm' }
    & Pick<ParagraphForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphFormattedTextWithTitle' }
    & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphLabCardListing' }
    & Pick<ParagraphLabCardListing, 'title'>
  ) | (
    { __typename: 'ParagraphLinkList' }
    & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  ) | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  ) | (
    { __typename: 'ParagraphListingAllocation' }
    & Pick<ParagraphListingAllocation, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingClinicsByArea' }
    & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingDiseaseFromLocation' }
    & Pick<ParagraphListingDiseaseFromLocation, 'title'>
    & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
  ) | (
    { __typename: 'ParagraphListingDiseaseSearchSource' }
    & Pick<ParagraphListingDiseaseSearchSource, 'title'>
  ) | (
    { __typename: 'ParagraphListingEventsEmbed' }
    & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByDepartment' }
    & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
    & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingJobList' }
    & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
  ) | (
    { __typename: 'ParagraphListingJobToolSearch' }
    & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
    & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
  ) | (
    { __typename: 'ParagraphListingLocationByTreatmentOffer' }
    & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingMedicineNews' }
    & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
    & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFiltered' }
    & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
    & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFrontpage' }
    & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
    & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomResearch' }
    & Pick<ParagraphListingNewsroomResearch, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomTreatment' }
    & Pick<ParagraphListingNewsroomTreatment, 'argument'>
  ) | (
    { __typename: 'ParagraphListingSpecialists' }
    & Pick<ParagraphListingSpecialists, 'title'>
  ) | (
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  ) | (
    { __typename: 'ParagraphLogoCloud' }
    & { logoImages: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphMegaTeasers' }
    & Pick<ParagraphMegaTeasers, 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphNewsTeaser' }
    & { newsContent: Maybe<(
      Pick<ContentNews, 'path' | 'title' | 'date'>
      & { teaserImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphSiteSearch' }
    & Pick<ParagraphSiteSearch, 'placeholderText'>
  ) | (
    { __typename: 'ParagraphSpacer' }
    & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
  ) | (
    { __typename: 'ParagraphSpecialistsSlider' }
    & Pick<ParagraphSpecialistsSlider, 'title'>
    & { specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
    & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
  ) | (
    { __typename: 'ParagraphStaticWallsBlock' }
    & Pick<ParagraphStaticWallsBlock, 'title'>
  ) | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphTeasers' }
    & Pick<ParagraphTeasers, 'display' | 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTestimonialSlider' }
    & Pick<ParagraphTestimonialSlider, 'title'>
    & { testimonial: Array<Maybe<(
      Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  ) | (
    { __typename: 'ParagraphTiles' }
    & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    )>> }
  ) | (
    { __typename: 'ParagraphTimeline' }
    & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>>, advertCollection: Maybe<(
    Pick<ContentAdvertCollection, 'frequency' | 'positioning' | 'repetitions'>
    & { collection: Array<Maybe<(
      Pick<ContentAdvert, 'id' | 'title' | 'text' | 'textAlignment' | 'buttonPlacement'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, link: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  )>, metaTags: Maybe<Array<Maybe<(
    Pick<MetaTag, 'tag'>
    & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
  )>>> }
);

export type LocationContactPageFragment = (
  Pick<ContentLocationContact, 'path' | 'title' | 'companyName' | 'addressFirstLine' | 'addressSecondLine' | 'postCode' | 'city' | 'email' | 'phone' | 'mapOverlayHtml' | 'latitude' | 'longitude'>
  & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, locationHeader: { location: Maybe<(
      Pick<ContentLocation, 'path' | 'title' | 'subtitle'>
      & { contact: Maybe<Pick<ContentLocationContact, 'path'>> }
    )>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>> }, infoAddress: Array<Maybe<(
    { __typename: 'ParagraphAccordion' }
    & { accordionElements: Array<(
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    )> }
  ) | (
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphAnchor' }
    & Pick<ParagraphAnchor, 'anchorLink'>
  ) | (
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumbers' }
    & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
    & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumberRange' }
      & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphBabiesSearch' }
    & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphCallToAction' }
    & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
    & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualEvent' }
    & { event: Maybe<(
      Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualText' }
    & Pick<ParagraphContextualText, 'title' | 'textHtml'>
    & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
  ) | (
    { __typename: 'ParagraphDocuments' }
    & Pick<ParagraphDocuments, 'title'>
    & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
  ) | { __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphEventForm' }
    & Pick<ParagraphEventForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphEventsSearch' }
    & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphFileList' }
    & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphForm' }
    & Pick<ParagraphForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphFormattedTextWithTitle' }
    & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphLabCardListing' }
    & Pick<ParagraphLabCardListing, 'title'>
  ) | (
    { __typename: 'ParagraphLinkList' }
    & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  ) | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  ) | (
    { __typename: 'ParagraphListingAllocation' }
    & Pick<ParagraphListingAllocation, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingClinicsByArea' }
    & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingDiseaseFromLocation' }
    & Pick<ParagraphListingDiseaseFromLocation, 'title'>
    & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
  ) | (
    { __typename: 'ParagraphListingDiseaseSearchSource' }
    & Pick<ParagraphListingDiseaseSearchSource, 'title'>
  ) | (
    { __typename: 'ParagraphListingEventsEmbed' }
    & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByDepartment' }
    & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
    & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingJobList' }
    & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
  ) | (
    { __typename: 'ParagraphListingJobToolSearch' }
    & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
    & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
  ) | (
    { __typename: 'ParagraphListingLocationByTreatmentOffer' }
    & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingMedicineNews' }
    & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
    & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFiltered' }
    & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
    & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFrontpage' }
    & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
    & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomResearch' }
    & Pick<ParagraphListingNewsroomResearch, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomTreatment' }
    & Pick<ParagraphListingNewsroomTreatment, 'argument'>
  ) | (
    { __typename: 'ParagraphListingSpecialists' }
    & Pick<ParagraphListingSpecialists, 'title'>
  ) | (
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  ) | (
    { __typename: 'ParagraphLogoCloud' }
    & { logoImages: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphMegaTeasers' }
    & Pick<ParagraphMegaTeasers, 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphNewsTeaser' }
    & { newsContent: Maybe<(
      Pick<ContentNews, 'path' | 'title' | 'date'>
      & { teaserImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphSiteSearch' }
    & Pick<ParagraphSiteSearch, 'placeholderText'>
  ) | (
    { __typename: 'ParagraphSpacer' }
    & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
  ) | (
    { __typename: 'ParagraphSpecialistsSlider' }
    & Pick<ParagraphSpecialistsSlider, 'title'>
    & { specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
    & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
  ) | (
    { __typename: 'ParagraphStaticWallsBlock' }
    & Pick<ParagraphStaticWallsBlock, 'title'>
  ) | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphTeasers' }
    & Pick<ParagraphTeasers, 'display' | 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTestimonialSlider' }
    & Pick<ParagraphTestimonialSlider, 'title'>
    & { testimonial: Array<Maybe<(
      Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  ) | (
    { __typename: 'ParagraphTiles' }
    & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    )>> }
  ) | (
    { __typename: 'ParagraphTimeline' }
    & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>>, infoBooking: Array<Maybe<(
    { __typename: 'ParagraphAccordion' }
    & { accordionElements: Array<(
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    )> }
  ) | (
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphAnchor' }
    & Pick<ParagraphAnchor, 'anchorLink'>
  ) | (
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumbers' }
    & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
    & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumberRange' }
      & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphBabiesSearch' }
    & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphCallToAction' }
    & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
    & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualEvent' }
    & { event: Maybe<(
      Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualText' }
    & Pick<ParagraphContextualText, 'title' | 'textHtml'>
    & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
  ) | (
    { __typename: 'ParagraphDocuments' }
    & Pick<ParagraphDocuments, 'title'>
    & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
  ) | { __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphEventForm' }
    & Pick<ParagraphEventForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphEventsSearch' }
    & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphFileList' }
    & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphForm' }
    & Pick<ParagraphForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphFormattedTextWithTitle' }
    & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphLabCardListing' }
    & Pick<ParagraphLabCardListing, 'title'>
  ) | (
    { __typename: 'ParagraphLinkList' }
    & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  ) | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  ) | (
    { __typename: 'ParagraphListingAllocation' }
    & Pick<ParagraphListingAllocation, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingClinicsByArea' }
    & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingDiseaseFromLocation' }
    & Pick<ParagraphListingDiseaseFromLocation, 'title'>
    & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
  ) | (
    { __typename: 'ParagraphListingDiseaseSearchSource' }
    & Pick<ParagraphListingDiseaseSearchSource, 'title'>
  ) | (
    { __typename: 'ParagraphListingEventsEmbed' }
    & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByDepartment' }
    & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
    & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingJobList' }
    & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
  ) | (
    { __typename: 'ParagraphListingJobToolSearch' }
    & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
    & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
  ) | (
    { __typename: 'ParagraphListingLocationByTreatmentOffer' }
    & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingMedicineNews' }
    & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
    & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFiltered' }
    & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
    & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFrontpage' }
    & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
    & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomResearch' }
    & Pick<ParagraphListingNewsroomResearch, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomTreatment' }
    & Pick<ParagraphListingNewsroomTreatment, 'argument'>
  ) | (
    { __typename: 'ParagraphListingSpecialists' }
    & Pick<ParagraphListingSpecialists, 'title'>
  ) | (
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  ) | (
    { __typename: 'ParagraphLogoCloud' }
    & { logoImages: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphMegaTeasers' }
    & Pick<ParagraphMegaTeasers, 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphNewsTeaser' }
    & { newsContent: Maybe<(
      Pick<ContentNews, 'path' | 'title' | 'date'>
      & { teaserImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphSiteSearch' }
    & Pick<ParagraphSiteSearch, 'placeholderText'>
  ) | (
    { __typename: 'ParagraphSpacer' }
    & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
  ) | (
    { __typename: 'ParagraphSpecialistsSlider' }
    & Pick<ParagraphSpecialistsSlider, 'title'>
    & { specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
    & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
  ) | (
    { __typename: 'ParagraphStaticWallsBlock' }
    & Pick<ParagraphStaticWallsBlock, 'title'>
  ) | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphTeasers' }
    & Pick<ParagraphTeasers, 'display' | 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTestimonialSlider' }
    & Pick<ParagraphTestimonialSlider, 'title'>
    & { testimonial: Array<Maybe<(
      Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  ) | (
    { __typename: 'ParagraphTiles' }
    & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    )>> }
  ) | (
    { __typename: 'ParagraphTimeline' }
    & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>>, infoEmergency: Array<Maybe<(
    { __typename: 'ParagraphAccordion' }
    & { accordionElements: Array<(
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    )> }
  ) | (
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphAnchor' }
    & Pick<ParagraphAnchor, 'anchorLink'>
  ) | (
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumbers' }
    & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
    & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumberRange' }
      & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphBabiesSearch' }
    & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphCallToAction' }
    & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
    & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualEvent' }
    & { event: Maybe<(
      Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualText' }
    & Pick<ParagraphContextualText, 'title' | 'textHtml'>
    & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
  ) | (
    { __typename: 'ParagraphDocuments' }
    & Pick<ParagraphDocuments, 'title'>
    & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
  ) | { __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphEventForm' }
    & Pick<ParagraphEventForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphEventsSearch' }
    & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphFileList' }
    & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphForm' }
    & Pick<ParagraphForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphFormattedTextWithTitle' }
    & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphLabCardListing' }
    & Pick<ParagraphLabCardListing, 'title'>
  ) | (
    { __typename: 'ParagraphLinkList' }
    & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  ) | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  ) | (
    { __typename: 'ParagraphListingAllocation' }
    & Pick<ParagraphListingAllocation, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingClinicsByArea' }
    & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingDiseaseFromLocation' }
    & Pick<ParagraphListingDiseaseFromLocation, 'title'>
    & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
  ) | (
    { __typename: 'ParagraphListingDiseaseSearchSource' }
    & Pick<ParagraphListingDiseaseSearchSource, 'title'>
  ) | (
    { __typename: 'ParagraphListingEventsEmbed' }
    & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByDepartment' }
    & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
    & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingJobList' }
    & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
  ) | (
    { __typename: 'ParagraphListingJobToolSearch' }
    & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
    & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
  ) | (
    { __typename: 'ParagraphListingLocationByTreatmentOffer' }
    & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingMedicineNews' }
    & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
    & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFiltered' }
    & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
    & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFrontpage' }
    & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
    & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomResearch' }
    & Pick<ParagraphListingNewsroomResearch, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomTreatment' }
    & Pick<ParagraphListingNewsroomTreatment, 'argument'>
  ) | (
    { __typename: 'ParagraphListingSpecialists' }
    & Pick<ParagraphListingSpecialists, 'title'>
  ) | (
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  ) | (
    { __typename: 'ParagraphLogoCloud' }
    & { logoImages: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphMegaTeasers' }
    & Pick<ParagraphMegaTeasers, 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphNewsTeaser' }
    & { newsContent: Maybe<(
      Pick<ContentNews, 'path' | 'title' | 'date'>
      & { teaserImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphSiteSearch' }
    & Pick<ParagraphSiteSearch, 'placeholderText'>
  ) | (
    { __typename: 'ParagraphSpacer' }
    & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
  ) | (
    { __typename: 'ParagraphSpecialistsSlider' }
    & Pick<ParagraphSpecialistsSlider, 'title'>
    & { specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
    & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
  ) | (
    { __typename: 'ParagraphStaticWallsBlock' }
    & Pick<ParagraphStaticWallsBlock, 'title'>
  ) | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphTeasers' }
    & Pick<ParagraphTeasers, 'display' | 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTestimonialSlider' }
    & Pick<ParagraphTestimonialSlider, 'title'>
    & { testimonial: Array<Maybe<(
      Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  ) | (
    { __typename: 'ParagraphTiles' }
    & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    )>> }
  ) | (
    { __typename: 'ParagraphTimeline' }
    & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>>, parentLocation: Maybe<Pick<ContentLocation, 'title'>>, metaTags: Maybe<Array<Maybe<(
    Pick<MetaTag, 'tag'>
    & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
  )>>> }
);

export type LocationNewsPageFragment = (
  Pick<ContentLocation, 'drupalId' | 'title' | 'subtitle'>
  & { locationPath: ContentLocation['path'] }
  & { locationBreadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, locationNavigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>>, contact: Maybe<(
    Pick<ContentLocationContact, 'path' | 'title' | 'companyName' | 'addressFirstLine' | 'addressSecondLine' | 'postCode' | 'city' | 'email' | 'phone' | 'mapOverlayHtml' | 'latitude' | 'longitude'>
    & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, locationHeader: { location: Maybe<(
        Pick<ContentLocation, 'path' | 'title' | 'subtitle'>
        & { contact: Maybe<Pick<ContentLocationContact, 'path'>> }
      )>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>> }, infoAddress: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, infoBooking: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, infoEmergency: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, parentLocation: Maybe<Pick<ContentLocation, 'title'>>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )>, metaTags: Maybe<Array<Maybe<(
    Pick<MetaTag, 'tag'>
    & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
  )>>> }
);

export type LocationPageFragment = (
  Pick<ContentLocation, 'drupalId' | 'path' | 'title' | 'subtitle' | 'welcomeTitle' | 'specialistsTitle' | 'displayRelatedNews' | 'teamPageTitle' | 'hideParentLocationTitleFromContactInformation'>
  & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>>, content: Array<Maybe<(
    { __typename: 'ParagraphAccordion' }
    & { accordionElements: Array<(
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    )> }
  ) | (
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphAnchor' }
    & Pick<ParagraphAnchor, 'anchorLink'>
  ) | (
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumbers' }
    & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
    & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumberRange' }
      & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphBabiesSearch' }
    & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphCallToAction' }
    & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
    & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualEvent' }
    & { event: Maybe<(
      Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualText' }
    & Pick<ParagraphContextualText, 'title' | 'textHtml'>
    & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
  ) | (
    { __typename: 'ParagraphDocuments' }
    & Pick<ParagraphDocuments, 'title'>
    & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
  ) | { __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphEventForm' }
    & Pick<ParagraphEventForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphEventsSearch' }
    & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphFileList' }
    & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphForm' }
    & Pick<ParagraphForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphFormattedTextWithTitle' }
    & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphLabCardListing' }
    & Pick<ParagraphLabCardListing, 'title'>
  ) | (
    { __typename: 'ParagraphLinkList' }
    & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  ) | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  ) | (
    { __typename: 'ParagraphListingAllocation' }
    & Pick<ParagraphListingAllocation, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingClinicsByArea' }
    & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingDiseaseFromLocation' }
    & Pick<ParagraphListingDiseaseFromLocation, 'title'>
    & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
  ) | (
    { __typename: 'ParagraphListingDiseaseSearchSource' }
    & Pick<ParagraphListingDiseaseSearchSource, 'title'>
  ) | (
    { __typename: 'ParagraphListingEventsEmbed' }
    & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByDepartment' }
    & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
    & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingJobList' }
    & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
  ) | (
    { __typename: 'ParagraphListingJobToolSearch' }
    & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
    & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
  ) | (
    { __typename: 'ParagraphListingLocationByTreatmentOffer' }
    & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingMedicineNews' }
    & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
    & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFiltered' }
    & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
    & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFrontpage' }
    & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
    & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomResearch' }
    & Pick<ParagraphListingNewsroomResearch, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomTreatment' }
    & Pick<ParagraphListingNewsroomTreatment, 'argument'>
  ) | (
    { __typename: 'ParagraphListingSpecialists' }
    & Pick<ParagraphListingSpecialists, 'title'>
  ) | (
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  ) | (
    { __typename: 'ParagraphLogoCloud' }
    & { logoImages: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphMegaTeasers' }
    & Pick<ParagraphMegaTeasers, 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphNewsTeaser' }
    & { newsContent: Maybe<(
      Pick<ContentNews, 'path' | 'title' | 'date'>
      & { teaserImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphSiteSearch' }
    & Pick<ParagraphSiteSearch, 'placeholderText'>
  ) | (
    { __typename: 'ParagraphSpacer' }
    & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
  ) | (
    { __typename: 'ParagraphSpecialistsSlider' }
    & Pick<ParagraphSpecialistsSlider, 'title'>
    & { specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
    & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
  ) | (
    { __typename: 'ParagraphStaticWallsBlock' }
    & Pick<ParagraphStaticWallsBlock, 'title'>
  ) | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphTeasers' }
    & Pick<ParagraphTeasers, 'display' | 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTestimonialSlider' }
    & Pick<ParagraphTestimonialSlider, 'title'>
    & { testimonial: Array<Maybe<(
      Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  ) | (
    { __typename: 'ParagraphTiles' }
    & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    )>> }
  ) | (
    { __typename: 'ParagraphTimeline' }
    & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>>, specialists: Array<Maybe<(
    { __typename: 'ContentSpecialist' }
    & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
    & { imagePortrait: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  )>>, contact: Maybe<(
    Pick<ContentLocationContact, 'path' | 'title' | 'companyName' | 'addressFirstLine' | 'addressSecondLine' | 'postCode' | 'city' | 'email' | 'phone' | 'mapOverlayHtml' | 'latitude' | 'longitude'>
    & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, locationHeader: { location: Maybe<(
        Pick<ContentLocation, 'path' | 'title' | 'subtitle'>
        & { contact: Maybe<Pick<ContentLocationContact, 'path'>> }
      )>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>> }, infoAddress: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, infoBooking: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, infoEmergency: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, parentLocation: Maybe<Pick<ContentLocation, 'title'>>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )>, contentSidebar: Array<Maybe<(
    { __typename: 'ParagraphAccordion' }
    & { accordionElements: Array<(
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    )> }
  ) | (
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphAnchor' }
    & Pick<ParagraphAnchor, 'anchorLink'>
  ) | (
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumbers' }
    & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
    & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumberRange' }
      & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphBabiesSearch' }
    & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphCallToAction' }
    & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
    & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualEvent' }
    & { event: Maybe<(
      Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualText' }
    & Pick<ParagraphContextualText, 'title' | 'textHtml'>
    & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
  ) | (
    { __typename: 'ParagraphDocuments' }
    & Pick<ParagraphDocuments, 'title'>
    & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
  ) | { __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphEventForm' }
    & Pick<ParagraphEventForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphEventsSearch' }
    & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphFileList' }
    & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphForm' }
    & Pick<ParagraphForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphFormattedTextWithTitle' }
    & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphLabCardListing' }
    & Pick<ParagraphLabCardListing, 'title'>
  ) | (
    { __typename: 'ParagraphLinkList' }
    & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  ) | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  ) | (
    { __typename: 'ParagraphListingAllocation' }
    & Pick<ParagraphListingAllocation, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingClinicsByArea' }
    & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingDiseaseFromLocation' }
    & Pick<ParagraphListingDiseaseFromLocation, 'title'>
    & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
  ) | (
    { __typename: 'ParagraphListingDiseaseSearchSource' }
    & Pick<ParagraphListingDiseaseSearchSource, 'title'>
  ) | (
    { __typename: 'ParagraphListingEventsEmbed' }
    & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByDepartment' }
    & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
    & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingJobList' }
    & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
  ) | (
    { __typename: 'ParagraphListingJobToolSearch' }
    & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
    & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
  ) | (
    { __typename: 'ParagraphListingLocationByTreatmentOffer' }
    & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingMedicineNews' }
    & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
    & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFiltered' }
    & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
    & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFrontpage' }
    & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
    & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomResearch' }
    & Pick<ParagraphListingNewsroomResearch, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomTreatment' }
    & Pick<ParagraphListingNewsroomTreatment, 'argument'>
  ) | (
    { __typename: 'ParagraphListingSpecialists' }
    & Pick<ParagraphListingSpecialists, 'title'>
  ) | (
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  ) | (
    { __typename: 'ParagraphLogoCloud' }
    & { logoImages: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphMegaTeasers' }
    & Pick<ParagraphMegaTeasers, 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphNewsTeaser' }
    & { newsContent: Maybe<(
      Pick<ContentNews, 'path' | 'title' | 'date'>
      & { teaserImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphSiteSearch' }
    & Pick<ParagraphSiteSearch, 'placeholderText'>
  ) | (
    { __typename: 'ParagraphSpacer' }
    & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
  ) | (
    { __typename: 'ParagraphSpecialistsSlider' }
    & Pick<ParagraphSpecialistsSlider, 'title'>
    & { specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
    & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
  ) | (
    { __typename: 'ParagraphStaticWallsBlock' }
    & Pick<ParagraphStaticWallsBlock, 'title'>
  ) | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphTeasers' }
    & Pick<ParagraphTeasers, 'display' | 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTestimonialSlider' }
    & Pick<ParagraphTestimonialSlider, 'title'>
    & { testimonial: Array<Maybe<(
      Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  ) | (
    { __typename: 'ParagraphTiles' }
    & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    )>> }
  ) | (
    { __typename: 'ParagraphTimeline' }
    & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>>, contentBottom: Array<Maybe<(
    { __typename: 'ParagraphAccordion' }
    & { accordionElements: Array<(
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    )> }
  ) | (
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphAnchor' }
    & Pick<ParagraphAnchor, 'anchorLink'>
  ) | (
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumbers' }
    & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
    & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumberRange' }
      & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphBabiesSearch' }
    & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphCallToAction' }
    & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
    & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualEvent' }
    & { event: Maybe<(
      Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualText' }
    & Pick<ParagraphContextualText, 'title' | 'textHtml'>
    & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
  ) | (
    { __typename: 'ParagraphDocuments' }
    & Pick<ParagraphDocuments, 'title'>
    & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
  ) | { __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphEventForm' }
    & Pick<ParagraphEventForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphEventsSearch' }
    & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphFileList' }
    & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphForm' }
    & Pick<ParagraphForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphFormattedTextWithTitle' }
    & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphLabCardListing' }
    & Pick<ParagraphLabCardListing, 'title'>
  ) | (
    { __typename: 'ParagraphLinkList' }
    & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  ) | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  ) | (
    { __typename: 'ParagraphListingAllocation' }
    & Pick<ParagraphListingAllocation, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingClinicsByArea' }
    & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingDiseaseFromLocation' }
    & Pick<ParagraphListingDiseaseFromLocation, 'title'>
    & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
  ) | (
    { __typename: 'ParagraphListingDiseaseSearchSource' }
    & Pick<ParagraphListingDiseaseSearchSource, 'title'>
  ) | (
    { __typename: 'ParagraphListingEventsEmbed' }
    & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByDepartment' }
    & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
    & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingJobList' }
    & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
  ) | (
    { __typename: 'ParagraphListingJobToolSearch' }
    & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
    & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
  ) | (
    { __typename: 'ParagraphListingLocationByTreatmentOffer' }
    & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingMedicineNews' }
    & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
    & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFiltered' }
    & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
    & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFrontpage' }
    & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
    & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomResearch' }
    & Pick<ParagraphListingNewsroomResearch, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomTreatment' }
    & Pick<ParagraphListingNewsroomTreatment, 'argument'>
  ) | (
    { __typename: 'ParagraphListingSpecialists' }
    & Pick<ParagraphListingSpecialists, 'title'>
  ) | (
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  ) | (
    { __typename: 'ParagraphLogoCloud' }
    & { logoImages: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphMegaTeasers' }
    & Pick<ParagraphMegaTeasers, 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphNewsTeaser' }
    & { newsContent: Maybe<(
      Pick<ContentNews, 'path' | 'title' | 'date'>
      & { teaserImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphSiteSearch' }
    & Pick<ParagraphSiteSearch, 'placeholderText'>
  ) | (
    { __typename: 'ParagraphSpacer' }
    & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
  ) | (
    { __typename: 'ParagraphSpecialistsSlider' }
    & Pick<ParagraphSpecialistsSlider, 'title'>
    & { specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
    & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
  ) | (
    { __typename: 'ParagraphStaticWallsBlock' }
    & Pick<ParagraphStaticWallsBlock, 'title'>
  ) | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphTeasers' }
    & Pick<ParagraphTeasers, 'display' | 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTestimonialSlider' }
    & Pick<ParagraphTestimonialSlider, 'title'>
    & { testimonial: Array<Maybe<(
      Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  ) | (
    { __typename: 'ParagraphTiles' }
    & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    )>> }
  ) | (
    { __typename: 'ParagraphTimeline' }
    & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>>, metaTags: Maybe<Array<Maybe<(
    Pick<MetaTag, 'tag'>
    & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
  )>>> }
);

export type LocationTeamPageFragment = (
  Pick<ContentLocation, 'drupalId' | 'title' | 'subtitle' | 'teamPageTitle'>
  & { locationPath: ContentLocation['path'] }
  & { locationBreadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, locationNavigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>>, contact: Maybe<(
    Pick<ContentLocationContact, 'path' | 'title' | 'companyName' | 'addressFirstLine' | 'addressSecondLine' | 'postCode' | 'city' | 'email' | 'phone' | 'mapOverlayHtml' | 'latitude' | 'longitude'>
    & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, locationHeader: { location: Maybe<(
        Pick<ContentLocation, 'path' | 'title' | 'subtitle'>
        & { contact: Maybe<Pick<ContentLocationContact, 'path'>> }
      )>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>> }, infoAddress: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, infoBooking: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, infoEmergency: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, parentLocation: Maybe<Pick<ContentLocation, 'title'>>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )>, metaTags: Maybe<Array<Maybe<(
    Pick<MetaTag, 'tag'>
    & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
  )>>>, area: Maybe<Pick<TermAdministrativeArea, 'title' | 'areaIdentifier'>> }
);

export type NewsPageFragment = (
  Pick<ContentNews, 'drupalId' | 'title' | 'lead' | 'date' | 'dateChanged' | 'readTime' | 'caption' | 'types' | 'gtmData'>
  & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, constructionTerms: Array<Maybe<(
    Pick<TermConstruction, 'title'>
    & { referenceNode: Maybe<Pick<ContentBaby, 'title' | 'path'> | Pick<ContentDisease, 'title' | 'path'> | Pick<ContentDocumentationPage, 'title' | 'path'> | Pick<ContentEvent, 'title' | 'path'> | Pick<ContentKitchenSink, 'title' | 'path'> | Pick<ContentLandingPage, 'title' | 'path'> | Pick<ContentLocation, 'title' | 'path'> | Pick<ContentLocationContact, 'title' | 'path'> | Pick<ContentNews, 'title' | 'path'> | Pick<ContentPage, 'title' | 'path'> | Pick<ContentPatientInformation, 'title' | 'path'> | Pick<ContentSpecialist, 'title' | 'path'> | Pick<ContentTeam, 'title' | 'path'> | Pick<GroupDocumentation, 'title' | 'path'>> }
  )>>, knowledgeTerms: Array<Maybe<(
    Pick<TermKnowledge, 'title'>
    & { referenceNode: Maybe<Pick<ContentBaby, 'title' | 'path'> | Pick<ContentDisease, 'title' | 'path'> | Pick<ContentDocumentationPage, 'title' | 'path'> | Pick<ContentEvent, 'title' | 'path'> | Pick<ContentKitchenSink, 'title' | 'path'> | Pick<ContentLandingPage, 'title' | 'path'> | Pick<ContentLocation, 'title' | 'path'> | Pick<ContentLocationContact, 'title' | 'path'> | Pick<ContentNews, 'title' | 'path'> | Pick<ContentPage, 'title' | 'path'> | Pick<ContentPatientInformation, 'title' | 'path'> | Pick<ContentSpecialist, 'title' | 'path'> | Pick<ContentTeam, 'title' | 'path'> | Pick<GroupDocumentation, 'title' | 'path'>> }
  )>>, strategyTerms: Array<Maybe<(
    Pick<TermStrategy, 'title'>
    & { referenceNode: Maybe<Pick<ContentBaby, 'title' | 'path'> | Pick<ContentDisease, 'title' | 'path'> | Pick<ContentDocumentationPage, 'title' | 'path'> | Pick<ContentEvent, 'title' | 'path'> | Pick<ContentKitchenSink, 'title' | 'path'> | Pick<ContentLandingPage, 'title' | 'path'> | Pick<ContentLocation, 'title' | 'path'> | Pick<ContentLocationContact, 'title' | 'path'> | Pick<ContentNews, 'title' | 'path'> | Pick<ContentPage, 'title' | 'path'> | Pick<ContentPatientInformation, 'title' | 'path'> | Pick<ContentSpecialist, 'title' | 'path'> | Pick<ContentTeam, 'title' | 'path'> | Pick<GroupDocumentation, 'title' | 'path'>> }
  )>>, teaserImage: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>>, styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )>, body: Array<Maybe<(
    { __typename: 'ParagraphAccordion' }
    & { accordionElements: Array<(
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    )> }
  ) | (
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphAnchor' }
    & Pick<ParagraphAnchor, 'anchorLink'>
  ) | (
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumbers' }
    & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
    & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumberRange' }
      & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphBabiesSearch' }
    & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphCallToAction' }
    & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
    & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualEvent' }
    & { event: Maybe<(
      Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualText' }
    & Pick<ParagraphContextualText, 'title' | 'textHtml'>
    & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
  ) | (
    { __typename: 'ParagraphDocuments' }
    & Pick<ParagraphDocuments, 'title'>
    & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
  ) | { __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphEventForm' }
    & Pick<ParagraphEventForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphEventsSearch' }
    & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphFileList' }
    & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphForm' }
    & Pick<ParagraphForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphFormattedTextWithTitle' }
    & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphLabCardListing' }
    & Pick<ParagraphLabCardListing, 'title'>
  ) | (
    { __typename: 'ParagraphLinkList' }
    & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  ) | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  ) | (
    { __typename: 'ParagraphListingAllocation' }
    & Pick<ParagraphListingAllocation, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingClinicsByArea' }
    & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingDiseaseFromLocation' }
    & Pick<ParagraphListingDiseaseFromLocation, 'title'>
    & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
  ) | (
    { __typename: 'ParagraphListingDiseaseSearchSource' }
    & Pick<ParagraphListingDiseaseSearchSource, 'title'>
  ) | (
    { __typename: 'ParagraphListingEventsEmbed' }
    & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByDepartment' }
    & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
    & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingJobList' }
    & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
  ) | (
    { __typename: 'ParagraphListingJobToolSearch' }
    & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
    & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
  ) | (
    { __typename: 'ParagraphListingLocationByTreatmentOffer' }
    & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingMedicineNews' }
    & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
    & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFiltered' }
    & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
    & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFrontpage' }
    & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
    & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomResearch' }
    & Pick<ParagraphListingNewsroomResearch, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomTreatment' }
    & Pick<ParagraphListingNewsroomTreatment, 'argument'>
  ) | (
    { __typename: 'ParagraphListingSpecialists' }
    & Pick<ParagraphListingSpecialists, 'title'>
  ) | (
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  ) | (
    { __typename: 'ParagraphLogoCloud' }
    & { logoImages: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphMegaTeasers' }
    & Pick<ParagraphMegaTeasers, 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphNewsTeaser' }
    & { newsContent: Maybe<(
      Pick<ContentNews, 'path' | 'title' | 'date'>
      & { teaserImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphSiteSearch' }
    & Pick<ParagraphSiteSearch, 'placeholderText'>
  ) | (
    { __typename: 'ParagraphSpacer' }
    & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
  ) | (
    { __typename: 'ParagraphSpecialistsSlider' }
    & Pick<ParagraphSpecialistsSlider, 'title'>
    & { specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
    & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
  ) | (
    { __typename: 'ParagraphStaticWallsBlock' }
    & Pick<ParagraphStaticWallsBlock, 'title'>
  ) | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphTeasers' }
    & Pick<ParagraphTeasers, 'display' | 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTestimonialSlider' }
    & Pick<ParagraphTestimonialSlider, 'title'>
    & { testimonial: Array<Maybe<(
      Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  ) | (
    { __typename: 'ParagraphTiles' }
    & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    )>> }
  ) | (
    { __typename: 'ParagraphTimeline' }
    & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>>, locations: Array<Maybe<(
    Pick<ContentLocation, 'title' | 'path'>
    & { area: Maybe<Pick<TermAdministrativeArea, 'title'>> }
  )>>, specialists: Array<Maybe<(
    { __typename: 'ContentSpecialist' }
    & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
    & { imagePortrait: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  )>>, diseases: Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>, sidebar: Array<Maybe<(
    { __typename: 'ParagraphAccordion' }
    & { accordionElements: Array<(
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    )> }
  ) | (
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphAnchor' }
    & Pick<ParagraphAnchor, 'anchorLink'>
  ) | (
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumbers' }
    & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
    & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumberRange' }
      & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphBabiesSearch' }
    & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphCallToAction' }
    & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
    & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualEvent' }
    & { event: Maybe<(
      Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualText' }
    & Pick<ParagraphContextualText, 'title' | 'textHtml'>
    & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
  ) | (
    { __typename: 'ParagraphDocuments' }
    & Pick<ParagraphDocuments, 'title'>
    & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
  ) | { __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphEventForm' }
    & Pick<ParagraphEventForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphEventsSearch' }
    & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphFileList' }
    & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphForm' }
    & Pick<ParagraphForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphFormattedTextWithTitle' }
    & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphLabCardListing' }
    & Pick<ParagraphLabCardListing, 'title'>
  ) | (
    { __typename: 'ParagraphLinkList' }
    & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  ) | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  ) | (
    { __typename: 'ParagraphListingAllocation' }
    & Pick<ParagraphListingAllocation, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingClinicsByArea' }
    & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingDiseaseFromLocation' }
    & Pick<ParagraphListingDiseaseFromLocation, 'title'>
    & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
  ) | (
    { __typename: 'ParagraphListingDiseaseSearchSource' }
    & Pick<ParagraphListingDiseaseSearchSource, 'title'>
  ) | (
    { __typename: 'ParagraphListingEventsEmbed' }
    & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByDepartment' }
    & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
    & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingJobList' }
    & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
  ) | (
    { __typename: 'ParagraphListingJobToolSearch' }
    & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
    & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
  ) | (
    { __typename: 'ParagraphListingLocationByTreatmentOffer' }
    & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingMedicineNews' }
    & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
    & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFiltered' }
    & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
    & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFrontpage' }
    & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
    & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomResearch' }
    & Pick<ParagraphListingNewsroomResearch, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomTreatment' }
    & Pick<ParagraphListingNewsroomTreatment, 'argument'>
  ) | (
    { __typename: 'ParagraphListingSpecialists' }
    & Pick<ParagraphListingSpecialists, 'title'>
  ) | (
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  ) | (
    { __typename: 'ParagraphLogoCloud' }
    & { logoImages: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphMegaTeasers' }
    & Pick<ParagraphMegaTeasers, 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphNewsTeaser' }
    & { newsContent: Maybe<(
      Pick<ContentNews, 'path' | 'title' | 'date'>
      & { teaserImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphSiteSearch' }
    & Pick<ParagraphSiteSearch, 'placeholderText'>
  ) | (
    { __typename: 'ParagraphSpacer' }
    & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
  ) | (
    { __typename: 'ParagraphSpecialistsSlider' }
    & Pick<ParagraphSpecialistsSlider, 'title'>
    & { specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
    & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
  ) | (
    { __typename: 'ParagraphStaticWallsBlock' }
    & Pick<ParagraphStaticWallsBlock, 'title'>
  ) | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphTeasers' }
    & Pick<ParagraphTeasers, 'display' | 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTestimonialSlider' }
    & Pick<ParagraphTestimonialSlider, 'title'>
    & { testimonial: Array<Maybe<(
      Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  ) | (
    { __typename: 'ParagraphTiles' }
    & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    )>> }
  ) | (
    { __typename: 'ParagraphTimeline' }
    & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>>, metaTags: Maybe<Array<Maybe<(
    Pick<MetaTag, 'tag'>
    & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
  )>>> }
);

export type PatientInformationPageFragment = (
  Pick<ContentPatientInformation, 'title' | 'path'>
  & { documentationGroup: Maybe<(
    Pick<GroupDocumentation, 'title' | 'path'>
    & { mainContent: Maybe<Pick<ContentDocumentationPage, 'path'> | Pick<ContentPatientInformation, 'path'>>, menuMain: Maybe<Array<Pick<MenuItem, 'id' | 'parent' | 'url' | 'label'>>> }
  )>, body: Array<Maybe<(
    { __typename: 'ParagraphAccordion' }
    & { accordionElements: Array<(
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    )> }
  ) | (
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphAnchor' }
    & Pick<ParagraphAnchor, 'anchorLink'>
  ) | (
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumbers' }
    & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
    & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumberRange' }
      & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphBabiesSearch' }
    & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphCallToAction' }
    & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
    & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualEvent' }
    & { event: Maybe<(
      Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualText' }
    & Pick<ParagraphContextualText, 'title' | 'textHtml'>
    & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
  ) | (
    { __typename: 'ParagraphDocuments' }
    & Pick<ParagraphDocuments, 'title'>
    & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
  ) | { __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphEventForm' }
    & Pick<ParagraphEventForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphEventsSearch' }
    & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphFileList' }
    & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphForm' }
    & Pick<ParagraphForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphFormattedTextWithTitle' }
    & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphLabCardListing' }
    & Pick<ParagraphLabCardListing, 'title'>
  ) | (
    { __typename: 'ParagraphLinkList' }
    & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  ) | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  ) | (
    { __typename: 'ParagraphListingAllocation' }
    & Pick<ParagraphListingAllocation, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingClinicsByArea' }
    & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingDiseaseFromLocation' }
    & Pick<ParagraphListingDiseaseFromLocation, 'title'>
    & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
  ) | (
    { __typename: 'ParagraphListingDiseaseSearchSource' }
    & Pick<ParagraphListingDiseaseSearchSource, 'title'>
  ) | (
    { __typename: 'ParagraphListingEventsEmbed' }
    & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByDepartment' }
    & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
    & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingJobList' }
    & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
  ) | (
    { __typename: 'ParagraphListingJobToolSearch' }
    & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
    & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
  ) | (
    { __typename: 'ParagraphListingLocationByTreatmentOffer' }
    & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingMedicineNews' }
    & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
    & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFiltered' }
    & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
    & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFrontpage' }
    & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
    & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomResearch' }
    & Pick<ParagraphListingNewsroomResearch, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomTreatment' }
    & Pick<ParagraphListingNewsroomTreatment, 'argument'>
  ) | (
    { __typename: 'ParagraphListingSpecialists' }
    & Pick<ParagraphListingSpecialists, 'title'>
  ) | (
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  ) | (
    { __typename: 'ParagraphLogoCloud' }
    & { logoImages: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphMegaTeasers' }
    & Pick<ParagraphMegaTeasers, 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphNewsTeaser' }
    & { newsContent: Maybe<(
      Pick<ContentNews, 'path' | 'title' | 'date'>
      & { teaserImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphSiteSearch' }
    & Pick<ParagraphSiteSearch, 'placeholderText'>
  ) | (
    { __typename: 'ParagraphSpacer' }
    & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
  ) | (
    { __typename: 'ParagraphSpecialistsSlider' }
    & Pick<ParagraphSpecialistsSlider, 'title'>
    & { specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
    & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
  ) | (
    { __typename: 'ParagraphStaticWallsBlock' }
    & Pick<ParagraphStaticWallsBlock, 'title'>
  ) | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphTeasers' }
    & Pick<ParagraphTeasers, 'display' | 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTestimonialSlider' }
    & Pick<ParagraphTestimonialSlider, 'title'>
    & { testimonial: Array<Maybe<(
      Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  ) | (
    { __typename: 'ParagraphTiles' }
    & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    )>> }
  ) | (
    { __typename: 'ParagraphTimeline' }
    & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>>, metaTags: Maybe<Array<Maybe<(
    Pick<MetaTag, 'tag'>
    & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
  )>>> }
);

export type SpecialistPageFragment = (
  Pick<ContentSpecialist, 'drupalId' | 'title' | 'firstName' | 'lastName' | 'degree' | 'job' | 'gender' | 'department' | 'path' | 'treatments' | 'email' | 'phone' | 'career' | 'memberships' | 'awards' | 'mandates' | 'studies' | 'gtmData' | 'languages' | 'forceChildrenHospitalTheme'>
  & { imageLandscape: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )>, areas: Array<Maybe<Pick<TermAdministrativeArea, 'title'>>>, locations: Array<Maybe<(
    Pick<ContentLocation, 'title' | 'path'>
    & { area: Maybe<Pick<TermAdministrativeArea, 'title'>> }
  )>>, expertise: Maybe<Array<Maybe<Pick<TermExpertise, 'title'>>>>, publications: Maybe<Pick<LinkWithText, 'text' | 'url'>>, personalSecretaries: Array<Pick<Secretary, 'title' | 'email' | 'phone'>>, offices: Maybe<Array<Maybe<(
    Pick<ContentLocationContact, 'email' | 'phone'>
    & { locationHeader: { location: Maybe<(
        Pick<ContentLocation, 'title' | 'path'>
        & { area: Maybe<Pick<TermAdministrativeArea, 'title'>> }
      )> } }
  )>>>, contactInfo: Array<Pick<SpecialistContactInfo, 'label' | 'value'>>, metaTags: Maybe<Array<Maybe<(
    Pick<MetaTag, 'tag'>
    & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
  )>>> }
);

export type TeamPageFragment = (
  Pick<ContentTeam, 'title' | 'specialistsTitle'>
  & { description: ContentTeam['lead'] }
  & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, body: Array<Maybe<(
    { __typename: 'ParagraphAccordion' }
    & { accordionElements: Array<(
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    )> }
  ) | (
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphAnchor' }
    & Pick<ParagraphAnchor, 'anchorLink'>
  ) | (
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumbers' }
    & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
    & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumberRange' }
      & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphBabiesSearch' }
    & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphCallToAction' }
    & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
    & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualEvent' }
    & { event: Maybe<(
      Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualText' }
    & Pick<ParagraphContextualText, 'title' | 'textHtml'>
    & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
  ) | (
    { __typename: 'ParagraphDocuments' }
    & Pick<ParagraphDocuments, 'title'>
    & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
  ) | { __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphEventForm' }
    & Pick<ParagraphEventForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphEventsSearch' }
    & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphFileList' }
    & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphForm' }
    & Pick<ParagraphForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphFormattedTextWithTitle' }
    & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphLabCardListing' }
    & Pick<ParagraphLabCardListing, 'title'>
  ) | (
    { __typename: 'ParagraphLinkList' }
    & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  ) | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  ) | (
    { __typename: 'ParagraphListingAllocation' }
    & Pick<ParagraphListingAllocation, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingClinicsByArea' }
    & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingDiseaseFromLocation' }
    & Pick<ParagraphListingDiseaseFromLocation, 'title'>
    & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
  ) | (
    { __typename: 'ParagraphListingDiseaseSearchSource' }
    & Pick<ParagraphListingDiseaseSearchSource, 'title'>
  ) | (
    { __typename: 'ParagraphListingEventsEmbed' }
    & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByDepartment' }
    & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
    & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingJobList' }
    & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
  ) | (
    { __typename: 'ParagraphListingJobToolSearch' }
    & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
    & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
  ) | (
    { __typename: 'ParagraphListingLocationByTreatmentOffer' }
    & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingMedicineNews' }
    & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
    & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFiltered' }
    & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
    & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFrontpage' }
    & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
    & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomResearch' }
    & Pick<ParagraphListingNewsroomResearch, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomTreatment' }
    & Pick<ParagraphListingNewsroomTreatment, 'argument'>
  ) | (
    { __typename: 'ParagraphListingSpecialists' }
    & Pick<ParagraphListingSpecialists, 'title'>
  ) | (
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  ) | (
    { __typename: 'ParagraphLogoCloud' }
    & { logoImages: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphMegaTeasers' }
    & Pick<ParagraphMegaTeasers, 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphNewsTeaser' }
    & { newsContent: Maybe<(
      Pick<ContentNews, 'path' | 'title' | 'date'>
      & { teaserImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphSiteSearch' }
    & Pick<ParagraphSiteSearch, 'placeholderText'>
  ) | (
    { __typename: 'ParagraphSpacer' }
    & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
  ) | (
    { __typename: 'ParagraphSpecialistsSlider' }
    & Pick<ParagraphSpecialistsSlider, 'title'>
    & { specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
    & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
  ) | (
    { __typename: 'ParagraphStaticWallsBlock' }
    & Pick<ParagraphStaticWallsBlock, 'title'>
  ) | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphTeasers' }
    & Pick<ParagraphTeasers, 'display' | 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTestimonialSlider' }
    & Pick<ParagraphTestimonialSlider, 'title'>
    & { testimonial: Array<Maybe<(
      Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  ) | (
    { __typename: 'ParagraphTiles' }
    & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    )>> }
  ) | (
    { __typename: 'ParagraphTimeline' }
    & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>>, specialists: Array<Maybe<(
    { __typename: 'ContentSpecialist' }
    & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
    & { imagePortrait: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  )>>, contentBottom: Array<Maybe<(
    { __typename: 'ParagraphAccordion' }
    & { accordionElements: Array<(
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    )> }
  ) | (
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphAnchor' }
    & Pick<ParagraphAnchor, 'anchorLink'>
  ) | (
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumbers' }
    & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
    & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumberRange' }
      & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphBabiesSearch' }
    & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphCallToAction' }
    & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
    & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualEvent' }
    & { event: Maybe<(
      Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualText' }
    & Pick<ParagraphContextualText, 'title' | 'textHtml'>
    & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
  ) | (
    { __typename: 'ParagraphDocuments' }
    & Pick<ParagraphDocuments, 'title'>
    & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
  ) | { __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphEventForm' }
    & Pick<ParagraphEventForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphEventsSearch' }
    & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphFileList' }
    & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphForm' }
    & Pick<ParagraphForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphFormattedTextWithTitle' }
    & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphLabCardListing' }
    & Pick<ParagraphLabCardListing, 'title'>
  ) | (
    { __typename: 'ParagraphLinkList' }
    & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  ) | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  ) | (
    { __typename: 'ParagraphListingAllocation' }
    & Pick<ParagraphListingAllocation, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingClinicsByArea' }
    & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingDiseaseFromLocation' }
    & Pick<ParagraphListingDiseaseFromLocation, 'title'>
    & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
  ) | (
    { __typename: 'ParagraphListingDiseaseSearchSource' }
    & Pick<ParagraphListingDiseaseSearchSource, 'title'>
  ) | (
    { __typename: 'ParagraphListingEventsEmbed' }
    & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByDepartment' }
    & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
    & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingJobList' }
    & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
  ) | (
    { __typename: 'ParagraphListingJobToolSearch' }
    & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
    & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
  ) | (
    { __typename: 'ParagraphListingLocationByTreatmentOffer' }
    & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingMedicineNews' }
    & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
    & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFiltered' }
    & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
    & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFrontpage' }
    & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
    & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomResearch' }
    & Pick<ParagraphListingNewsroomResearch, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomTreatment' }
    & Pick<ParagraphListingNewsroomTreatment, 'argument'>
  ) | (
    { __typename: 'ParagraphListingSpecialists' }
    & Pick<ParagraphListingSpecialists, 'title'>
  ) | (
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  ) | (
    { __typename: 'ParagraphLogoCloud' }
    & { logoImages: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphMegaTeasers' }
    & Pick<ParagraphMegaTeasers, 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphNewsTeaser' }
    & { newsContent: Maybe<(
      Pick<ContentNews, 'path' | 'title' | 'date'>
      & { teaserImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphSiteSearch' }
    & Pick<ParagraphSiteSearch, 'placeholderText'>
  ) | (
    { __typename: 'ParagraphSpacer' }
    & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
  ) | (
    { __typename: 'ParagraphSpecialistsSlider' }
    & Pick<ParagraphSpecialistsSlider, 'title'>
    & { specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
    & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
  ) | (
    { __typename: 'ParagraphStaticWallsBlock' }
    & Pick<ParagraphStaticWallsBlock, 'title'>
  ) | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphTeasers' }
    & Pick<ParagraphTeasers, 'display' | 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTestimonialSlider' }
    & Pick<ParagraphTestimonialSlider, 'title'>
    & { testimonial: Array<Maybe<(
      Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  ) | (
    { __typename: 'ParagraphTiles' }
    & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    )>> }
  ) | (
    { __typename: 'ParagraphTimeline' }
    & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>>, contentSidebar: Array<Maybe<(
    { __typename: 'ParagraphAccordion' }
    & { accordionElements: Array<(
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    )> }
  ) | (
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphAnchor' }
    & Pick<ParagraphAnchor, 'anchorLink'>
  ) | (
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumbers' }
    & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
    & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumberRange' }
      & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphBabiesSearch' }
    & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphCallToAction' }
    & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
    & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualEvent' }
    & { event: Maybe<(
      Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphContextualText' }
    & Pick<ParagraphContextualText, 'title' | 'textHtml'>
    & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
  ) | (
    { __typename: 'ParagraphDocuments' }
    & Pick<ParagraphDocuments, 'title'>
    & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
  ) | { __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphEventForm' }
    & Pick<ParagraphEventForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphEventsSearch' }
    & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
  ) | (
    { __typename: 'ParagraphFileList' }
    & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphForm' }
    & Pick<ParagraphForm, 'formUrl'>
  ) | (
    { __typename: 'ParagraphFormattedTextWithTitle' }
    & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
  ) | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphLabCardListing' }
    & Pick<ParagraphLabCardListing, 'title'>
  ) | (
    { __typename: 'ParagraphLinkList' }
    & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    )>> }
  ) | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  ) | (
    { __typename: 'ParagraphListingAllocation' }
    & Pick<ParagraphListingAllocation, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingClinicsByArea' }
    & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingDiseaseFromLocation' }
    & Pick<ParagraphListingDiseaseFromLocation, 'title'>
    & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
  ) | (
    { __typename: 'ParagraphListingDiseaseSearchSource' }
    & Pick<ParagraphListingDiseaseSearchSource, 'title'>
  ) | (
    { __typename: 'ParagraphListingEventsEmbed' }
    & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByDepartment' }
    & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
    & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
    & { cta: Pick<Link, 'url'> }
  ) | (
    { __typename: 'ParagraphListingJobList' }
    & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
  ) | (
    { __typename: 'ParagraphListingJobToolSearch' }
    & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
    & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
  ) | (
    { __typename: 'ParagraphListingLocationByTreatmentOffer' }
    & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingMedicineNews' }
    & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
    & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFiltered' }
    & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
    & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
  ) | (
    { __typename: 'ParagraphListingNewsroomFrontpage' }
    & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
    & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomResearch' }
    & Pick<ParagraphListingNewsroomResearch, 'argument'>
  ) | (
    { __typename: 'ParagraphListingNewsroomTreatment' }
    & Pick<ParagraphListingNewsroomTreatment, 'argument'>
  ) | (
    { __typename: 'ParagraphListingSpecialists' }
    & Pick<ParagraphListingSpecialists, 'title'>
  ) | (
    { __typename: 'ParagraphLiteratureLinks' }
    & { refLinks: Maybe<Array<Maybe<(
      Pick<LiteratureLinks, 'description'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLiteraturePdfs' }
    & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
  ) | (
    { __typename: 'ParagraphLiteratureText' }
    & Pick<ParagraphLiteratureText, 'textHtml'>
  ) | (
    { __typename: 'ParagraphLogoCloud' }
    & { logoImages: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>> }
  ) | (
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphMegaTeasers' }
    & Pick<ParagraphMegaTeasers, 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphNewsTeaser' }
    & { newsContent: Maybe<(
      Pick<ContentNews, 'path' | 'title' | 'date'>
      & { teaserImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )> }
  ) | (
    { __typename: 'ParagraphPreAnalyticData' }
    & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
    & { containerImage: Maybe<(
      Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
    )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphSiteSearch' }
    & Pick<ParagraphSiteSearch, 'placeholderText'>
  ) | (
    { __typename: 'ParagraphSpacer' }
    & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
  ) | (
    { __typename: 'ParagraphSpecialistsSlider' }
    & Pick<ParagraphSpecialistsSlider, 'title'>
    & { specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
    & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
  ) | (
    { __typename: 'ParagraphStaticWallsBlock' }
    & Pick<ParagraphStaticWallsBlock, 'title'>
  ) | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphTeasers' }
    & Pick<ParagraphTeasers, 'display' | 'title'>
    & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTestimonialSlider' }
    & Pick<ParagraphTestimonialSlider, 'title'>
    & { testimonial: Array<Maybe<(
      Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
      & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  ) | (
    { __typename: 'ParagraphTiles' }
    & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    )>> }
  ) | (
    { __typename: 'ParagraphTimeline' }
    & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  ) | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>>, locationHeader: { location: Maybe<(
      Pick<ContentLocation, 'path' | 'title' | 'subtitle'>
      & { contact: Maybe<Pick<ContentLocationContact, 'path'>> }
    )>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>> }, metaTags: Maybe<Array<Maybe<(
    Pick<MetaTag, 'tag'>
    & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
  )>>> }
);

export type ParagraphAccordionElementFragment = (
  { __typename: 'ParagraphAccordionElement' }
  & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
);

export type ParagraphAccordionFragment = (
  { __typename: 'ParagraphAccordion' }
  & { accordionElements: Array<(
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  )> }
);

export type EmptyFragment = { __typename: 'ParagraphEmpty' };

type AllParagraphs_ParagraphAccordion_Fragment = (
  { __typename: 'ParagraphAccordion' }
  & { accordionElements: Array<(
    { __typename: 'ParagraphAccordionElement' }
    & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
  )> }
);

type AllParagraphs_ParagraphAccordionElement_Fragment = (
  { __typename: 'ParagraphAccordionElement' }
  & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
);

type AllParagraphs_ParagraphAnchor_Fragment = (
  { __typename: 'ParagraphAnchor' }
  & Pick<ParagraphAnchor, 'anchorLink'>
);

type AllParagraphs_ParagraphAnimatedNumberElement_Fragment = (
  { __typename: 'ParagraphAnimatedNumberElement' }
  & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
  & { Image: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )> }
);

type AllParagraphs_ParagraphAnimatedNumbers_Fragment = (
  { __typename: 'ParagraphAnimatedNumbers' }
  & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
  & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumberRange' }
    & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  )>> }
);

type AllParagraphs_ParagraphBabiesSearch_Fragment = (
  { __typename: 'ParagraphBabiesSearch' }
  & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
);

type AllParagraphs_ParagraphCallToAction_Fragment = (
  { __typename: 'ParagraphCallToAction' }
  & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
  & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )> }
);

type AllParagraphs_ParagraphContextualEvent_Fragment = (
  { __typename: 'ParagraphContextualEvent' }
  & { event: Maybe<(
    Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  )> }
);

type AllParagraphs_ParagraphContextualText_Fragment = (
  { __typename: 'ParagraphContextualText' }
  & Pick<ParagraphContextualText, 'title' | 'textHtml'>
  & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
);

type AllParagraphs_ParagraphDocuments_Fragment = (
  { __typename: 'ParagraphDocuments' }
  & Pick<ParagraphDocuments, 'title'>
  & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
);

type AllParagraphs_ParagraphEmpty_Fragment = { __typename: 'ParagraphEmpty' };

type AllParagraphs_ParagraphEventForm_Fragment = (
  { __typename: 'ParagraphEventForm' }
  & Pick<ParagraphEventForm, 'formUrl'>
);

type AllParagraphs_ParagraphEventsSearch_Fragment = (
  { __typename: 'ParagraphEventsSearch' }
  & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
);

type AllParagraphs_ParagraphFileList_Fragment = (
  { __typename: 'ParagraphFileList' }
  & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
);

type AllParagraphs_ParagraphForm_Fragment = (
  { __typename: 'ParagraphForm' }
  & Pick<ParagraphForm, 'formUrl'>
);

type AllParagraphs_ParagraphFormattedTextWithTitle_Fragment = (
  { __typename: 'ParagraphFormattedTextWithTitle' }
  & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
);

type AllParagraphs_ParagraphImageCarousel_Fragment = (
  { __typename: 'ParagraphImageCarousel' }
  & Pick<ParagraphImageCarousel, 'display'>
  & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  )>> }
);

type AllParagraphs_ParagraphImageWithCaption_Fragment = (
  { __typename: 'ParagraphImageWithCaption' }
  & Pick<ParagraphImageWithCaption, 'caption'>
  & { image: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )> }
);

type AllParagraphs_ParagraphLabCardListing_Fragment = (
  { __typename: 'ParagraphLabCardListing' }
  & Pick<ParagraphLabCardListing, 'title'>
);

type AllParagraphs_ParagraphLinkList_Fragment = (
  { __typename: 'ParagraphLinkList' }
  & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  )>> }
);

type AllParagraphs_ParagraphLinkListLink_Fragment = (
  { __typename: 'ParagraphLinkListLink' }
  & Pick<ParagraphLinkListLink, 'title'>
  & { listLink: Pick<LinkWithText, 'url' | 'text'> }
);

type AllParagraphs_ParagraphListingAllocation_Fragment = (
  { __typename: 'ParagraphListingAllocation' }
  & Pick<ParagraphListingAllocation, 'title' | 'argument'>
);

type AllParagraphs_ParagraphListingClinicsByArea_Fragment = (
  { __typename: 'ParagraphListingClinicsByArea' }
  & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
);

type AllParagraphs_ParagraphListingDiseaseFromLocation_Fragment = (
  { __typename: 'ParagraphListingDiseaseFromLocation' }
  & Pick<ParagraphListingDiseaseFromLocation, 'title'>
  & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
);

type AllParagraphs_ParagraphListingDiseaseSearchSource_Fragment = (
  { __typename: 'ParagraphListingDiseaseSearchSource' }
  & Pick<ParagraphListingDiseaseSearchSource, 'title'>
);

type AllParagraphs_ParagraphListingEventsEmbed_Fragment = (
  { __typename: 'ParagraphListingEventsEmbed' }
  & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
  & { cta: Pick<Link, 'url'> }
);

type AllParagraphs_ParagraphListingEventsEmbedByDepartment_Fragment = (
  { __typename: 'ParagraphListingEventsEmbedByDepartment' }
  & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
  & { cta: Pick<Link, 'url'> }
);

type AllParagraphs_ParagraphListingEventsEmbedByTypeAndDepartment_Fragment = (
  { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
  & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
  & { cta: Pick<Link, 'url'> }
);

type AllParagraphs_ParagraphListingJobList_Fragment = (
  { __typename: 'ParagraphListingJobList' }
  & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
);

type AllParagraphs_ParagraphListingJobToolSearch_Fragment = (
  { __typename: 'ParagraphListingJobToolSearch' }
  & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
  & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
);

type AllParagraphs_ParagraphListingLocationByTreatmentOffer_Fragment = (
  { __typename: 'ParagraphListingLocationByTreatmentOffer' }
  & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
);

type AllParagraphs_ParagraphListingMedicineNews_Fragment = (
  { __typename: 'ParagraphListingMedicineNews' }
  & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
  & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
);

type AllParagraphs_ParagraphListingNewsroomFiltered_Fragment = (
  { __typename: 'ParagraphListingNewsroomFiltered' }
  & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
  & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
);

type AllParagraphs_ParagraphListingNewsroomFrontpage_Fragment = (
  { __typename: 'ParagraphListingNewsroomFrontpage' }
  & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
);

type AllParagraphs_ParagraphListingNewsroomPersonnelBlock_Fragment = (
  { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
  & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
);

type AllParagraphs_ParagraphListingNewsroomResearch_Fragment = (
  { __typename: 'ParagraphListingNewsroomResearch' }
  & Pick<ParagraphListingNewsroomResearch, 'argument'>
);

type AllParagraphs_ParagraphListingNewsroomTreatment_Fragment = (
  { __typename: 'ParagraphListingNewsroomTreatment' }
  & Pick<ParagraphListingNewsroomTreatment, 'argument'>
);

type AllParagraphs_ParagraphListingSpecialists_Fragment = (
  { __typename: 'ParagraphListingSpecialists' }
  & Pick<ParagraphListingSpecialists, 'title'>
);

type AllParagraphs_ParagraphLiteratureLinks_Fragment = (
  { __typename: 'ParagraphLiteratureLinks' }
  & { refLinks: Maybe<Array<Maybe<(
    Pick<LiteratureLinks, 'description'>
    & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
  )>>> }
);

type AllParagraphs_ParagraphLiteraturePdfs_Fragment = (
  { __typename: 'ParagraphLiteraturePdfs' }
  & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
);

type AllParagraphs_ParagraphLiteratureText_Fragment = (
  { __typename: 'ParagraphLiteratureText' }
  & Pick<ParagraphLiteratureText, 'textHtml'>
);

type AllParagraphs_ParagraphLogoCloud_Fragment = (
  { __typename: 'ParagraphLogoCloud' }
  & { logoImages: Maybe<Array<Maybe<(
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  )>>> }
);

type AllParagraphs_ParagraphLogoCloudImage_Fragment = (
  { __typename: 'ParagraphLogoCloudImage' }
  & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )> }
);

type AllParagraphs_ParagraphMegaTeasers_Fragment = (
  { __typename: 'ParagraphMegaTeasers' }
  & Pick<ParagraphMegaTeasers, 'title'>
  & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  )>> }
);

type AllParagraphs_ParagraphNewsTeaser_Fragment = (
  { __typename: 'ParagraphNewsTeaser' }
  & { newsContent: Maybe<(
    Pick<ContentNews, 'path' | 'title' | 'date'>
    & { teaserImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  )> }
);

type AllParagraphs_ParagraphPreAnalyticData_Fragment = (
  { __typename: 'ParagraphPreAnalyticData' }
  & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
  & { containerImage: Maybe<(
    Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
  )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
);

type AllParagraphs_ParagraphQuote_Fragment = (
  { __typename: 'ParagraphQuote' }
  & Pick<ParagraphQuote, 'author' | 'quote'>
);

type AllParagraphs_ParagraphSiteSearch_Fragment = (
  { __typename: 'ParagraphSiteSearch' }
  & Pick<ParagraphSiteSearch, 'placeholderText'>
);

type AllParagraphs_ParagraphSpacer_Fragment = (
  { __typename: 'ParagraphSpacer' }
  & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
);

type AllParagraphs_ParagraphSpecialistsSlider_Fragment = (
  { __typename: 'ParagraphSpecialistsSlider' }
  & Pick<ParagraphSpecialistsSlider, 'title'>
  & { specialists: Array<Maybe<(
    { __typename: 'ContentSpecialist' }
    & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
    & { imagePortrait: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  )>> }
);

type AllParagraphs_ParagraphStaticCampaignMonitorSubscribeForm_Fragment = (
  { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
  & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
);

type AllParagraphs_ParagraphStaticWallsBlock_Fragment = (
  { __typename: 'ParagraphStaticWallsBlock' }
  & Pick<ParagraphStaticWallsBlock, 'title'>
);

type AllParagraphs_ParagraphTeaser_Fragment = (
  { __typename: 'ParagraphTeaser' }
  & Pick<ParagraphTeaser, 'title' | 'lead'>
  & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )> }
);

type AllParagraphs_ParagraphTeasers_Fragment = (
  { __typename: 'ParagraphTeasers' }
  & Pick<ParagraphTeasers, 'display' | 'title'>
  & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  )>> }
);

type AllParagraphs_ParagraphTestimonialSlider_Fragment = (
  { __typename: 'ParagraphTestimonialSlider' }
  & Pick<ParagraphTestimonialSlider, 'title'>
  & { testimonial: Array<Maybe<(
    Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
    & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  )>> }
);

type AllParagraphs_ParagraphTile_Fragment = (
  { __typename: 'ParagraphTile' }
  & Pick<ParagraphTile, 'text' | 'url'>
);

type AllParagraphs_ParagraphTiles_Fragment = (
  { __typename: 'ParagraphTiles' }
  & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  )>> }
);

type AllParagraphs_ParagraphTimeline_Fragment = (
  { __typename: 'ParagraphTimeline' }
  & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  )>> }
);

type AllParagraphs_ParagraphTimelineElement_Fragment = (
  { __typename: 'ParagraphTimelineElement' }
  & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
  & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>> }
);

type AllParagraphs_ParagraphTimelineGroup_Fragment = (
  { __typename: 'ParagraphTimelineGroup' }
  & Pick<ParagraphTimelineGroup, 'groupTitle'>
  & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  )>> }
);

type AllParagraphs_ParagraphVideo_Fragment = (
  { __typename: 'ParagraphVideo' }
  & { image: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )>, video: Maybe<(
    { __typename: 'MediaVideoLocal' }
    & Pick<MediaVideoLocal, 'url'>
  ) | (
    { __typename: 'MediaVideoRemote' }
    & Pick<MediaVideoRemote, 'url'>
  )> }
);

type AllParagraphs_ParagraphWysiwygContent_Fragment = (
  { __typename: 'ParagraphWysiwygContent' }
  & Pick<ParagraphWysiwygContent, 'textHtml'>
);

type AllParagraphs_ParagraphYoutubeEmbed_Fragment = (
  { __typename: 'ParagraphYoutubeEmbed' }
  & { embed: Pick<Link, 'url'> }
);

export type AllParagraphsFragment = AllParagraphs_ParagraphAccordion_Fragment | AllParagraphs_ParagraphAccordionElement_Fragment | AllParagraphs_ParagraphAnchor_Fragment | AllParagraphs_ParagraphAnimatedNumberElement_Fragment | AllParagraphs_ParagraphAnimatedNumbers_Fragment | AllParagraphs_ParagraphBabiesSearch_Fragment | AllParagraphs_ParagraphCallToAction_Fragment | AllParagraphs_ParagraphContextualEvent_Fragment | AllParagraphs_ParagraphContextualText_Fragment | AllParagraphs_ParagraphDocuments_Fragment | AllParagraphs_ParagraphEmpty_Fragment | AllParagraphs_ParagraphEventForm_Fragment | AllParagraphs_ParagraphEventsSearch_Fragment | AllParagraphs_ParagraphFileList_Fragment | AllParagraphs_ParagraphForm_Fragment | AllParagraphs_ParagraphFormattedTextWithTitle_Fragment | AllParagraphs_ParagraphImageCarousel_Fragment | AllParagraphs_ParagraphImageWithCaption_Fragment | AllParagraphs_ParagraphLabCardListing_Fragment | AllParagraphs_ParagraphLinkList_Fragment | AllParagraphs_ParagraphLinkListLink_Fragment | AllParagraphs_ParagraphListingAllocation_Fragment | AllParagraphs_ParagraphListingClinicsByArea_Fragment | AllParagraphs_ParagraphListingDiseaseFromLocation_Fragment | AllParagraphs_ParagraphListingDiseaseSearchSource_Fragment | AllParagraphs_ParagraphListingEventsEmbed_Fragment | AllParagraphs_ParagraphListingEventsEmbedByDepartment_Fragment | AllParagraphs_ParagraphListingEventsEmbedByTypeAndDepartment_Fragment | AllParagraphs_ParagraphListingJobList_Fragment | AllParagraphs_ParagraphListingJobToolSearch_Fragment | AllParagraphs_ParagraphListingLocationByTreatmentOffer_Fragment | AllParagraphs_ParagraphListingMedicineNews_Fragment | AllParagraphs_ParagraphListingNewsroomFiltered_Fragment | AllParagraphs_ParagraphListingNewsroomFrontpage_Fragment | AllParagraphs_ParagraphListingNewsroomPersonnelBlock_Fragment | AllParagraphs_ParagraphListingNewsroomResearch_Fragment | AllParagraphs_ParagraphListingNewsroomTreatment_Fragment | AllParagraphs_ParagraphListingSpecialists_Fragment | AllParagraphs_ParagraphLiteratureLinks_Fragment | AllParagraphs_ParagraphLiteraturePdfs_Fragment | AllParagraphs_ParagraphLiteratureText_Fragment | AllParagraphs_ParagraphLogoCloud_Fragment | AllParagraphs_ParagraphLogoCloudImage_Fragment | AllParagraphs_ParagraphMegaTeasers_Fragment | AllParagraphs_ParagraphNewsTeaser_Fragment | AllParagraphs_ParagraphPreAnalyticData_Fragment | AllParagraphs_ParagraphQuote_Fragment | AllParagraphs_ParagraphSiteSearch_Fragment | AllParagraphs_ParagraphSpacer_Fragment | AllParagraphs_ParagraphSpecialistsSlider_Fragment | AllParagraphs_ParagraphStaticCampaignMonitorSubscribeForm_Fragment | AllParagraphs_ParagraphStaticWallsBlock_Fragment | AllParagraphs_ParagraphTeaser_Fragment | AllParagraphs_ParagraphTeasers_Fragment | AllParagraphs_ParagraphTestimonialSlider_Fragment | AllParagraphs_ParagraphTile_Fragment | AllParagraphs_ParagraphTiles_Fragment | AllParagraphs_ParagraphTimeline_Fragment | AllParagraphs_ParagraphTimelineElement_Fragment | AllParagraphs_ParagraphTimelineGroup_Fragment | AllParagraphs_ParagraphVideo_Fragment | AllParagraphs_ParagraphWysiwygContent_Fragment | AllParagraphs_ParagraphYoutubeEmbed_Fragment;

export type ParagraphListingAllocationFragment = (
  { __typename: 'ParagraphListingAllocation' }
  & Pick<ParagraphListingAllocation, 'title' | 'argument'>
);

export type ParagraphAnchorFragment = (
  { __typename: 'ParagraphAnchor' }
  & Pick<ParagraphAnchor, 'anchorLink'>
);

export type AnimatedNumberElementFragment = (
  { __typename: 'ParagraphAnimatedNumberElement' }
  & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
  & { Image: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )> }
);

export type AnimatedNumberRangeFragment = (
  { __typename: 'ParagraphAnimatedNumberRange' }
  & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
  & { Image: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )> }
);

export type AnimatedNumbersFragment = (
  { __typename: 'ParagraphAnimatedNumbers' }
  & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
  & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
    { __typename: 'ParagraphAnimatedNumberElement' }
    & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphAnimatedNumberRange' }
    & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
    & { Image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  )>> }
);

export type ParagraphBabyGalleryFragment = (
  { __typename: 'ParagraphBabiesSearch' }
  & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
);

export type CallToActionFragment = (
  { __typename: 'ParagraphCallToAction' }
  & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
  & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )> }
);

export type CmSubscribeFormFragment = (
  { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
  & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
);

export type CarouselImageFragment = (
  { __typename: 'ParagraphImageWithCaption' }
  & Pick<ParagraphImageWithCaption, 'caption'>
  & { image: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )> }
);

export type CarouselVideoFragment = (
  { __typename: 'ParagraphVideo' }
  & { image: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )>, video: Maybe<(
    { __typename: 'MediaVideoLocal' }
    & Pick<MediaVideoLocal, 'url'>
  ) | (
    { __typename: 'MediaVideoRemote' }
    & Pick<MediaVideoRemote, 'url'>
  )> }
);

export type CarouselFragment = (
  { __typename: 'ParagraphImageCarousel' }
  & Pick<ParagraphImageCarousel, 'display'>
  & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  )>> }
);

export type ParagraphListingClinicsByAreaFragment = (
  { __typename: 'ParagraphListingClinicsByArea' }
  & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
);

export type ParagraphListingClinicsByTreatmentFragment = (
  { __typename: 'ParagraphListingLocationByTreatmentOffer' }
  & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
);

export type ContextualEventFragment = (
  { __typename: 'ParagraphContextualEvent' }
  & { event: Maybe<(
    Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  )> }
);

export type ContextualTextFragment = (
  { __typename: 'ParagraphContextualText' }
  & Pick<ParagraphContextualText, 'title' | 'textHtml'>
  & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
);

export type ParagraphListingDiseaseFromLocationFragment = (
  { __typename: 'ParagraphListingDiseaseFromLocation' }
  & Pick<ParagraphListingDiseaseFromLocation, 'title'>
  & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
);

export type DiseaseListingFragment = (
  { __typename: 'ParagraphListingDiseaseSearchSource' }
  & Pick<ParagraphListingDiseaseSearchSource, 'title'>
);

export type DocumentsFragment = (
  { __typename: 'ParagraphDocuments' }
  & Pick<ParagraphDocuments, 'title'>
  & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
);

export type EventSearchFragment = (
  { __typename: 'ParagraphEventsSearch' }
  & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
);

export type ParagraphListingEventsEmbedFragment = (
  { __typename: 'ParagraphListingEventsEmbed' }
  & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
  & { cta: Pick<Link, 'url'> }
);

export type ParagraphListingEventsEmbedByDepartmentFragment = (
  { __typename: 'ParagraphListingEventsEmbedByDepartment' }
  & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
  & { cta: Pick<Link, 'url'> }
);

export type ParagraphListingEventsEmbedByTypeAndDepartmentFragment = (
  { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
  & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
  & { cta: Pick<Link, 'url'> }
);

export type FileListFragment = (
  { __typename: 'ParagraphFileList' }
  & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
);

export type FormattedTextWithTitleFragment = (
  { __typename: 'ParagraphFormattedTextWithTitle' }
  & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
);

export type ImageWithCaptionFragment = (
  { __typename: 'ParagraphImageWithCaption' }
  & Pick<ParagraphImageWithCaption, 'caption'>
  & { image: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )> }
);

export type ParagraphListingJobListFragment = (
  { __typename: 'ParagraphListingJobList' }
  & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
);

export type ParagraphListingJobToolSearchFragment = (
  { __typename: 'ParagraphListingJobToolSearch' }
  & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
  & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
);

export type ParagraphLabCardListingFragment = (
  { __typename: 'ParagraphLabCardListing' }
  & Pick<ParagraphLabCardListing, 'title'>
);

export type LinkListLinkFragment = (
  { __typename: 'ParagraphLinkListLink' }
  & Pick<ParagraphLinkListLink, 'title'>
  & { listLink: Pick<LinkWithText, 'url' | 'text'> }
);

export type LinkListFragment = (
  { __typename: 'ParagraphLinkList' }
  & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphLinkListLink' }
    & Pick<ParagraphLinkListLink, 'title'>
    & { listLink: Pick<LinkWithText, 'url' | 'text'> }
  )>> }
);

export type ParagraphLiteratureLinksFragment = (
  { __typename: 'ParagraphLiteratureLinks' }
  & { refLinks: Maybe<Array<Maybe<(
    Pick<LiteratureLinks, 'description'>
    & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
  )>>> }
);

export type ParagraphLiteraturePdfsFragment = (
  { __typename: 'ParagraphLiteraturePdfs' }
  & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
);

export type ParagraphLiteratureTextFragment = (
  { __typename: 'ParagraphLiteratureText' }
  & Pick<ParagraphLiteratureText, 'textHtml'>
);

export type LocalVideoFragment = (
  { __typename: 'ParagraphVideo' }
  & { image: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )>, video: Maybe<(
    { __typename: 'MediaVideoLocal' }
    & Pick<MediaVideoLocal, 'url'>
  ) | (
    { __typename: 'MediaVideoRemote' }
    & Pick<MediaVideoRemote, 'url'>
  )> }
);

export type ParagraphLogoCloudImageFragment = (
  { __typename: 'ParagraphLogoCloudImage' }
  & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )> }
);

export type ParagraphLogoCloudFragment = (
  { __typename: 'ParagraphLogoCloud' }
  & { logoImages: Maybe<Array<Maybe<(
    { __typename: 'ParagraphLogoCloudImage' }
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  )>>> }
);

type MediaVideo_MediaVideoLocal_Fragment = (
  { __typename: 'MediaVideoLocal' }
  & Pick<MediaVideoLocal, 'url'>
);

type MediaVideo_MediaVideoRemote_Fragment = (
  { __typename: 'MediaVideoRemote' }
  & Pick<MediaVideoRemote, 'url'>
);

export type MediaVideoFragment = MediaVideo_MediaVideoLocal_Fragment | MediaVideo_MediaVideoRemote_Fragment;

export type ParagraphListingMedicineNewsFragment = (
  { __typename: 'ParagraphListingMedicineNews' }
  & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
  & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
);

export type MegaTeasersFragment = (
  { __typename: 'ParagraphMegaTeasers' }
  & Pick<ParagraphMegaTeasers, 'title'>
  & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  )>> }
);

export type NewsTeaserFragment = (
  { __typename: 'ParagraphNewsTeaser' }
  & { newsContent: Maybe<(
    Pick<ContentNews, 'path' | 'title' | 'date'>
    & { teaserImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  )> }
);

export type ParagraphNewsroomFilteredFragment = (
  { __typename: 'ParagraphListingNewsroomFiltered' }
  & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
  & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
);

export type ParagraphNewsroomFrontpageFragment = (
  { __typename: 'ParagraphListingNewsroomFrontpage' }
  & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
);

export type ParagraphNewsroomPersonnelBlockFragment = (
  { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
  & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
);

export type ParagraphNewsroomResearchFragment = (
  { __typename: 'ParagraphListingNewsroomResearch' }
  & Pick<ParagraphListingNewsroomResearch, 'argument'>
);

export type ParagraphNewsroomTreatmentFragment = (
  { __typename: 'ParagraphListingNewsroomTreatment' }
  & Pick<ParagraphListingNewsroomTreatment, 'argument'>
);

export type ParagraphPreAnalyticDataFragment = (
  { __typename: 'ParagraphPreAnalyticData' }
  & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
  & { containerImage: Maybe<(
    Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
  )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
);

export type QuoteFragment = (
  { __typename: 'ParagraphQuote' }
  & Pick<ParagraphQuote, 'author' | 'quote'>
);

export type SiteSearchFragment = (
  { __typename: 'ParagraphSiteSearch' }
  & Pick<ParagraphSiteSearch, 'placeholderText'>
);

export type SpacerFragment = (
  { __typename: 'ParagraphSpacer' }
  & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
);

export type ParagraphSpecialistGalleryFragment = (
  { __typename: 'ParagraphListingSpecialists' }
  & Pick<ParagraphListingSpecialists, 'title'>
);

export type SpecialistSlideFragment = (
  { __typename: 'ContentSpecialist' }
  & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
  & { imagePortrait: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )> }
);

export type SpecialistSliderFragment = (
  { __typename: 'ParagraphSpecialistsSlider' }
  & Pick<ParagraphSpecialistsSlider, 'title'>
  & { specialists: Array<Maybe<(
    { __typename: 'ContentSpecialist' }
    & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
    & { imagePortrait: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  )>> }
);

export type TeaserFragment = (
  { __typename: 'ParagraphTeaser' }
  & Pick<ParagraphTeaser, 'title' | 'lead'>
  & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
    { __typename: 'MediaImage' }
    & Pick<MediaImage, 'id' | 'alt'>
    & { styles: Array<(
      Pick<ImageStyle, 'id'>
      & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
    )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
  )> }
);

export type TeasersFragment = (
  { __typename: 'ParagraphTeasers' }
  & Pick<ParagraphTeasers, 'display' | 'title'>
  & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphTeaser' }
    & Pick<ParagraphTeaser, 'title' | 'lead'>
    & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  )>> }
);

export type TestimonialSliderFragment = (
  { __typename: 'ParagraphTestimonialSlider' }
  & Pick<ParagraphTestimonialSlider, 'title'>
  & { testimonial: Array<Maybe<(
    Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
    & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  )>> }
);

export type TileFragment = (
  { __typename: 'ParagraphTile' }
  & Pick<ParagraphTile, 'text' | 'url'>
);

export type TilesFragment = (
  { __typename: 'ParagraphTiles' }
  & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphTile' }
    & Pick<ParagraphTile, 'text' | 'url'>
  )>> }
);

export type TimelineElementFragment = (
  { __typename: 'ParagraphTimelineElement' }
  & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
  & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphImageCarousel' }
    & Pick<ParagraphImageCarousel, 'display'>
    & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    )>> }
  ) | (
    { __typename: 'ParagraphImageWithCaption' }
    & Pick<ParagraphImageWithCaption, 'caption'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )> }
  ) | (
    { __typename: 'ParagraphQuote' }
    & Pick<ParagraphQuote, 'author' | 'quote'>
  ) | (
    { __typename: 'ParagraphVideo' }
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )> }
  ) | (
    { __typename: 'ParagraphWysiwygContent' }
    & Pick<ParagraphWysiwygContent, 'textHtml'>
  ) | (
    { __typename: 'ParagraphYoutubeEmbed' }
    & { embed: Pick<Link, 'url'> }
  )>> }
);

export type TimelineGroupFragment = (
  { __typename: 'ParagraphTimelineGroup' }
  & Pick<ParagraphTimelineGroup, 'groupTitle'>
  & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphTimelineElement' }
    & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
    & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  )>> }
);

export type TimelineFragment = (
  { __typename: 'ParagraphTimeline' }
  & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
    { __typename: 'ParagraphTimelineGroup' }
    & Pick<ParagraphTimelineGroup, 'groupTitle'>
    & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    )>> }
  )>> }
);

export type WallsIoFragment = (
  { __typename: 'ParagraphStaticWallsBlock' }
  & Pick<ParagraphStaticWallsBlock, 'title'>
);

export type ParagraphWebformFragment = (
  { __typename: 'ParagraphForm' }
  & Pick<ParagraphForm, 'formUrl'>
);

export type ParagraphWebformEventFragment = (
  { __typename: 'ParagraphEventForm' }
  & Pick<ParagraphEventForm, 'formUrl'>
);

export type WysiwygFragment = (
  { __typename: 'ParagraphWysiwygContent' }
  & Pick<ParagraphWysiwygContent, 'textHtml'>
);

export type YoutubeEmbedFragment = (
  { __typename: 'ParagraphYoutubeEmbed' }
  & { embed: Pick<Link, 'url'> }
);

export type ContentAnalysisQueryVariables = Exact<{
  remoteId: Scalars['String'];
}>;


export type ContentAnalysisQuery = { content: Maybe<(
    Pick<ContentAnalysis, 'drupalId' | 'analysisName' | 'analysisExternal' | 'synonymsKeyWords' | 'clinicIndicationHtml' | 'sampleStabilityStorageHtml' | 'subsequentRegulationHtml' | 'interferenceFactorsHtml' | 'methodHtml' | 'unit' | 'conversionFactorHtml' | 'referenceRangesHtml' | 'analysisFrequency' | 'interpretationHtml' | 'notesInternalHtml'>
    & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>>, preAnalyticData: Maybe<Array<Maybe<(
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    )>>>, laboratoryContact: Maybe<Array<Maybe<Pick<TermLabContact, 'uuid' | 'labContact' | 'telephoneNumber' | 'internalLab'>>>>, literatureReference: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    )>>>, specialityArea: Maybe<Array<Maybe<Pick<TermSpecialityArea, 'uuid' | 'title'>>>>, links: Maybe<Array<Maybe<Pick<LinkWithText, 'text' | 'url'>>>>, taxposition: Maybe<Array<Maybe<Pick<TermTaxposition, 'taxposition' | 'taxpoints' | 'description'>>>> }
  )> };

export type ContentAnalysisRevisionQueryVariables = Exact<{
  remoteId: Scalars['String'];
  revisionId: Scalars['String'];
}>;


export type ContentAnalysisRevisionQuery = { content: Maybe<(
    Pick<ContentAnalysis, 'drupalId' | 'analysisName' | 'analysisExternal' | 'synonymsKeyWords' | 'clinicIndicationHtml' | 'sampleStabilityStorageHtml' | 'subsequentRegulationHtml' | 'interferenceFactorsHtml' | 'methodHtml' | 'unit' | 'conversionFactorHtml' | 'referenceRangesHtml' | 'analysisFrequency' | 'interpretationHtml' | 'notesInternalHtml'>
    & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>>, preAnalyticData: Maybe<Array<Maybe<(
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    )>>>, laboratoryContact: Maybe<Array<Maybe<Pick<TermLabContact, 'uuid' | 'labContact' | 'telephoneNumber' | 'internalLab'>>>>, literatureReference: Maybe<Array<Maybe<(
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    )>>>, specialityArea: Maybe<Array<Maybe<Pick<TermSpecialityArea, 'uuid' | 'title'>>>>, links: Maybe<Array<Maybe<Pick<LinkWithText, 'text' | 'url'>>>>, taxposition: Maybe<Array<Maybe<Pick<TermTaxposition, 'taxposition' | 'taxpoints' | 'description'>>>> }
  )> };

export type ContentBabyQueryVariables = Exact<{
  remoteId: Scalars['String'];
}>;


export type ContentBabyQuery = { content: Maybe<(
    Pick<ContentBaby, 'title' | 'dateOfBirth' | 'gender' | 'weight' | 'height' | 'createdTimestamp' | 'gtmData'>
    & { location: Maybe<(
      Pick<ContentLocation, 'title' | 'path'>
      & { area: Maybe<Pick<TermAdministrativeArea, 'title'>> }
    )>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type ContentBabyRevisionQueryVariables = Exact<{
  remoteId: Scalars['String'];
  revisionId: Scalars['String'];
}>;


export type ContentBabyRevisionQuery = { content: Maybe<(
    Pick<ContentBaby, 'title' | 'dateOfBirth' | 'gender' | 'weight' | 'height' | 'createdTimestamp' | 'gtmData'>
    & { location: Maybe<(
      Pick<ContentLocation, 'title' | 'path'>
      & { area: Maybe<Pick<TermAdministrativeArea, 'title'>> }
    )>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type ContentDiseaseQueryVariables = Exact<{
  remoteId: Scalars['String'];
}>;


export type ContentDiseaseQuery = { content: Maybe<(
    Pick<ContentDisease, 'drupalId' | 'title' | 'shortDescriptionHtml' | 'overviewHtml' | 'causesHtml' | 'symptomsHtml' | 'diagnosisHtml' | 'courseHtml' | 'treatmentHtml' | 'preventionHtml' | 'specialistsTitle' | 'gtmData'>
    & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, faqs: Maybe<{ accordionElements: Array<Pick<ParagraphAccordionElement, 'title' | 'textHtml'>> }>, specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>, paragraphBottom: Array<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type ContentDiseaseRevisionQueryVariables = Exact<{
  remoteId: Scalars['String'];
  revisionId: Scalars['String'];
}>;


export type ContentDiseaseRevisionQuery = { content: Maybe<(
    Pick<ContentDisease, 'drupalId' | 'title' | 'shortDescriptionHtml' | 'overviewHtml' | 'causesHtml' | 'symptomsHtml' | 'diagnosisHtml' | 'courseHtml' | 'treatmentHtml' | 'preventionHtml' | 'specialistsTitle' | 'gtmData'>
    & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, faqs: Maybe<{ accordionElements: Array<Pick<ParagraphAccordionElement, 'title' | 'textHtml'>> }>, specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>, paragraphBottom: Array<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type ContentDocumentationPageQueryVariables = Exact<{
  remoteId: Scalars['String'];
}>;


export type ContentDocumentationPageQuery = { content: Maybe<(
    Pick<ContentDocumentationPage, 'title' | 'path'>
    & { group: Maybe<(
      Pick<GroupDocumentation, 'title' | 'path'>
      & { mainContent: Maybe<Pick<ContentDocumentationPage, 'path'> | Pick<ContentPatientInformation, 'path'>>, menuMain: Maybe<Array<Pick<MenuItem, 'id' | 'parent' | 'url' | 'label'>>> }
    )>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>>, paragraphs: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  )> };

export type ContentDocumentationPageRevisionQueryVariables = Exact<{
  remoteId: Scalars['String'];
  revisionId: Scalars['String'];
}>;


export type ContentDocumentationPageRevisionQuery = { content: Maybe<(
    Pick<ContentDocumentationPage, 'title' | 'path'>
    & { group: Maybe<(
      Pick<GroupDocumentation, 'title' | 'path'>
      & { mainContent: Maybe<Pick<ContentDocumentationPage, 'path'> | Pick<ContentPatientInformation, 'path'>>, menuMain: Maybe<Array<Pick<MenuItem, 'id' | 'parent' | 'url' | 'label'>>> }
    )>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>>, paragraphs: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  )> };

export type ContentEventQueryVariables = Exact<{
  remoteId: Scalars['String'];
}>;


export type ContentEventQuery = { content: Maybe<(
    Pick<ContentEvent, 'drupalId' | 'createdTimestamp' | 'title' | 'location' | 'startDate' | 'startTime' | 'endDate' | 'endTime' | 'lead' | 'eventStatus' | 'gtmData'>
    & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, organizer: Array<Maybe<Pick<ContentLocation, 'title' | 'subtitle' | 'path'>>>, content: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, form: Maybe<Pick<ParagraphEventForm, 'formUrl'>>, sidebar: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type ContentEventRevisionQueryVariables = Exact<{
  remoteId: Scalars['String'];
  revisionId: Scalars['String'];
}>;


export type ContentEventRevisionQuery = { content: Maybe<(
    Pick<ContentEvent, 'drupalId' | 'createdTimestamp' | 'title' | 'location' | 'startDate' | 'startTime' | 'endDate' | 'endTime' | 'lead' | 'eventStatus' | 'gtmData'>
    & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, organizer: Array<Maybe<Pick<ContentLocation, 'title' | 'subtitle' | 'path'>>>, content: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, form: Maybe<Pick<ParagraphEventForm, 'formUrl'>>, sidebar: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type ContentKitchenSinkQueryVariables = Exact<{
  remoteId: Scalars['String'];
}>;


export type ContentKitchenSinkQuery = { content: Maybe<(
    Pick<ContentKitchenSink, 'title'>
    & { paragraphs: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  )> };

export type ContentKitchenSinkRevisionQueryVariables = Exact<{
  remoteId: Scalars['String'];
  revisionId: Scalars['String'];
}>;


export type ContentKitchenSinkRevisionQuery = { content: Maybe<(
    Pick<ContentKitchenSink, 'title'>
    & { paragraphs: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>> }
  )> };

export type ContentLandingPageQueryVariables = Exact<{
  remoteId: Scalars['String'];
}>;


export type ContentLandingPageQuery = { content: Maybe<(
    Pick<ContentLandingPage, 'title' | 'description' | 'increaseHeroHeight'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )>, body: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, advertCollection: Maybe<(
      Pick<ContentAdvertCollection, 'frequency' | 'positioning' | 'repetitions'>
      & { collection: Array<Maybe<(
        Pick<ContentAdvert, 'id' | 'title' | 'text' | 'textAlignment' | 'buttonPlacement'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, link: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    )>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type ContentLandingPageRevisionQueryVariables = Exact<{
  remoteId: Scalars['String'];
  revisionId: Scalars['String'];
}>;


export type ContentLandingPageRevisionQuery = { content: Maybe<(
    Pick<ContentLandingPage, 'title' | 'description' | 'increaseHeroHeight'>
    & { image: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, video: Maybe<(
      { __typename: 'MediaVideoLocal' }
      & Pick<MediaVideoLocal, 'url'>
    ) | (
      { __typename: 'MediaVideoRemote' }
      & Pick<MediaVideoRemote, 'url'>
    )>, body: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, advertCollection: Maybe<(
      Pick<ContentAdvertCollection, 'frequency' | 'positioning' | 'repetitions'>
      & { collection: Array<Maybe<(
        Pick<ContentAdvert, 'id' | 'title' | 'text' | 'textAlignment' | 'buttonPlacement'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, link: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    )>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type ContentLocationContactQueryVariables = Exact<{
  remoteId: Scalars['String'];
}>;


export type ContentLocationContactQuery = { content: Maybe<(
    Pick<ContentLocationContact, 'path' | 'title' | 'companyName' | 'addressFirstLine' | 'addressSecondLine' | 'postCode' | 'city' | 'email' | 'phone' | 'mapOverlayHtml' | 'latitude' | 'longitude'>
    & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, locationHeader: { location: Maybe<(
        Pick<ContentLocation, 'path' | 'title' | 'subtitle'>
        & { contact: Maybe<Pick<ContentLocationContact, 'path'>> }
      )>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>> }, infoAddress: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, infoBooking: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, infoEmergency: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, parentLocation: Maybe<Pick<ContentLocation, 'title'>>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type ContentLocationContactRevisionQueryVariables = Exact<{
  remoteId: Scalars['String'];
  revisionId: Scalars['String'];
}>;


export type ContentLocationContactRevisionQuery = { content: Maybe<(
    Pick<ContentLocationContact, 'path' | 'title' | 'companyName' | 'addressFirstLine' | 'addressSecondLine' | 'postCode' | 'city' | 'email' | 'phone' | 'mapOverlayHtml' | 'latitude' | 'longitude'>
    & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, locationHeader: { location: Maybe<(
        Pick<ContentLocation, 'path' | 'title' | 'subtitle'>
        & { contact: Maybe<Pick<ContentLocationContact, 'path'>> }
      )>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>> }, infoAddress: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, infoBooking: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, infoEmergency: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, parentLocation: Maybe<Pick<ContentLocation, 'title'>>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type ContentLocationNewsQueryVariables = Exact<{
  remoteId: Scalars['String'];
}>;


export type ContentLocationNewsQuery = { content: Maybe<(
    Pick<ContentLocation, 'drupalId' | 'title' | 'subtitle'>
    & { locationPath: ContentLocation['path'] }
    & { locationBreadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, locationNavigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>>, contact: Maybe<(
      Pick<ContentLocationContact, 'path' | 'title' | 'companyName' | 'addressFirstLine' | 'addressSecondLine' | 'postCode' | 'city' | 'email' | 'phone' | 'mapOverlayHtml' | 'latitude' | 'longitude'>
      & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, locationHeader: { location: Maybe<(
          Pick<ContentLocation, 'path' | 'title' | 'subtitle'>
          & { contact: Maybe<Pick<ContentLocationContact, 'path'>> }
        )>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>> }, infoAddress: Array<Maybe<(
        { __typename: 'ParagraphAccordion' }
        & { accordionElements: Array<(
          { __typename: 'ParagraphAccordionElement' }
          & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
        )> }
      ) | (
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphAnchor' }
        & Pick<ParagraphAnchor, 'anchorLink'>
      ) | (
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumbers' }
        & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
        & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
          { __typename: 'ParagraphAnimatedNumberElement' }
          & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphAnimatedNumberRange' }
          & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphBabiesSearch' }
        & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphCallToAction' }
        & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
        & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualEvent' }
        & { event: Maybe<(
          Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualText' }
        & Pick<ParagraphContextualText, 'title' | 'textHtml'>
        & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
      ) | (
        { __typename: 'ParagraphDocuments' }
        & Pick<ParagraphDocuments, 'title'>
        & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
      ) | { __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphEventForm' }
        & Pick<ParagraphEventForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphEventsSearch' }
        & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphFileList' }
        & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphForm' }
        & Pick<ParagraphForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphFormattedTextWithTitle' }
        & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphLabCardListing' }
        & Pick<ParagraphLabCardListing, 'title'>
      ) | (
        { __typename: 'ParagraphLinkList' }
        & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphLinkListLink' }
          & Pick<ParagraphLinkListLink, 'title'>
          & { listLink: Pick<LinkWithText, 'url' | 'text'> }
        )>> }
      ) | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      ) | (
        { __typename: 'ParagraphListingAllocation' }
        & Pick<ParagraphListingAllocation, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingClinicsByArea' }
        & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingDiseaseFromLocation' }
        & Pick<ParagraphListingDiseaseFromLocation, 'title'>
        & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
      ) | (
        { __typename: 'ParagraphListingDiseaseSearchSource' }
        & Pick<ParagraphListingDiseaseSearchSource, 'title'>
      ) | (
        { __typename: 'ParagraphListingEventsEmbed' }
        & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByDepartment' }
        & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
        & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingJobList' }
        & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
      ) | (
        { __typename: 'ParagraphListingJobToolSearch' }
        & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
        & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
      ) | (
        { __typename: 'ParagraphListingLocationByTreatmentOffer' }
        & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingMedicineNews' }
        & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
        & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFiltered' }
        & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
        & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFrontpage' }
        & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
        & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomResearch' }
        & Pick<ParagraphListingNewsroomResearch, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomTreatment' }
        & Pick<ParagraphListingNewsroomTreatment, 'argument'>
      ) | (
        { __typename: 'ParagraphListingSpecialists' }
        & Pick<ParagraphListingSpecialists, 'title'>
      ) | (
        { __typename: 'ParagraphLiteratureLinks' }
        & { refLinks: Maybe<Array<Maybe<(
          Pick<LiteratureLinks, 'description'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLiteraturePdfs' }
        & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
      ) | (
        { __typename: 'ParagraphLiteratureText' }
        & Pick<ParagraphLiteratureText, 'textHtml'>
      ) | (
        { __typename: 'ParagraphLogoCloud' }
        & { logoImages: Maybe<Array<Maybe<(
          { __typename: 'ParagraphLogoCloudImage' }
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphMegaTeasers' }
        & Pick<ParagraphMegaTeasers, 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphNewsTeaser' }
        & { newsContent: Maybe<(
          Pick<ContentNews, 'path' | 'title' | 'date'>
          & { teaserImage: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphPreAnalyticData' }
        & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
        & { containerImage: Maybe<(
          Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
        )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphSiteSearch' }
        & Pick<ParagraphSiteSearch, 'placeholderText'>
      ) | (
        { __typename: 'ParagraphSpacer' }
        & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
      ) | (
        { __typename: 'ParagraphSpecialistsSlider' }
        & Pick<ParagraphSpecialistsSlider, 'title'>
        & { specialists: Array<Maybe<(
          { __typename: 'ContentSpecialist' }
          & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
          & { imagePortrait: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
        & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
      ) | (
        { __typename: 'ParagraphStaticWallsBlock' }
        & Pick<ParagraphStaticWallsBlock, 'title'>
      ) | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphTeasers' }
        & Pick<ParagraphTeasers, 'display' | 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTestimonialSlider' }
        & Pick<ParagraphTestimonialSlider, 'title'>
        & { testimonial: Array<Maybe<(
          Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      ) | (
        { __typename: 'ParagraphTiles' }
        & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTile' }
          & Pick<ParagraphTile, 'text' | 'url'>
        )>> }
      ) | (
        { __typename: 'ParagraphTimeline' }
        & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineGroup' }
          & Pick<ParagraphTimelineGroup, 'groupTitle'>
          & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphTimelineElement' }
            & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
            & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageCarousel' }
              & Pick<ParagraphImageCarousel, 'display'>
              & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
                { __typename: 'ParagraphImageWithCaption' }
                & Pick<ParagraphImageWithCaption, 'caption'>
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )> }
              ) | (
                { __typename: 'ParagraphVideo' }
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )>, video: Maybe<(
                  { __typename: 'MediaVideoLocal' }
                  & Pick<MediaVideoLocal, 'url'>
                ) | (
                  { __typename: 'MediaVideoRemote' }
                  & Pick<MediaVideoRemote, 'url'>
                )> }
              )>> }
            ) | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphQuote' }
              & Pick<ParagraphQuote, 'author' | 'quote'>
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            ) | (
              { __typename: 'ParagraphWysiwygContent' }
              & Pick<ParagraphWysiwygContent, 'textHtml'>
            ) | (
              { __typename: 'ParagraphYoutubeEmbed' }
              & { embed: Pick<Link, 'url'> }
            )>> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>>, infoBooking: Array<Maybe<(
        { __typename: 'ParagraphAccordion' }
        & { accordionElements: Array<(
          { __typename: 'ParagraphAccordionElement' }
          & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
        )> }
      ) | (
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphAnchor' }
        & Pick<ParagraphAnchor, 'anchorLink'>
      ) | (
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumbers' }
        & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
        & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
          { __typename: 'ParagraphAnimatedNumberElement' }
          & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphAnimatedNumberRange' }
          & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphBabiesSearch' }
        & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphCallToAction' }
        & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
        & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualEvent' }
        & { event: Maybe<(
          Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualText' }
        & Pick<ParagraphContextualText, 'title' | 'textHtml'>
        & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
      ) | (
        { __typename: 'ParagraphDocuments' }
        & Pick<ParagraphDocuments, 'title'>
        & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
      ) | { __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphEventForm' }
        & Pick<ParagraphEventForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphEventsSearch' }
        & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphFileList' }
        & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphForm' }
        & Pick<ParagraphForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphFormattedTextWithTitle' }
        & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphLabCardListing' }
        & Pick<ParagraphLabCardListing, 'title'>
      ) | (
        { __typename: 'ParagraphLinkList' }
        & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphLinkListLink' }
          & Pick<ParagraphLinkListLink, 'title'>
          & { listLink: Pick<LinkWithText, 'url' | 'text'> }
        )>> }
      ) | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      ) | (
        { __typename: 'ParagraphListingAllocation' }
        & Pick<ParagraphListingAllocation, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingClinicsByArea' }
        & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingDiseaseFromLocation' }
        & Pick<ParagraphListingDiseaseFromLocation, 'title'>
        & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
      ) | (
        { __typename: 'ParagraphListingDiseaseSearchSource' }
        & Pick<ParagraphListingDiseaseSearchSource, 'title'>
      ) | (
        { __typename: 'ParagraphListingEventsEmbed' }
        & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByDepartment' }
        & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
        & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingJobList' }
        & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
      ) | (
        { __typename: 'ParagraphListingJobToolSearch' }
        & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
        & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
      ) | (
        { __typename: 'ParagraphListingLocationByTreatmentOffer' }
        & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingMedicineNews' }
        & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
        & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFiltered' }
        & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
        & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFrontpage' }
        & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
        & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomResearch' }
        & Pick<ParagraphListingNewsroomResearch, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomTreatment' }
        & Pick<ParagraphListingNewsroomTreatment, 'argument'>
      ) | (
        { __typename: 'ParagraphListingSpecialists' }
        & Pick<ParagraphListingSpecialists, 'title'>
      ) | (
        { __typename: 'ParagraphLiteratureLinks' }
        & { refLinks: Maybe<Array<Maybe<(
          Pick<LiteratureLinks, 'description'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLiteraturePdfs' }
        & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
      ) | (
        { __typename: 'ParagraphLiteratureText' }
        & Pick<ParagraphLiteratureText, 'textHtml'>
      ) | (
        { __typename: 'ParagraphLogoCloud' }
        & { logoImages: Maybe<Array<Maybe<(
          { __typename: 'ParagraphLogoCloudImage' }
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphMegaTeasers' }
        & Pick<ParagraphMegaTeasers, 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphNewsTeaser' }
        & { newsContent: Maybe<(
          Pick<ContentNews, 'path' | 'title' | 'date'>
          & { teaserImage: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphPreAnalyticData' }
        & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
        & { containerImage: Maybe<(
          Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
        )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphSiteSearch' }
        & Pick<ParagraphSiteSearch, 'placeholderText'>
      ) | (
        { __typename: 'ParagraphSpacer' }
        & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
      ) | (
        { __typename: 'ParagraphSpecialistsSlider' }
        & Pick<ParagraphSpecialistsSlider, 'title'>
        & { specialists: Array<Maybe<(
          { __typename: 'ContentSpecialist' }
          & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
          & { imagePortrait: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
        & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
      ) | (
        { __typename: 'ParagraphStaticWallsBlock' }
        & Pick<ParagraphStaticWallsBlock, 'title'>
      ) | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphTeasers' }
        & Pick<ParagraphTeasers, 'display' | 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTestimonialSlider' }
        & Pick<ParagraphTestimonialSlider, 'title'>
        & { testimonial: Array<Maybe<(
          Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      ) | (
        { __typename: 'ParagraphTiles' }
        & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTile' }
          & Pick<ParagraphTile, 'text' | 'url'>
        )>> }
      ) | (
        { __typename: 'ParagraphTimeline' }
        & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineGroup' }
          & Pick<ParagraphTimelineGroup, 'groupTitle'>
          & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphTimelineElement' }
            & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
            & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageCarousel' }
              & Pick<ParagraphImageCarousel, 'display'>
              & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
                { __typename: 'ParagraphImageWithCaption' }
                & Pick<ParagraphImageWithCaption, 'caption'>
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )> }
              ) | (
                { __typename: 'ParagraphVideo' }
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )>, video: Maybe<(
                  { __typename: 'MediaVideoLocal' }
                  & Pick<MediaVideoLocal, 'url'>
                ) | (
                  { __typename: 'MediaVideoRemote' }
                  & Pick<MediaVideoRemote, 'url'>
                )> }
              )>> }
            ) | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphQuote' }
              & Pick<ParagraphQuote, 'author' | 'quote'>
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            ) | (
              { __typename: 'ParagraphWysiwygContent' }
              & Pick<ParagraphWysiwygContent, 'textHtml'>
            ) | (
              { __typename: 'ParagraphYoutubeEmbed' }
              & { embed: Pick<Link, 'url'> }
            )>> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>>, infoEmergency: Array<Maybe<(
        { __typename: 'ParagraphAccordion' }
        & { accordionElements: Array<(
          { __typename: 'ParagraphAccordionElement' }
          & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
        )> }
      ) | (
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphAnchor' }
        & Pick<ParagraphAnchor, 'anchorLink'>
      ) | (
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumbers' }
        & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
        & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
          { __typename: 'ParagraphAnimatedNumberElement' }
          & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphAnimatedNumberRange' }
          & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphBabiesSearch' }
        & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphCallToAction' }
        & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
        & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualEvent' }
        & { event: Maybe<(
          Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualText' }
        & Pick<ParagraphContextualText, 'title' | 'textHtml'>
        & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
      ) | (
        { __typename: 'ParagraphDocuments' }
        & Pick<ParagraphDocuments, 'title'>
        & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
      ) | { __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphEventForm' }
        & Pick<ParagraphEventForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphEventsSearch' }
        & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphFileList' }
        & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphForm' }
        & Pick<ParagraphForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphFormattedTextWithTitle' }
        & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphLabCardListing' }
        & Pick<ParagraphLabCardListing, 'title'>
      ) | (
        { __typename: 'ParagraphLinkList' }
        & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphLinkListLink' }
          & Pick<ParagraphLinkListLink, 'title'>
          & { listLink: Pick<LinkWithText, 'url' | 'text'> }
        )>> }
      ) | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      ) | (
        { __typename: 'ParagraphListingAllocation' }
        & Pick<ParagraphListingAllocation, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingClinicsByArea' }
        & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingDiseaseFromLocation' }
        & Pick<ParagraphListingDiseaseFromLocation, 'title'>
        & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
      ) | (
        { __typename: 'ParagraphListingDiseaseSearchSource' }
        & Pick<ParagraphListingDiseaseSearchSource, 'title'>
      ) | (
        { __typename: 'ParagraphListingEventsEmbed' }
        & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByDepartment' }
        & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
        & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingJobList' }
        & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
      ) | (
        { __typename: 'ParagraphListingJobToolSearch' }
        & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
        & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
      ) | (
        { __typename: 'ParagraphListingLocationByTreatmentOffer' }
        & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingMedicineNews' }
        & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
        & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFiltered' }
        & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
        & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFrontpage' }
        & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
        & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomResearch' }
        & Pick<ParagraphListingNewsroomResearch, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomTreatment' }
        & Pick<ParagraphListingNewsroomTreatment, 'argument'>
      ) | (
        { __typename: 'ParagraphListingSpecialists' }
        & Pick<ParagraphListingSpecialists, 'title'>
      ) | (
        { __typename: 'ParagraphLiteratureLinks' }
        & { refLinks: Maybe<Array<Maybe<(
          Pick<LiteratureLinks, 'description'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLiteraturePdfs' }
        & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
      ) | (
        { __typename: 'ParagraphLiteratureText' }
        & Pick<ParagraphLiteratureText, 'textHtml'>
      ) | (
        { __typename: 'ParagraphLogoCloud' }
        & { logoImages: Maybe<Array<Maybe<(
          { __typename: 'ParagraphLogoCloudImage' }
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphMegaTeasers' }
        & Pick<ParagraphMegaTeasers, 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphNewsTeaser' }
        & { newsContent: Maybe<(
          Pick<ContentNews, 'path' | 'title' | 'date'>
          & { teaserImage: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphPreAnalyticData' }
        & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
        & { containerImage: Maybe<(
          Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
        )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphSiteSearch' }
        & Pick<ParagraphSiteSearch, 'placeholderText'>
      ) | (
        { __typename: 'ParagraphSpacer' }
        & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
      ) | (
        { __typename: 'ParagraphSpecialistsSlider' }
        & Pick<ParagraphSpecialistsSlider, 'title'>
        & { specialists: Array<Maybe<(
          { __typename: 'ContentSpecialist' }
          & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
          & { imagePortrait: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
        & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
      ) | (
        { __typename: 'ParagraphStaticWallsBlock' }
        & Pick<ParagraphStaticWallsBlock, 'title'>
      ) | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphTeasers' }
        & Pick<ParagraphTeasers, 'display' | 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTestimonialSlider' }
        & Pick<ParagraphTestimonialSlider, 'title'>
        & { testimonial: Array<Maybe<(
          Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      ) | (
        { __typename: 'ParagraphTiles' }
        & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTile' }
          & Pick<ParagraphTile, 'text' | 'url'>
        )>> }
      ) | (
        { __typename: 'ParagraphTimeline' }
        & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineGroup' }
          & Pick<ParagraphTimelineGroup, 'groupTitle'>
          & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphTimelineElement' }
            & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
            & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageCarousel' }
              & Pick<ParagraphImageCarousel, 'display'>
              & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
                { __typename: 'ParagraphImageWithCaption' }
                & Pick<ParagraphImageWithCaption, 'caption'>
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )> }
              ) | (
                { __typename: 'ParagraphVideo' }
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )>, video: Maybe<(
                  { __typename: 'MediaVideoLocal' }
                  & Pick<MediaVideoLocal, 'url'>
                ) | (
                  { __typename: 'MediaVideoRemote' }
                  & Pick<MediaVideoRemote, 'url'>
                )> }
              )>> }
            ) | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphQuote' }
              & Pick<ParagraphQuote, 'author' | 'quote'>
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            ) | (
              { __typename: 'ParagraphWysiwygContent' }
              & Pick<ParagraphWysiwygContent, 'textHtml'>
            ) | (
              { __typename: 'ParagraphYoutubeEmbed' }
              & { embed: Pick<Link, 'url'> }
            )>> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>>, parentLocation: Maybe<Pick<ContentLocation, 'title'>>, metaTags: Maybe<Array<Maybe<(
        Pick<MetaTag, 'tag'>
        & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
      )>>> }
    )>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type ContentLocationNewsRevisionQueryVariables = Exact<{
  remoteId: Scalars['String'];
  revisionId: Scalars['String'];
}>;


export type ContentLocationNewsRevisionQuery = { content: Maybe<(
    Pick<ContentLocation, 'drupalId' | 'title' | 'subtitle'>
    & { locationPath: ContentLocation['path'] }
    & { locationBreadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, locationNavigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>>, contact: Maybe<(
      Pick<ContentLocationContact, 'path' | 'title' | 'companyName' | 'addressFirstLine' | 'addressSecondLine' | 'postCode' | 'city' | 'email' | 'phone' | 'mapOverlayHtml' | 'latitude' | 'longitude'>
      & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, locationHeader: { location: Maybe<(
          Pick<ContentLocation, 'path' | 'title' | 'subtitle'>
          & { contact: Maybe<Pick<ContentLocationContact, 'path'>> }
        )>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>> }, infoAddress: Array<Maybe<(
        { __typename: 'ParagraphAccordion' }
        & { accordionElements: Array<(
          { __typename: 'ParagraphAccordionElement' }
          & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
        )> }
      ) | (
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphAnchor' }
        & Pick<ParagraphAnchor, 'anchorLink'>
      ) | (
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumbers' }
        & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
        & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
          { __typename: 'ParagraphAnimatedNumberElement' }
          & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphAnimatedNumberRange' }
          & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphBabiesSearch' }
        & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphCallToAction' }
        & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
        & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualEvent' }
        & { event: Maybe<(
          Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualText' }
        & Pick<ParagraphContextualText, 'title' | 'textHtml'>
        & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
      ) | (
        { __typename: 'ParagraphDocuments' }
        & Pick<ParagraphDocuments, 'title'>
        & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
      ) | { __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphEventForm' }
        & Pick<ParagraphEventForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphEventsSearch' }
        & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphFileList' }
        & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphForm' }
        & Pick<ParagraphForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphFormattedTextWithTitle' }
        & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphLabCardListing' }
        & Pick<ParagraphLabCardListing, 'title'>
      ) | (
        { __typename: 'ParagraphLinkList' }
        & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphLinkListLink' }
          & Pick<ParagraphLinkListLink, 'title'>
          & { listLink: Pick<LinkWithText, 'url' | 'text'> }
        )>> }
      ) | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      ) | (
        { __typename: 'ParagraphListingAllocation' }
        & Pick<ParagraphListingAllocation, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingClinicsByArea' }
        & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingDiseaseFromLocation' }
        & Pick<ParagraphListingDiseaseFromLocation, 'title'>
        & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
      ) | (
        { __typename: 'ParagraphListingDiseaseSearchSource' }
        & Pick<ParagraphListingDiseaseSearchSource, 'title'>
      ) | (
        { __typename: 'ParagraphListingEventsEmbed' }
        & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByDepartment' }
        & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
        & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingJobList' }
        & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
      ) | (
        { __typename: 'ParagraphListingJobToolSearch' }
        & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
        & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
      ) | (
        { __typename: 'ParagraphListingLocationByTreatmentOffer' }
        & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingMedicineNews' }
        & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
        & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFiltered' }
        & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
        & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFrontpage' }
        & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
        & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomResearch' }
        & Pick<ParagraphListingNewsroomResearch, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomTreatment' }
        & Pick<ParagraphListingNewsroomTreatment, 'argument'>
      ) | (
        { __typename: 'ParagraphListingSpecialists' }
        & Pick<ParagraphListingSpecialists, 'title'>
      ) | (
        { __typename: 'ParagraphLiteratureLinks' }
        & { refLinks: Maybe<Array<Maybe<(
          Pick<LiteratureLinks, 'description'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLiteraturePdfs' }
        & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
      ) | (
        { __typename: 'ParagraphLiteratureText' }
        & Pick<ParagraphLiteratureText, 'textHtml'>
      ) | (
        { __typename: 'ParagraphLogoCloud' }
        & { logoImages: Maybe<Array<Maybe<(
          { __typename: 'ParagraphLogoCloudImage' }
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphMegaTeasers' }
        & Pick<ParagraphMegaTeasers, 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphNewsTeaser' }
        & { newsContent: Maybe<(
          Pick<ContentNews, 'path' | 'title' | 'date'>
          & { teaserImage: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphPreAnalyticData' }
        & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
        & { containerImage: Maybe<(
          Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
        )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphSiteSearch' }
        & Pick<ParagraphSiteSearch, 'placeholderText'>
      ) | (
        { __typename: 'ParagraphSpacer' }
        & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
      ) | (
        { __typename: 'ParagraphSpecialistsSlider' }
        & Pick<ParagraphSpecialistsSlider, 'title'>
        & { specialists: Array<Maybe<(
          { __typename: 'ContentSpecialist' }
          & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
          & { imagePortrait: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
        & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
      ) | (
        { __typename: 'ParagraphStaticWallsBlock' }
        & Pick<ParagraphStaticWallsBlock, 'title'>
      ) | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphTeasers' }
        & Pick<ParagraphTeasers, 'display' | 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTestimonialSlider' }
        & Pick<ParagraphTestimonialSlider, 'title'>
        & { testimonial: Array<Maybe<(
          Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      ) | (
        { __typename: 'ParagraphTiles' }
        & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTile' }
          & Pick<ParagraphTile, 'text' | 'url'>
        )>> }
      ) | (
        { __typename: 'ParagraphTimeline' }
        & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineGroup' }
          & Pick<ParagraphTimelineGroup, 'groupTitle'>
          & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphTimelineElement' }
            & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
            & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageCarousel' }
              & Pick<ParagraphImageCarousel, 'display'>
              & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
                { __typename: 'ParagraphImageWithCaption' }
                & Pick<ParagraphImageWithCaption, 'caption'>
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )> }
              ) | (
                { __typename: 'ParagraphVideo' }
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )>, video: Maybe<(
                  { __typename: 'MediaVideoLocal' }
                  & Pick<MediaVideoLocal, 'url'>
                ) | (
                  { __typename: 'MediaVideoRemote' }
                  & Pick<MediaVideoRemote, 'url'>
                )> }
              )>> }
            ) | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphQuote' }
              & Pick<ParagraphQuote, 'author' | 'quote'>
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            ) | (
              { __typename: 'ParagraphWysiwygContent' }
              & Pick<ParagraphWysiwygContent, 'textHtml'>
            ) | (
              { __typename: 'ParagraphYoutubeEmbed' }
              & { embed: Pick<Link, 'url'> }
            )>> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>>, infoBooking: Array<Maybe<(
        { __typename: 'ParagraphAccordion' }
        & { accordionElements: Array<(
          { __typename: 'ParagraphAccordionElement' }
          & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
        )> }
      ) | (
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphAnchor' }
        & Pick<ParagraphAnchor, 'anchorLink'>
      ) | (
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumbers' }
        & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
        & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
          { __typename: 'ParagraphAnimatedNumberElement' }
          & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphAnimatedNumberRange' }
          & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphBabiesSearch' }
        & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphCallToAction' }
        & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
        & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualEvent' }
        & { event: Maybe<(
          Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualText' }
        & Pick<ParagraphContextualText, 'title' | 'textHtml'>
        & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
      ) | (
        { __typename: 'ParagraphDocuments' }
        & Pick<ParagraphDocuments, 'title'>
        & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
      ) | { __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphEventForm' }
        & Pick<ParagraphEventForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphEventsSearch' }
        & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphFileList' }
        & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphForm' }
        & Pick<ParagraphForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphFormattedTextWithTitle' }
        & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphLabCardListing' }
        & Pick<ParagraphLabCardListing, 'title'>
      ) | (
        { __typename: 'ParagraphLinkList' }
        & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphLinkListLink' }
          & Pick<ParagraphLinkListLink, 'title'>
          & { listLink: Pick<LinkWithText, 'url' | 'text'> }
        )>> }
      ) | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      ) | (
        { __typename: 'ParagraphListingAllocation' }
        & Pick<ParagraphListingAllocation, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingClinicsByArea' }
        & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingDiseaseFromLocation' }
        & Pick<ParagraphListingDiseaseFromLocation, 'title'>
        & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
      ) | (
        { __typename: 'ParagraphListingDiseaseSearchSource' }
        & Pick<ParagraphListingDiseaseSearchSource, 'title'>
      ) | (
        { __typename: 'ParagraphListingEventsEmbed' }
        & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByDepartment' }
        & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
        & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingJobList' }
        & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
      ) | (
        { __typename: 'ParagraphListingJobToolSearch' }
        & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
        & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
      ) | (
        { __typename: 'ParagraphListingLocationByTreatmentOffer' }
        & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingMedicineNews' }
        & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
        & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFiltered' }
        & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
        & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFrontpage' }
        & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
        & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomResearch' }
        & Pick<ParagraphListingNewsroomResearch, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomTreatment' }
        & Pick<ParagraphListingNewsroomTreatment, 'argument'>
      ) | (
        { __typename: 'ParagraphListingSpecialists' }
        & Pick<ParagraphListingSpecialists, 'title'>
      ) | (
        { __typename: 'ParagraphLiteratureLinks' }
        & { refLinks: Maybe<Array<Maybe<(
          Pick<LiteratureLinks, 'description'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLiteraturePdfs' }
        & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
      ) | (
        { __typename: 'ParagraphLiteratureText' }
        & Pick<ParagraphLiteratureText, 'textHtml'>
      ) | (
        { __typename: 'ParagraphLogoCloud' }
        & { logoImages: Maybe<Array<Maybe<(
          { __typename: 'ParagraphLogoCloudImage' }
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphMegaTeasers' }
        & Pick<ParagraphMegaTeasers, 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphNewsTeaser' }
        & { newsContent: Maybe<(
          Pick<ContentNews, 'path' | 'title' | 'date'>
          & { teaserImage: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphPreAnalyticData' }
        & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
        & { containerImage: Maybe<(
          Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
        )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphSiteSearch' }
        & Pick<ParagraphSiteSearch, 'placeholderText'>
      ) | (
        { __typename: 'ParagraphSpacer' }
        & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
      ) | (
        { __typename: 'ParagraphSpecialistsSlider' }
        & Pick<ParagraphSpecialistsSlider, 'title'>
        & { specialists: Array<Maybe<(
          { __typename: 'ContentSpecialist' }
          & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
          & { imagePortrait: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
        & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
      ) | (
        { __typename: 'ParagraphStaticWallsBlock' }
        & Pick<ParagraphStaticWallsBlock, 'title'>
      ) | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphTeasers' }
        & Pick<ParagraphTeasers, 'display' | 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTestimonialSlider' }
        & Pick<ParagraphTestimonialSlider, 'title'>
        & { testimonial: Array<Maybe<(
          Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      ) | (
        { __typename: 'ParagraphTiles' }
        & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTile' }
          & Pick<ParagraphTile, 'text' | 'url'>
        )>> }
      ) | (
        { __typename: 'ParagraphTimeline' }
        & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineGroup' }
          & Pick<ParagraphTimelineGroup, 'groupTitle'>
          & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphTimelineElement' }
            & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
            & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageCarousel' }
              & Pick<ParagraphImageCarousel, 'display'>
              & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
                { __typename: 'ParagraphImageWithCaption' }
                & Pick<ParagraphImageWithCaption, 'caption'>
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )> }
              ) | (
                { __typename: 'ParagraphVideo' }
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )>, video: Maybe<(
                  { __typename: 'MediaVideoLocal' }
                  & Pick<MediaVideoLocal, 'url'>
                ) | (
                  { __typename: 'MediaVideoRemote' }
                  & Pick<MediaVideoRemote, 'url'>
                )> }
              )>> }
            ) | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphQuote' }
              & Pick<ParagraphQuote, 'author' | 'quote'>
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            ) | (
              { __typename: 'ParagraphWysiwygContent' }
              & Pick<ParagraphWysiwygContent, 'textHtml'>
            ) | (
              { __typename: 'ParagraphYoutubeEmbed' }
              & { embed: Pick<Link, 'url'> }
            )>> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>>, infoEmergency: Array<Maybe<(
        { __typename: 'ParagraphAccordion' }
        & { accordionElements: Array<(
          { __typename: 'ParagraphAccordionElement' }
          & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
        )> }
      ) | (
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphAnchor' }
        & Pick<ParagraphAnchor, 'anchorLink'>
      ) | (
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumbers' }
        & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
        & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
          { __typename: 'ParagraphAnimatedNumberElement' }
          & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphAnimatedNumberRange' }
          & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphBabiesSearch' }
        & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphCallToAction' }
        & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
        & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualEvent' }
        & { event: Maybe<(
          Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualText' }
        & Pick<ParagraphContextualText, 'title' | 'textHtml'>
        & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
      ) | (
        { __typename: 'ParagraphDocuments' }
        & Pick<ParagraphDocuments, 'title'>
        & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
      ) | { __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphEventForm' }
        & Pick<ParagraphEventForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphEventsSearch' }
        & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphFileList' }
        & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphForm' }
        & Pick<ParagraphForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphFormattedTextWithTitle' }
        & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphLabCardListing' }
        & Pick<ParagraphLabCardListing, 'title'>
      ) | (
        { __typename: 'ParagraphLinkList' }
        & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphLinkListLink' }
          & Pick<ParagraphLinkListLink, 'title'>
          & { listLink: Pick<LinkWithText, 'url' | 'text'> }
        )>> }
      ) | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      ) | (
        { __typename: 'ParagraphListingAllocation' }
        & Pick<ParagraphListingAllocation, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingClinicsByArea' }
        & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingDiseaseFromLocation' }
        & Pick<ParagraphListingDiseaseFromLocation, 'title'>
        & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
      ) | (
        { __typename: 'ParagraphListingDiseaseSearchSource' }
        & Pick<ParagraphListingDiseaseSearchSource, 'title'>
      ) | (
        { __typename: 'ParagraphListingEventsEmbed' }
        & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByDepartment' }
        & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
        & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingJobList' }
        & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
      ) | (
        { __typename: 'ParagraphListingJobToolSearch' }
        & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
        & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
      ) | (
        { __typename: 'ParagraphListingLocationByTreatmentOffer' }
        & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingMedicineNews' }
        & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
        & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFiltered' }
        & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
        & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFrontpage' }
        & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
        & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomResearch' }
        & Pick<ParagraphListingNewsroomResearch, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomTreatment' }
        & Pick<ParagraphListingNewsroomTreatment, 'argument'>
      ) | (
        { __typename: 'ParagraphListingSpecialists' }
        & Pick<ParagraphListingSpecialists, 'title'>
      ) | (
        { __typename: 'ParagraphLiteratureLinks' }
        & { refLinks: Maybe<Array<Maybe<(
          Pick<LiteratureLinks, 'description'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLiteraturePdfs' }
        & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
      ) | (
        { __typename: 'ParagraphLiteratureText' }
        & Pick<ParagraphLiteratureText, 'textHtml'>
      ) | (
        { __typename: 'ParagraphLogoCloud' }
        & { logoImages: Maybe<Array<Maybe<(
          { __typename: 'ParagraphLogoCloudImage' }
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphMegaTeasers' }
        & Pick<ParagraphMegaTeasers, 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphNewsTeaser' }
        & { newsContent: Maybe<(
          Pick<ContentNews, 'path' | 'title' | 'date'>
          & { teaserImage: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphPreAnalyticData' }
        & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
        & { containerImage: Maybe<(
          Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
        )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphSiteSearch' }
        & Pick<ParagraphSiteSearch, 'placeholderText'>
      ) | (
        { __typename: 'ParagraphSpacer' }
        & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
      ) | (
        { __typename: 'ParagraphSpecialistsSlider' }
        & Pick<ParagraphSpecialistsSlider, 'title'>
        & { specialists: Array<Maybe<(
          { __typename: 'ContentSpecialist' }
          & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
          & { imagePortrait: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
        & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
      ) | (
        { __typename: 'ParagraphStaticWallsBlock' }
        & Pick<ParagraphStaticWallsBlock, 'title'>
      ) | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphTeasers' }
        & Pick<ParagraphTeasers, 'display' | 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTestimonialSlider' }
        & Pick<ParagraphTestimonialSlider, 'title'>
        & { testimonial: Array<Maybe<(
          Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      ) | (
        { __typename: 'ParagraphTiles' }
        & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTile' }
          & Pick<ParagraphTile, 'text' | 'url'>
        )>> }
      ) | (
        { __typename: 'ParagraphTimeline' }
        & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineGroup' }
          & Pick<ParagraphTimelineGroup, 'groupTitle'>
          & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphTimelineElement' }
            & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
            & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageCarousel' }
              & Pick<ParagraphImageCarousel, 'display'>
              & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
                { __typename: 'ParagraphImageWithCaption' }
                & Pick<ParagraphImageWithCaption, 'caption'>
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )> }
              ) | (
                { __typename: 'ParagraphVideo' }
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )>, video: Maybe<(
                  { __typename: 'MediaVideoLocal' }
                  & Pick<MediaVideoLocal, 'url'>
                ) | (
                  { __typename: 'MediaVideoRemote' }
                  & Pick<MediaVideoRemote, 'url'>
                )> }
              )>> }
            ) | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphQuote' }
              & Pick<ParagraphQuote, 'author' | 'quote'>
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            ) | (
              { __typename: 'ParagraphWysiwygContent' }
              & Pick<ParagraphWysiwygContent, 'textHtml'>
            ) | (
              { __typename: 'ParagraphYoutubeEmbed' }
              & { embed: Pick<Link, 'url'> }
            )>> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>>, parentLocation: Maybe<Pick<ContentLocation, 'title'>>, metaTags: Maybe<Array<Maybe<(
        Pick<MetaTag, 'tag'>
        & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
      )>>> }
    )>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type ContentLocationTeamQueryVariables = Exact<{
  remoteId: Scalars['String'];
}>;


export type ContentLocationTeamQuery = { content: Maybe<(
    Pick<ContentLocation, 'drupalId' | 'title' | 'subtitle' | 'teamPageTitle'>
    & { locationPath: ContentLocation['path'] }
    & { locationBreadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, locationNavigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>>, contact: Maybe<(
      Pick<ContentLocationContact, 'path' | 'title' | 'companyName' | 'addressFirstLine' | 'addressSecondLine' | 'postCode' | 'city' | 'email' | 'phone' | 'mapOverlayHtml' | 'latitude' | 'longitude'>
      & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, locationHeader: { location: Maybe<(
          Pick<ContentLocation, 'path' | 'title' | 'subtitle'>
          & { contact: Maybe<Pick<ContentLocationContact, 'path'>> }
        )>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>> }, infoAddress: Array<Maybe<(
        { __typename: 'ParagraphAccordion' }
        & { accordionElements: Array<(
          { __typename: 'ParagraphAccordionElement' }
          & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
        )> }
      ) | (
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphAnchor' }
        & Pick<ParagraphAnchor, 'anchorLink'>
      ) | (
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumbers' }
        & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
        & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
          { __typename: 'ParagraphAnimatedNumberElement' }
          & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphAnimatedNumberRange' }
          & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphBabiesSearch' }
        & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphCallToAction' }
        & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
        & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualEvent' }
        & { event: Maybe<(
          Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualText' }
        & Pick<ParagraphContextualText, 'title' | 'textHtml'>
        & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
      ) | (
        { __typename: 'ParagraphDocuments' }
        & Pick<ParagraphDocuments, 'title'>
        & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
      ) | { __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphEventForm' }
        & Pick<ParagraphEventForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphEventsSearch' }
        & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphFileList' }
        & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphForm' }
        & Pick<ParagraphForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphFormattedTextWithTitle' }
        & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphLabCardListing' }
        & Pick<ParagraphLabCardListing, 'title'>
      ) | (
        { __typename: 'ParagraphLinkList' }
        & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphLinkListLink' }
          & Pick<ParagraphLinkListLink, 'title'>
          & { listLink: Pick<LinkWithText, 'url' | 'text'> }
        )>> }
      ) | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      ) | (
        { __typename: 'ParagraphListingAllocation' }
        & Pick<ParagraphListingAllocation, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingClinicsByArea' }
        & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingDiseaseFromLocation' }
        & Pick<ParagraphListingDiseaseFromLocation, 'title'>
        & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
      ) | (
        { __typename: 'ParagraphListingDiseaseSearchSource' }
        & Pick<ParagraphListingDiseaseSearchSource, 'title'>
      ) | (
        { __typename: 'ParagraphListingEventsEmbed' }
        & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByDepartment' }
        & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
        & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingJobList' }
        & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
      ) | (
        { __typename: 'ParagraphListingJobToolSearch' }
        & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
        & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
      ) | (
        { __typename: 'ParagraphListingLocationByTreatmentOffer' }
        & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingMedicineNews' }
        & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
        & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFiltered' }
        & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
        & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFrontpage' }
        & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
        & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomResearch' }
        & Pick<ParagraphListingNewsroomResearch, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomTreatment' }
        & Pick<ParagraphListingNewsroomTreatment, 'argument'>
      ) | (
        { __typename: 'ParagraphListingSpecialists' }
        & Pick<ParagraphListingSpecialists, 'title'>
      ) | (
        { __typename: 'ParagraphLiteratureLinks' }
        & { refLinks: Maybe<Array<Maybe<(
          Pick<LiteratureLinks, 'description'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLiteraturePdfs' }
        & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
      ) | (
        { __typename: 'ParagraphLiteratureText' }
        & Pick<ParagraphLiteratureText, 'textHtml'>
      ) | (
        { __typename: 'ParagraphLogoCloud' }
        & { logoImages: Maybe<Array<Maybe<(
          { __typename: 'ParagraphLogoCloudImage' }
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphMegaTeasers' }
        & Pick<ParagraphMegaTeasers, 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphNewsTeaser' }
        & { newsContent: Maybe<(
          Pick<ContentNews, 'path' | 'title' | 'date'>
          & { teaserImage: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphPreAnalyticData' }
        & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
        & { containerImage: Maybe<(
          Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
        )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphSiteSearch' }
        & Pick<ParagraphSiteSearch, 'placeholderText'>
      ) | (
        { __typename: 'ParagraphSpacer' }
        & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
      ) | (
        { __typename: 'ParagraphSpecialistsSlider' }
        & Pick<ParagraphSpecialistsSlider, 'title'>
        & { specialists: Array<Maybe<(
          { __typename: 'ContentSpecialist' }
          & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
          & { imagePortrait: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
        & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
      ) | (
        { __typename: 'ParagraphStaticWallsBlock' }
        & Pick<ParagraphStaticWallsBlock, 'title'>
      ) | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphTeasers' }
        & Pick<ParagraphTeasers, 'display' | 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTestimonialSlider' }
        & Pick<ParagraphTestimonialSlider, 'title'>
        & { testimonial: Array<Maybe<(
          Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      ) | (
        { __typename: 'ParagraphTiles' }
        & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTile' }
          & Pick<ParagraphTile, 'text' | 'url'>
        )>> }
      ) | (
        { __typename: 'ParagraphTimeline' }
        & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineGroup' }
          & Pick<ParagraphTimelineGroup, 'groupTitle'>
          & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphTimelineElement' }
            & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
            & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageCarousel' }
              & Pick<ParagraphImageCarousel, 'display'>
              & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
                { __typename: 'ParagraphImageWithCaption' }
                & Pick<ParagraphImageWithCaption, 'caption'>
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )> }
              ) | (
                { __typename: 'ParagraphVideo' }
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )>, video: Maybe<(
                  { __typename: 'MediaVideoLocal' }
                  & Pick<MediaVideoLocal, 'url'>
                ) | (
                  { __typename: 'MediaVideoRemote' }
                  & Pick<MediaVideoRemote, 'url'>
                )> }
              )>> }
            ) | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphQuote' }
              & Pick<ParagraphQuote, 'author' | 'quote'>
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            ) | (
              { __typename: 'ParagraphWysiwygContent' }
              & Pick<ParagraphWysiwygContent, 'textHtml'>
            ) | (
              { __typename: 'ParagraphYoutubeEmbed' }
              & { embed: Pick<Link, 'url'> }
            )>> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>>, infoBooking: Array<Maybe<(
        { __typename: 'ParagraphAccordion' }
        & { accordionElements: Array<(
          { __typename: 'ParagraphAccordionElement' }
          & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
        )> }
      ) | (
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphAnchor' }
        & Pick<ParagraphAnchor, 'anchorLink'>
      ) | (
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumbers' }
        & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
        & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
          { __typename: 'ParagraphAnimatedNumberElement' }
          & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphAnimatedNumberRange' }
          & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphBabiesSearch' }
        & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphCallToAction' }
        & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
        & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualEvent' }
        & { event: Maybe<(
          Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualText' }
        & Pick<ParagraphContextualText, 'title' | 'textHtml'>
        & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
      ) | (
        { __typename: 'ParagraphDocuments' }
        & Pick<ParagraphDocuments, 'title'>
        & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
      ) | { __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphEventForm' }
        & Pick<ParagraphEventForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphEventsSearch' }
        & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphFileList' }
        & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphForm' }
        & Pick<ParagraphForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphFormattedTextWithTitle' }
        & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphLabCardListing' }
        & Pick<ParagraphLabCardListing, 'title'>
      ) | (
        { __typename: 'ParagraphLinkList' }
        & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphLinkListLink' }
          & Pick<ParagraphLinkListLink, 'title'>
          & { listLink: Pick<LinkWithText, 'url' | 'text'> }
        )>> }
      ) | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      ) | (
        { __typename: 'ParagraphListingAllocation' }
        & Pick<ParagraphListingAllocation, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingClinicsByArea' }
        & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingDiseaseFromLocation' }
        & Pick<ParagraphListingDiseaseFromLocation, 'title'>
        & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
      ) | (
        { __typename: 'ParagraphListingDiseaseSearchSource' }
        & Pick<ParagraphListingDiseaseSearchSource, 'title'>
      ) | (
        { __typename: 'ParagraphListingEventsEmbed' }
        & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByDepartment' }
        & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
        & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingJobList' }
        & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
      ) | (
        { __typename: 'ParagraphListingJobToolSearch' }
        & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
        & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
      ) | (
        { __typename: 'ParagraphListingLocationByTreatmentOffer' }
        & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingMedicineNews' }
        & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
        & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFiltered' }
        & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
        & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFrontpage' }
        & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
        & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomResearch' }
        & Pick<ParagraphListingNewsroomResearch, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomTreatment' }
        & Pick<ParagraphListingNewsroomTreatment, 'argument'>
      ) | (
        { __typename: 'ParagraphListingSpecialists' }
        & Pick<ParagraphListingSpecialists, 'title'>
      ) | (
        { __typename: 'ParagraphLiteratureLinks' }
        & { refLinks: Maybe<Array<Maybe<(
          Pick<LiteratureLinks, 'description'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLiteraturePdfs' }
        & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
      ) | (
        { __typename: 'ParagraphLiteratureText' }
        & Pick<ParagraphLiteratureText, 'textHtml'>
      ) | (
        { __typename: 'ParagraphLogoCloud' }
        & { logoImages: Maybe<Array<Maybe<(
          { __typename: 'ParagraphLogoCloudImage' }
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphMegaTeasers' }
        & Pick<ParagraphMegaTeasers, 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphNewsTeaser' }
        & { newsContent: Maybe<(
          Pick<ContentNews, 'path' | 'title' | 'date'>
          & { teaserImage: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphPreAnalyticData' }
        & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
        & { containerImage: Maybe<(
          Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
        )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphSiteSearch' }
        & Pick<ParagraphSiteSearch, 'placeholderText'>
      ) | (
        { __typename: 'ParagraphSpacer' }
        & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
      ) | (
        { __typename: 'ParagraphSpecialistsSlider' }
        & Pick<ParagraphSpecialistsSlider, 'title'>
        & { specialists: Array<Maybe<(
          { __typename: 'ContentSpecialist' }
          & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
          & { imagePortrait: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
        & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
      ) | (
        { __typename: 'ParagraphStaticWallsBlock' }
        & Pick<ParagraphStaticWallsBlock, 'title'>
      ) | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphTeasers' }
        & Pick<ParagraphTeasers, 'display' | 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTestimonialSlider' }
        & Pick<ParagraphTestimonialSlider, 'title'>
        & { testimonial: Array<Maybe<(
          Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      ) | (
        { __typename: 'ParagraphTiles' }
        & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTile' }
          & Pick<ParagraphTile, 'text' | 'url'>
        )>> }
      ) | (
        { __typename: 'ParagraphTimeline' }
        & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineGroup' }
          & Pick<ParagraphTimelineGroup, 'groupTitle'>
          & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphTimelineElement' }
            & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
            & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageCarousel' }
              & Pick<ParagraphImageCarousel, 'display'>
              & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
                { __typename: 'ParagraphImageWithCaption' }
                & Pick<ParagraphImageWithCaption, 'caption'>
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )> }
              ) | (
                { __typename: 'ParagraphVideo' }
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )>, video: Maybe<(
                  { __typename: 'MediaVideoLocal' }
                  & Pick<MediaVideoLocal, 'url'>
                ) | (
                  { __typename: 'MediaVideoRemote' }
                  & Pick<MediaVideoRemote, 'url'>
                )> }
              )>> }
            ) | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphQuote' }
              & Pick<ParagraphQuote, 'author' | 'quote'>
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            ) | (
              { __typename: 'ParagraphWysiwygContent' }
              & Pick<ParagraphWysiwygContent, 'textHtml'>
            ) | (
              { __typename: 'ParagraphYoutubeEmbed' }
              & { embed: Pick<Link, 'url'> }
            )>> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>>, infoEmergency: Array<Maybe<(
        { __typename: 'ParagraphAccordion' }
        & { accordionElements: Array<(
          { __typename: 'ParagraphAccordionElement' }
          & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
        )> }
      ) | (
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphAnchor' }
        & Pick<ParagraphAnchor, 'anchorLink'>
      ) | (
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumbers' }
        & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
        & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
          { __typename: 'ParagraphAnimatedNumberElement' }
          & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphAnimatedNumberRange' }
          & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphBabiesSearch' }
        & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphCallToAction' }
        & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
        & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualEvent' }
        & { event: Maybe<(
          Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualText' }
        & Pick<ParagraphContextualText, 'title' | 'textHtml'>
        & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
      ) | (
        { __typename: 'ParagraphDocuments' }
        & Pick<ParagraphDocuments, 'title'>
        & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
      ) | { __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphEventForm' }
        & Pick<ParagraphEventForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphEventsSearch' }
        & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphFileList' }
        & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphForm' }
        & Pick<ParagraphForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphFormattedTextWithTitle' }
        & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphLabCardListing' }
        & Pick<ParagraphLabCardListing, 'title'>
      ) | (
        { __typename: 'ParagraphLinkList' }
        & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphLinkListLink' }
          & Pick<ParagraphLinkListLink, 'title'>
          & { listLink: Pick<LinkWithText, 'url' | 'text'> }
        )>> }
      ) | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      ) | (
        { __typename: 'ParagraphListingAllocation' }
        & Pick<ParagraphListingAllocation, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingClinicsByArea' }
        & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingDiseaseFromLocation' }
        & Pick<ParagraphListingDiseaseFromLocation, 'title'>
        & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
      ) | (
        { __typename: 'ParagraphListingDiseaseSearchSource' }
        & Pick<ParagraphListingDiseaseSearchSource, 'title'>
      ) | (
        { __typename: 'ParagraphListingEventsEmbed' }
        & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByDepartment' }
        & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
        & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingJobList' }
        & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
      ) | (
        { __typename: 'ParagraphListingJobToolSearch' }
        & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
        & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
      ) | (
        { __typename: 'ParagraphListingLocationByTreatmentOffer' }
        & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingMedicineNews' }
        & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
        & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFiltered' }
        & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
        & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFrontpage' }
        & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
        & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomResearch' }
        & Pick<ParagraphListingNewsroomResearch, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomTreatment' }
        & Pick<ParagraphListingNewsroomTreatment, 'argument'>
      ) | (
        { __typename: 'ParagraphListingSpecialists' }
        & Pick<ParagraphListingSpecialists, 'title'>
      ) | (
        { __typename: 'ParagraphLiteratureLinks' }
        & { refLinks: Maybe<Array<Maybe<(
          Pick<LiteratureLinks, 'description'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLiteraturePdfs' }
        & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
      ) | (
        { __typename: 'ParagraphLiteratureText' }
        & Pick<ParagraphLiteratureText, 'textHtml'>
      ) | (
        { __typename: 'ParagraphLogoCloud' }
        & { logoImages: Maybe<Array<Maybe<(
          { __typename: 'ParagraphLogoCloudImage' }
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphMegaTeasers' }
        & Pick<ParagraphMegaTeasers, 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphNewsTeaser' }
        & { newsContent: Maybe<(
          Pick<ContentNews, 'path' | 'title' | 'date'>
          & { teaserImage: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphPreAnalyticData' }
        & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
        & { containerImage: Maybe<(
          Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
        )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphSiteSearch' }
        & Pick<ParagraphSiteSearch, 'placeholderText'>
      ) | (
        { __typename: 'ParagraphSpacer' }
        & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
      ) | (
        { __typename: 'ParagraphSpecialistsSlider' }
        & Pick<ParagraphSpecialistsSlider, 'title'>
        & { specialists: Array<Maybe<(
          { __typename: 'ContentSpecialist' }
          & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
          & { imagePortrait: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
        & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
      ) | (
        { __typename: 'ParagraphStaticWallsBlock' }
        & Pick<ParagraphStaticWallsBlock, 'title'>
      ) | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphTeasers' }
        & Pick<ParagraphTeasers, 'display' | 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTestimonialSlider' }
        & Pick<ParagraphTestimonialSlider, 'title'>
        & { testimonial: Array<Maybe<(
          Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      ) | (
        { __typename: 'ParagraphTiles' }
        & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTile' }
          & Pick<ParagraphTile, 'text' | 'url'>
        )>> }
      ) | (
        { __typename: 'ParagraphTimeline' }
        & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineGroup' }
          & Pick<ParagraphTimelineGroup, 'groupTitle'>
          & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphTimelineElement' }
            & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
            & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageCarousel' }
              & Pick<ParagraphImageCarousel, 'display'>
              & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
                { __typename: 'ParagraphImageWithCaption' }
                & Pick<ParagraphImageWithCaption, 'caption'>
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )> }
              ) | (
                { __typename: 'ParagraphVideo' }
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )>, video: Maybe<(
                  { __typename: 'MediaVideoLocal' }
                  & Pick<MediaVideoLocal, 'url'>
                ) | (
                  { __typename: 'MediaVideoRemote' }
                  & Pick<MediaVideoRemote, 'url'>
                )> }
              )>> }
            ) | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphQuote' }
              & Pick<ParagraphQuote, 'author' | 'quote'>
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            ) | (
              { __typename: 'ParagraphWysiwygContent' }
              & Pick<ParagraphWysiwygContent, 'textHtml'>
            ) | (
              { __typename: 'ParagraphYoutubeEmbed' }
              & { embed: Pick<Link, 'url'> }
            )>> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>>, parentLocation: Maybe<Pick<ContentLocation, 'title'>>, metaTags: Maybe<Array<Maybe<(
        Pick<MetaTag, 'tag'>
        & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
      )>>> }
    )>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>>, area: Maybe<Pick<TermAdministrativeArea, 'title' | 'areaIdentifier'>> }
  )> };

export type ContentLocationTeamRevisionQueryVariables = Exact<{
  remoteId: Scalars['String'];
  revisionId: Scalars['String'];
}>;


export type ContentLocationTeamRevisionQuery = { content: Maybe<(
    Pick<ContentLocation, 'drupalId' | 'title' | 'subtitle' | 'teamPageTitle'>
    & { locationPath: ContentLocation['path'] }
    & { locationBreadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, locationNavigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>>, contact: Maybe<(
      Pick<ContentLocationContact, 'path' | 'title' | 'companyName' | 'addressFirstLine' | 'addressSecondLine' | 'postCode' | 'city' | 'email' | 'phone' | 'mapOverlayHtml' | 'latitude' | 'longitude'>
      & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, locationHeader: { location: Maybe<(
          Pick<ContentLocation, 'path' | 'title' | 'subtitle'>
          & { contact: Maybe<Pick<ContentLocationContact, 'path'>> }
        )>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>> }, infoAddress: Array<Maybe<(
        { __typename: 'ParagraphAccordion' }
        & { accordionElements: Array<(
          { __typename: 'ParagraphAccordionElement' }
          & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
        )> }
      ) | (
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphAnchor' }
        & Pick<ParagraphAnchor, 'anchorLink'>
      ) | (
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumbers' }
        & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
        & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
          { __typename: 'ParagraphAnimatedNumberElement' }
          & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphAnimatedNumberRange' }
          & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphBabiesSearch' }
        & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphCallToAction' }
        & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
        & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualEvent' }
        & { event: Maybe<(
          Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualText' }
        & Pick<ParagraphContextualText, 'title' | 'textHtml'>
        & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
      ) | (
        { __typename: 'ParagraphDocuments' }
        & Pick<ParagraphDocuments, 'title'>
        & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
      ) | { __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphEventForm' }
        & Pick<ParagraphEventForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphEventsSearch' }
        & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphFileList' }
        & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphForm' }
        & Pick<ParagraphForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphFormattedTextWithTitle' }
        & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphLabCardListing' }
        & Pick<ParagraphLabCardListing, 'title'>
      ) | (
        { __typename: 'ParagraphLinkList' }
        & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphLinkListLink' }
          & Pick<ParagraphLinkListLink, 'title'>
          & { listLink: Pick<LinkWithText, 'url' | 'text'> }
        )>> }
      ) | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      ) | (
        { __typename: 'ParagraphListingAllocation' }
        & Pick<ParagraphListingAllocation, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingClinicsByArea' }
        & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingDiseaseFromLocation' }
        & Pick<ParagraphListingDiseaseFromLocation, 'title'>
        & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
      ) | (
        { __typename: 'ParagraphListingDiseaseSearchSource' }
        & Pick<ParagraphListingDiseaseSearchSource, 'title'>
      ) | (
        { __typename: 'ParagraphListingEventsEmbed' }
        & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByDepartment' }
        & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
        & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingJobList' }
        & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
      ) | (
        { __typename: 'ParagraphListingJobToolSearch' }
        & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
        & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
      ) | (
        { __typename: 'ParagraphListingLocationByTreatmentOffer' }
        & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingMedicineNews' }
        & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
        & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFiltered' }
        & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
        & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFrontpage' }
        & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
        & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomResearch' }
        & Pick<ParagraphListingNewsroomResearch, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomTreatment' }
        & Pick<ParagraphListingNewsroomTreatment, 'argument'>
      ) | (
        { __typename: 'ParagraphListingSpecialists' }
        & Pick<ParagraphListingSpecialists, 'title'>
      ) | (
        { __typename: 'ParagraphLiteratureLinks' }
        & { refLinks: Maybe<Array<Maybe<(
          Pick<LiteratureLinks, 'description'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLiteraturePdfs' }
        & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
      ) | (
        { __typename: 'ParagraphLiteratureText' }
        & Pick<ParagraphLiteratureText, 'textHtml'>
      ) | (
        { __typename: 'ParagraphLogoCloud' }
        & { logoImages: Maybe<Array<Maybe<(
          { __typename: 'ParagraphLogoCloudImage' }
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphMegaTeasers' }
        & Pick<ParagraphMegaTeasers, 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphNewsTeaser' }
        & { newsContent: Maybe<(
          Pick<ContentNews, 'path' | 'title' | 'date'>
          & { teaserImage: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphPreAnalyticData' }
        & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
        & { containerImage: Maybe<(
          Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
        )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphSiteSearch' }
        & Pick<ParagraphSiteSearch, 'placeholderText'>
      ) | (
        { __typename: 'ParagraphSpacer' }
        & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
      ) | (
        { __typename: 'ParagraphSpecialistsSlider' }
        & Pick<ParagraphSpecialistsSlider, 'title'>
        & { specialists: Array<Maybe<(
          { __typename: 'ContentSpecialist' }
          & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
          & { imagePortrait: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
        & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
      ) | (
        { __typename: 'ParagraphStaticWallsBlock' }
        & Pick<ParagraphStaticWallsBlock, 'title'>
      ) | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphTeasers' }
        & Pick<ParagraphTeasers, 'display' | 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTestimonialSlider' }
        & Pick<ParagraphTestimonialSlider, 'title'>
        & { testimonial: Array<Maybe<(
          Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      ) | (
        { __typename: 'ParagraphTiles' }
        & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTile' }
          & Pick<ParagraphTile, 'text' | 'url'>
        )>> }
      ) | (
        { __typename: 'ParagraphTimeline' }
        & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineGroup' }
          & Pick<ParagraphTimelineGroup, 'groupTitle'>
          & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphTimelineElement' }
            & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
            & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageCarousel' }
              & Pick<ParagraphImageCarousel, 'display'>
              & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
                { __typename: 'ParagraphImageWithCaption' }
                & Pick<ParagraphImageWithCaption, 'caption'>
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )> }
              ) | (
                { __typename: 'ParagraphVideo' }
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )>, video: Maybe<(
                  { __typename: 'MediaVideoLocal' }
                  & Pick<MediaVideoLocal, 'url'>
                ) | (
                  { __typename: 'MediaVideoRemote' }
                  & Pick<MediaVideoRemote, 'url'>
                )> }
              )>> }
            ) | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphQuote' }
              & Pick<ParagraphQuote, 'author' | 'quote'>
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            ) | (
              { __typename: 'ParagraphWysiwygContent' }
              & Pick<ParagraphWysiwygContent, 'textHtml'>
            ) | (
              { __typename: 'ParagraphYoutubeEmbed' }
              & { embed: Pick<Link, 'url'> }
            )>> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>>, infoBooking: Array<Maybe<(
        { __typename: 'ParagraphAccordion' }
        & { accordionElements: Array<(
          { __typename: 'ParagraphAccordionElement' }
          & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
        )> }
      ) | (
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphAnchor' }
        & Pick<ParagraphAnchor, 'anchorLink'>
      ) | (
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumbers' }
        & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
        & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
          { __typename: 'ParagraphAnimatedNumberElement' }
          & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphAnimatedNumberRange' }
          & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphBabiesSearch' }
        & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphCallToAction' }
        & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
        & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualEvent' }
        & { event: Maybe<(
          Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualText' }
        & Pick<ParagraphContextualText, 'title' | 'textHtml'>
        & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
      ) | (
        { __typename: 'ParagraphDocuments' }
        & Pick<ParagraphDocuments, 'title'>
        & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
      ) | { __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphEventForm' }
        & Pick<ParagraphEventForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphEventsSearch' }
        & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphFileList' }
        & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphForm' }
        & Pick<ParagraphForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphFormattedTextWithTitle' }
        & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphLabCardListing' }
        & Pick<ParagraphLabCardListing, 'title'>
      ) | (
        { __typename: 'ParagraphLinkList' }
        & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphLinkListLink' }
          & Pick<ParagraphLinkListLink, 'title'>
          & { listLink: Pick<LinkWithText, 'url' | 'text'> }
        )>> }
      ) | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      ) | (
        { __typename: 'ParagraphListingAllocation' }
        & Pick<ParagraphListingAllocation, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingClinicsByArea' }
        & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingDiseaseFromLocation' }
        & Pick<ParagraphListingDiseaseFromLocation, 'title'>
        & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
      ) | (
        { __typename: 'ParagraphListingDiseaseSearchSource' }
        & Pick<ParagraphListingDiseaseSearchSource, 'title'>
      ) | (
        { __typename: 'ParagraphListingEventsEmbed' }
        & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByDepartment' }
        & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
        & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingJobList' }
        & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
      ) | (
        { __typename: 'ParagraphListingJobToolSearch' }
        & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
        & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
      ) | (
        { __typename: 'ParagraphListingLocationByTreatmentOffer' }
        & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingMedicineNews' }
        & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
        & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFiltered' }
        & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
        & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFrontpage' }
        & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
        & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomResearch' }
        & Pick<ParagraphListingNewsroomResearch, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomTreatment' }
        & Pick<ParagraphListingNewsroomTreatment, 'argument'>
      ) | (
        { __typename: 'ParagraphListingSpecialists' }
        & Pick<ParagraphListingSpecialists, 'title'>
      ) | (
        { __typename: 'ParagraphLiteratureLinks' }
        & { refLinks: Maybe<Array<Maybe<(
          Pick<LiteratureLinks, 'description'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLiteraturePdfs' }
        & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
      ) | (
        { __typename: 'ParagraphLiteratureText' }
        & Pick<ParagraphLiteratureText, 'textHtml'>
      ) | (
        { __typename: 'ParagraphLogoCloud' }
        & { logoImages: Maybe<Array<Maybe<(
          { __typename: 'ParagraphLogoCloudImage' }
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphMegaTeasers' }
        & Pick<ParagraphMegaTeasers, 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphNewsTeaser' }
        & { newsContent: Maybe<(
          Pick<ContentNews, 'path' | 'title' | 'date'>
          & { teaserImage: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphPreAnalyticData' }
        & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
        & { containerImage: Maybe<(
          Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
        )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphSiteSearch' }
        & Pick<ParagraphSiteSearch, 'placeholderText'>
      ) | (
        { __typename: 'ParagraphSpacer' }
        & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
      ) | (
        { __typename: 'ParagraphSpecialistsSlider' }
        & Pick<ParagraphSpecialistsSlider, 'title'>
        & { specialists: Array<Maybe<(
          { __typename: 'ContentSpecialist' }
          & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
          & { imagePortrait: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
        & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
      ) | (
        { __typename: 'ParagraphStaticWallsBlock' }
        & Pick<ParagraphStaticWallsBlock, 'title'>
      ) | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphTeasers' }
        & Pick<ParagraphTeasers, 'display' | 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTestimonialSlider' }
        & Pick<ParagraphTestimonialSlider, 'title'>
        & { testimonial: Array<Maybe<(
          Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      ) | (
        { __typename: 'ParagraphTiles' }
        & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTile' }
          & Pick<ParagraphTile, 'text' | 'url'>
        )>> }
      ) | (
        { __typename: 'ParagraphTimeline' }
        & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineGroup' }
          & Pick<ParagraphTimelineGroup, 'groupTitle'>
          & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphTimelineElement' }
            & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
            & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageCarousel' }
              & Pick<ParagraphImageCarousel, 'display'>
              & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
                { __typename: 'ParagraphImageWithCaption' }
                & Pick<ParagraphImageWithCaption, 'caption'>
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )> }
              ) | (
                { __typename: 'ParagraphVideo' }
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )>, video: Maybe<(
                  { __typename: 'MediaVideoLocal' }
                  & Pick<MediaVideoLocal, 'url'>
                ) | (
                  { __typename: 'MediaVideoRemote' }
                  & Pick<MediaVideoRemote, 'url'>
                )> }
              )>> }
            ) | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphQuote' }
              & Pick<ParagraphQuote, 'author' | 'quote'>
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            ) | (
              { __typename: 'ParagraphWysiwygContent' }
              & Pick<ParagraphWysiwygContent, 'textHtml'>
            ) | (
              { __typename: 'ParagraphYoutubeEmbed' }
              & { embed: Pick<Link, 'url'> }
            )>> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>>, infoEmergency: Array<Maybe<(
        { __typename: 'ParagraphAccordion' }
        & { accordionElements: Array<(
          { __typename: 'ParagraphAccordionElement' }
          & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
        )> }
      ) | (
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphAnchor' }
        & Pick<ParagraphAnchor, 'anchorLink'>
      ) | (
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumbers' }
        & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
        & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
          { __typename: 'ParagraphAnimatedNumberElement' }
          & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphAnimatedNumberRange' }
          & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphBabiesSearch' }
        & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphCallToAction' }
        & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
        & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualEvent' }
        & { event: Maybe<(
          Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualText' }
        & Pick<ParagraphContextualText, 'title' | 'textHtml'>
        & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
      ) | (
        { __typename: 'ParagraphDocuments' }
        & Pick<ParagraphDocuments, 'title'>
        & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
      ) | { __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphEventForm' }
        & Pick<ParagraphEventForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphEventsSearch' }
        & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphFileList' }
        & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphForm' }
        & Pick<ParagraphForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphFormattedTextWithTitle' }
        & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphLabCardListing' }
        & Pick<ParagraphLabCardListing, 'title'>
      ) | (
        { __typename: 'ParagraphLinkList' }
        & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphLinkListLink' }
          & Pick<ParagraphLinkListLink, 'title'>
          & { listLink: Pick<LinkWithText, 'url' | 'text'> }
        )>> }
      ) | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      ) | (
        { __typename: 'ParagraphListingAllocation' }
        & Pick<ParagraphListingAllocation, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingClinicsByArea' }
        & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingDiseaseFromLocation' }
        & Pick<ParagraphListingDiseaseFromLocation, 'title'>
        & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
      ) | (
        { __typename: 'ParagraphListingDiseaseSearchSource' }
        & Pick<ParagraphListingDiseaseSearchSource, 'title'>
      ) | (
        { __typename: 'ParagraphListingEventsEmbed' }
        & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByDepartment' }
        & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
        & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingJobList' }
        & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
      ) | (
        { __typename: 'ParagraphListingJobToolSearch' }
        & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
        & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
      ) | (
        { __typename: 'ParagraphListingLocationByTreatmentOffer' }
        & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingMedicineNews' }
        & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
        & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFiltered' }
        & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
        & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFrontpage' }
        & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
        & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomResearch' }
        & Pick<ParagraphListingNewsroomResearch, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomTreatment' }
        & Pick<ParagraphListingNewsroomTreatment, 'argument'>
      ) | (
        { __typename: 'ParagraphListingSpecialists' }
        & Pick<ParagraphListingSpecialists, 'title'>
      ) | (
        { __typename: 'ParagraphLiteratureLinks' }
        & { refLinks: Maybe<Array<Maybe<(
          Pick<LiteratureLinks, 'description'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLiteraturePdfs' }
        & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
      ) | (
        { __typename: 'ParagraphLiteratureText' }
        & Pick<ParagraphLiteratureText, 'textHtml'>
      ) | (
        { __typename: 'ParagraphLogoCloud' }
        & { logoImages: Maybe<Array<Maybe<(
          { __typename: 'ParagraphLogoCloudImage' }
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphMegaTeasers' }
        & Pick<ParagraphMegaTeasers, 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphNewsTeaser' }
        & { newsContent: Maybe<(
          Pick<ContentNews, 'path' | 'title' | 'date'>
          & { teaserImage: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphPreAnalyticData' }
        & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
        & { containerImage: Maybe<(
          Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
        )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphSiteSearch' }
        & Pick<ParagraphSiteSearch, 'placeholderText'>
      ) | (
        { __typename: 'ParagraphSpacer' }
        & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
      ) | (
        { __typename: 'ParagraphSpecialistsSlider' }
        & Pick<ParagraphSpecialistsSlider, 'title'>
        & { specialists: Array<Maybe<(
          { __typename: 'ContentSpecialist' }
          & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
          & { imagePortrait: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
        & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
      ) | (
        { __typename: 'ParagraphStaticWallsBlock' }
        & Pick<ParagraphStaticWallsBlock, 'title'>
      ) | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphTeasers' }
        & Pick<ParagraphTeasers, 'display' | 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTestimonialSlider' }
        & Pick<ParagraphTestimonialSlider, 'title'>
        & { testimonial: Array<Maybe<(
          Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      ) | (
        { __typename: 'ParagraphTiles' }
        & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTile' }
          & Pick<ParagraphTile, 'text' | 'url'>
        )>> }
      ) | (
        { __typename: 'ParagraphTimeline' }
        & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineGroup' }
          & Pick<ParagraphTimelineGroup, 'groupTitle'>
          & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphTimelineElement' }
            & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
            & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageCarousel' }
              & Pick<ParagraphImageCarousel, 'display'>
              & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
                { __typename: 'ParagraphImageWithCaption' }
                & Pick<ParagraphImageWithCaption, 'caption'>
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )> }
              ) | (
                { __typename: 'ParagraphVideo' }
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )>, video: Maybe<(
                  { __typename: 'MediaVideoLocal' }
                  & Pick<MediaVideoLocal, 'url'>
                ) | (
                  { __typename: 'MediaVideoRemote' }
                  & Pick<MediaVideoRemote, 'url'>
                )> }
              )>> }
            ) | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphQuote' }
              & Pick<ParagraphQuote, 'author' | 'quote'>
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            ) | (
              { __typename: 'ParagraphWysiwygContent' }
              & Pick<ParagraphWysiwygContent, 'textHtml'>
            ) | (
              { __typename: 'ParagraphYoutubeEmbed' }
              & { embed: Pick<Link, 'url'> }
            )>> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>>, parentLocation: Maybe<Pick<ContentLocation, 'title'>>, metaTags: Maybe<Array<Maybe<(
        Pick<MetaTag, 'tag'>
        & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
      )>>> }
    )>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>>, area: Maybe<Pick<TermAdministrativeArea, 'title' | 'areaIdentifier'>> }
  )> };

export type ContentLocationQueryVariables = Exact<{
  remoteId: Scalars['String'];
}>;


export type ContentLocationQuery = { content: Maybe<(
    Pick<ContentLocation, 'drupalId' | 'path' | 'title' | 'subtitle' | 'welcomeTitle' | 'specialistsTitle' | 'displayRelatedNews' | 'teamPageTitle' | 'hideParentLocationTitleFromContactInformation'>
    & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>>, content: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>, contact: Maybe<(
      Pick<ContentLocationContact, 'path' | 'title' | 'companyName' | 'addressFirstLine' | 'addressSecondLine' | 'postCode' | 'city' | 'email' | 'phone' | 'mapOverlayHtml' | 'latitude' | 'longitude'>
      & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, locationHeader: { location: Maybe<(
          Pick<ContentLocation, 'path' | 'title' | 'subtitle'>
          & { contact: Maybe<Pick<ContentLocationContact, 'path'>> }
        )>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>> }, infoAddress: Array<Maybe<(
        { __typename: 'ParagraphAccordion' }
        & { accordionElements: Array<(
          { __typename: 'ParagraphAccordionElement' }
          & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
        )> }
      ) | (
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphAnchor' }
        & Pick<ParagraphAnchor, 'anchorLink'>
      ) | (
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumbers' }
        & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
        & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
          { __typename: 'ParagraphAnimatedNumberElement' }
          & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphAnimatedNumberRange' }
          & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphBabiesSearch' }
        & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphCallToAction' }
        & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
        & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualEvent' }
        & { event: Maybe<(
          Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualText' }
        & Pick<ParagraphContextualText, 'title' | 'textHtml'>
        & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
      ) | (
        { __typename: 'ParagraphDocuments' }
        & Pick<ParagraphDocuments, 'title'>
        & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
      ) | { __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphEventForm' }
        & Pick<ParagraphEventForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphEventsSearch' }
        & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphFileList' }
        & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphForm' }
        & Pick<ParagraphForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphFormattedTextWithTitle' }
        & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphLabCardListing' }
        & Pick<ParagraphLabCardListing, 'title'>
      ) | (
        { __typename: 'ParagraphLinkList' }
        & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphLinkListLink' }
          & Pick<ParagraphLinkListLink, 'title'>
          & { listLink: Pick<LinkWithText, 'url' | 'text'> }
        )>> }
      ) | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      ) | (
        { __typename: 'ParagraphListingAllocation' }
        & Pick<ParagraphListingAllocation, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingClinicsByArea' }
        & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingDiseaseFromLocation' }
        & Pick<ParagraphListingDiseaseFromLocation, 'title'>
        & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
      ) | (
        { __typename: 'ParagraphListingDiseaseSearchSource' }
        & Pick<ParagraphListingDiseaseSearchSource, 'title'>
      ) | (
        { __typename: 'ParagraphListingEventsEmbed' }
        & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByDepartment' }
        & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
        & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingJobList' }
        & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
      ) | (
        { __typename: 'ParagraphListingJobToolSearch' }
        & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
        & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
      ) | (
        { __typename: 'ParagraphListingLocationByTreatmentOffer' }
        & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingMedicineNews' }
        & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
        & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFiltered' }
        & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
        & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFrontpage' }
        & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
        & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomResearch' }
        & Pick<ParagraphListingNewsroomResearch, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomTreatment' }
        & Pick<ParagraphListingNewsroomTreatment, 'argument'>
      ) | (
        { __typename: 'ParagraphListingSpecialists' }
        & Pick<ParagraphListingSpecialists, 'title'>
      ) | (
        { __typename: 'ParagraphLiteratureLinks' }
        & { refLinks: Maybe<Array<Maybe<(
          Pick<LiteratureLinks, 'description'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLiteraturePdfs' }
        & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
      ) | (
        { __typename: 'ParagraphLiteratureText' }
        & Pick<ParagraphLiteratureText, 'textHtml'>
      ) | (
        { __typename: 'ParagraphLogoCloud' }
        & { logoImages: Maybe<Array<Maybe<(
          { __typename: 'ParagraphLogoCloudImage' }
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphMegaTeasers' }
        & Pick<ParagraphMegaTeasers, 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphNewsTeaser' }
        & { newsContent: Maybe<(
          Pick<ContentNews, 'path' | 'title' | 'date'>
          & { teaserImage: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphPreAnalyticData' }
        & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
        & { containerImage: Maybe<(
          Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
        )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphSiteSearch' }
        & Pick<ParagraphSiteSearch, 'placeholderText'>
      ) | (
        { __typename: 'ParagraphSpacer' }
        & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
      ) | (
        { __typename: 'ParagraphSpecialistsSlider' }
        & Pick<ParagraphSpecialistsSlider, 'title'>
        & { specialists: Array<Maybe<(
          { __typename: 'ContentSpecialist' }
          & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
          & { imagePortrait: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
        & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
      ) | (
        { __typename: 'ParagraphStaticWallsBlock' }
        & Pick<ParagraphStaticWallsBlock, 'title'>
      ) | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphTeasers' }
        & Pick<ParagraphTeasers, 'display' | 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTestimonialSlider' }
        & Pick<ParagraphTestimonialSlider, 'title'>
        & { testimonial: Array<Maybe<(
          Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      ) | (
        { __typename: 'ParagraphTiles' }
        & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTile' }
          & Pick<ParagraphTile, 'text' | 'url'>
        )>> }
      ) | (
        { __typename: 'ParagraphTimeline' }
        & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineGroup' }
          & Pick<ParagraphTimelineGroup, 'groupTitle'>
          & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphTimelineElement' }
            & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
            & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageCarousel' }
              & Pick<ParagraphImageCarousel, 'display'>
              & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
                { __typename: 'ParagraphImageWithCaption' }
                & Pick<ParagraphImageWithCaption, 'caption'>
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )> }
              ) | (
                { __typename: 'ParagraphVideo' }
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )>, video: Maybe<(
                  { __typename: 'MediaVideoLocal' }
                  & Pick<MediaVideoLocal, 'url'>
                ) | (
                  { __typename: 'MediaVideoRemote' }
                  & Pick<MediaVideoRemote, 'url'>
                )> }
              )>> }
            ) | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphQuote' }
              & Pick<ParagraphQuote, 'author' | 'quote'>
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            ) | (
              { __typename: 'ParagraphWysiwygContent' }
              & Pick<ParagraphWysiwygContent, 'textHtml'>
            ) | (
              { __typename: 'ParagraphYoutubeEmbed' }
              & { embed: Pick<Link, 'url'> }
            )>> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>>, infoBooking: Array<Maybe<(
        { __typename: 'ParagraphAccordion' }
        & { accordionElements: Array<(
          { __typename: 'ParagraphAccordionElement' }
          & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
        )> }
      ) | (
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphAnchor' }
        & Pick<ParagraphAnchor, 'anchorLink'>
      ) | (
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumbers' }
        & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
        & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
          { __typename: 'ParagraphAnimatedNumberElement' }
          & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphAnimatedNumberRange' }
          & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphBabiesSearch' }
        & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphCallToAction' }
        & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
        & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualEvent' }
        & { event: Maybe<(
          Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualText' }
        & Pick<ParagraphContextualText, 'title' | 'textHtml'>
        & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
      ) | (
        { __typename: 'ParagraphDocuments' }
        & Pick<ParagraphDocuments, 'title'>
        & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
      ) | { __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphEventForm' }
        & Pick<ParagraphEventForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphEventsSearch' }
        & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphFileList' }
        & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphForm' }
        & Pick<ParagraphForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphFormattedTextWithTitle' }
        & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphLabCardListing' }
        & Pick<ParagraphLabCardListing, 'title'>
      ) | (
        { __typename: 'ParagraphLinkList' }
        & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphLinkListLink' }
          & Pick<ParagraphLinkListLink, 'title'>
          & { listLink: Pick<LinkWithText, 'url' | 'text'> }
        )>> }
      ) | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      ) | (
        { __typename: 'ParagraphListingAllocation' }
        & Pick<ParagraphListingAllocation, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingClinicsByArea' }
        & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingDiseaseFromLocation' }
        & Pick<ParagraphListingDiseaseFromLocation, 'title'>
        & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
      ) | (
        { __typename: 'ParagraphListingDiseaseSearchSource' }
        & Pick<ParagraphListingDiseaseSearchSource, 'title'>
      ) | (
        { __typename: 'ParagraphListingEventsEmbed' }
        & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByDepartment' }
        & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
        & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingJobList' }
        & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
      ) | (
        { __typename: 'ParagraphListingJobToolSearch' }
        & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
        & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
      ) | (
        { __typename: 'ParagraphListingLocationByTreatmentOffer' }
        & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingMedicineNews' }
        & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
        & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFiltered' }
        & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
        & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFrontpage' }
        & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
        & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomResearch' }
        & Pick<ParagraphListingNewsroomResearch, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomTreatment' }
        & Pick<ParagraphListingNewsroomTreatment, 'argument'>
      ) | (
        { __typename: 'ParagraphListingSpecialists' }
        & Pick<ParagraphListingSpecialists, 'title'>
      ) | (
        { __typename: 'ParagraphLiteratureLinks' }
        & { refLinks: Maybe<Array<Maybe<(
          Pick<LiteratureLinks, 'description'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLiteraturePdfs' }
        & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
      ) | (
        { __typename: 'ParagraphLiteratureText' }
        & Pick<ParagraphLiteratureText, 'textHtml'>
      ) | (
        { __typename: 'ParagraphLogoCloud' }
        & { logoImages: Maybe<Array<Maybe<(
          { __typename: 'ParagraphLogoCloudImage' }
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphMegaTeasers' }
        & Pick<ParagraphMegaTeasers, 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphNewsTeaser' }
        & { newsContent: Maybe<(
          Pick<ContentNews, 'path' | 'title' | 'date'>
          & { teaserImage: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphPreAnalyticData' }
        & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
        & { containerImage: Maybe<(
          Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
        )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphSiteSearch' }
        & Pick<ParagraphSiteSearch, 'placeholderText'>
      ) | (
        { __typename: 'ParagraphSpacer' }
        & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
      ) | (
        { __typename: 'ParagraphSpecialistsSlider' }
        & Pick<ParagraphSpecialistsSlider, 'title'>
        & { specialists: Array<Maybe<(
          { __typename: 'ContentSpecialist' }
          & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
          & { imagePortrait: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
        & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
      ) | (
        { __typename: 'ParagraphStaticWallsBlock' }
        & Pick<ParagraphStaticWallsBlock, 'title'>
      ) | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphTeasers' }
        & Pick<ParagraphTeasers, 'display' | 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTestimonialSlider' }
        & Pick<ParagraphTestimonialSlider, 'title'>
        & { testimonial: Array<Maybe<(
          Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      ) | (
        { __typename: 'ParagraphTiles' }
        & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTile' }
          & Pick<ParagraphTile, 'text' | 'url'>
        )>> }
      ) | (
        { __typename: 'ParagraphTimeline' }
        & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineGroup' }
          & Pick<ParagraphTimelineGroup, 'groupTitle'>
          & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphTimelineElement' }
            & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
            & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageCarousel' }
              & Pick<ParagraphImageCarousel, 'display'>
              & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
                { __typename: 'ParagraphImageWithCaption' }
                & Pick<ParagraphImageWithCaption, 'caption'>
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )> }
              ) | (
                { __typename: 'ParagraphVideo' }
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )>, video: Maybe<(
                  { __typename: 'MediaVideoLocal' }
                  & Pick<MediaVideoLocal, 'url'>
                ) | (
                  { __typename: 'MediaVideoRemote' }
                  & Pick<MediaVideoRemote, 'url'>
                )> }
              )>> }
            ) | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphQuote' }
              & Pick<ParagraphQuote, 'author' | 'quote'>
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            ) | (
              { __typename: 'ParagraphWysiwygContent' }
              & Pick<ParagraphWysiwygContent, 'textHtml'>
            ) | (
              { __typename: 'ParagraphYoutubeEmbed' }
              & { embed: Pick<Link, 'url'> }
            )>> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>>, infoEmergency: Array<Maybe<(
        { __typename: 'ParagraphAccordion' }
        & { accordionElements: Array<(
          { __typename: 'ParagraphAccordionElement' }
          & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
        )> }
      ) | (
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphAnchor' }
        & Pick<ParagraphAnchor, 'anchorLink'>
      ) | (
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumbers' }
        & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
        & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
          { __typename: 'ParagraphAnimatedNumberElement' }
          & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphAnimatedNumberRange' }
          & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphBabiesSearch' }
        & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphCallToAction' }
        & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
        & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualEvent' }
        & { event: Maybe<(
          Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualText' }
        & Pick<ParagraphContextualText, 'title' | 'textHtml'>
        & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
      ) | (
        { __typename: 'ParagraphDocuments' }
        & Pick<ParagraphDocuments, 'title'>
        & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
      ) | { __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphEventForm' }
        & Pick<ParagraphEventForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphEventsSearch' }
        & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphFileList' }
        & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphForm' }
        & Pick<ParagraphForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphFormattedTextWithTitle' }
        & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphLabCardListing' }
        & Pick<ParagraphLabCardListing, 'title'>
      ) | (
        { __typename: 'ParagraphLinkList' }
        & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphLinkListLink' }
          & Pick<ParagraphLinkListLink, 'title'>
          & { listLink: Pick<LinkWithText, 'url' | 'text'> }
        )>> }
      ) | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      ) | (
        { __typename: 'ParagraphListingAllocation' }
        & Pick<ParagraphListingAllocation, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingClinicsByArea' }
        & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingDiseaseFromLocation' }
        & Pick<ParagraphListingDiseaseFromLocation, 'title'>
        & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
      ) | (
        { __typename: 'ParagraphListingDiseaseSearchSource' }
        & Pick<ParagraphListingDiseaseSearchSource, 'title'>
      ) | (
        { __typename: 'ParagraphListingEventsEmbed' }
        & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByDepartment' }
        & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
        & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingJobList' }
        & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
      ) | (
        { __typename: 'ParagraphListingJobToolSearch' }
        & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
        & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
      ) | (
        { __typename: 'ParagraphListingLocationByTreatmentOffer' }
        & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingMedicineNews' }
        & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
        & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFiltered' }
        & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
        & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFrontpage' }
        & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
        & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomResearch' }
        & Pick<ParagraphListingNewsroomResearch, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomTreatment' }
        & Pick<ParagraphListingNewsroomTreatment, 'argument'>
      ) | (
        { __typename: 'ParagraphListingSpecialists' }
        & Pick<ParagraphListingSpecialists, 'title'>
      ) | (
        { __typename: 'ParagraphLiteratureLinks' }
        & { refLinks: Maybe<Array<Maybe<(
          Pick<LiteratureLinks, 'description'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLiteraturePdfs' }
        & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
      ) | (
        { __typename: 'ParagraphLiteratureText' }
        & Pick<ParagraphLiteratureText, 'textHtml'>
      ) | (
        { __typename: 'ParagraphLogoCloud' }
        & { logoImages: Maybe<Array<Maybe<(
          { __typename: 'ParagraphLogoCloudImage' }
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphMegaTeasers' }
        & Pick<ParagraphMegaTeasers, 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphNewsTeaser' }
        & { newsContent: Maybe<(
          Pick<ContentNews, 'path' | 'title' | 'date'>
          & { teaserImage: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphPreAnalyticData' }
        & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
        & { containerImage: Maybe<(
          Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
        )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphSiteSearch' }
        & Pick<ParagraphSiteSearch, 'placeholderText'>
      ) | (
        { __typename: 'ParagraphSpacer' }
        & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
      ) | (
        { __typename: 'ParagraphSpecialistsSlider' }
        & Pick<ParagraphSpecialistsSlider, 'title'>
        & { specialists: Array<Maybe<(
          { __typename: 'ContentSpecialist' }
          & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
          & { imagePortrait: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
        & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
      ) | (
        { __typename: 'ParagraphStaticWallsBlock' }
        & Pick<ParagraphStaticWallsBlock, 'title'>
      ) | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphTeasers' }
        & Pick<ParagraphTeasers, 'display' | 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTestimonialSlider' }
        & Pick<ParagraphTestimonialSlider, 'title'>
        & { testimonial: Array<Maybe<(
          Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      ) | (
        { __typename: 'ParagraphTiles' }
        & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTile' }
          & Pick<ParagraphTile, 'text' | 'url'>
        )>> }
      ) | (
        { __typename: 'ParagraphTimeline' }
        & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineGroup' }
          & Pick<ParagraphTimelineGroup, 'groupTitle'>
          & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphTimelineElement' }
            & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
            & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageCarousel' }
              & Pick<ParagraphImageCarousel, 'display'>
              & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
                { __typename: 'ParagraphImageWithCaption' }
                & Pick<ParagraphImageWithCaption, 'caption'>
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )> }
              ) | (
                { __typename: 'ParagraphVideo' }
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )>, video: Maybe<(
                  { __typename: 'MediaVideoLocal' }
                  & Pick<MediaVideoLocal, 'url'>
                ) | (
                  { __typename: 'MediaVideoRemote' }
                  & Pick<MediaVideoRemote, 'url'>
                )> }
              )>> }
            ) | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphQuote' }
              & Pick<ParagraphQuote, 'author' | 'quote'>
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            ) | (
              { __typename: 'ParagraphWysiwygContent' }
              & Pick<ParagraphWysiwygContent, 'textHtml'>
            ) | (
              { __typename: 'ParagraphYoutubeEmbed' }
              & { embed: Pick<Link, 'url'> }
            )>> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>>, parentLocation: Maybe<Pick<ContentLocation, 'title'>>, metaTags: Maybe<Array<Maybe<(
        Pick<MetaTag, 'tag'>
        & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
      )>>> }
    )>, contentSidebar: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, contentBottom: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type ContentLocationRevisionQueryVariables = Exact<{
  remoteId: Scalars['String'];
  revisionId: Scalars['String'];
}>;


export type ContentLocationRevisionQuery = { content: Maybe<(
    Pick<ContentLocation, 'drupalId' | 'path' | 'title' | 'subtitle' | 'welcomeTitle' | 'specialistsTitle' | 'displayRelatedNews' | 'teamPageTitle' | 'hideParentLocationTitleFromContactInformation'>
    & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>>, content: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>, contact: Maybe<(
      Pick<ContentLocationContact, 'path' | 'title' | 'companyName' | 'addressFirstLine' | 'addressSecondLine' | 'postCode' | 'city' | 'email' | 'phone' | 'mapOverlayHtml' | 'latitude' | 'longitude'>
      & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, locationHeader: { location: Maybe<(
          Pick<ContentLocation, 'path' | 'title' | 'subtitle'>
          & { contact: Maybe<Pick<ContentLocationContact, 'path'>> }
        )>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>> }, infoAddress: Array<Maybe<(
        { __typename: 'ParagraphAccordion' }
        & { accordionElements: Array<(
          { __typename: 'ParagraphAccordionElement' }
          & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
        )> }
      ) | (
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphAnchor' }
        & Pick<ParagraphAnchor, 'anchorLink'>
      ) | (
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumbers' }
        & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
        & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
          { __typename: 'ParagraphAnimatedNumberElement' }
          & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphAnimatedNumberRange' }
          & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphBabiesSearch' }
        & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphCallToAction' }
        & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
        & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualEvent' }
        & { event: Maybe<(
          Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualText' }
        & Pick<ParagraphContextualText, 'title' | 'textHtml'>
        & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
      ) | (
        { __typename: 'ParagraphDocuments' }
        & Pick<ParagraphDocuments, 'title'>
        & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
      ) | { __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphEventForm' }
        & Pick<ParagraphEventForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphEventsSearch' }
        & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphFileList' }
        & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphForm' }
        & Pick<ParagraphForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphFormattedTextWithTitle' }
        & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphLabCardListing' }
        & Pick<ParagraphLabCardListing, 'title'>
      ) | (
        { __typename: 'ParagraphLinkList' }
        & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphLinkListLink' }
          & Pick<ParagraphLinkListLink, 'title'>
          & { listLink: Pick<LinkWithText, 'url' | 'text'> }
        )>> }
      ) | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      ) | (
        { __typename: 'ParagraphListingAllocation' }
        & Pick<ParagraphListingAllocation, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingClinicsByArea' }
        & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingDiseaseFromLocation' }
        & Pick<ParagraphListingDiseaseFromLocation, 'title'>
        & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
      ) | (
        { __typename: 'ParagraphListingDiseaseSearchSource' }
        & Pick<ParagraphListingDiseaseSearchSource, 'title'>
      ) | (
        { __typename: 'ParagraphListingEventsEmbed' }
        & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByDepartment' }
        & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
        & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingJobList' }
        & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
      ) | (
        { __typename: 'ParagraphListingJobToolSearch' }
        & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
        & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
      ) | (
        { __typename: 'ParagraphListingLocationByTreatmentOffer' }
        & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingMedicineNews' }
        & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
        & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFiltered' }
        & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
        & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFrontpage' }
        & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
        & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomResearch' }
        & Pick<ParagraphListingNewsroomResearch, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomTreatment' }
        & Pick<ParagraphListingNewsroomTreatment, 'argument'>
      ) | (
        { __typename: 'ParagraphListingSpecialists' }
        & Pick<ParagraphListingSpecialists, 'title'>
      ) | (
        { __typename: 'ParagraphLiteratureLinks' }
        & { refLinks: Maybe<Array<Maybe<(
          Pick<LiteratureLinks, 'description'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLiteraturePdfs' }
        & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
      ) | (
        { __typename: 'ParagraphLiteratureText' }
        & Pick<ParagraphLiteratureText, 'textHtml'>
      ) | (
        { __typename: 'ParagraphLogoCloud' }
        & { logoImages: Maybe<Array<Maybe<(
          { __typename: 'ParagraphLogoCloudImage' }
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphMegaTeasers' }
        & Pick<ParagraphMegaTeasers, 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphNewsTeaser' }
        & { newsContent: Maybe<(
          Pick<ContentNews, 'path' | 'title' | 'date'>
          & { teaserImage: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphPreAnalyticData' }
        & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
        & { containerImage: Maybe<(
          Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
        )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphSiteSearch' }
        & Pick<ParagraphSiteSearch, 'placeholderText'>
      ) | (
        { __typename: 'ParagraphSpacer' }
        & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
      ) | (
        { __typename: 'ParagraphSpecialistsSlider' }
        & Pick<ParagraphSpecialistsSlider, 'title'>
        & { specialists: Array<Maybe<(
          { __typename: 'ContentSpecialist' }
          & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
          & { imagePortrait: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
        & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
      ) | (
        { __typename: 'ParagraphStaticWallsBlock' }
        & Pick<ParagraphStaticWallsBlock, 'title'>
      ) | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphTeasers' }
        & Pick<ParagraphTeasers, 'display' | 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTestimonialSlider' }
        & Pick<ParagraphTestimonialSlider, 'title'>
        & { testimonial: Array<Maybe<(
          Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      ) | (
        { __typename: 'ParagraphTiles' }
        & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTile' }
          & Pick<ParagraphTile, 'text' | 'url'>
        )>> }
      ) | (
        { __typename: 'ParagraphTimeline' }
        & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineGroup' }
          & Pick<ParagraphTimelineGroup, 'groupTitle'>
          & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphTimelineElement' }
            & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
            & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageCarousel' }
              & Pick<ParagraphImageCarousel, 'display'>
              & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
                { __typename: 'ParagraphImageWithCaption' }
                & Pick<ParagraphImageWithCaption, 'caption'>
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )> }
              ) | (
                { __typename: 'ParagraphVideo' }
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )>, video: Maybe<(
                  { __typename: 'MediaVideoLocal' }
                  & Pick<MediaVideoLocal, 'url'>
                ) | (
                  { __typename: 'MediaVideoRemote' }
                  & Pick<MediaVideoRemote, 'url'>
                )> }
              )>> }
            ) | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphQuote' }
              & Pick<ParagraphQuote, 'author' | 'quote'>
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            ) | (
              { __typename: 'ParagraphWysiwygContent' }
              & Pick<ParagraphWysiwygContent, 'textHtml'>
            ) | (
              { __typename: 'ParagraphYoutubeEmbed' }
              & { embed: Pick<Link, 'url'> }
            )>> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>>, infoBooking: Array<Maybe<(
        { __typename: 'ParagraphAccordion' }
        & { accordionElements: Array<(
          { __typename: 'ParagraphAccordionElement' }
          & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
        )> }
      ) | (
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphAnchor' }
        & Pick<ParagraphAnchor, 'anchorLink'>
      ) | (
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumbers' }
        & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
        & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
          { __typename: 'ParagraphAnimatedNumberElement' }
          & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphAnimatedNumberRange' }
          & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphBabiesSearch' }
        & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphCallToAction' }
        & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
        & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualEvent' }
        & { event: Maybe<(
          Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualText' }
        & Pick<ParagraphContextualText, 'title' | 'textHtml'>
        & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
      ) | (
        { __typename: 'ParagraphDocuments' }
        & Pick<ParagraphDocuments, 'title'>
        & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
      ) | { __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphEventForm' }
        & Pick<ParagraphEventForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphEventsSearch' }
        & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphFileList' }
        & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphForm' }
        & Pick<ParagraphForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphFormattedTextWithTitle' }
        & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphLabCardListing' }
        & Pick<ParagraphLabCardListing, 'title'>
      ) | (
        { __typename: 'ParagraphLinkList' }
        & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphLinkListLink' }
          & Pick<ParagraphLinkListLink, 'title'>
          & { listLink: Pick<LinkWithText, 'url' | 'text'> }
        )>> }
      ) | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      ) | (
        { __typename: 'ParagraphListingAllocation' }
        & Pick<ParagraphListingAllocation, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingClinicsByArea' }
        & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingDiseaseFromLocation' }
        & Pick<ParagraphListingDiseaseFromLocation, 'title'>
        & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
      ) | (
        { __typename: 'ParagraphListingDiseaseSearchSource' }
        & Pick<ParagraphListingDiseaseSearchSource, 'title'>
      ) | (
        { __typename: 'ParagraphListingEventsEmbed' }
        & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByDepartment' }
        & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
        & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingJobList' }
        & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
      ) | (
        { __typename: 'ParagraphListingJobToolSearch' }
        & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
        & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
      ) | (
        { __typename: 'ParagraphListingLocationByTreatmentOffer' }
        & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingMedicineNews' }
        & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
        & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFiltered' }
        & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
        & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFrontpage' }
        & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
        & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomResearch' }
        & Pick<ParagraphListingNewsroomResearch, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomTreatment' }
        & Pick<ParagraphListingNewsroomTreatment, 'argument'>
      ) | (
        { __typename: 'ParagraphListingSpecialists' }
        & Pick<ParagraphListingSpecialists, 'title'>
      ) | (
        { __typename: 'ParagraphLiteratureLinks' }
        & { refLinks: Maybe<Array<Maybe<(
          Pick<LiteratureLinks, 'description'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLiteraturePdfs' }
        & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
      ) | (
        { __typename: 'ParagraphLiteratureText' }
        & Pick<ParagraphLiteratureText, 'textHtml'>
      ) | (
        { __typename: 'ParagraphLogoCloud' }
        & { logoImages: Maybe<Array<Maybe<(
          { __typename: 'ParagraphLogoCloudImage' }
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphMegaTeasers' }
        & Pick<ParagraphMegaTeasers, 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphNewsTeaser' }
        & { newsContent: Maybe<(
          Pick<ContentNews, 'path' | 'title' | 'date'>
          & { teaserImage: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphPreAnalyticData' }
        & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
        & { containerImage: Maybe<(
          Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
        )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphSiteSearch' }
        & Pick<ParagraphSiteSearch, 'placeholderText'>
      ) | (
        { __typename: 'ParagraphSpacer' }
        & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
      ) | (
        { __typename: 'ParagraphSpecialistsSlider' }
        & Pick<ParagraphSpecialistsSlider, 'title'>
        & { specialists: Array<Maybe<(
          { __typename: 'ContentSpecialist' }
          & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
          & { imagePortrait: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
        & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
      ) | (
        { __typename: 'ParagraphStaticWallsBlock' }
        & Pick<ParagraphStaticWallsBlock, 'title'>
      ) | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphTeasers' }
        & Pick<ParagraphTeasers, 'display' | 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTestimonialSlider' }
        & Pick<ParagraphTestimonialSlider, 'title'>
        & { testimonial: Array<Maybe<(
          Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      ) | (
        { __typename: 'ParagraphTiles' }
        & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTile' }
          & Pick<ParagraphTile, 'text' | 'url'>
        )>> }
      ) | (
        { __typename: 'ParagraphTimeline' }
        & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineGroup' }
          & Pick<ParagraphTimelineGroup, 'groupTitle'>
          & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphTimelineElement' }
            & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
            & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageCarousel' }
              & Pick<ParagraphImageCarousel, 'display'>
              & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
                { __typename: 'ParagraphImageWithCaption' }
                & Pick<ParagraphImageWithCaption, 'caption'>
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )> }
              ) | (
                { __typename: 'ParagraphVideo' }
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )>, video: Maybe<(
                  { __typename: 'MediaVideoLocal' }
                  & Pick<MediaVideoLocal, 'url'>
                ) | (
                  { __typename: 'MediaVideoRemote' }
                  & Pick<MediaVideoRemote, 'url'>
                )> }
              )>> }
            ) | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphQuote' }
              & Pick<ParagraphQuote, 'author' | 'quote'>
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            ) | (
              { __typename: 'ParagraphWysiwygContent' }
              & Pick<ParagraphWysiwygContent, 'textHtml'>
            ) | (
              { __typename: 'ParagraphYoutubeEmbed' }
              & { embed: Pick<Link, 'url'> }
            )>> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>>, infoEmergency: Array<Maybe<(
        { __typename: 'ParagraphAccordion' }
        & { accordionElements: Array<(
          { __typename: 'ParagraphAccordionElement' }
          & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
        )> }
      ) | (
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphAnchor' }
        & Pick<ParagraphAnchor, 'anchorLink'>
      ) | (
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumbers' }
        & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
        & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
          { __typename: 'ParagraphAnimatedNumberElement' }
          & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphAnimatedNumberRange' }
          & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
          & { Image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphBabiesSearch' }
        & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphCallToAction' }
        & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
        & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualEvent' }
        & { event: Maybe<(
          Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphContextualText' }
        & Pick<ParagraphContextualText, 'title' | 'textHtml'>
        & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
      ) | (
        { __typename: 'ParagraphDocuments' }
        & Pick<ParagraphDocuments, 'title'>
        & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
      ) | { __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphEventForm' }
        & Pick<ParagraphEventForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphEventsSearch' }
        & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
      ) | (
        { __typename: 'ParagraphFileList' }
        & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphForm' }
        & Pick<ParagraphForm, 'formUrl'>
      ) | (
        { __typename: 'ParagraphFormattedTextWithTitle' }
        & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
      ) | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphLabCardListing' }
        & Pick<ParagraphLabCardListing, 'title'>
      ) | (
        { __typename: 'ParagraphLinkList' }
        & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphLinkListLink' }
          & Pick<ParagraphLinkListLink, 'title'>
          & { listLink: Pick<LinkWithText, 'url' | 'text'> }
        )>> }
      ) | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      ) | (
        { __typename: 'ParagraphListingAllocation' }
        & Pick<ParagraphListingAllocation, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingClinicsByArea' }
        & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingDiseaseFromLocation' }
        & Pick<ParagraphListingDiseaseFromLocation, 'title'>
        & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
      ) | (
        { __typename: 'ParagraphListingDiseaseSearchSource' }
        & Pick<ParagraphListingDiseaseSearchSource, 'title'>
      ) | (
        { __typename: 'ParagraphListingEventsEmbed' }
        & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByDepartment' }
        & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
        & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
        & { cta: Pick<Link, 'url'> }
      ) | (
        { __typename: 'ParagraphListingJobList' }
        & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
      ) | (
        { __typename: 'ParagraphListingJobToolSearch' }
        & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
        & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
      ) | (
        { __typename: 'ParagraphListingLocationByTreatmentOffer' }
        & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingMedicineNews' }
        & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
        & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFiltered' }
        & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
        & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
      ) | (
        { __typename: 'ParagraphListingNewsroomFrontpage' }
        & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
        & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomResearch' }
        & Pick<ParagraphListingNewsroomResearch, 'argument'>
      ) | (
        { __typename: 'ParagraphListingNewsroomTreatment' }
        & Pick<ParagraphListingNewsroomTreatment, 'argument'>
      ) | (
        { __typename: 'ParagraphListingSpecialists' }
        & Pick<ParagraphListingSpecialists, 'title'>
      ) | (
        { __typename: 'ParagraphLiteratureLinks' }
        & { refLinks: Maybe<Array<Maybe<(
          Pick<LiteratureLinks, 'description'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLiteraturePdfs' }
        & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
      ) | (
        { __typename: 'ParagraphLiteratureText' }
        & Pick<ParagraphLiteratureText, 'textHtml'>
      ) | (
        { __typename: 'ParagraphLogoCloud' }
        & { logoImages: Maybe<Array<Maybe<(
          { __typename: 'ParagraphLogoCloudImage' }
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>>> }
      ) | (
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphMegaTeasers' }
        & Pick<ParagraphMegaTeasers, 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphNewsTeaser' }
        & { newsContent: Maybe<(
          Pick<ContentNews, 'path' | 'title' | 'date'>
          & { teaserImage: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )> }
      ) | (
        { __typename: 'ParagraphPreAnalyticData' }
        & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
        & { containerImage: Maybe<(
          Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
        )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphSiteSearch' }
        & Pick<ParagraphSiteSearch, 'placeholderText'>
      ) | (
        { __typename: 'ParagraphSpacer' }
        & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
      ) | (
        { __typename: 'ParagraphSpecialistsSlider' }
        & Pick<ParagraphSpecialistsSlider, 'title'>
        & { specialists: Array<Maybe<(
          { __typename: 'ContentSpecialist' }
          & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
          & { imagePortrait: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
        & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
      ) | (
        { __typename: 'ParagraphStaticWallsBlock' }
        & Pick<ParagraphStaticWallsBlock, 'title'>
      ) | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphTeasers' }
        & Pick<ParagraphTeasers, 'display' | 'title'>
        & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTeaser' }
          & Pick<ParagraphTeaser, 'title' | 'lead'>
          & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTestimonialSlider' }
        & Pick<ParagraphTestimonialSlider, 'title'>
        & { testimonial: Array<Maybe<(
          Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
          & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      ) | (
        { __typename: 'ParagraphTiles' }
        & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTile' }
          & Pick<ParagraphTile, 'text' | 'url'>
        )>> }
      ) | (
        { __typename: 'ParagraphTimeline' }
        & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineGroup' }
          & Pick<ParagraphTimelineGroup, 'groupTitle'>
          & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphTimelineElement' }
            & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
            & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageCarousel' }
              & Pick<ParagraphImageCarousel, 'display'>
              & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
                { __typename: 'ParagraphImageWithCaption' }
                & Pick<ParagraphImageWithCaption, 'caption'>
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )> }
              ) | (
                { __typename: 'ParagraphVideo' }
                & { image: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )>, video: Maybe<(
                  { __typename: 'MediaVideoLocal' }
                  & Pick<MediaVideoLocal, 'url'>
                ) | (
                  { __typename: 'MediaVideoRemote' }
                  & Pick<MediaVideoRemote, 'url'>
                )> }
              )>> }
            ) | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphQuote' }
              & Pick<ParagraphQuote, 'author' | 'quote'>
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            ) | (
              { __typename: 'ParagraphWysiwygContent' }
              & Pick<ParagraphWysiwygContent, 'textHtml'>
            ) | (
              { __typename: 'ParagraphYoutubeEmbed' }
              & { embed: Pick<Link, 'url'> }
            )>> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      ) | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>>, parentLocation: Maybe<Pick<ContentLocation, 'title'>>, metaTags: Maybe<Array<Maybe<(
        Pick<MetaTag, 'tag'>
        & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
      )>>> }
    )>, contentSidebar: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, contentBottom: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type ContentNewsQueryVariables = Exact<{
  remoteId: Scalars['String'];
}>;


export type ContentNewsQuery = { content: Maybe<(
    Pick<ContentNews, 'drupalId' | 'title' | 'lead' | 'date' | 'dateChanged' | 'readTime' | 'caption' | 'types' | 'gtmData'>
    & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, constructionTerms: Array<Maybe<(
      Pick<TermConstruction, 'title'>
      & { referenceNode: Maybe<Pick<ContentBaby, 'title' | 'path'> | Pick<ContentDisease, 'title' | 'path'> | Pick<ContentDocumentationPage, 'title' | 'path'> | Pick<ContentEvent, 'title' | 'path'> | Pick<ContentKitchenSink, 'title' | 'path'> | Pick<ContentLandingPage, 'title' | 'path'> | Pick<ContentLocation, 'title' | 'path'> | Pick<ContentLocationContact, 'title' | 'path'> | Pick<ContentNews, 'title' | 'path'> | Pick<ContentPage, 'title' | 'path'> | Pick<ContentPatientInformation, 'title' | 'path'> | Pick<ContentSpecialist, 'title' | 'path'> | Pick<ContentTeam, 'title' | 'path'> | Pick<GroupDocumentation, 'title' | 'path'>> }
    )>>, knowledgeTerms: Array<Maybe<(
      Pick<TermKnowledge, 'title'>
      & { referenceNode: Maybe<Pick<ContentBaby, 'title' | 'path'> | Pick<ContentDisease, 'title' | 'path'> | Pick<ContentDocumentationPage, 'title' | 'path'> | Pick<ContentEvent, 'title' | 'path'> | Pick<ContentKitchenSink, 'title' | 'path'> | Pick<ContentLandingPage, 'title' | 'path'> | Pick<ContentLocation, 'title' | 'path'> | Pick<ContentLocationContact, 'title' | 'path'> | Pick<ContentNews, 'title' | 'path'> | Pick<ContentPage, 'title' | 'path'> | Pick<ContentPatientInformation, 'title' | 'path'> | Pick<ContentSpecialist, 'title' | 'path'> | Pick<ContentTeam, 'title' | 'path'> | Pick<GroupDocumentation, 'title' | 'path'>> }
    )>>, strategyTerms: Array<Maybe<(
      Pick<TermStrategy, 'title'>
      & { referenceNode: Maybe<Pick<ContentBaby, 'title' | 'path'> | Pick<ContentDisease, 'title' | 'path'> | Pick<ContentDocumentationPage, 'title' | 'path'> | Pick<ContentEvent, 'title' | 'path'> | Pick<ContentKitchenSink, 'title' | 'path'> | Pick<ContentLandingPage, 'title' | 'path'> | Pick<ContentLocation, 'title' | 'path'> | Pick<ContentLocationContact, 'title' | 'path'> | Pick<ContentNews, 'title' | 'path'> | Pick<ContentPage, 'title' | 'path'> | Pick<ContentPatientInformation, 'title' | 'path'> | Pick<ContentSpecialist, 'title' | 'path'> | Pick<ContentTeam, 'title' | 'path'> | Pick<GroupDocumentation, 'title' | 'path'>> }
    )>>, teaserImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>>, styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, body: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, locations: Array<Maybe<(
      Pick<ContentLocation, 'title' | 'path'>
      & { area: Maybe<Pick<TermAdministrativeArea, 'title'>> }
    )>>, specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>, diseases: Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>, sidebar: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type ContentNewsRevisionQueryVariables = Exact<{
  remoteId: Scalars['String'];
  revisionId: Scalars['String'];
}>;


export type ContentNewsRevisionQuery = { content: Maybe<(
    Pick<ContentNews, 'drupalId' | 'title' | 'lead' | 'date' | 'dateChanged' | 'readTime' | 'caption' | 'types' | 'gtmData'>
    & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, constructionTerms: Array<Maybe<(
      Pick<TermConstruction, 'title'>
      & { referenceNode: Maybe<Pick<ContentBaby, 'title' | 'path'> | Pick<ContentDisease, 'title' | 'path'> | Pick<ContentDocumentationPage, 'title' | 'path'> | Pick<ContentEvent, 'title' | 'path'> | Pick<ContentKitchenSink, 'title' | 'path'> | Pick<ContentLandingPage, 'title' | 'path'> | Pick<ContentLocation, 'title' | 'path'> | Pick<ContentLocationContact, 'title' | 'path'> | Pick<ContentNews, 'title' | 'path'> | Pick<ContentPage, 'title' | 'path'> | Pick<ContentPatientInformation, 'title' | 'path'> | Pick<ContentSpecialist, 'title' | 'path'> | Pick<ContentTeam, 'title' | 'path'> | Pick<GroupDocumentation, 'title' | 'path'>> }
    )>>, knowledgeTerms: Array<Maybe<(
      Pick<TermKnowledge, 'title'>
      & { referenceNode: Maybe<Pick<ContentBaby, 'title' | 'path'> | Pick<ContentDisease, 'title' | 'path'> | Pick<ContentDocumentationPage, 'title' | 'path'> | Pick<ContentEvent, 'title' | 'path'> | Pick<ContentKitchenSink, 'title' | 'path'> | Pick<ContentLandingPage, 'title' | 'path'> | Pick<ContentLocation, 'title' | 'path'> | Pick<ContentLocationContact, 'title' | 'path'> | Pick<ContentNews, 'title' | 'path'> | Pick<ContentPage, 'title' | 'path'> | Pick<ContentPatientInformation, 'title' | 'path'> | Pick<ContentSpecialist, 'title' | 'path'> | Pick<ContentTeam, 'title' | 'path'> | Pick<GroupDocumentation, 'title' | 'path'>> }
    )>>, strategyTerms: Array<Maybe<(
      Pick<TermStrategy, 'title'>
      & { referenceNode: Maybe<Pick<ContentBaby, 'title' | 'path'> | Pick<ContentDisease, 'title' | 'path'> | Pick<ContentDocumentationPage, 'title' | 'path'> | Pick<ContentEvent, 'title' | 'path'> | Pick<ContentKitchenSink, 'title' | 'path'> | Pick<ContentLandingPage, 'title' | 'path'> | Pick<ContentLocation, 'title' | 'path'> | Pick<ContentLocationContact, 'title' | 'path'> | Pick<ContentNews, 'title' | 'path'> | Pick<ContentPage, 'title' | 'path'> | Pick<ContentPatientInformation, 'title' | 'path'> | Pick<ContentSpecialist, 'title' | 'path'> | Pick<ContentTeam, 'title' | 'path'> | Pick<GroupDocumentation, 'title' | 'path'>> }
    )>>, teaserImage: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>>, styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, body: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, locations: Array<Maybe<(
      Pick<ContentLocation, 'title' | 'path'>
      & { area: Maybe<Pick<TermAdministrativeArea, 'title'>> }
    )>>, specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>, diseases: Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>, sidebar: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type ContentPageQueryVariables = Exact<{
  remoteId: Scalars['String'];
}>;


export type ContentPageQuery = { content: Maybe<(
    Pick<ContentPage, 'title' | 'description'>
    & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, locationHeader: { location: Maybe<(
        Pick<ContentLocation, 'path' | 'title' | 'subtitle'>
        & { contact: Maybe<Pick<ContentLocationContact, 'path'>> }
      )>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>> }, body: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, sidebar: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, bottom: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>>, translations: Maybe<Array<Maybe<Pick<ContentPage, 'path' | 'translationsLanguageTitle'>>>> }
  )> };

export type ContentPageRevisionQueryVariables = Exact<{
  remoteId: Scalars['String'];
  revisionId: Scalars['String'];
}>;


export type ContentPageRevisionQuery = { content: Maybe<(
    Pick<ContentPage, 'title' | 'description'>
    & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, locationHeader: { location: Maybe<(
        Pick<ContentLocation, 'path' | 'title' | 'subtitle'>
        & { contact: Maybe<Pick<ContentLocationContact, 'path'>> }
      )>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>> }, body: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, sidebar: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, bottom: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>>, translations: Maybe<Array<Maybe<Pick<ContentPage, 'path' | 'translationsLanguageTitle'>>>> }
  )> };

export type ContentPatientInformationQueryVariables = Exact<{
  remoteId: Scalars['String'];
}>;


export type ContentPatientInformationQuery = { content: Maybe<(
    Pick<ContentPatientInformation, 'title' | 'path'>
    & { documentationGroup: Maybe<(
      Pick<GroupDocumentation, 'title' | 'path'>
      & { mainContent: Maybe<Pick<ContentDocumentationPage, 'path'> | Pick<ContentPatientInformation, 'path'>>, menuMain: Maybe<Array<Pick<MenuItem, 'id' | 'parent' | 'url' | 'label'>>> }
    )>, body: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type ContentPatientInformationRevisionQueryVariables = Exact<{
  remoteId: Scalars['String'];
  revisionId: Scalars['String'];
}>;


export type ContentPatientInformationRevisionQuery = { content: Maybe<(
    Pick<ContentPatientInformation, 'title' | 'path'>
    & { documentationGroup: Maybe<(
      Pick<GroupDocumentation, 'title' | 'path'>
      & { mainContent: Maybe<Pick<ContentDocumentationPage, 'path'> | Pick<ContentPatientInformation, 'path'>>, menuMain: Maybe<Array<Pick<MenuItem, 'id' | 'parent' | 'url' | 'label'>>> }
    )>, body: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type ContentSpecialistQueryVariables = Exact<{
  remoteId: Scalars['String'];
}>;


export type ContentSpecialistQuery = { content: Maybe<(
    Pick<ContentSpecialist, 'drupalId' | 'title' | 'firstName' | 'lastName' | 'degree' | 'job' | 'gender' | 'department' | 'path' | 'treatments' | 'email' | 'phone' | 'career' | 'memberships' | 'awards' | 'mandates' | 'studies' | 'gtmData' | 'languages' | 'forceChildrenHospitalTheme'>
    & { imageLandscape: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, areas: Array<Maybe<Pick<TermAdministrativeArea, 'title'>>>, locations: Array<Maybe<(
      Pick<ContentLocation, 'title' | 'path'>
      & { area: Maybe<Pick<TermAdministrativeArea, 'title'>> }
    )>>, expertise: Maybe<Array<Maybe<Pick<TermExpertise, 'title'>>>>, publications: Maybe<Pick<LinkWithText, 'text' | 'url'>>, personalSecretaries: Array<Pick<Secretary, 'title' | 'email' | 'phone'>>, offices: Maybe<Array<Maybe<(
      Pick<ContentLocationContact, 'email' | 'phone'>
      & { locationHeader: { location: Maybe<(
          Pick<ContentLocation, 'title' | 'path'>
          & { area: Maybe<Pick<TermAdministrativeArea, 'title'>> }
        )> } }
    )>>>, contactInfo: Array<Pick<SpecialistContactInfo, 'label' | 'value'>>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type ContentSpecialistRevisionQueryVariables = Exact<{
  remoteId: Scalars['String'];
  revisionId: Scalars['String'];
}>;


export type ContentSpecialistRevisionQuery = { content: Maybe<(
    Pick<ContentSpecialist, 'drupalId' | 'title' | 'firstName' | 'lastName' | 'degree' | 'job' | 'gender' | 'department' | 'path' | 'treatments' | 'email' | 'phone' | 'career' | 'memberships' | 'awards' | 'mandates' | 'studies' | 'gtmData' | 'languages' | 'forceChildrenHospitalTheme'>
    & { imageLandscape: Maybe<(
      { __typename: 'MediaImage' }
      & Pick<MediaImage, 'id' | 'alt'>
      & { styles: Array<(
        Pick<ImageStyle, 'id'>
        & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
      )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
    )>, areas: Array<Maybe<Pick<TermAdministrativeArea, 'title'>>>, locations: Array<Maybe<(
      Pick<ContentLocation, 'title' | 'path'>
      & { area: Maybe<Pick<TermAdministrativeArea, 'title'>> }
    )>>, expertise: Maybe<Array<Maybe<Pick<TermExpertise, 'title'>>>>, publications: Maybe<Pick<LinkWithText, 'text' | 'url'>>, personalSecretaries: Array<Pick<Secretary, 'title' | 'email' | 'phone'>>, offices: Maybe<Array<Maybe<(
      Pick<ContentLocationContact, 'email' | 'phone'>
      & { locationHeader: { location: Maybe<(
          Pick<ContentLocation, 'title' | 'path'>
          & { area: Maybe<Pick<TermAdministrativeArea, 'title'>> }
        )> } }
    )>>>, contactInfo: Array<Pick<SpecialistContactInfo, 'label' | 'value'>>, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type ContentTeamQueryVariables = Exact<{
  remoteId: Scalars['String'];
}>;


export type ContentTeamQuery = { content: Maybe<(
    Pick<ContentTeam, 'title' | 'specialistsTitle'>
    & { description: ContentTeam['lead'] }
    & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, body: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>, contentBottom: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, contentSidebar: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, locationHeader: { location: Maybe<(
        Pick<ContentLocation, 'path' | 'title' | 'subtitle'>
        & { contact: Maybe<Pick<ContentLocationContact, 'path'>> }
      )>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>> }, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type ContentTeamRevisionQueryVariables = Exact<{
  remoteId: Scalars['String'];
  revisionId: Scalars['String'];
}>;


export type ContentTeamRevisionQuery = { content: Maybe<(
    Pick<ContentTeam, 'title' | 'specialistsTitle'>
    & { description: ContentTeam['lead'] }
    & { breadcrumbs: Array<Pick<BreadcrumbItem, 'url' | 'text'>>, body: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, specialists: Array<Maybe<(
      { __typename: 'ContentSpecialist' }
      & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
      & { imagePortrait: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    )>>, contentBottom: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, contentSidebar: Array<Maybe<(
      { __typename: 'ParagraphAccordion' }
      & { accordionElements: Array<(
        { __typename: 'ParagraphAccordionElement' }
        & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
      )> }
    ) | (
      { __typename: 'ParagraphAccordionElement' }
      & Pick<ParagraphAccordionElement, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphAnchor' }
      & Pick<ParagraphAnchor, 'anchorLink'>
    ) | (
      { __typename: 'ParagraphAnimatedNumberElement' }
      & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
      & { Image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphAnimatedNumbers' }
      & Pick<ParagraphAnimatedNumbers, 'title' | 'linkType'>
      & { animLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, items: Array<Maybe<(
        { __typename: 'ParagraphAnimatedNumberElement' }
        & Pick<ParagraphAnimatedNumberElement, 'itemTitle' | 'itemNumber' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphAnimatedNumberRange' }
        & Pick<ParagraphAnimatedNumberRange, 'itemTitle' | 'itemFirstNumber' | 'itemSecondNumber' | 'itemConnectingWord' | 'itemDisableSeparator' | 'itemUnit'>
        & { Image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphBabiesSearch' }
      & { filters: { gender: Array<Pick<Item, 'id' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphCallToAction' }
      & Pick<ParagraphCallToAction, 'ctaTitle' | 'ctaDescription' | 'imgAlignment'>
      & { ctaLink: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, ctaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualEvent' }
      & { event: Maybe<(
        Pick<ContentEvent, 'id' | 'path' | 'title' | 'location' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphContextualText' }
      & Pick<ParagraphContextualText, 'title' | 'textHtml'>
      & { link: Maybe<Pick<LinkWithText, 'url' | 'text' | '_original_typename'>> }
    ) | (
      { __typename: 'ParagraphDocuments' }
      & Pick<ParagraphDocuments, 'title'>
      & { documents: Array<Maybe<Pick<MediaFile, 'title' | '_original_typename' | 'url'>>> }
    ) | { __typename: 'ParagraphEmpty' } | (
      { __typename: 'ParagraphEventForm' }
      & Pick<ParagraphEventForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphEventsSearch' }
      & { filters: { type: Array<Pick<ItemWithParent, 'id' | 'parentId' | 'title'>>, location: Array<Pick<Item, 'id' | 'title'>> } }
    ) | (
      { __typename: 'ParagraphFileList' }
      & { files: Maybe<Array<Maybe<Pick<MediaFile, 'url' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphForm' }
      & Pick<ParagraphForm, 'formUrl'>
    ) | (
      { __typename: 'ParagraphFormattedTextWithTitle' }
      & Pick<ParagraphFormattedTextWithTitle, 'title' | 'textHtml'>
    ) | (
      { __typename: 'ParagraphImageCarousel' }
      & Pick<ParagraphImageCarousel, 'display'>
      & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphImageWithCaption' }
      & Pick<ParagraphImageWithCaption, 'caption'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphLabCardListing' }
      & Pick<ParagraphLabCardListing, 'title'>
    ) | (
      { __typename: 'ParagraphLinkList' }
      & { links: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphLinkListLink' }
        & Pick<ParagraphLinkListLink, 'title'>
        & { listLink: Pick<LinkWithText, 'url' | 'text'> }
      )>> }
    ) | (
      { __typename: 'ParagraphLinkListLink' }
      & Pick<ParagraphLinkListLink, 'title'>
      & { listLink: Pick<LinkWithText, 'url' | 'text'> }
    ) | (
      { __typename: 'ParagraphListingAllocation' }
      & Pick<ParagraphListingAllocation, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingClinicsByArea' }
      & Pick<ParagraphListingClinicsByArea, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingDiseaseFromLocation' }
      & Pick<ParagraphListingDiseaseFromLocation, 'title'>
      & { diseaseList: Maybe<Array<Maybe<Pick<ContentDisease, 'title' | 'path'>>>> }
    ) | (
      { __typename: 'ParagraphListingDiseaseSearchSource' }
      & Pick<ParagraphListingDiseaseSearchSource, 'title'>
    ) | (
      { __typename: 'ParagraphListingEventsEmbed' }
      & Pick<ParagraphListingEventsEmbed, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByDepartment' }
      & Pick<ParagraphListingEventsEmbedByDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingEventsEmbedByTypeAndDepartment' }
      & Pick<ParagraphListingEventsEmbedByTypeAndDepartment, 'title' | 'argument'>
      & { cta: Pick<Link, 'url'> }
    ) | (
      { __typename: 'ParagraphListingJobList' }
      & Pick<ParagraphListingJobList, 'title' | 'keyword' | 'location'>
    ) | (
      { __typename: 'ParagraphListingJobToolSearch' }
      & Pick<ParagraphListingJobToolSearch, 'title' | 'argument'>
      & { jobFilters: { workload: Array<Pick<Item, 'id' | 'title'>>, area: Array<Pick<Item, 'id' | 'title'>>, location: Maybe<Array<Maybe<Pick<Item, 'id' | 'title'>>>> } }
    ) | (
      { __typename: 'ParagraphListingLocationByTreatmentOffer' }
      & Pick<ParagraphListingLocationByTreatmentOffer, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingMedicineNews' }
      & Pick<ParagraphListingMedicineNews, 'title' | 'argument'>
      & { medicineFilters: Maybe<{ change: Array<Pick<Item, 'id' | 'title'>> }> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFiltered' }
      & Pick<ParagraphListingNewsroomFiltered, 'title' | 'argument'>
      & { exposedFilters: Array<Maybe<Pick<ViewExposedFilters, 'filter' | 'value'>>> }
    ) | (
      { __typename: 'ParagraphListingNewsroomFrontpage' }
      & Pick<ParagraphListingNewsroomFrontpage, 'title' | 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomPersonnelBlock' }
      & Pick<ParagraphListingNewsroomPersonnelBlock, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomResearch' }
      & Pick<ParagraphListingNewsroomResearch, 'argument'>
    ) | (
      { __typename: 'ParagraphListingNewsroomTreatment' }
      & Pick<ParagraphListingNewsroomTreatment, 'argument'>
    ) | (
      { __typename: 'ParagraphListingSpecialists' }
      & Pick<ParagraphListingSpecialists, 'title'>
    ) | (
      { __typename: 'ParagraphLiteratureLinks' }
      & { refLinks: Maybe<Array<Maybe<(
        Pick<LiteratureLinks, 'description'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLiteraturePdfs' }
      & { pdfs: Maybe<Array<Maybe<Pick<MediaLabCardPdf, 'uuid' | 'name' | 'url' | 'description'>>>> }
    ) | (
      { __typename: 'ParagraphLiteratureText' }
      & Pick<ParagraphLiteratureText, 'textHtml'>
    ) | (
      { __typename: 'ParagraphLogoCloud' }
      & { logoImages: Maybe<Array<Maybe<(
        { __typename: 'ParagraphLogoCloudImage' }
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>>> }
    ) | (
      { __typename: 'ParagraphLogoCloudImage' }
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphMegaTeasers' }
      & Pick<ParagraphMegaTeasers, 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphNewsTeaser' }
      & { newsContent: Maybe<(
        Pick<ContentNews, 'path' | 'title' | 'date'>
        & { teaserImage: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'ParagraphPreAnalyticData' }
      & Pick<ParagraphPreAnalyticData, 'patientType' | 'materialAmountHtml' | 'minimumVolumeHtml' | 'furtherRemarksHtml'>
      & { containerImage: Maybe<(
        Pick<MediaLabCardContainer, 'uuid' | 'containerName' | 'imageCaption' | 'alt' | 'original'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, stylesOther: Array<Pick<ImageStyleOther, 'id' | 'url'>> }
      )>, sampleMaterial: Maybe<Array<Maybe<Pick<TermSampleMaterial, 'uuid' | 'title'>>>> }
    ) | (
      { __typename: 'ParagraphQuote' }
      & Pick<ParagraphQuote, 'author' | 'quote'>
    ) | (
      { __typename: 'ParagraphSiteSearch' }
      & Pick<ParagraphSiteSearch, 'placeholderText'>
    ) | (
      { __typename: 'ParagraphSpacer' }
      & Pick<ParagraphSpacer, 'desktopOnly' | 'withoutBorder'>
    ) | (
      { __typename: 'ParagraphSpecialistsSlider' }
      & Pick<ParagraphSpecialistsSlider, 'title'>
      & { specialists: Array<Maybe<(
        { __typename: 'ContentSpecialist' }
        & Pick<ContentSpecialist, 'title' | 'path' | 'gender'>
        & { imagePortrait: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphStaticCampaignMonitorSubscribeForm' }
      & Pick<ParagraphStaticCampaignMonitorSubscribeForm, 'title'>
    ) | (
      { __typename: 'ParagraphStaticWallsBlock' }
      & Pick<ParagraphStaticWallsBlock, 'title'>
    ) | (
      { __typename: 'ParagraphTeaser' }
      & Pick<ParagraphTeaser, 'title' | 'lead'>
      & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'ParagraphTeasers' }
      & Pick<ParagraphTeasers, 'display' | 'title'>
      & { teasers: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTeaser' }
        & Pick<ParagraphTeaser, 'title' | 'lead'>
        & { link: Maybe<Pick<Link, 'url'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTestimonialSlider' }
      & Pick<ParagraphTestimonialSlider, 'title'>
      & { testimonial: Array<Maybe<(
        Pick<ContentTestimonial, 'title' | 'author' | 'textFullHtml' | 'textSummaryHtml'>
        & { link: Maybe<Pick<LinkWithOptionalText, 'url' | 'text'>>, image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )>> }
    ) | (
      { __typename: 'ParagraphTile' }
      & Pick<ParagraphTile, 'text' | 'url'>
    ) | (
      { __typename: 'ParagraphTiles' }
      & { tiles: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTile' }
        & Pick<ParagraphTile, 'text' | 'url'>
      )>> }
    ) | (
      { __typename: 'ParagraphTimeline' }
      & { groups: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineGroup' }
        & Pick<ParagraphTimelineGroup, 'groupTitle'>
        & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphTimelineElement' }
          & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
          & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageCarousel' }
            & Pick<ParagraphImageCarousel, 'display'>
            & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
              { __typename: 'ParagraphImageWithCaption' }
              & Pick<ParagraphImageWithCaption, 'caption'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'ParagraphVideo' }
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, video: Maybe<(
                { __typename: 'MediaVideoLocal' }
                & Pick<MediaVideoLocal, 'url'>
              ) | (
                { __typename: 'MediaVideoRemote' }
                & Pick<MediaVideoRemote, 'url'>
              )> }
            )>> }
          ) | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphQuote' }
            & Pick<ParagraphQuote, 'author' | 'quote'>
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          ) | (
            { __typename: 'ParagraphWysiwygContent' }
            & Pick<ParagraphWysiwygContent, 'textHtml'>
          ) | (
            { __typename: 'ParagraphYoutubeEmbed' }
            & { embed: Pick<Link, 'url'> }
          )>> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineElement' }
      & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
      & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphImageCarousel' }
        & Pick<ParagraphImageCarousel, 'display'>
        & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        )>> }
      ) | (
        { __typename: 'ParagraphImageWithCaption' }
        & Pick<ParagraphImageWithCaption, 'caption'>
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      ) | (
        { __typename: 'ParagraphQuote' }
        & Pick<ParagraphQuote, 'author' | 'quote'>
      ) | (
        { __typename: 'ParagraphVideo' }
        & { image: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )>, video: Maybe<(
          { __typename: 'MediaVideoLocal' }
          & Pick<MediaVideoLocal, 'url'>
        ) | (
          { __typename: 'MediaVideoRemote' }
          & Pick<MediaVideoRemote, 'url'>
        )> }
      ) | (
        { __typename: 'ParagraphWysiwygContent' }
        & Pick<ParagraphWysiwygContent, 'textHtml'>
      ) | (
        { __typename: 'ParagraphYoutubeEmbed' }
        & { embed: Pick<Link, 'url'> }
      )>> }
    ) | (
      { __typename: 'ParagraphTimelineGroup' }
      & Pick<ParagraphTimelineGroup, 'groupTitle'>
      & { elements: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
        { __typename: 'ParagraphTimelineElement' }
        & Pick<ParagraphTimelineElement, 'elementTitle' | 'anchorLabel'>
        & { body: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
          { __typename: 'ParagraphImageCarousel' }
          & Pick<ParagraphImageCarousel, 'display'>
          & { items: Array<Maybe<{ __typename: 'ParagraphEmpty' } | (
            { __typename: 'ParagraphImageWithCaption' }
            & Pick<ParagraphImageWithCaption, 'caption'>
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )> }
          ) | (
            { __typename: 'ParagraphVideo' }
            & { image: Maybe<(
              { __typename: 'MediaImage' }
              & Pick<MediaImage, 'id' | 'alt'>
              & { styles: Array<(
                Pick<ImageStyle, 'id'>
                & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
              )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
            )>, video: Maybe<(
              { __typename: 'MediaVideoLocal' }
              & Pick<MediaVideoLocal, 'url'>
            ) | (
              { __typename: 'MediaVideoRemote' }
              & Pick<MediaVideoRemote, 'url'>
            )> }
          )>> }
        ) | (
          { __typename: 'ParagraphImageWithCaption' }
          & Pick<ParagraphImageWithCaption, 'caption'>
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )> }
        ) | (
          { __typename: 'ParagraphQuote' }
          & Pick<ParagraphQuote, 'author' | 'quote'>
        ) | (
          { __typename: 'ParagraphVideo' }
          & { image: Maybe<(
            { __typename: 'MediaImage' }
            & Pick<MediaImage, 'id' | 'alt'>
            & { styles: Array<(
              Pick<ImageStyle, 'id'>
              & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
            )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
          )>, video: Maybe<(
            { __typename: 'MediaVideoLocal' }
            & Pick<MediaVideoLocal, 'url'>
          ) | (
            { __typename: 'MediaVideoRemote' }
            & Pick<MediaVideoRemote, 'url'>
          )> }
        ) | (
          { __typename: 'ParagraphWysiwygContent' }
          & Pick<ParagraphWysiwygContent, 'textHtml'>
        ) | (
          { __typename: 'ParagraphYoutubeEmbed' }
          & { embed: Pick<Link, 'url'> }
        )>> }
      )>> }
    ) | (
      { __typename: 'ParagraphVideo' }
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, video: Maybe<(
        { __typename: 'MediaVideoLocal' }
        & Pick<MediaVideoLocal, 'url'>
      ) | (
        { __typename: 'MediaVideoRemote' }
        & Pick<MediaVideoRemote, 'url'>
      )> }
    ) | (
      { __typename: 'ParagraphWysiwygContent' }
      & Pick<ParagraphWysiwygContent, 'textHtml'>
    ) | (
      { __typename: 'ParagraphYoutubeEmbed' }
      & { embed: Pick<Link, 'url'> }
    )>>, locationHeader: { location: Maybe<(
        Pick<ContentLocation, 'path' | 'title' | 'subtitle'>
        & { contact: Maybe<Pick<ContentLocationContact, 'path'>> }
      )>, navigation: Array<Pick<NavigationItem, 'title' | 'url' | 'isActive'>> }, metaTags: Maybe<Array<Maybe<(
      Pick<MetaTag, 'tag'>
      & { attributes: Pick<MetaTagAttributes, 'rel' | 'property' | 'name' | 'href' | 'content'> }
    )>>> }
  )> };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { currentUser: Pick<User, 'id' | 'name'> };

export type DsLoopQueryVariables = Exact<{
  remoteId: Scalars['String'];
}>;


export type DsLoopQuery = { content: Maybe<{ segments: Array<(
      Pick<DsLoopSegment, 'amountOfSlidesToPick'>
      & { filters: Pick<DsSegmentFilters, 'departmentIds' | 'treatmentAreaIds' | 'projectIds'>, filtersExclude: Pick<DsSegmentFilters, 'departmentIds' | 'treatmentAreaIds' | 'projectIds'>, playlist: Maybe<{ content: { babies: Maybe<Array<Maybe<(
            Pick<ContentBaby, 'id' | 'title'>
            & { image: Maybe<{ src: MediaImage['original'] }>, department: Maybe<{ id: ContentLocation['drupalId'] }> }
          )>>> } | { events: Maybe<Array<Maybe<(
            Pick<ContentEvent, 'title' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
            & { department: Array<Maybe<{ id: ContentLocation['drupalId'] }>> }
          )>>> } | { slides: Maybe<Array<Maybe<(
            Pick<DsSlide, 'id'>
            & { dsSettings: Pick<SettingsDigitalSignage, 'durationBabies' | 'durationEvents' | 'durationFullScreen' | 'durationHealthTip' | 'durationHistory' | 'durationInstagram' | 'durationQuiz' | 'durationQuizAnswerReveal' | 'durationSimple'>, metadata: Pick<DsSlideMetadata, 'departmentIds' | 'treatmentAreaIds' | 'projectIds'>, layout: (
              { __typename: 'DsFullScreenSlide' }
              & Pick<DsFullScreenSlide, 'durationSeconds'>
              & { mediaImage: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, mediaVideoRemote: Maybe<Pick<MediaVideoRemote, 'url'>>, mediaVideoLocal: Maybe<Pick<MediaVideoLocal, 'url'>> }
            ) | (
              { __typename: 'DsHealthTipSlide' }
              & Pick<DsHealthTipSlide, 'title' | 'contentHtml' | 'label'>
              & { expert: Maybe<(
                Pick<ContentSpecialist, 'title' | 'job'>
                & { areas: Array<Maybe<Pick<TermAdministrativeArea, 'title'>>>, imageLandscape: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )> }
              )> }
            ) | (
              { __typename: 'DsHistorySlide' }
              & Pick<DsHistorySlide, 'thenCaption' | 'nowCaption' | 'nowDescriptionHtml'>
              & { thenImage: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, nowImage: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'DsInstagramSlide' }
              & Pick<DsInstagramSlide, 'title' | 'contentHtml' | 'cta'>
              & { images: Array<Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>>, expert: Maybe<Pick<ContentSpecialist, 'id'>> }
            ) | (
              { __typename: 'DsQuizSlide' }
              & Pick<DsQuizSlide, 'question' | 'answers' | 'correctAnswer'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'DsSimpleSlide' }
              & Pick<DsSimpleSlide, 'title' | 'contentHtml'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) }
          )>>> } }> }
    )>, dsSettings: Pick<SettingsDigitalSignage, 'durationBabies' | 'durationEvents' | 'durationFullScreen' | 'durationHealthTip' | 'durationHistory' | 'durationInstagram' | 'durationQuiz' | 'durationQuizAnswerReveal' | 'durationSimple'> }> };

export type DsLoopRevisionQueryVariables = Exact<{
  remoteId: Scalars['String'];
  revisionId: Scalars['String'];
}>;


export type DsLoopRevisionQuery = { content: Maybe<{ segments: Array<(
      Pick<DsLoopSegment, 'amountOfSlidesToPick'>
      & { filters: Pick<DsSegmentFilters, 'departmentIds' | 'treatmentAreaIds' | 'projectIds'>, filtersExclude: Pick<DsSegmentFilters, 'departmentIds' | 'treatmentAreaIds' | 'projectIds'>, playlist: Maybe<{ content: { babies: Maybe<Array<Maybe<(
            Pick<ContentBaby, 'id' | 'title'>
            & { image: Maybe<{ src: MediaImage['original'] }>, department: Maybe<{ id: ContentLocation['drupalId'] }> }
          )>>> } | { events: Maybe<Array<Maybe<(
            Pick<ContentEvent, 'title' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'eventStatus'>
            & { department: Array<Maybe<{ id: ContentLocation['drupalId'] }>> }
          )>>> } | { slides: Maybe<Array<Maybe<(
            Pick<DsSlide, 'id'>
            & { dsSettings: Pick<SettingsDigitalSignage, 'durationBabies' | 'durationEvents' | 'durationFullScreen' | 'durationHealthTip' | 'durationHistory' | 'durationInstagram' | 'durationQuiz' | 'durationQuizAnswerReveal' | 'durationSimple'>, metadata: Pick<DsSlideMetadata, 'departmentIds' | 'treatmentAreaIds' | 'projectIds'>, layout: (
              { __typename: 'DsFullScreenSlide' }
              & Pick<DsFullScreenSlide, 'durationSeconds'>
              & { mediaImage: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, mediaVideoRemote: Maybe<Pick<MediaVideoRemote, 'url'>>, mediaVideoLocal: Maybe<Pick<MediaVideoLocal, 'url'>> }
            ) | (
              { __typename: 'DsHealthTipSlide' }
              & Pick<DsHealthTipSlide, 'title' | 'contentHtml' | 'label'>
              & { expert: Maybe<(
                Pick<ContentSpecialist, 'title' | 'job'>
                & { areas: Array<Maybe<Pick<TermAdministrativeArea, 'title'>>>, imageLandscape: Maybe<(
                  { __typename: 'MediaImage' }
                  & Pick<MediaImage, 'id' | 'alt'>
                  & { styles: Array<(
                    Pick<ImageStyle, 'id'>
                    & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                  )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
                )> }
              )> }
            ) | (
              { __typename: 'DsHistorySlide' }
              & Pick<DsHistorySlide, 'thenCaption' | 'nowCaption' | 'nowDescriptionHtml'>
              & { thenImage: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>, nowImage: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'DsInstagramSlide' }
              & Pick<DsInstagramSlide, 'title' | 'contentHtml' | 'cta'>
              & { images: Array<Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )>>, expert: Maybe<Pick<ContentSpecialist, 'id'>> }
            ) | (
              { __typename: 'DsQuizSlide' }
              & Pick<DsQuizSlide, 'question' | 'answers' | 'correctAnswer'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) | (
              { __typename: 'DsSimpleSlide' }
              & Pick<DsSimpleSlide, 'title' | 'contentHtml'>
              & { image: Maybe<(
                { __typename: 'MediaImage' }
                & Pick<MediaImage, 'id' | 'alt'>
                & { styles: Array<(
                  Pick<ImageStyle, 'id'>
                  & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
                )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
              )> }
            ) }
          )>>> } }> }
    )>, dsSettings: Pick<SettingsDigitalSignage, 'durationBabies' | 'durationEvents' | 'durationFullScreen' | 'durationHealthTip' | 'durationHistory' | 'durationInstagram' | 'durationQuiz' | 'durationQuizAnswerReveal' | 'durationSimple'> }> };

export type DsSlideQueryVariables = Exact<{
  remoteId: Scalars['String'];
}>;


export type DsSlideQuery = { content: Maybe<(
    Pick<DsSlide, 'id'>
    & { dsSettings: Pick<SettingsDigitalSignage, 'durationBabies' | 'durationEvents' | 'durationFullScreen' | 'durationHealthTip' | 'durationHistory' | 'durationInstagram' | 'durationQuiz' | 'durationQuizAnswerReveal' | 'durationSimple'>, metadata: Pick<DsSlideMetadata, 'departmentIds' | 'treatmentAreaIds' | 'projectIds'>, layout: (
      { __typename: 'DsFullScreenSlide' }
      & Pick<DsFullScreenSlide, 'durationSeconds'>
      & { mediaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, mediaVideoRemote: Maybe<Pick<MediaVideoRemote, 'url'>>, mediaVideoLocal: Maybe<Pick<MediaVideoLocal, 'url'>> }
    ) | (
      { __typename: 'DsHealthTipSlide' }
      & Pick<DsHealthTipSlide, 'title' | 'contentHtml' | 'label'>
      & { expert: Maybe<(
        Pick<ContentSpecialist, 'title' | 'job'>
        & { areas: Array<Maybe<Pick<TermAdministrativeArea, 'title'>>>, imageLandscape: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'DsHistorySlide' }
      & Pick<DsHistorySlide, 'thenCaption' | 'nowCaption' | 'nowDescriptionHtml'>
      & { thenImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, nowImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'DsInstagramSlide' }
      & Pick<DsInstagramSlide, 'title' | 'contentHtml' | 'cta'>
      & { images: Array<Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>>, expert: Maybe<Pick<ContentSpecialist, 'id'>> }
    ) | (
      { __typename: 'DsQuizSlide' }
      & Pick<DsQuizSlide, 'question' | 'answers' | 'correctAnswer'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'DsSimpleSlide' }
      & Pick<DsSimpleSlide, 'title' | 'contentHtml'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) }
  )> };

export type DsSlideRevisionQueryVariables = Exact<{
  remoteId: Scalars['String'];
  revisionId: Scalars['String'];
}>;


export type DsSlideRevisionQuery = { content: Maybe<(
    Pick<DsSlide, 'id'>
    & { dsSettings: Pick<SettingsDigitalSignage, 'durationBabies' | 'durationEvents' | 'durationFullScreen' | 'durationHealthTip' | 'durationHistory' | 'durationInstagram' | 'durationQuiz' | 'durationQuizAnswerReveal' | 'durationSimple'>, metadata: Pick<DsSlideMetadata, 'departmentIds' | 'treatmentAreaIds' | 'projectIds'>, layout: (
      { __typename: 'DsFullScreenSlide' }
      & Pick<DsFullScreenSlide, 'durationSeconds'>
      & { mediaImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, mediaVideoRemote: Maybe<Pick<MediaVideoRemote, 'url'>>, mediaVideoLocal: Maybe<Pick<MediaVideoLocal, 'url'>> }
    ) | (
      { __typename: 'DsHealthTipSlide' }
      & Pick<DsHealthTipSlide, 'title' | 'contentHtml' | 'label'>
      & { expert: Maybe<(
        Pick<ContentSpecialist, 'title' | 'job'>
        & { areas: Array<Maybe<Pick<TermAdministrativeArea, 'title'>>>, imageLandscape: Maybe<(
          { __typename: 'MediaImage' }
          & Pick<MediaImage, 'id' | 'alt'>
          & { styles: Array<(
            Pick<ImageStyle, 'id'>
            & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
          )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
        )> }
      )> }
    ) | (
      { __typename: 'DsHistorySlide' }
      & Pick<DsHistorySlide, 'thenCaption' | 'nowCaption' | 'nowDescriptionHtml'>
      & { thenImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>, nowImage: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'DsInstagramSlide' }
      & Pick<DsInstagramSlide, 'title' | 'contentHtml' | 'cta'>
      & { images: Array<Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )>>, expert: Maybe<Pick<ContentSpecialist, 'id'>> }
    ) | (
      { __typename: 'DsQuizSlide' }
      & Pick<DsQuizSlide, 'question' | 'answers' | 'correctAnswer'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) | (
      { __typename: 'DsSimpleSlide' }
      & Pick<DsSimpleSlide, 'title' | 'contentHtml'>
      & { image: Maybe<(
        { __typename: 'MediaImage' }
        & Pick<MediaImage, 'id' | 'alt'>
        & { styles: Array<(
          Pick<ImageStyle, 'id'>
          & { sources: Array<Pick<ImageSource, 'url' | 'width' | 'height'>> }
        )>, focalPoint: Pick<FocalPoint, 'x' | 'y'> }
      )> }
    ) }
  )> };

export const BreadcrumbItemFragmentDoc = `
    fragment BreadcrumbItem on BreadcrumbItem {
  url
  text
}
    `;
export const MetatagsFragmentDoc = `
    fragment Metatags on MetaTag {
  attributes {
    rel
    property
    name
    href
    content
  }
  tag
}
    `;
export const ImageSourceFragmentDoc = `
    fragment ImageSource on ImageSource {
  url
  width
  height
}
    `;
export const ImageStyleOtherFragmentDoc = `
    fragment ImageStyleOther on ImageStyleOther {
  id
  url
}
    `;
export const LabCardContainerFragmentDoc = `
    fragment LabCardContainer on MediaLabCardContainer {
  uuid
  containerName
  imageCaption
  styles {
    id
    sources {
      ...ImageSource
    }
  }
  alt
  stylesOther {
    ...ImageStyleOther
  }
  original
}
    `;
export const ParagraphPreAnalyticDataFragmentDoc = `
    fragment ParagraphPreAnalyticData on ParagraphPreAnalyticData {
  __typename
  patientType
  containerImage {
    ...LabCardContainer
  }
  materialAmountHtml
  minimumVolumeHtml
  sampleMaterial {
    uuid
    title
  }
  furtherRemarksHtml
}
    `;
export const ParagraphLiteratureLinksFragmentDoc = `
    fragment ParagraphLiteratureLinks on ParagraphLiteratureLinks {
  __typename
  refLinks {
    link {
      url
      text
    }
    description
  }
}
    `;
export const LabCardPdfFragmentDoc = `
    fragment LabCardPdf on MediaLabCardPdf {
  uuid
  name
  url
  description
}
    `;
export const ParagraphLiteraturePdfsFragmentDoc = `
    fragment ParagraphLiteraturePdfs on ParagraphLiteraturePdfs {
  __typename
  pdfs {
    ...LabCardPdf
  }
}
    `;
export const ParagraphLiteratureTextFragmentDoc = `
    fragment ParagraphLiteratureText on ParagraphLiteratureText {
  __typename
  textHtml
}
    `;
export const AnalysisPageFragmentDoc = `
    fragment AnalysisPage on ContentAnalysis {
  drupalId
  breadcrumbs {
    ...BreadcrumbItem
  }
  metaTags {
    ...Metatags
  }
  analysisName
  analysisExternal
  synonymsKeyWords
  clinicIndicationHtml
  preAnalyticData {
    ...ParagraphPreAnalyticData
  }
  sampleStabilityStorageHtml
  subsequentRegulationHtml
  interferenceFactorsHtml
  laboratoryContact {
    uuid
    labContact
    telephoneNumber
    internalLab
  }
  methodHtml
  unit
  conversionFactorHtml
  referenceRangesHtml
  analysisFrequency
  interpretationHtml
  literatureReference {
    ...ParagraphLiteratureLinks
    ...ParagraphLiteraturePdfs
    ...ParagraphLiteratureText
  }
  specialityArea {
    uuid
    title
  }
  links {
    text
    url
  }
  taxposition {
    taxposition
    taxpoints
    description
  }
  notesInternalHtml
}
    `;
export const ImageFragmentDoc = `
    fragment Image on MediaImage {
  __typename
  id
  styles {
    id
    sources {
      ...ImageSource
    }
  }
  alt
  focalPoint {
    x
    y
  }
}
    `;
export const BabyPageFragmentDoc = `
    fragment BabyPage on ContentBaby {
  title
  dateOfBirth
  gender
  weight
  height
  location {
    title
    path
    area {
      title
    }
  }
  image {
    ...Image
  }
  metaTags {
    ...Metatags
  }
  createdTimestamp
  gtmData
}
    `;
export const LocationHeaderFragmentDoc = `
    fragment LocationHeader on LocationHeader {
  location {
    path
    title
    subtitle
    contact {
      path
    }
  }
  navigation {
    title
    url
    isActive
  }
}
    `;
export const EmptyFragmentDoc = `
    fragment Empty on ParagraphEmpty {
  __typename
}
    `;
export const WysiwygFragmentDoc = `
    fragment Wysiwyg on ParagraphWysiwygContent {
  __typename
  textHtml
}
    `;
export const ParagraphAccordionElementFragmentDoc = `
    fragment ParagraphAccordionElement on ParagraphAccordionElement {
  __typename
  title
  textHtml
}
    `;
export const ParagraphAccordionFragmentDoc = `
    fragment ParagraphAccordion on ParagraphAccordion {
  __typename
  accordionElements {
    ...ParagraphAccordionElement
  }
}
    `;
export const LinkListLinkFragmentDoc = `
    fragment LinkListLink on ParagraphLinkListLink {
  __typename
  title
  listLink {
    url
    text
  }
}
    `;
export const LinkListFragmentDoc = `
    fragment LinkList on ParagraphLinkList {
  __typename
  links {
    ...LinkListLink
    ... on ParagraphEmpty {
      __typename
    }
  }
}
    `;
export const TileFragmentDoc = `
    fragment Tile on ParagraphTile {
  __typename
  text
  url
}
    `;
export const TilesFragmentDoc = `
    fragment Tiles on ParagraphTiles {
  __typename
  tiles {
    ...Tile
    ... on ParagraphEmpty {
      __typename
    }
  }
}
    `;
export const ParagraphBabyGalleryFragmentDoc = `
    fragment ParagraphBabyGallery on ParagraphBabiesSearch {
  __typename
  filters {
    gender {
      id
      title
    }
    location {
      id
      title
    }
  }
}
    `;
export const SpecialistSlideFragmentDoc = `
    fragment SpecialistSlide on ContentSpecialist {
  __typename
  title
  path
  imagePortrait {
    ...Image
  }
  gender
}
    `;
export const SpecialistSliderFragmentDoc = `
    fragment SpecialistSlider on ParagraphSpecialistsSlider {
  __typename
  title
  specialists {
    ...SpecialistSlide
  }
}
    `;
export const DiseaseListingFragmentDoc = `
    fragment DiseaseListing on ParagraphListingDiseaseSearchSource {
  __typename
  title
}
    `;
export const ContextualTextFragmentDoc = `
    fragment ContextualText on ParagraphContextualText {
  __typename
  title
  textHtml
  link {
    url
    text
    _original_typename
  }
}
    `;
export const DocumentsFragmentDoc = `
    fragment Documents on ParagraphDocuments {
  __typename
  title
  documents {
    title
    _original_typename
    url
  }
}
    `;
export const FileListFragmentDoc = `
    fragment FileList on ParagraphFileList {
  __typename
  files {
    url
    title
  }
}
    `;
export const TestimonialSliderFragmentDoc = `
    fragment TestimonialSlider on ParagraphTestimonialSlider {
  __typename
  title
  testimonial {
    title
    author
    link {
      url
      text
    }
    image {
      ...Image
    }
    textFullHtml
    textSummaryHtml
  }
}
    `;
export const ImageWithCaptionFragmentDoc = `
    fragment ImageWithCaption on ParagraphImageWithCaption {
  __typename
  image {
    ...Image
  }
  caption
}
    `;
export const EventSearchFragmentDoc = `
    fragment EventSearch on ParagraphEventsSearch {
  __typename
  filters {
    type {
      id
      parentId
      title
    }
    location {
      id
      title
    }
  }
}
    `;
export const QuoteFragmentDoc = `
    fragment Quote on ParagraphQuote {
  __typename
  author
  quote
}
    `;
export const FormattedTextWithTitleFragmentDoc = `
    fragment FormattedTextWithTitle on ParagraphFormattedTextWithTitle {
  __typename
  title
  textHtml
}
    `;
export const TeaserFragmentDoc = `
    fragment Teaser on ParagraphTeaser {
  __typename
  title
  link {
    url
  }
  image {
    ...Image
  }
  lead
}
    `;
export const TeasersFragmentDoc = `
    fragment Teasers on ParagraphTeasers {
  __typename
  display
  title
  teasers {
    ...Teaser
    ... on ParagraphEmpty {
      __typename
    }
  }
}
    `;
export const MegaTeasersFragmentDoc = `
    fragment MegaTeasers on ParagraphMegaTeasers {
  __typename
  title
  teasers {
    ...Teaser
    ... on ParagraphEmpty {
      __typename
    }
  }
}
    `;
export const ParagraphSpecialistGalleryFragmentDoc = `
    fragment ParagraphSpecialistGallery on ParagraphListingSpecialists {
  __typename
  title
}
    `;
export const YoutubeEmbedFragmentDoc = `
    fragment YoutubeEmbed on ParagraphYoutubeEmbed {
  __typename
  embed {
    url
  }
}
    `;
export const MediaVideoFragmentDoc = `
    fragment MediaVideo on MediaVideo {
  ... on MediaVideoLocal {
    __typename
    url
  }
  ... on MediaVideoRemote {
    __typename
    url
  }
}
    `;
export const LocalVideoFragmentDoc = `
    fragment LocalVideo on ParagraphVideo {
  __typename
  image {
    ...Image
  }
  video {
    ...MediaVideo
  }
}
    `;
export const CarouselImageFragmentDoc = `
    fragment CarouselImage on ParagraphImageWithCaption {
  __typename
  caption
  image {
    ...Image
  }
}
    `;
export const CarouselVideoFragmentDoc = `
    fragment CarouselVideo on ParagraphVideo {
  __typename
  image {
    ...Image
  }
  video {
    ...MediaVideo
  }
}
    `;
export const CarouselFragmentDoc = `
    fragment Carousel on ParagraphImageCarousel {
  __typename
  display
  items {
    ...CarouselImage
    ...CarouselVideo
    ... on ParagraphEmpty {
      __typename
    }
  }
}
    `;
export const ParagraphListingClinicsByAreaFragmentDoc = `
    fragment ParagraphListingClinicsByArea on ParagraphListingClinicsByArea {
  __typename
  title
  argument
}
    `;
export const ParagraphListingAllocationFragmentDoc = `
    fragment ParagraphListingAllocation on ParagraphListingAllocation {
  __typename
  title
  argument
}
    `;
export const ParagraphListingJobToolSearchFragmentDoc = `
    fragment ParagraphListingJobToolSearch on ParagraphListingJobToolSearch {
  __typename
  title
  argument
  jobFilters {
    workload {
      id
      title
    }
    area {
      id
      title
    }
    location {
      id
      title
    }
  }
}
    `;
export const ParagraphListingJobListFragmentDoc = `
    fragment ParagraphListingJobList on ParagraphListingJobList {
  __typename
  title
  keyword
  location
}
    `;
export const ParagraphListingMedicineNewsFragmentDoc = `
    fragment ParagraphListingMedicineNews on ParagraphListingMedicineNews {
  __typename
  title
  argument
  medicineFilters {
    change {
      id
      title
    }
  }
}
    `;
export const ParagraphListingEventsEmbedFragmentDoc = `
    fragment ParagraphListingEventsEmbed on ParagraphListingEventsEmbed {
  __typename
  title
  argument
  cta {
    url
  }
}
    `;
export const ParagraphListingEventsEmbedByDepartmentFragmentDoc = `
    fragment ParagraphListingEventsEmbedByDepartment on ParagraphListingEventsEmbedByDepartment {
  __typename
  title
  argument
  cta {
    url
  }
}
    `;
export const ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc = `
    fragment ParagraphListingEventsEmbedByTypeAndDepartment on ParagraphListingEventsEmbedByTypeAndDepartment {
  __typename
  title
  argument
  cta {
    url
  }
}
    `;
export const ParagraphListingDiseaseFromLocationFragmentDoc = `
    fragment ParagraphListingDiseaseFromLocation on ParagraphListingDiseaseFromLocation {
  __typename
  title
  diseaseList {
    title
    path
  }
}
    `;
export const ParagraphListingClinicsByTreatmentFragmentDoc = `
    fragment ParagraphListingClinicsByTreatment on ParagraphListingLocationByTreatmentOffer {
  __typename
  title
  argument
}
    `;
export const SpacerFragmentDoc = `
    fragment Spacer on ParagraphSpacer {
  __typename
  desktopOnly
  withoutBorder
}
    `;
export const ParagraphAnchorFragmentDoc = `
    fragment ParagraphAnchor on ParagraphAnchor {
  __typename
  anchorLink
}
    `;
export const AnimatedNumberElementFragmentDoc = `
    fragment AnimatedNumberElement on ParagraphAnimatedNumberElement {
  __typename
  itemTitle
  itemNumber
  itemDisableSeparator
  itemUnit
  Image {
    ...Image
  }
}
    `;
export const AnimatedNumberRangeFragmentDoc = `
    fragment AnimatedNumberRange on ParagraphAnimatedNumberRange {
  __typename
  itemTitle
  itemFirstNumber
  itemSecondNumber
  itemConnectingWord
  itemDisableSeparator
  itemUnit
  Image {
    ...Image
  }
}
    `;
export const AnimatedNumbersFragmentDoc = `
    fragment AnimatedNumbers on ParagraphAnimatedNumbers {
  __typename
  title
  animLink {
    url
    text
  }
  linkType
  items {
    ...AnimatedNumberElement
    ...AnimatedNumberRange
  }
}
    `;
export const ParagraphNewsroomFrontpageFragmentDoc = `
    fragment ParagraphNewsroomFrontpage on ParagraphListingNewsroomFrontpage {
  __typename
  title
  argument
}
    `;
export const ParagraphNewsroomFilteredFragmentDoc = `
    fragment ParagraphNewsroomFiltered on ParagraphListingNewsroomFiltered {
  __typename
  title
  argument
  exposedFilters {
    filter
    value
  }
}
    `;
export const ParagraphNewsroomPersonnelBlockFragmentDoc = `
    fragment ParagraphNewsroomPersonnelBlock on ParagraphListingNewsroomPersonnelBlock {
  __typename
  argument
}
    `;
export const ParagraphWebformFragmentDoc = `
    fragment ParagraphWebform on ParagraphForm {
  __typename
  formUrl
}
    `;
export const ParagraphWebformEventFragmentDoc = `
    fragment ParagraphWebformEvent on ParagraphEventForm {
  __typename
  formUrl
}
    `;
export const ContextualEventFragmentDoc = `
    fragment ContextualEvent on ParagraphContextualEvent {
  __typename
  event {
    id
    path
    image {
      ...Image
    }
    title
    location
    startDate
    endDate
    startTime
    endTime
    eventStatus
  }
}
    `;
export const SiteSearchFragmentDoc = `
    fragment SiteSearch on ParagraphSiteSearch {
  __typename
  placeholderText
}
    `;
export const CmSubscribeFormFragmentDoc = `
    fragment CmSubscribeForm on ParagraphStaticCampaignMonitorSubscribeForm {
  __typename
  title
}
    `;
export const CallToActionFragmentDoc = `
    fragment CallToAction on ParagraphCallToAction {
  __typename
  ctaTitle
  ctaDescription
  ctaLink {
    url
    text
  }
  imgAlignment
  ctaImage {
    ...Image
  }
}
    `;
export const WallsIoFragmentDoc = `
    fragment WallsIo on ParagraphStaticWallsBlock {
  __typename
  title
}
    `;
export const NewsTeaserFragmentDoc = `
    fragment NewsTeaser on ParagraphNewsTeaser {
  __typename
  newsContent {
    path
    title
    date
    teaserImage {
      ...Image
    }
  }
}
    `;
export const ParagraphNewsroomResearchFragmentDoc = `
    fragment ParagraphNewsroomResearch on ParagraphListingNewsroomResearch {
  __typename
  argument
}
    `;
export const ParagraphNewsroomTreatmentFragmentDoc = `
    fragment ParagraphNewsroomTreatment on ParagraphListingNewsroomTreatment {
  __typename
  argument
}
    `;
export const TimelineElementFragmentDoc = `
    fragment TimelineElement on ParagraphTimelineElement {
  __typename
  elementTitle
  anchorLabel
  body {
    ...Empty
    ...Wysiwyg
    ...ImageWithCaption
    ...YoutubeEmbed
    ...LocalVideo
    ...Carousel
    ...Quote
  }
}
    `;
export const TimelineGroupFragmentDoc = `
    fragment TimelineGroup on ParagraphTimelineGroup {
  __typename
  groupTitle
  elements {
    ...TimelineElement
    ...Empty
  }
}
    `;
export const TimelineFragmentDoc = `
    fragment Timeline on ParagraphTimeline {
  __typename
  groups {
    ...TimelineGroup
    ...Empty
  }
}
    `;
export const ParagraphLogoCloudImageFragmentDoc = `
    fragment ParagraphLogoCloudImage on ParagraphLogoCloudImage {
  __typename
  link {
    url
  }
  image {
    ...Image
  }
}
    `;
export const ParagraphLogoCloudFragmentDoc = `
    fragment ParagraphLogoCloud on ParagraphLogoCloud {
  __typename
  logoImages {
    ...ParagraphLogoCloudImage
  }
}
    `;
export const ParagraphLabCardListingFragmentDoc = `
    fragment ParagraphLabCardListing on ParagraphLabCardListing {
  __typename
  title
}
    `;
export const AllParagraphsFragmentDoc = `
    fragment AllParagraphs on AllParagraphs {
  ...Empty
  ...Wysiwyg
  ...ParagraphAccordion
  ...ParagraphAccordionElement
  ...LinkList
  ...LinkListLink
  ...Tiles
  ...Tile
  ...ParagraphBabyGallery
  ...SpecialistSlider
  ...DiseaseListing
  ...ContextualText
  ...Documents
  ...FileList
  ...TestimonialSlider
  ...ImageWithCaption
  ...EventSearch
  ...Quote
  ...FormattedTextWithTitle
  ...Teasers
  ...MegaTeasers
  ...Teaser
  ...ParagraphSpecialistGallery
  ...YoutubeEmbed
  ...LocalVideo
  ...Carousel
  ...ParagraphListingClinicsByArea
  ...ParagraphListingAllocation
  ...ParagraphListingJobToolSearch
  ...ParagraphListingJobList
  ...ParagraphListingMedicineNews
  ...ParagraphListingEventsEmbed
  ...ParagraphListingEventsEmbedByDepartment
  ...ParagraphListingEventsEmbedByTypeAndDepartment
  ...ParagraphListingDiseaseFromLocation
  ...ParagraphListingClinicsByTreatment
  ...Spacer
  ...ParagraphAnchor
  ...AnimatedNumberElement
  ...AnimatedNumbers
  ...ParagraphNewsroomFrontpage
  ...ParagraphNewsroomFiltered
  ...ParagraphNewsroomPersonnelBlock
  ...ParagraphWebform
  ...ParagraphWebformEvent
  ...ContextualEvent
  ...SiteSearch
  ...CmSubscribeForm
  ...CallToAction
  ...WallsIo
  ...NewsTeaser
  ...ParagraphNewsroomResearch
  ...ParagraphNewsroomTreatment
  ...Timeline
  ...TimelineElement
  ...TimelineGroup
  ...ParagraphLogoCloud
  ...ParagraphLogoCloudImage
  ...ParagraphPreAnalyticData
  ...ParagraphLiteratureLinks
  ...ParagraphLiteraturePdfs
  ...ParagraphLiteratureText
  ...ParagraphLabCardListing
}
    `;
export const BasicPageFragmentDoc = `
    fragment BasicPage on ContentPage {
  breadcrumbs {
    ...BreadcrumbItem
  }
  title
  description
  locationHeader {
    ...LocationHeader
  }
  body {
    ...AllParagraphs
  }
  sidebar {
    ...AllParagraphs
  }
  bottom {
    ...AllParagraphs
  }
  metaTags {
    ...Metatags
  }
  translations {
    path
    translationsLanguageTitle
  }
}
    `;
export const DiseasePageFragmentDoc = `
    fragment DiseasePage on ContentDisease {
  drupalId
  breadcrumbs {
    ...BreadcrumbItem
  }
  title
  shortDescriptionHtml
  overviewHtml
  causesHtml
  symptomsHtml
  diagnosisHtml
  courseHtml
  treatmentHtml
  preventionHtml
  faqs {
    accordionElements {
      title
      textHtml
    }
  }
  specialistsTitle
  specialists {
    ...SpecialistSlide
  }
  paragraphBottom {
    ...AllParagraphs
  }
  metaTags {
    ...Metatags
  }
  gtmData
}
    `;
export const DocumentationPageFragmentDoc = `
    fragment DocumentationPage on ContentDocumentationPage {
  title
  path
  group {
    title
    path
    mainContent {
      ... on ContentDocumentationPage {
        path
      }
      ... on ContentPatientInformation {
        path
      }
    }
    menuMain {
      id
      parent
      url
      label
    }
  }
  metaTags {
    ...Metatags
  }
  paragraphs {
    ...AllParagraphs
  }
}
    `;
export const DsSettingsFragmentDoc = `
    fragment DsSettings on SettingsDigitalSignage {
  durationBabies
  durationEvents
  durationFullScreen
  durationHealthTip
  durationHistory
  durationInstagram
  durationQuiz
  durationQuizAnswerReveal
  durationSimple
}
    `;
export const DsSlideFragmentDoc = `
    fragment DsSlide on DsSlide {
  id
  dsSettings {
    ...DsSettings
  }
  metadata {
    departmentIds
    treatmentAreaIds
    projectIds
  }
  layout {
    ... on DsFullScreenSlide {
      __typename
      mediaImage {
        ...Image
      }
      mediaVideoRemote {
        url
      }
      mediaVideoLocal {
        url
      }
      durationSeconds
    }
    ... on DsHealthTipSlide {
      __typename
      title
      contentHtml
      expert {
        title
        job
        areas {
          title
        }
        imageLandscape {
          ...Image
        }
      }
      label
    }
    ... on DsHistorySlide {
      __typename
      thenImage {
        ...Image
      }
      thenCaption
      nowImage {
        ...Image
      }
      nowCaption
      nowDescriptionHtml
    }
    ... on DsInstagramSlide {
      __typename
      title
      contentHtml
      images {
        ...Image
      }
      cta
      expert {
        id
      }
    }
    ... on DsQuizSlide {
      __typename
      question
      answers
      correctAnswer
      image {
        ...Image
      }
    }
    ... on DsSimpleSlide {
      __typename
      title
      contentHtml
      image {
        ...Image
      }
    }
  }
}
    `;
export const DsLoopFragmentDoc = `
    fragment DsLoop on DsLoop {
  segments {
    amountOfSlidesToPick
    filters {
      departmentIds
      treatmentAreaIds
      projectIds
    }
    filtersExclude {
      departmentIds
      treatmentAreaIds
      projectIds
    }
    playlist {
      content {
        ... on PlaylistSlides {
          slides {
            ...DsSlide
          }
        }
        ... on PlaylistEvents {
          events {
            title
            startDate
            endDate
            startTime
            endTime
            eventStatus
            department: organizer {
              id: drupalId
            }
          }
        }
        ... on PlaylistBabies {
          babies {
            id
            title
            image {
              src: original
            }
            department: location {
              id: drupalId
            }
          }
        }
      }
    }
  }
  dsSettings {
    ...DsSettings
  }
}
    `;
export const EventPageFragmentDoc = `
    fragment EventPage on ContentEvent {
  drupalId
  createdTimestamp
  breadcrumbs {
    ...BreadcrumbItem
  }
  title
  image {
    ...Image
  }
  location
  startDate
  startTime
  endDate
  endTime
  lead
  eventStatus
  organizer {
    title
    subtitle
    path
  }
  content {
    ...AllParagraphs
  }
  form {
    formUrl
  }
  sidebar {
    ...AllParagraphs
  }
  metaTags {
    ...Metatags
  }
  gtmData
}
    `;
export const GroupDocumentationFragmentDoc = `
    fragment GroupDocumentation on GroupDocumentation {
  path
  mainContent {
    ... on ContentDocumentationPage {
      path
    }
    ... on ContentPatientInformation {
      path
    }
  }
  menuMain {
    id
    parent
    url
    label
  }
}
    `;
export const KitchenSinkFragmentDoc = `
    fragment KitchenSink on ContentKitchenSink {
  title
  paragraphs {
    ...AllParagraphs
  }
}
    `;
export const AdvertFragmentDoc = `
    fragment Advert on ContentAdvert {
  id
  title
  image {
    ...Image
  }
  text
  textAlignment
  buttonPlacement
  link {
    url
    text
  }
}
    `;
export const AdvertCollectionFragmentDoc = `
    fragment AdvertCollection on ContentAdvertCollection {
  frequency
  positioning
  repetitions
  collection {
    ...Advert
  }
}
    `;
export const LandingPageFragmentDoc = `
    fragment LandingPage on ContentLandingPage {
  title
  description
  image {
    ...Image
  }
  increaseHeroHeight
  video {
    ...MediaVideo
  }
  body {
    ...AllParagraphs
  }
  advertCollection {
    ...AdvertCollection
  }
  metaTags {
    ...Metatags
  }
}
    `;
export const LocationContactPageFragmentDoc = `
    fragment LocationContactPage on ContentLocationContact {
  path
  breadcrumbs {
    ...BreadcrumbItem
  }
  locationHeader {
    ...LocationHeader
  }
  title
  companyName
  addressFirstLine
  addressSecondLine
  postCode
  city
  email
  phone
  mapOverlayHtml
  latitude
  longitude
  infoAddress {
    ...AllParagraphs
  }
  infoBooking {
    ...AllParagraphs
  }
  infoEmergency {
    ...AllParagraphs
  }
  locationHeader {
    ...LocationHeader
  }
  parentLocation {
    title
  }
  metaTags {
    ...Metatags
  }
}
    `;
export const LocationNewsPageFragmentDoc = `
    fragment LocationNewsPage on ContentLocation {
  drupalId
  locationPath: path
  locationBreadcrumbs: breadcrumbs {
    ...BreadcrumbItem
  }
  title
  subtitle
  locationNavigation: navigation {
    title
    url
    isActive
  }
  contact {
    ...LocationContactPage
  }
  metaTags {
    ...Metatags
  }
}
    `;
export const LocationPageFragmentDoc = `
    fragment LocationPage on ContentLocation {
  drupalId
  path
  breadcrumbs {
    ...BreadcrumbItem
  }
  title
  subtitle
  welcomeTitle
  navigation {
    title
    url
    isActive
  }
  content {
    ...AllParagraphs
  }
  specialistsTitle
  specialists {
    ...SpecialistSlide
  }
  displayRelatedNews
  contact {
    ...LocationContactPage
  }
  contentSidebar {
    ...AllParagraphs
  }
  contentBottom {
    ...AllParagraphs
  }
  metaTags {
    ...Metatags
  }
  teamPageTitle
  hideParentLocationTitleFromContactInformation
}
    `;
export const LocationTeamPageFragmentDoc = `
    fragment LocationTeamPage on ContentLocation {
  drupalId
  locationPath: path
  locationBreadcrumbs: breadcrumbs {
    ...BreadcrumbItem
  }
  title
  subtitle
  locationNavigation: navigation {
    title
    url
    isActive
  }
  contact {
    ...LocationContactPage
  }
  metaTags {
    ...Metatags
  }
  area {
    title
    areaIdentifier
  }
  teamPageTitle
}
    `;
export const AllContentFragmentDoc = `
    fragment AllContent on AllContent {
  ... on ContentLandingPage {
    title
    path
  }
  ... on ContentDisease {
    title
    path
  }
  ... on ContentKitchenSink {
    title
    path
  }
  ... on ContentSpecialist {
    title
    path
  }
  ... on ContentNews {
    title
    path
  }
  ... on ContentLocation {
    title
    path
  }
  ... on ContentLocationContact {
    title
    path
  }
  ... on ContentPage {
    title
    path
  }
  ... on ContentEvent {
    title
    path
  }
  ... on ContentBaby {
    title
    path
  }
  ... on ContentTeam {
    title
    path
  }
  ... on ContentPatientInformation {
    title
    path
  }
  ... on ContentDocumentationPage {
    title
    path
  }
  ... on GroupDocumentation {
    title
    path
  }
}
    `;
export const NewsPageFragmentDoc = `
    fragment NewsPage on ContentNews {
  drupalId
  breadcrumbs {
    ...BreadcrumbItem
  }
  title
  lead
  date
  dateChanged
  readTime
  caption
  constructionTerms {
    title
    referenceNode {
      ...AllContent
    }
  }
  knowledgeTerms {
    title
    referenceNode {
      ...AllContent
    }
  }
  strategyTerms {
    title
    referenceNode {
      ...AllContent
    }
  }
  teaserImage {
    ...Image
    stylesOther {
      id
      url
    }
  }
  body {
    ...AllParagraphs
  }
  locations {
    title
    path
    area {
      title
    }
  }
  specialists {
    ...SpecialistSlide
  }
  diseases {
    title
    path
  }
  sidebar {
    ...AllParagraphs
  }
  types
  metaTags {
    ...Metatags
  }
  gtmData
}
    `;
export const PatientInformationPageFragmentDoc = `
    fragment PatientInformationPage on ContentPatientInformation {
  title
  path
  documentationGroup {
    title
    path
    mainContent {
      ... on ContentDocumentationPage {
        path
      }
      ... on ContentPatientInformation {
        path
      }
    }
    menuMain {
      id
      parent
      url
      label
    }
  }
  body {
    ...AllParagraphs
  }
  metaTags {
    ...Metatags
  }
}
    `;
export const SpecialistPageFragmentDoc = `
    fragment SpecialistPage on ContentSpecialist {
  drupalId
  title
  firstName
  lastName
  imageLandscape {
    ...Image
  }
  degree
  job
  gender
  areas {
    title
  }
  locations {
    title
    path
    area {
      title
    }
  }
  department
  expertise {
    title
  }
  path
  treatments
  publications {
    text
    url
  }
  email
  phone
  career
  memberships
  awards
  mandates
  studies
  personalSecretaries {
    title
    email
    phone
  }
  offices {
    email
    phone
    locationHeader {
      location {
        title
        path
        area {
          title
        }
      }
    }
  }
  contactInfo {
    label
    value
  }
  metaTags {
    ...Metatags
  }
  gtmData
  languages
  forceChildrenHospitalTheme
}
    `;
export const TeamPageFragmentDoc = `
    fragment TeamPage on ContentTeam {
  breadcrumbs {
    ...BreadcrumbItem
  }
  title
  description: lead
  body: description {
    ...AllParagraphs
  }
  specialistsTitle
  specialists {
    ...SpecialistSlide
  }
  contentBottom {
    ...AllParagraphs
  }
  contentSidebar {
    ...AllParagraphs
  }
  locationHeader {
    ...LocationHeader
  }
  metaTags {
    ...Metatags
  }
}
    `;
export const ContentAnalysisDocument = `
    query ContentAnalysis($remoteId: String!) {
  content: loadContentAnalysis(id: $remoteId) {
    ...AnalysisPage
  }
}
    ${AnalysisPageFragmentDoc}
${BreadcrumbItemFragmentDoc}
${MetatagsFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageSourceFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}`;
export const useContentAnalysisQuery = <
      TData = ContentAnalysisQuery,
      TError = unknown
    >(
      variables: ContentAnalysisQueryVariables,
      options?: UseQueryOptions<ContentAnalysisQuery, TError, TData>
    ) =>
    useQuery<ContentAnalysisQuery, TError, TData>(
      ['ContentAnalysis', variables],
      fetcher<ContentAnalysisQuery, ContentAnalysisQueryVariables>(ContentAnalysisDocument, variables),
      options
    );
export const useInfiniteContentAnalysisQuery = <
      TData = ContentAnalysisQuery,
      TError = unknown
    >(
      variables: ContentAnalysisQueryVariables,
      options?: UseInfiniteQueryOptions<ContentAnalysisQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentAnalysisQuery, TError, TData>(
      ['ContentAnalysis.infinite', variables],
      (metaData) => fetcher<ContentAnalysisQuery, ContentAnalysisQueryVariables>(ContentAnalysisDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentAnalysisRevisionDocument = `
    query ContentAnalysisRevision($remoteId: String!, $revisionId: String!) {
  content: loadContentAnalysisRevision(id: $remoteId, revision: $revisionId) {
    ...AnalysisPage
  }
}
    ${AnalysisPageFragmentDoc}
${BreadcrumbItemFragmentDoc}
${MetatagsFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageSourceFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}`;
export const useContentAnalysisRevisionQuery = <
      TData = ContentAnalysisRevisionQuery,
      TError = unknown
    >(
      variables: ContentAnalysisRevisionQueryVariables,
      options?: UseQueryOptions<ContentAnalysisRevisionQuery, TError, TData>
    ) =>
    useQuery<ContentAnalysisRevisionQuery, TError, TData>(
      ['ContentAnalysisRevision', variables],
      fetcher<ContentAnalysisRevisionQuery, ContentAnalysisRevisionQueryVariables>(ContentAnalysisRevisionDocument, variables),
      options
    );
export const useInfiniteContentAnalysisRevisionQuery = <
      TData = ContentAnalysisRevisionQuery,
      TError = unknown
    >(
      variables: ContentAnalysisRevisionQueryVariables,
      options?: UseInfiniteQueryOptions<ContentAnalysisRevisionQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentAnalysisRevisionQuery, TError, TData>(
      ['ContentAnalysisRevision.infinite', variables],
      (metaData) => fetcher<ContentAnalysisRevisionQuery, ContentAnalysisRevisionQueryVariables>(ContentAnalysisRevisionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentBabyDocument = `
    query ContentBaby($remoteId: String!) {
  content: loadContentBaby(id: $remoteId) {
    ...BabyPage
  }
}
    ${BabyPageFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentBabyQuery = <
      TData = ContentBabyQuery,
      TError = unknown
    >(
      variables: ContentBabyQueryVariables,
      options?: UseQueryOptions<ContentBabyQuery, TError, TData>
    ) =>
    useQuery<ContentBabyQuery, TError, TData>(
      ['ContentBaby', variables],
      fetcher<ContentBabyQuery, ContentBabyQueryVariables>(ContentBabyDocument, variables),
      options
    );
export const useInfiniteContentBabyQuery = <
      TData = ContentBabyQuery,
      TError = unknown
    >(
      variables: ContentBabyQueryVariables,
      options?: UseInfiniteQueryOptions<ContentBabyQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentBabyQuery, TError, TData>(
      ['ContentBaby.infinite', variables],
      (metaData) => fetcher<ContentBabyQuery, ContentBabyQueryVariables>(ContentBabyDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentBabyRevisionDocument = `
    query ContentBabyRevision($remoteId: String!, $revisionId: String!) {
  content: loadContentBabyRevision(id: $remoteId, revision: $revisionId) {
    ...BabyPage
  }
}
    ${BabyPageFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentBabyRevisionQuery = <
      TData = ContentBabyRevisionQuery,
      TError = unknown
    >(
      variables: ContentBabyRevisionQueryVariables,
      options?: UseQueryOptions<ContentBabyRevisionQuery, TError, TData>
    ) =>
    useQuery<ContentBabyRevisionQuery, TError, TData>(
      ['ContentBabyRevision', variables],
      fetcher<ContentBabyRevisionQuery, ContentBabyRevisionQueryVariables>(ContentBabyRevisionDocument, variables),
      options
    );
export const useInfiniteContentBabyRevisionQuery = <
      TData = ContentBabyRevisionQuery,
      TError = unknown
    >(
      variables: ContentBabyRevisionQueryVariables,
      options?: UseInfiniteQueryOptions<ContentBabyRevisionQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentBabyRevisionQuery, TError, TData>(
      ['ContentBabyRevision.infinite', variables],
      (metaData) => fetcher<ContentBabyRevisionQuery, ContentBabyRevisionQueryVariables>(ContentBabyRevisionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentDiseaseDocument = `
    query ContentDisease($remoteId: String!) {
  content: loadContentDisease(id: $remoteId) {
    ...DiseasePage
  }
}
    ${DiseasePageFragmentDoc}
${BreadcrumbItemFragmentDoc}
${SpecialistSlideFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentDiseaseQuery = <
      TData = ContentDiseaseQuery,
      TError = unknown
    >(
      variables: ContentDiseaseQueryVariables,
      options?: UseQueryOptions<ContentDiseaseQuery, TError, TData>
    ) =>
    useQuery<ContentDiseaseQuery, TError, TData>(
      ['ContentDisease', variables],
      fetcher<ContentDiseaseQuery, ContentDiseaseQueryVariables>(ContentDiseaseDocument, variables),
      options
    );
export const useInfiniteContentDiseaseQuery = <
      TData = ContentDiseaseQuery,
      TError = unknown
    >(
      variables: ContentDiseaseQueryVariables,
      options?: UseInfiniteQueryOptions<ContentDiseaseQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentDiseaseQuery, TError, TData>(
      ['ContentDisease.infinite', variables],
      (metaData) => fetcher<ContentDiseaseQuery, ContentDiseaseQueryVariables>(ContentDiseaseDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentDiseaseRevisionDocument = `
    query ContentDiseaseRevision($remoteId: String!, $revisionId: String!) {
  content: loadContentDiseaseRevision(id: $remoteId, revision: $revisionId) {
    ...DiseasePage
  }
}
    ${DiseasePageFragmentDoc}
${BreadcrumbItemFragmentDoc}
${SpecialistSlideFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentDiseaseRevisionQuery = <
      TData = ContentDiseaseRevisionQuery,
      TError = unknown
    >(
      variables: ContentDiseaseRevisionQueryVariables,
      options?: UseQueryOptions<ContentDiseaseRevisionQuery, TError, TData>
    ) =>
    useQuery<ContentDiseaseRevisionQuery, TError, TData>(
      ['ContentDiseaseRevision', variables],
      fetcher<ContentDiseaseRevisionQuery, ContentDiseaseRevisionQueryVariables>(ContentDiseaseRevisionDocument, variables),
      options
    );
export const useInfiniteContentDiseaseRevisionQuery = <
      TData = ContentDiseaseRevisionQuery,
      TError = unknown
    >(
      variables: ContentDiseaseRevisionQueryVariables,
      options?: UseInfiniteQueryOptions<ContentDiseaseRevisionQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentDiseaseRevisionQuery, TError, TData>(
      ['ContentDiseaseRevision.infinite', variables],
      (metaData) => fetcher<ContentDiseaseRevisionQuery, ContentDiseaseRevisionQueryVariables>(ContentDiseaseRevisionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentDocumentationPageDocument = `
    query ContentDocumentationPage($remoteId: String!) {
  content: loadContentDocumentationPage(id: $remoteId) {
    ...DocumentationPage
  }
}
    ${DocumentationPageFragmentDoc}
${MetatagsFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}`;
export const useContentDocumentationPageQuery = <
      TData = ContentDocumentationPageQuery,
      TError = unknown
    >(
      variables: ContentDocumentationPageQueryVariables,
      options?: UseQueryOptions<ContentDocumentationPageQuery, TError, TData>
    ) =>
    useQuery<ContentDocumentationPageQuery, TError, TData>(
      ['ContentDocumentationPage', variables],
      fetcher<ContentDocumentationPageQuery, ContentDocumentationPageQueryVariables>(ContentDocumentationPageDocument, variables),
      options
    );
export const useInfiniteContentDocumentationPageQuery = <
      TData = ContentDocumentationPageQuery,
      TError = unknown
    >(
      variables: ContentDocumentationPageQueryVariables,
      options?: UseInfiniteQueryOptions<ContentDocumentationPageQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentDocumentationPageQuery, TError, TData>(
      ['ContentDocumentationPage.infinite', variables],
      (metaData) => fetcher<ContentDocumentationPageQuery, ContentDocumentationPageQueryVariables>(ContentDocumentationPageDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentDocumentationPageRevisionDocument = `
    query ContentDocumentationPageRevision($remoteId: String!, $revisionId: String!) {
  content: loadContentDocumentationPageRevision(
    id: $remoteId
    revision: $revisionId
  ) {
    ...DocumentationPage
  }
}
    ${DocumentationPageFragmentDoc}
${MetatagsFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}`;
export const useContentDocumentationPageRevisionQuery = <
      TData = ContentDocumentationPageRevisionQuery,
      TError = unknown
    >(
      variables: ContentDocumentationPageRevisionQueryVariables,
      options?: UseQueryOptions<ContentDocumentationPageRevisionQuery, TError, TData>
    ) =>
    useQuery<ContentDocumentationPageRevisionQuery, TError, TData>(
      ['ContentDocumentationPageRevision', variables],
      fetcher<ContentDocumentationPageRevisionQuery, ContentDocumentationPageRevisionQueryVariables>(ContentDocumentationPageRevisionDocument, variables),
      options
    );
export const useInfiniteContentDocumentationPageRevisionQuery = <
      TData = ContentDocumentationPageRevisionQuery,
      TError = unknown
    >(
      variables: ContentDocumentationPageRevisionQueryVariables,
      options?: UseInfiniteQueryOptions<ContentDocumentationPageRevisionQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentDocumentationPageRevisionQuery, TError, TData>(
      ['ContentDocumentationPageRevision.infinite', variables],
      (metaData) => fetcher<ContentDocumentationPageRevisionQuery, ContentDocumentationPageRevisionQueryVariables>(ContentDocumentationPageRevisionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentEventDocument = `
    query ContentEvent($remoteId: String!) {
  content: loadContentEvent(id: $remoteId) {
    ...EventPage
  }
}
    ${EventPageFragmentDoc}
${BreadcrumbItemFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentEventQuery = <
      TData = ContentEventQuery,
      TError = unknown
    >(
      variables: ContentEventQueryVariables,
      options?: UseQueryOptions<ContentEventQuery, TError, TData>
    ) =>
    useQuery<ContentEventQuery, TError, TData>(
      ['ContentEvent', variables],
      fetcher<ContentEventQuery, ContentEventQueryVariables>(ContentEventDocument, variables),
      options
    );
export const useInfiniteContentEventQuery = <
      TData = ContentEventQuery,
      TError = unknown
    >(
      variables: ContentEventQueryVariables,
      options?: UseInfiniteQueryOptions<ContentEventQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentEventQuery, TError, TData>(
      ['ContentEvent.infinite', variables],
      (metaData) => fetcher<ContentEventQuery, ContentEventQueryVariables>(ContentEventDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentEventRevisionDocument = `
    query ContentEventRevision($remoteId: String!, $revisionId: String!) {
  content: loadContentEventRevision(id: $remoteId, revision: $revisionId) {
    ...EventPage
  }
}
    ${EventPageFragmentDoc}
${BreadcrumbItemFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentEventRevisionQuery = <
      TData = ContentEventRevisionQuery,
      TError = unknown
    >(
      variables: ContentEventRevisionQueryVariables,
      options?: UseQueryOptions<ContentEventRevisionQuery, TError, TData>
    ) =>
    useQuery<ContentEventRevisionQuery, TError, TData>(
      ['ContentEventRevision', variables],
      fetcher<ContentEventRevisionQuery, ContentEventRevisionQueryVariables>(ContentEventRevisionDocument, variables),
      options
    );
export const useInfiniteContentEventRevisionQuery = <
      TData = ContentEventRevisionQuery,
      TError = unknown
    >(
      variables: ContentEventRevisionQueryVariables,
      options?: UseInfiniteQueryOptions<ContentEventRevisionQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentEventRevisionQuery, TError, TData>(
      ['ContentEventRevision.infinite', variables],
      (metaData) => fetcher<ContentEventRevisionQuery, ContentEventRevisionQueryVariables>(ContentEventRevisionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentKitchenSinkDocument = `
    query ContentKitchenSink($remoteId: String!) {
  content: loadContentKitchenSink(id: $remoteId) {
    ...KitchenSink
  }
}
    ${KitchenSinkFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}`;
export const useContentKitchenSinkQuery = <
      TData = ContentKitchenSinkQuery,
      TError = unknown
    >(
      variables: ContentKitchenSinkQueryVariables,
      options?: UseQueryOptions<ContentKitchenSinkQuery, TError, TData>
    ) =>
    useQuery<ContentKitchenSinkQuery, TError, TData>(
      ['ContentKitchenSink', variables],
      fetcher<ContentKitchenSinkQuery, ContentKitchenSinkQueryVariables>(ContentKitchenSinkDocument, variables),
      options
    );
export const useInfiniteContentKitchenSinkQuery = <
      TData = ContentKitchenSinkQuery,
      TError = unknown
    >(
      variables: ContentKitchenSinkQueryVariables,
      options?: UseInfiniteQueryOptions<ContentKitchenSinkQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentKitchenSinkQuery, TError, TData>(
      ['ContentKitchenSink.infinite', variables],
      (metaData) => fetcher<ContentKitchenSinkQuery, ContentKitchenSinkQueryVariables>(ContentKitchenSinkDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentKitchenSinkRevisionDocument = `
    query ContentKitchenSinkRevision($remoteId: String!, $revisionId: String!) {
  content: loadContentKitchenSinkRevision(id: $remoteId, revision: $revisionId) {
    ...KitchenSink
  }
}
    ${KitchenSinkFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}`;
export const useContentKitchenSinkRevisionQuery = <
      TData = ContentKitchenSinkRevisionQuery,
      TError = unknown
    >(
      variables: ContentKitchenSinkRevisionQueryVariables,
      options?: UseQueryOptions<ContentKitchenSinkRevisionQuery, TError, TData>
    ) =>
    useQuery<ContentKitchenSinkRevisionQuery, TError, TData>(
      ['ContentKitchenSinkRevision', variables],
      fetcher<ContentKitchenSinkRevisionQuery, ContentKitchenSinkRevisionQueryVariables>(ContentKitchenSinkRevisionDocument, variables),
      options
    );
export const useInfiniteContentKitchenSinkRevisionQuery = <
      TData = ContentKitchenSinkRevisionQuery,
      TError = unknown
    >(
      variables: ContentKitchenSinkRevisionQueryVariables,
      options?: UseInfiniteQueryOptions<ContentKitchenSinkRevisionQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentKitchenSinkRevisionQuery, TError, TData>(
      ['ContentKitchenSinkRevision.infinite', variables],
      (metaData) => fetcher<ContentKitchenSinkRevisionQuery, ContentKitchenSinkRevisionQueryVariables>(ContentKitchenSinkRevisionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentLandingPageDocument = `
    query ContentLandingPage($remoteId: String!) {
  content: loadContentLandingPage(id: $remoteId) {
    ...LandingPage
  }
}
    ${LandingPageFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${MediaVideoFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${AdvertCollectionFragmentDoc}
${AdvertFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentLandingPageQuery = <
      TData = ContentLandingPageQuery,
      TError = unknown
    >(
      variables: ContentLandingPageQueryVariables,
      options?: UseQueryOptions<ContentLandingPageQuery, TError, TData>
    ) =>
    useQuery<ContentLandingPageQuery, TError, TData>(
      ['ContentLandingPage', variables],
      fetcher<ContentLandingPageQuery, ContentLandingPageQueryVariables>(ContentLandingPageDocument, variables),
      options
    );
export const useInfiniteContentLandingPageQuery = <
      TData = ContentLandingPageQuery,
      TError = unknown
    >(
      variables: ContentLandingPageQueryVariables,
      options?: UseInfiniteQueryOptions<ContentLandingPageQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentLandingPageQuery, TError, TData>(
      ['ContentLandingPage.infinite', variables],
      (metaData) => fetcher<ContentLandingPageQuery, ContentLandingPageQueryVariables>(ContentLandingPageDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentLandingPageRevisionDocument = `
    query ContentLandingPageRevision($remoteId: String!, $revisionId: String!) {
  content: loadContentLandingPageRevision(id: $remoteId, revision: $revisionId) {
    ...LandingPage
  }
}
    ${LandingPageFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${MediaVideoFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${AdvertCollectionFragmentDoc}
${AdvertFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentLandingPageRevisionQuery = <
      TData = ContentLandingPageRevisionQuery,
      TError = unknown
    >(
      variables: ContentLandingPageRevisionQueryVariables,
      options?: UseQueryOptions<ContentLandingPageRevisionQuery, TError, TData>
    ) =>
    useQuery<ContentLandingPageRevisionQuery, TError, TData>(
      ['ContentLandingPageRevision', variables],
      fetcher<ContentLandingPageRevisionQuery, ContentLandingPageRevisionQueryVariables>(ContentLandingPageRevisionDocument, variables),
      options
    );
export const useInfiniteContentLandingPageRevisionQuery = <
      TData = ContentLandingPageRevisionQuery,
      TError = unknown
    >(
      variables: ContentLandingPageRevisionQueryVariables,
      options?: UseInfiniteQueryOptions<ContentLandingPageRevisionQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentLandingPageRevisionQuery, TError, TData>(
      ['ContentLandingPageRevision.infinite', variables],
      (metaData) => fetcher<ContentLandingPageRevisionQuery, ContentLandingPageRevisionQueryVariables>(ContentLandingPageRevisionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentLocationContactDocument = `
    query ContentLocationContact($remoteId: String!) {
  content: loadContentLocationContact(id: $remoteId) {
    ...LocationContactPage
  }
}
    ${LocationContactPageFragmentDoc}
${BreadcrumbItemFragmentDoc}
${LocationHeaderFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentLocationContactQuery = <
      TData = ContentLocationContactQuery,
      TError = unknown
    >(
      variables: ContentLocationContactQueryVariables,
      options?: UseQueryOptions<ContentLocationContactQuery, TError, TData>
    ) =>
    useQuery<ContentLocationContactQuery, TError, TData>(
      ['ContentLocationContact', variables],
      fetcher<ContentLocationContactQuery, ContentLocationContactQueryVariables>(ContentLocationContactDocument, variables),
      options
    );
export const useInfiniteContentLocationContactQuery = <
      TData = ContentLocationContactQuery,
      TError = unknown
    >(
      variables: ContentLocationContactQueryVariables,
      options?: UseInfiniteQueryOptions<ContentLocationContactQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentLocationContactQuery, TError, TData>(
      ['ContentLocationContact.infinite', variables],
      (metaData) => fetcher<ContentLocationContactQuery, ContentLocationContactQueryVariables>(ContentLocationContactDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentLocationContactRevisionDocument = `
    query ContentLocationContactRevision($remoteId: String!, $revisionId: String!) {
  content: loadContentLocationContactRevision(
    id: $remoteId
    revision: $revisionId
  ) {
    ...LocationContactPage
  }
}
    ${LocationContactPageFragmentDoc}
${BreadcrumbItemFragmentDoc}
${LocationHeaderFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentLocationContactRevisionQuery = <
      TData = ContentLocationContactRevisionQuery,
      TError = unknown
    >(
      variables: ContentLocationContactRevisionQueryVariables,
      options?: UseQueryOptions<ContentLocationContactRevisionQuery, TError, TData>
    ) =>
    useQuery<ContentLocationContactRevisionQuery, TError, TData>(
      ['ContentLocationContactRevision', variables],
      fetcher<ContentLocationContactRevisionQuery, ContentLocationContactRevisionQueryVariables>(ContentLocationContactRevisionDocument, variables),
      options
    );
export const useInfiniteContentLocationContactRevisionQuery = <
      TData = ContentLocationContactRevisionQuery,
      TError = unknown
    >(
      variables: ContentLocationContactRevisionQueryVariables,
      options?: UseInfiniteQueryOptions<ContentLocationContactRevisionQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentLocationContactRevisionQuery, TError, TData>(
      ['ContentLocationContactRevision.infinite', variables],
      (metaData) => fetcher<ContentLocationContactRevisionQuery, ContentLocationContactRevisionQueryVariables>(ContentLocationContactRevisionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentLocationNewsDocument = `
    query ContentLocationNews($remoteId: String!) {
  content: loadContentLocation(id: $remoteId) {
    ...LocationNewsPage
  }
}
    ${LocationNewsPageFragmentDoc}
${BreadcrumbItemFragmentDoc}
${LocationContactPageFragmentDoc}
${LocationHeaderFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentLocationNewsQuery = <
      TData = ContentLocationNewsQuery,
      TError = unknown
    >(
      variables: ContentLocationNewsQueryVariables,
      options?: UseQueryOptions<ContentLocationNewsQuery, TError, TData>
    ) =>
    useQuery<ContentLocationNewsQuery, TError, TData>(
      ['ContentLocationNews', variables],
      fetcher<ContentLocationNewsQuery, ContentLocationNewsQueryVariables>(ContentLocationNewsDocument, variables),
      options
    );
export const useInfiniteContentLocationNewsQuery = <
      TData = ContentLocationNewsQuery,
      TError = unknown
    >(
      variables: ContentLocationNewsQueryVariables,
      options?: UseInfiniteQueryOptions<ContentLocationNewsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentLocationNewsQuery, TError, TData>(
      ['ContentLocationNews.infinite', variables],
      (metaData) => fetcher<ContentLocationNewsQuery, ContentLocationNewsQueryVariables>(ContentLocationNewsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentLocationNewsRevisionDocument = `
    query ContentLocationNewsRevision($remoteId: String!, $revisionId: String!) {
  content: loadContentLocationRevision(id: $remoteId, revision: $revisionId) {
    ...LocationNewsPage
  }
}
    ${LocationNewsPageFragmentDoc}
${BreadcrumbItemFragmentDoc}
${LocationContactPageFragmentDoc}
${LocationHeaderFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentLocationNewsRevisionQuery = <
      TData = ContentLocationNewsRevisionQuery,
      TError = unknown
    >(
      variables: ContentLocationNewsRevisionQueryVariables,
      options?: UseQueryOptions<ContentLocationNewsRevisionQuery, TError, TData>
    ) =>
    useQuery<ContentLocationNewsRevisionQuery, TError, TData>(
      ['ContentLocationNewsRevision', variables],
      fetcher<ContentLocationNewsRevisionQuery, ContentLocationNewsRevisionQueryVariables>(ContentLocationNewsRevisionDocument, variables),
      options
    );
export const useInfiniteContentLocationNewsRevisionQuery = <
      TData = ContentLocationNewsRevisionQuery,
      TError = unknown
    >(
      variables: ContentLocationNewsRevisionQueryVariables,
      options?: UseInfiniteQueryOptions<ContentLocationNewsRevisionQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentLocationNewsRevisionQuery, TError, TData>(
      ['ContentLocationNewsRevision.infinite', variables],
      (metaData) => fetcher<ContentLocationNewsRevisionQuery, ContentLocationNewsRevisionQueryVariables>(ContentLocationNewsRevisionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentLocationTeamDocument = `
    query ContentLocationTeam($remoteId: String!) {
  content: loadContentLocation(id: $remoteId) {
    ...LocationTeamPage
  }
}
    ${LocationTeamPageFragmentDoc}
${BreadcrumbItemFragmentDoc}
${LocationContactPageFragmentDoc}
${LocationHeaderFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentLocationTeamQuery = <
      TData = ContentLocationTeamQuery,
      TError = unknown
    >(
      variables: ContentLocationTeamQueryVariables,
      options?: UseQueryOptions<ContentLocationTeamQuery, TError, TData>
    ) =>
    useQuery<ContentLocationTeamQuery, TError, TData>(
      ['ContentLocationTeam', variables],
      fetcher<ContentLocationTeamQuery, ContentLocationTeamQueryVariables>(ContentLocationTeamDocument, variables),
      options
    );
export const useInfiniteContentLocationTeamQuery = <
      TData = ContentLocationTeamQuery,
      TError = unknown
    >(
      variables: ContentLocationTeamQueryVariables,
      options?: UseInfiniteQueryOptions<ContentLocationTeamQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentLocationTeamQuery, TError, TData>(
      ['ContentLocationTeam.infinite', variables],
      (metaData) => fetcher<ContentLocationTeamQuery, ContentLocationTeamQueryVariables>(ContentLocationTeamDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentLocationTeamRevisionDocument = `
    query ContentLocationTeamRevision($remoteId: String!, $revisionId: String!) {
  content: loadContentLocationRevision(id: $remoteId, revision: $revisionId) {
    ...LocationTeamPage
  }
}
    ${LocationTeamPageFragmentDoc}
${BreadcrumbItemFragmentDoc}
${LocationContactPageFragmentDoc}
${LocationHeaderFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentLocationTeamRevisionQuery = <
      TData = ContentLocationTeamRevisionQuery,
      TError = unknown
    >(
      variables: ContentLocationTeamRevisionQueryVariables,
      options?: UseQueryOptions<ContentLocationTeamRevisionQuery, TError, TData>
    ) =>
    useQuery<ContentLocationTeamRevisionQuery, TError, TData>(
      ['ContentLocationTeamRevision', variables],
      fetcher<ContentLocationTeamRevisionQuery, ContentLocationTeamRevisionQueryVariables>(ContentLocationTeamRevisionDocument, variables),
      options
    );
export const useInfiniteContentLocationTeamRevisionQuery = <
      TData = ContentLocationTeamRevisionQuery,
      TError = unknown
    >(
      variables: ContentLocationTeamRevisionQueryVariables,
      options?: UseInfiniteQueryOptions<ContentLocationTeamRevisionQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentLocationTeamRevisionQuery, TError, TData>(
      ['ContentLocationTeamRevision.infinite', variables],
      (metaData) => fetcher<ContentLocationTeamRevisionQuery, ContentLocationTeamRevisionQueryVariables>(ContentLocationTeamRevisionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentLocationDocument = `
    query ContentLocation($remoteId: String!) {
  content: loadContentLocation(id: $remoteId) {
    ...LocationPage
  }
}
    ${LocationPageFragmentDoc}
${BreadcrumbItemFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${LocationContactPageFragmentDoc}
${LocationHeaderFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentLocationQuery = <
      TData = ContentLocationQuery,
      TError = unknown
    >(
      variables: ContentLocationQueryVariables,
      options?: UseQueryOptions<ContentLocationQuery, TError, TData>
    ) =>
    useQuery<ContentLocationQuery, TError, TData>(
      ['ContentLocation', variables],
      fetcher<ContentLocationQuery, ContentLocationQueryVariables>(ContentLocationDocument, variables),
      options
    );
export const useInfiniteContentLocationQuery = <
      TData = ContentLocationQuery,
      TError = unknown
    >(
      variables: ContentLocationQueryVariables,
      options?: UseInfiniteQueryOptions<ContentLocationQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentLocationQuery, TError, TData>(
      ['ContentLocation.infinite', variables],
      (metaData) => fetcher<ContentLocationQuery, ContentLocationQueryVariables>(ContentLocationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentLocationRevisionDocument = `
    query ContentLocationRevision($remoteId: String!, $revisionId: String!) {
  content: loadContentLocationRevision(id: $remoteId, revision: $revisionId) {
    ...LocationPage
  }
}
    ${LocationPageFragmentDoc}
${BreadcrumbItemFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${LocationContactPageFragmentDoc}
${LocationHeaderFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentLocationRevisionQuery = <
      TData = ContentLocationRevisionQuery,
      TError = unknown
    >(
      variables: ContentLocationRevisionQueryVariables,
      options?: UseQueryOptions<ContentLocationRevisionQuery, TError, TData>
    ) =>
    useQuery<ContentLocationRevisionQuery, TError, TData>(
      ['ContentLocationRevision', variables],
      fetcher<ContentLocationRevisionQuery, ContentLocationRevisionQueryVariables>(ContentLocationRevisionDocument, variables),
      options
    );
export const useInfiniteContentLocationRevisionQuery = <
      TData = ContentLocationRevisionQuery,
      TError = unknown
    >(
      variables: ContentLocationRevisionQueryVariables,
      options?: UseInfiniteQueryOptions<ContentLocationRevisionQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentLocationRevisionQuery, TError, TData>(
      ['ContentLocationRevision.infinite', variables],
      (metaData) => fetcher<ContentLocationRevisionQuery, ContentLocationRevisionQueryVariables>(ContentLocationRevisionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentNewsDocument = `
    query ContentNews($remoteId: String!) {
  content: loadContentNews(id: $remoteId) {
    ...NewsPage
  }
}
    ${NewsPageFragmentDoc}
${BreadcrumbItemFragmentDoc}
${AllContentFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentNewsQuery = <
      TData = ContentNewsQuery,
      TError = unknown
    >(
      variables: ContentNewsQueryVariables,
      options?: UseQueryOptions<ContentNewsQuery, TError, TData>
    ) =>
    useQuery<ContentNewsQuery, TError, TData>(
      ['ContentNews', variables],
      fetcher<ContentNewsQuery, ContentNewsQueryVariables>(ContentNewsDocument, variables),
      options
    );
export const useInfiniteContentNewsQuery = <
      TData = ContentNewsQuery,
      TError = unknown
    >(
      variables: ContentNewsQueryVariables,
      options?: UseInfiniteQueryOptions<ContentNewsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentNewsQuery, TError, TData>(
      ['ContentNews.infinite', variables],
      (metaData) => fetcher<ContentNewsQuery, ContentNewsQueryVariables>(ContentNewsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentNewsRevisionDocument = `
    query ContentNewsRevision($remoteId: String!, $revisionId: String!) {
  content: loadContentNewsRevision(id: $remoteId, revision: $revisionId) {
    ...NewsPage
  }
}
    ${NewsPageFragmentDoc}
${BreadcrumbItemFragmentDoc}
${AllContentFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentNewsRevisionQuery = <
      TData = ContentNewsRevisionQuery,
      TError = unknown
    >(
      variables: ContentNewsRevisionQueryVariables,
      options?: UseQueryOptions<ContentNewsRevisionQuery, TError, TData>
    ) =>
    useQuery<ContentNewsRevisionQuery, TError, TData>(
      ['ContentNewsRevision', variables],
      fetcher<ContentNewsRevisionQuery, ContentNewsRevisionQueryVariables>(ContentNewsRevisionDocument, variables),
      options
    );
export const useInfiniteContentNewsRevisionQuery = <
      TData = ContentNewsRevisionQuery,
      TError = unknown
    >(
      variables: ContentNewsRevisionQueryVariables,
      options?: UseInfiniteQueryOptions<ContentNewsRevisionQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentNewsRevisionQuery, TError, TData>(
      ['ContentNewsRevision.infinite', variables],
      (metaData) => fetcher<ContentNewsRevisionQuery, ContentNewsRevisionQueryVariables>(ContentNewsRevisionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentPageDocument = `
    query ContentPage($remoteId: String!) {
  content: loadContentPage(id: $remoteId) {
    ...BasicPage
  }
}
    ${BasicPageFragmentDoc}
${BreadcrumbItemFragmentDoc}
${LocationHeaderFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentPageQuery = <
      TData = ContentPageQuery,
      TError = unknown
    >(
      variables: ContentPageQueryVariables,
      options?: UseQueryOptions<ContentPageQuery, TError, TData>
    ) =>
    useQuery<ContentPageQuery, TError, TData>(
      ['ContentPage', variables],
      fetcher<ContentPageQuery, ContentPageQueryVariables>(ContentPageDocument, variables),
      options
    );
export const useInfiniteContentPageQuery = <
      TData = ContentPageQuery,
      TError = unknown
    >(
      variables: ContentPageQueryVariables,
      options?: UseInfiniteQueryOptions<ContentPageQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentPageQuery, TError, TData>(
      ['ContentPage.infinite', variables],
      (metaData) => fetcher<ContentPageQuery, ContentPageQueryVariables>(ContentPageDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentPageRevisionDocument = `
    query ContentPageRevision($remoteId: String!, $revisionId: String!) {
  content: loadContentPageRevision(id: $remoteId, revision: $revisionId) {
    ...BasicPage
  }
}
    ${BasicPageFragmentDoc}
${BreadcrumbItemFragmentDoc}
${LocationHeaderFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentPageRevisionQuery = <
      TData = ContentPageRevisionQuery,
      TError = unknown
    >(
      variables: ContentPageRevisionQueryVariables,
      options?: UseQueryOptions<ContentPageRevisionQuery, TError, TData>
    ) =>
    useQuery<ContentPageRevisionQuery, TError, TData>(
      ['ContentPageRevision', variables],
      fetcher<ContentPageRevisionQuery, ContentPageRevisionQueryVariables>(ContentPageRevisionDocument, variables),
      options
    );
export const useInfiniteContentPageRevisionQuery = <
      TData = ContentPageRevisionQuery,
      TError = unknown
    >(
      variables: ContentPageRevisionQueryVariables,
      options?: UseInfiniteQueryOptions<ContentPageRevisionQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentPageRevisionQuery, TError, TData>(
      ['ContentPageRevision.infinite', variables],
      (metaData) => fetcher<ContentPageRevisionQuery, ContentPageRevisionQueryVariables>(ContentPageRevisionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentPatientInformationDocument = `
    query ContentPatientInformation($remoteId: String!) {
  content: loadContentPatientInformation(id: $remoteId) {
    ...PatientInformationPage
  }
}
    ${PatientInformationPageFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentPatientInformationQuery = <
      TData = ContentPatientInformationQuery,
      TError = unknown
    >(
      variables: ContentPatientInformationQueryVariables,
      options?: UseQueryOptions<ContentPatientInformationQuery, TError, TData>
    ) =>
    useQuery<ContentPatientInformationQuery, TError, TData>(
      ['ContentPatientInformation', variables],
      fetcher<ContentPatientInformationQuery, ContentPatientInformationQueryVariables>(ContentPatientInformationDocument, variables),
      options
    );
export const useInfiniteContentPatientInformationQuery = <
      TData = ContentPatientInformationQuery,
      TError = unknown
    >(
      variables: ContentPatientInformationQueryVariables,
      options?: UseInfiniteQueryOptions<ContentPatientInformationQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentPatientInformationQuery, TError, TData>(
      ['ContentPatientInformation.infinite', variables],
      (metaData) => fetcher<ContentPatientInformationQuery, ContentPatientInformationQueryVariables>(ContentPatientInformationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentPatientInformationRevisionDocument = `
    query ContentPatientInformationRevision($remoteId: String!, $revisionId: String!) {
  content: loadContentPatientInformationRevision(
    id: $remoteId
    revision: $revisionId
  ) {
    ...PatientInformationPage
  }
}
    ${PatientInformationPageFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentPatientInformationRevisionQuery = <
      TData = ContentPatientInformationRevisionQuery,
      TError = unknown
    >(
      variables: ContentPatientInformationRevisionQueryVariables,
      options?: UseQueryOptions<ContentPatientInformationRevisionQuery, TError, TData>
    ) =>
    useQuery<ContentPatientInformationRevisionQuery, TError, TData>(
      ['ContentPatientInformationRevision', variables],
      fetcher<ContentPatientInformationRevisionQuery, ContentPatientInformationRevisionQueryVariables>(ContentPatientInformationRevisionDocument, variables),
      options
    );
export const useInfiniteContentPatientInformationRevisionQuery = <
      TData = ContentPatientInformationRevisionQuery,
      TError = unknown
    >(
      variables: ContentPatientInformationRevisionQueryVariables,
      options?: UseInfiniteQueryOptions<ContentPatientInformationRevisionQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentPatientInformationRevisionQuery, TError, TData>(
      ['ContentPatientInformationRevision.infinite', variables],
      (metaData) => fetcher<ContentPatientInformationRevisionQuery, ContentPatientInformationRevisionQueryVariables>(ContentPatientInformationRevisionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentSpecialistDocument = `
    query ContentSpecialist($remoteId: String!) {
  content: loadContentSpecialist(id: $remoteId) {
    ...SpecialistPage
  }
}
    ${SpecialistPageFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentSpecialistQuery = <
      TData = ContentSpecialistQuery,
      TError = unknown
    >(
      variables: ContentSpecialistQueryVariables,
      options?: UseQueryOptions<ContentSpecialistQuery, TError, TData>
    ) =>
    useQuery<ContentSpecialistQuery, TError, TData>(
      ['ContentSpecialist', variables],
      fetcher<ContentSpecialistQuery, ContentSpecialistQueryVariables>(ContentSpecialistDocument, variables),
      options
    );
export const useInfiniteContentSpecialistQuery = <
      TData = ContentSpecialistQuery,
      TError = unknown
    >(
      variables: ContentSpecialistQueryVariables,
      options?: UseInfiniteQueryOptions<ContentSpecialistQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentSpecialistQuery, TError, TData>(
      ['ContentSpecialist.infinite', variables],
      (metaData) => fetcher<ContentSpecialistQuery, ContentSpecialistQueryVariables>(ContentSpecialistDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentSpecialistRevisionDocument = `
    query ContentSpecialistRevision($remoteId: String!, $revisionId: String!) {
  content: loadContentSpecialistRevision(id: $remoteId, revision: $revisionId) {
    ...SpecialistPage
  }
}
    ${SpecialistPageFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentSpecialistRevisionQuery = <
      TData = ContentSpecialistRevisionQuery,
      TError = unknown
    >(
      variables: ContentSpecialistRevisionQueryVariables,
      options?: UseQueryOptions<ContentSpecialistRevisionQuery, TError, TData>
    ) =>
    useQuery<ContentSpecialistRevisionQuery, TError, TData>(
      ['ContentSpecialistRevision', variables],
      fetcher<ContentSpecialistRevisionQuery, ContentSpecialistRevisionQueryVariables>(ContentSpecialistRevisionDocument, variables),
      options
    );
export const useInfiniteContentSpecialistRevisionQuery = <
      TData = ContentSpecialistRevisionQuery,
      TError = unknown
    >(
      variables: ContentSpecialistRevisionQueryVariables,
      options?: UseInfiniteQueryOptions<ContentSpecialistRevisionQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentSpecialistRevisionQuery, TError, TData>(
      ['ContentSpecialistRevision.infinite', variables],
      (metaData) => fetcher<ContentSpecialistRevisionQuery, ContentSpecialistRevisionQueryVariables>(ContentSpecialistRevisionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentTeamDocument = `
    query ContentTeam($remoteId: String!) {
  content: loadContentTeam(id: $remoteId) {
    ...TeamPage
  }
}
    ${TeamPageFragmentDoc}
${BreadcrumbItemFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${LocationHeaderFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentTeamQuery = <
      TData = ContentTeamQuery,
      TError = unknown
    >(
      variables: ContentTeamQueryVariables,
      options?: UseQueryOptions<ContentTeamQuery, TError, TData>
    ) =>
    useQuery<ContentTeamQuery, TError, TData>(
      ['ContentTeam', variables],
      fetcher<ContentTeamQuery, ContentTeamQueryVariables>(ContentTeamDocument, variables),
      options
    );
export const useInfiniteContentTeamQuery = <
      TData = ContentTeamQuery,
      TError = unknown
    >(
      variables: ContentTeamQueryVariables,
      options?: UseInfiniteQueryOptions<ContentTeamQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentTeamQuery, TError, TData>(
      ['ContentTeam.infinite', variables],
      (metaData) => fetcher<ContentTeamQuery, ContentTeamQueryVariables>(ContentTeamDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ContentTeamRevisionDocument = `
    query ContentTeamRevision($remoteId: String!, $revisionId: String!) {
  content: loadContentTeamRevision(id: $remoteId, revision: $revisionId) {
    ...TeamPage
  }
}
    ${TeamPageFragmentDoc}
${BreadcrumbItemFragmentDoc}
${AllParagraphsFragmentDoc}
${EmptyFragmentDoc}
${WysiwygFragmentDoc}
${ParagraphAccordionFragmentDoc}
${ParagraphAccordionElementFragmentDoc}
${LinkListFragmentDoc}
${LinkListLinkFragmentDoc}
${TilesFragmentDoc}
${TileFragmentDoc}
${ParagraphBabyGalleryFragmentDoc}
${SpecialistSliderFragmentDoc}
${SpecialistSlideFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}
${DiseaseListingFragmentDoc}
${ContextualTextFragmentDoc}
${DocumentsFragmentDoc}
${FileListFragmentDoc}
${TestimonialSliderFragmentDoc}
${ImageWithCaptionFragmentDoc}
${EventSearchFragmentDoc}
${QuoteFragmentDoc}
${FormattedTextWithTitleFragmentDoc}
${TeasersFragmentDoc}
${TeaserFragmentDoc}
${MegaTeasersFragmentDoc}
${ParagraphSpecialistGalleryFragmentDoc}
${YoutubeEmbedFragmentDoc}
${LocalVideoFragmentDoc}
${MediaVideoFragmentDoc}
${CarouselFragmentDoc}
${CarouselImageFragmentDoc}
${CarouselVideoFragmentDoc}
${ParagraphListingClinicsByAreaFragmentDoc}
${ParagraphListingAllocationFragmentDoc}
${ParagraphListingJobToolSearchFragmentDoc}
${ParagraphListingJobListFragmentDoc}
${ParagraphListingMedicineNewsFragmentDoc}
${ParagraphListingEventsEmbedFragmentDoc}
${ParagraphListingEventsEmbedByDepartmentFragmentDoc}
${ParagraphListingEventsEmbedByTypeAndDepartmentFragmentDoc}
${ParagraphListingDiseaseFromLocationFragmentDoc}
${ParagraphListingClinicsByTreatmentFragmentDoc}
${SpacerFragmentDoc}
${ParagraphAnchorFragmentDoc}
${AnimatedNumberElementFragmentDoc}
${AnimatedNumbersFragmentDoc}
${AnimatedNumberRangeFragmentDoc}
${ParagraphNewsroomFrontpageFragmentDoc}
${ParagraphNewsroomFilteredFragmentDoc}
${ParagraphNewsroomPersonnelBlockFragmentDoc}
${ParagraphWebformFragmentDoc}
${ParagraphWebformEventFragmentDoc}
${ContextualEventFragmentDoc}
${SiteSearchFragmentDoc}
${CmSubscribeFormFragmentDoc}
${CallToActionFragmentDoc}
${WallsIoFragmentDoc}
${NewsTeaserFragmentDoc}
${ParagraphNewsroomResearchFragmentDoc}
${ParagraphNewsroomTreatmentFragmentDoc}
${TimelineFragmentDoc}
${TimelineGroupFragmentDoc}
${TimelineElementFragmentDoc}
${ParagraphLogoCloudFragmentDoc}
${ParagraphLogoCloudImageFragmentDoc}
${ParagraphPreAnalyticDataFragmentDoc}
${LabCardContainerFragmentDoc}
${ImageStyleOtherFragmentDoc}
${ParagraphLiteratureLinksFragmentDoc}
${ParagraphLiteraturePdfsFragmentDoc}
${LabCardPdfFragmentDoc}
${ParagraphLiteratureTextFragmentDoc}
${ParagraphLabCardListingFragmentDoc}
${LocationHeaderFragmentDoc}
${MetatagsFragmentDoc}`;
export const useContentTeamRevisionQuery = <
      TData = ContentTeamRevisionQuery,
      TError = unknown
    >(
      variables: ContentTeamRevisionQueryVariables,
      options?: UseQueryOptions<ContentTeamRevisionQuery, TError, TData>
    ) =>
    useQuery<ContentTeamRevisionQuery, TError, TData>(
      ['ContentTeamRevision', variables],
      fetcher<ContentTeamRevisionQuery, ContentTeamRevisionQueryVariables>(ContentTeamRevisionDocument, variables),
      options
    );
export const useInfiniteContentTeamRevisionQuery = <
      TData = ContentTeamRevisionQuery,
      TError = unknown
    >(
      variables: ContentTeamRevisionQueryVariables,
      options?: UseInfiniteQueryOptions<ContentTeamRevisionQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentTeamRevisionQuery, TError, TData>(
      ['ContentTeamRevision.infinite', variables],
      (metaData) => fetcher<ContentTeamRevisionQuery, ContentTeamRevisionQueryVariables>(ContentTeamRevisionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const CurrentUserDocument = `
    query CurrentUser {
  currentUser {
    id
    name
  }
}
    `;
export const useCurrentUserQuery = <
      TData = CurrentUserQuery,
      TError = unknown
    >(
      variables?: CurrentUserQueryVariables,
      options?: UseQueryOptions<CurrentUserQuery, TError, TData>
    ) =>
    useQuery<CurrentUserQuery, TError, TData>(
      variables === undefined ? ['CurrentUser'] : ['CurrentUser', variables],
      fetcher<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, variables),
      options
    );
export const useInfiniteCurrentUserQuery = <
      TData = CurrentUserQuery,
      TError = unknown
    >(
      variables?: CurrentUserQueryVariables,
      options?: UseInfiniteQueryOptions<CurrentUserQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<CurrentUserQuery, TError, TData>(
      variables === undefined ? ['CurrentUser.infinite'] : ['CurrentUser.infinite', variables],
      (metaData) => fetcher<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const DsLoopDocument = `
    query DsLoop($remoteId: String!) {
  content: loadDsLoop(id: $remoteId) {
    ...DsLoop
  }
}
    ${DsLoopFragmentDoc}
${DsSlideFragmentDoc}
${DsSettingsFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}`;
export const useDsLoopQuery = <
      TData = DsLoopQuery,
      TError = unknown
    >(
      variables: DsLoopQueryVariables,
      options?: UseQueryOptions<DsLoopQuery, TError, TData>
    ) =>
    useQuery<DsLoopQuery, TError, TData>(
      ['DsLoop', variables],
      fetcher<DsLoopQuery, DsLoopQueryVariables>(DsLoopDocument, variables),
      options
    );
export const useInfiniteDsLoopQuery = <
      TData = DsLoopQuery,
      TError = unknown
    >(
      variables: DsLoopQueryVariables,
      options?: UseInfiniteQueryOptions<DsLoopQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<DsLoopQuery, TError, TData>(
      ['DsLoop.infinite', variables],
      (metaData) => fetcher<DsLoopQuery, DsLoopQueryVariables>(DsLoopDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const DsLoopRevisionDocument = `
    query DsLoopRevision($remoteId: String!, $revisionId: String!) {
  content: loadDsLoopRevision(id: $remoteId, revision: $revisionId) {
    ...DsLoop
  }
}
    ${DsLoopFragmentDoc}
${DsSlideFragmentDoc}
${DsSettingsFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}`;
export const useDsLoopRevisionQuery = <
      TData = DsLoopRevisionQuery,
      TError = unknown
    >(
      variables: DsLoopRevisionQueryVariables,
      options?: UseQueryOptions<DsLoopRevisionQuery, TError, TData>
    ) =>
    useQuery<DsLoopRevisionQuery, TError, TData>(
      ['DsLoopRevision', variables],
      fetcher<DsLoopRevisionQuery, DsLoopRevisionQueryVariables>(DsLoopRevisionDocument, variables),
      options
    );
export const useInfiniteDsLoopRevisionQuery = <
      TData = DsLoopRevisionQuery,
      TError = unknown
    >(
      variables: DsLoopRevisionQueryVariables,
      options?: UseInfiniteQueryOptions<DsLoopRevisionQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<DsLoopRevisionQuery, TError, TData>(
      ['DsLoopRevision.infinite', variables],
      (metaData) => fetcher<DsLoopRevisionQuery, DsLoopRevisionQueryVariables>(DsLoopRevisionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const DsSlideDocument = `
    query DsSlide($remoteId: String!) {
  content: loadDsSlide(id: $remoteId) {
    ...DsSlide
  }
}
    ${DsSlideFragmentDoc}
${DsSettingsFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}`;
export const useDsSlideQuery = <
      TData = DsSlideQuery,
      TError = unknown
    >(
      variables: DsSlideQueryVariables,
      options?: UseQueryOptions<DsSlideQuery, TError, TData>
    ) =>
    useQuery<DsSlideQuery, TError, TData>(
      ['DsSlide', variables],
      fetcher<DsSlideQuery, DsSlideQueryVariables>(DsSlideDocument, variables),
      options
    );
export const useInfiniteDsSlideQuery = <
      TData = DsSlideQuery,
      TError = unknown
    >(
      variables: DsSlideQueryVariables,
      options?: UseInfiniteQueryOptions<DsSlideQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<DsSlideQuery, TError, TData>(
      ['DsSlide.infinite', variables],
      (metaData) => fetcher<DsSlideQuery, DsSlideQueryVariables>(DsSlideDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const DsSlideRevisionDocument = `
    query DsSlideRevision($remoteId: String!, $revisionId: String!) {
  content: loadDsSlideRevision(id: $remoteId, revision: $revisionId) {
    ...DsSlide
  }
}
    ${DsSlideFragmentDoc}
${DsSettingsFragmentDoc}
${ImageFragmentDoc}
${ImageSourceFragmentDoc}`;
export const useDsSlideRevisionQuery = <
      TData = DsSlideRevisionQuery,
      TError = unknown
    >(
      variables: DsSlideRevisionQueryVariables,
      options?: UseQueryOptions<DsSlideRevisionQuery, TError, TData>
    ) =>
    useQuery<DsSlideRevisionQuery, TError, TData>(
      ['DsSlideRevision', variables],
      fetcher<DsSlideRevisionQuery, DsSlideRevisionQueryVariables>(DsSlideRevisionDocument, variables),
      options
    );
export const useInfiniteDsSlideRevisionQuery = <
      TData = DsSlideRevisionQuery,
      TError = unknown
    >(
      variables: DsSlideRevisionQueryVariables,
      options?: UseInfiniteQueryOptions<DsSlideRevisionQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<DsSlideRevisionQuery, TError, TData>(
      ['DsSlideRevision.infinite', variables],
      (metaData) => fetcher<DsSlideRevisionQuery, DsSlideRevisionQueryVariables>(DsSlideRevisionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};
